import { ColorSchemeCode } from "../enums/ColorScheme";

function Add(props) {
  return (
    <svg width={props.width ? props.width : "15"} height={props.height ? props.height : "15"} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.6875 0.5C7.93614 0.5 8.1746 0.598772 8.35041 0.774587C8.52623 0.950403 8.625 1.18886 8.625 1.4375V6.75H13.9375C14.1861 6.75 14.4246 6.84877 14.6004 7.02459C14.7762 7.2004 14.875 7.43886 14.875 7.6875C14.875 7.93614 14.7762 8.1746 14.6004 8.35041C14.4246 8.52623 14.1861 8.625 13.9375 8.625H8.625V13.9375C8.625 14.1861 8.52623 14.4246 8.35041 14.6004C8.1746 14.7762 7.93614 14.875 7.6875 14.875C7.43886 14.875 7.2004 14.7762 7.02459 14.6004C6.84877 14.4246 6.75 14.1861 6.75 13.9375V8.625H1.4375C1.18886 8.625 0.950403 8.52623 0.774587 8.35041C0.598772 8.1746 0.5 7.93614 0.5 7.6875C0.5 7.43886 0.598772 7.2004 0.774587 7.02459C0.950403 6.84877 1.18886 6.75 1.4375 6.75H6.75V1.4375C6.75 1.18886 6.84877 0.950403 7.02459 0.774587C7.2004 0.598772 7.43886 0.5 7.6875 0.5Z" fill={props.color ? props.color : "#84889B"}/>
    </svg>
  );
}

function LogoMain({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="url(#paint0_linear)" />
      <path
        d="M11.2492 16.9353C9.06182 19.2163 9.33439 22.7471 10.431 24.2151L10.4967 24.2856L10.542 24.3246C10.7114 24.463 12.4131 24.714 13.7491 23.6284L19.6219 17.4041L19.1731 16.9358C18.0786 15.7945 16.6453 15.2241 15.2109 15.2241C13.7775 15.2241 12.3431 15.7945 11.2487 16.9358L11.2492 16.9353Z"
        fill="white"
      />
      <path
        d="M28.8239 16.9793L28.5151 17.3002L34.0353 23.2225C32.561 22.0259 31.1934 22.6547 31.1934 22.6547C30.8408 22.7731 30.3988 23.0478 30.1326 23.3256L24.153 29.5505L26.3882 31.8762C27.3532 32.8792 28.8439 32.9975 29.9358 32.2367C30.0858 32.1325 30.2284 32.0136 30.361 31.8762L31.6891 30.495L36.7573 25.2268C37.2953 24.6665 37.7162 24.0047 37.9954 23.2799C38.8084 21.1772 38.3964 18.6831 36.7573 16.9793C35.6618 15.8411 34.2263 15.2712 32.7909 15.2712C31.3555 15.2712 29.9195 15.8411 28.8239 16.9793V16.9793Z"
        fill="white"
      />
      <path
        d="M22.3177 15.1871L14.0165 23.9818C13.1799 24.6617 12.2601 24.8043 11.6355 24.8043C11.5392 24.8043 11.4429 24.8006 11.3488 24.7927L17.9167 31.71C18.1449 31.9514 18.4199 32.1437 18.725 32.2752C19.0301 32.4067 19.3588 32.4745 19.691 32.4745C20.3661 32.4745 21.0012 32.1999 21.48 31.701L29.827 23.0084C30.1369 22.6837 30.5209 22.439 30.9462 22.2954C31.3866 22.1486 31.8018 22.0733 32.1812 22.0733C32.2396 22.0733 32.2969 22.0754 32.3543 22.0786L25.9495 15.1802C25.7167 14.9341 25.4362 14.7379 25.125 14.6038C24.8139 14.4696 24.4787 14.4002 24.1399 14.3999C23.4511 14.3999 22.8034 14.6804 22.3172 15.1866L22.3177 15.1871Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="49.5634"
          y1="10.475"
          x2="3.78696e-06"
          y2="46.4054"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2FD8E5" />
          <stop offset="1" stop-color="#FF6CD6" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function NavDashboardIcon(props) {
  return (
    <svg fill="#000000" width="28px" height="28px"  viewBox="-4.5 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title></title>
    <path d="M19.469 12.594l3.625 3.313c0.438 0.406 0.313 0.719-0.281 0.719h-2.719v8.656c0 0.594-0.5 1.125-1.094 1.125h-4.719v-6.063c0-0.594-0.531-1.125-1.125-1.125h-2.969c-0.594 0-1.125 0.531-1.125 1.125v6.063h-4.719c-0.594 0-1.125-0.531-1.125-1.125v-8.656h-2.688c-0.594 0-0.719-0.313-0.281-0.719l10.594-9.625c0.438-0.406 1.188-0.406 1.656 0l2.406 2.156v-1.719c0-0.594 0.531-1.125 1.125-1.125h2.344c0.594 0 1.094 0.531 1.094 1.125v5.875z"></path>
    </svg>
  );
}

function NavCampaignIcon({ color }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 15.4961C23 14.6677 23.6716 13.9961 24.5 13.9961C25.3285 13.9961 26.0001 14.6677 26.0001 15.4961C26.0001 16.3246 25.3285 16.9962 24.5 16.9962C23.6716 16.9962 23 16.3246 23 15.4961Z"
        fill="#B2B2CC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.98074 17.8008L10.7157 21.4756C10.7763 21.7788 11.0425 21.997 11.3517 21.997C11.7098 21.997 12.0002 21.7066 12.0002 21.3485V17.9969H14.0003V21.3485C14.0003 22.8112 12.8144 23.997 11.3517 23.997C10.0891 23.997 9.00211 23.1059 8.7545 21.8679L8.01953 18.193L9.98074 17.8008Z"
        fill="#B2B2CC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.0005 11.5054C25.0005 8.80208 22.0663 7.11924 19.733 8.48429L15.8346 10.7649C14.4559 11.5715 12.8873 11.9966 11.2899 11.9966H9.50009C7.56704 11.9966 6 13.5637 6 15.4967C6 17.4298 7.56704 18.9968 9.50009 18.9968H11.2858C12.8855 18.9968 14.4563 19.4232 15.8364 20.232L19.7307 22.5142C22.064 23.8816 25.0005 22.1989 25.0005 19.4944V11.5054ZM20.7429 10.2106C21.7429 9.6256 23.0004 10.3468 23.0004 11.5054V19.4944C23.0004 20.6535 21.7419 21.3747 20.7419 20.7886L16.8477 18.5064C16.2576 18.1606 15.6389 17.872 15.0002 17.6428V13.3521C15.6378 13.1237 16.2553 12.836 16.8445 12.4912L20.7429 10.2106ZM13.0002 13.8629C12.4365 13.9517 11.8647 13.9967 11.2899 13.9967H9.50009C8.67164 13.9967 8.00005 14.6683 8.00005 15.4967C8.00005 16.3252 8.67164 16.9968 9.50009 16.9968H11.2858C11.862 16.9968 12.4352 17.042 13.0002 17.1312V13.8629Z"
        fill="#B2B2CC"
      />
    </svg>
  );
}

function NavDesignIcon() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M12.6801 19.6027L12.611 19.5336C12.394 19.3166 12.394 18.9648 12.611 18.7479L18.4923 12.8666C18.7092 12.6496 19.061 12.6496 19.278 12.8666L19.3471 12.9357C20.215 13.8036 20.215 15.2107 19.3471 16.0786L15.823 19.6027C14.9551 20.4706 13.548 20.4706 12.6801 19.6027Z"
          fill="#A0A3BD"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.0113985 3.47363L1.65157 11.817C2.00572 13.6186 3.22702 15.1288 4.91458 15.852L9.64999 17.8814C9.8588 17.9709 10.1011 17.9242 10.2617 17.7636L17.5079 10.5174C17.6685 10.3568 17.7152 10.1145 17.6257 9.90568L15.5962 5.17035C14.873 3.48281 13.3628 2.26154 11.5613 1.90741L3.20618 0.265053C2.66981 0.159618 2.31961 0.810777 2.70328 1.20015L8.39141 6.97286C8.55002 6.93692 8.71507 6.91795 8.88455 6.91795C10.1119 6.91795 11.1069 7.91292 11.1069 9.14028C11.1069 10.3676 10.1119 11.3626 8.88455 11.3626C7.65719 11.3626 6.66221 10.3676 6.66221 9.14028C6.66221 8.98574 6.67799 8.83489 6.70801 8.68924L0.947928 2.97213C0.559212 2.58632 -0.0942445 2.93623 0.0113985 3.47363Z"
          fill="#A0A3BD"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.253662)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function NavGrowthIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.483 1.7a2.337 2.337 0 011.75-.783h5.766c2.011 0 3.05 2.34 1.789 3.823l-.091.106c-.031.035-.048.055-.07.084L14.33 9.374a6.153 6.153 0 01-.225.272.253.253 0 00-.027.28.28.28 0 00.095.115.283.283 0 00.158.043c2.087 0 2.915 2.706 1.173 3.858L6.796 20.78l-.04.025c-.29.182-.624.28-.966.28-1.337 0-2.145-1.354-1.676-2.489.055-.13.12-.246.158-.317l.005-.01c.047-.084.064-.117.075-.144l2.075-4.94c.076-.168.162-.332.257-.49l.033-.057a.495.495 0 00-.446-.72h-.265c-1.98 0-3.062-2.308-1.793-3.818l4.229-6.35.042-.047V1.7zm1.405 1.184L5.672 9.217l-.043.047a.493.493 0 00.377.82h.264c1.814 0 2.882 1.932 2.054 3.437-.058.105-.097.17-.126.218a1.236 1.236 0 00-.081.154l-2.075 4.94c-.052.127-.115.24-.153.31l-.008.012-.01.019 8.57-6.729.041-.025a.256.256 0 00.117-.134.287.287 0 000-.17.292.292 0 00-.092-.147.264.264 0 00-.176-.053c-1.806 0-2.745-2.084-1.645-3.43a3.41 3.41 0 01.115-.136.789.789 0 00.056-.068l3.296-4.444c.075-.099.154-.194.237-.286.257-.302.044-.802-.392-.802h-5.766a.505.505 0 00-.343.134h-.001z"
        fill={props.color || "#2E3039"}
      />
    </svg>
  );
}

function NudgesIcon({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="2.35303"
        width="17.6471"
        height="17.6471"
        rx="4"
        fill={color ? color : "#A0A3BD"}
      />
      <path
        d="M19.5 3.23529C19.5 4.74596 18.2754 5.97059 16.7647 5.97059C15.254 5.97059 14.0294 4.74596 14.0294 3.23529C14.0294 1.72463 15.254 0.5 16.7647 0.5C18.2754 0.5 19.5 1.72463 19.5 3.23529Z"
        fill={color ? color : "#A0A3BD"}
        stroke="white"
      />
    </svg>
  );
}

function WalletScanIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.786 1.834h.14a1.019 1.019 0 010 2.037c-1.013 0-1.32.008-1.546.069a2.037 2.037 0 00-1.44 1.44c-.06.227-.07.533-.07 1.546a1.019 1.019 0 11-2.036 0v-.14c0-.81-.001-1.412.138-1.933a4.074 4.074 0 012.881-2.88c.521-.14 1.123-.14 1.933-.14zM15.214 20.167h-.14a1.019 1.019 0 010-2.037c1.013 0 1.32-.009 1.546-.07a2.037 2.037 0 001.44-1.44c.061-.227.07-.533.07-1.546a1.019 1.019 0 012.037 0v.14c0 .81 0 1.412-.14 1.933a4.074 4.074 0 01-2.88 2.88c-.521.14-1.123.14-1.933.14zM1.834 15.074v.14c0 .81-.001 1.412.138 1.933a4.074 4.074 0 002.881 2.88c.521.14 1.123.14 1.933.14h.14a1.019 1.019 0 100-2.037c-1.013 0-1.32-.009-1.546-.07a2.037 2.037 0 01-1.44-1.44c-.06-.227-.07-.533-.07-1.546a1.019 1.019 0 00-2.036 0zM20.167 6.786v.14a1.019 1.019 0 11-2.037 0c0-1.013-.009-1.32-.07-1.546a2.037 2.037 0 00-1.44-1.44c-.227-.06-.533-.07-1.546-.07a1.019 1.019 0 010-2.036h.14c.81 0 1.412-.001 1.933.138a4.074 4.074 0 012.88 2.881c.14.521.14 1.123.14 1.933zM2.852 9.982a1.019 1.019 0 000 2.037h16.296a1.019 1.019 0 000-2.037H2.852z"
        fill={props.color || "#2E3039"}
      />
    </svg>
  );
}

function NavAudienceIcon(props) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.5624 4.8126C6.83306 4.8126 6.13359 5.10234 5.61786 5.61806C5.10214 6.13379 4.8124 6.83326 4.8124 7.5626C4.8124 8.29195 5.10214 8.99142 5.61786 9.50715C6.13359 10.0229 6.83306 10.3126 7.5624 10.3126C8.29175 10.3126 8.99122 10.0229 9.50695 9.50715C10.0227 8.99142 10.3124 8.29195 10.3124 7.5626C10.3124 6.83326 10.0227 6.13379 9.50695 5.61806C8.99122 5.10234 8.29175 4.8126 7.5624 4.8126ZM2.7499 7.5626C2.74981 6.76493 2.94799 5.97974 3.32662 5.27766C3.70525 4.57557 4.25247 3.97861 4.91904 3.54047C5.58561 3.10233 6.35064 2.83675 7.14531 2.76762C7.93999 2.69849 8.73938 2.82797 9.4716 3.14442C10.2038 3.46087 10.8459 3.95437 11.3401 4.58052C11.8343 5.20667 12.1651 5.94584 12.3027 6.73155C12.4404 7.51726 12.3805 8.32486 12.1287 9.08172C11.8768 9.83858 11.4407 10.521 10.8597 11.0675C11.9553 11.599 12.9066 12.387 13.6329 13.3646C14.3591 14.3422 14.8389 15.4805 15.0314 16.683C15.0526 16.8168 15.0473 16.9534 15.0157 17.0852C14.9841 17.2169 14.9268 17.3411 14.8472 17.4508C14.7676 17.5604 14.6672 17.6532 14.5517 17.724C14.4362 17.7948 14.3079 17.8422 14.1741 17.8634C14.0403 17.8846 13.9036 17.8793 13.7719 17.8477C13.6402 17.8161 13.5159 17.7588 13.4063 17.6792C13.2967 17.5996 13.2038 17.4992 13.133 17.3837C13.0622 17.2682 13.0149 17.1399 12.9937 17.0061C12.7856 15.7155 12.1247 14.5411 11.1295 13.6935C10.1343 12.8458 8.86969 12.3803 7.5624 12.3803C6.25512 12.3803 4.99056 12.8458 3.99532 13.6935C3.00008 14.5411 2.33922 15.7155 2.13115 17.0061C2.10985 17.1399 2.06239 17.2682 1.99151 17.3837C1.92062 17.4991 1.82768 17.5995 1.718 17.679C1.60833 17.7586 1.48406 17.8157 1.35229 17.8473C1.22052 17.8788 1.08383 17.884 0.950029 17.8627C0.816229 17.8414 0.687935 17.794 0.572473 17.7231C0.457011 17.6522 0.356643 17.5593 0.277098 17.4496C0.197553 17.3399 0.140389 17.2156 0.108871 17.0839C0.0773529 16.9521 0.0720973 16.8154 0.0934042 16.6816C0.286365 15.4796 0.766295 14.3418 1.49251 13.3648C2.21873 12.3877 3.16982 11.6002 4.26515 11.0689C3.78601 10.6193 3.40429 10.0761 3.14364 9.47299C2.883 8.86986 2.74898 8.21964 2.7499 7.5626ZM15.1249 5.50011C14.8514 5.50011 14.5891 5.60875 14.3957 5.80215C14.2023 5.99555 14.0937 6.25785 14.0937 6.53135C14.0937 6.80486 14.2023 7.06716 14.3957 7.26056C14.5891 7.45396 14.8514 7.5626 15.1249 7.5626C15.5901 7.56263 16.0417 7.71994 16.4062 8.009C16.7708 8.29805 17.0269 8.70186 17.133 9.15484C17.239 9.60781 17.1889 10.0834 16.9906 10.5042C16.7923 10.9251 16.4575 11.2665 16.0407 11.4731C15.8687 11.5586 15.7241 11.6904 15.6231 11.8536C15.522 12.0169 15.4685 12.2051 15.4687 12.3971V12.8811C15.4684 13.1127 15.5461 13.3377 15.6892 13.5198C15.8324 13.7019 16.0327 13.8305 16.2579 13.8849C17.9079 14.2822 19.2307 15.5349 19.7257 17.1464C19.7649 17.2764 19.8295 17.3973 19.9156 17.5023C20.0018 17.6073 20.1078 17.6943 20.2276 17.7582C20.3475 17.8221 20.4787 17.8617 20.6139 17.8747C20.7491 17.8877 20.8855 17.8739 21.0154 17.8341C21.1452 17.7943 21.2659 17.7292 21.3705 17.6426C21.4751 17.556 21.5616 17.4495 21.625 17.3294C21.6883 17.2093 21.7274 17.0779 21.7398 16.9426C21.7522 16.8074 21.7378 16.671 21.6974 16.5414C21.4222 15.6484 20.9683 14.8207 20.3631 14.1088C19.758 13.3968 19.0143 12.8154 18.1774 12.3999C18.715 11.8085 19.0692 11.0738 19.197 10.2849C19.3248 9.49604 19.2208 8.68703 18.8974 7.9562C18.5741 7.22538 18.0455 6.6042 17.3757 6.16818C16.706 5.73216 15.9241 5.50006 15.1249 5.50011Z"
        fill={props.color || "#2E3039"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.84157 7.56273C2.84067 8.20722 2.97212 8.84502 3.22779 9.43662C3.48345 10.0282 3.85788 10.561 4.32788 11.002L4.42505 11.0932L4.30516 11.1513C3.22308 11.6762 2.28351 12.4542 1.56608 13.4195C0.84867 14.3847 0.374554 15.5086 0.183923 16.6961C0.164518 16.818 0.169309 16.9425 0.198023 17.0625C0.226741 17.1826 0.278825 17.2958 0.351303 17.3958C0.42378 17.4957 0.515231 17.5804 0.620434 17.645C0.725638 17.7096 0.842533 17.7528 0.964445 17.7722C1.08636 17.7916 1.2109 17.7868 1.33096 17.7581C1.45102 17.7294 1.56425 17.6773 1.66419 17.6048C1.76412 17.5324 1.8488 17.4409 1.91339 17.3357C1.97798 17.2305 2.02121 17.1136 2.04063 16.9917C2.25216 15.6796 2.92406 14.4855 3.93588 13.6237C4.9477 12.7619 6.23334 12.2886 7.5624 12.2886C8.89147 12.2886 10.1771 12.7619 11.1889 13.6237C12.2007 14.4855 12.8726 15.6794 13.0842 16.9915C13.1035 17.1134 13.1467 17.2306 13.2112 17.3358C13.2757 17.441 13.3603 17.5325 13.4602 17.6051C13.5601 17.6776 13.6732 17.7298 13.7933 17.7585C13.9133 17.7873 14.0378 17.7922 14.1597 17.7729C14.2816 17.7536 14.3986 17.7104 14.5038 17.6459C14.609 17.5814 14.7005 17.4968 14.7731 17.3969C14.8456 17.297 14.8977 17.1838 14.9265 17.0638C14.9553 16.9438 14.9602 16.8192 14.9409 16.6973C14.7506 15.5094 14.2767 14.385 13.5593 13.4193C12.8418 12.4535 11.9021 11.6751 10.8196 11.15L10.6999 11.0919L10.7969 11.0007C11.3668 10.4646 11.7946 9.79522 12.0417 9.05278C12.2888 8.31033 12.3474 7.51811 12.2124 6.74737C12.0774 5.97663 11.7529 5.25153 11.2681 4.63731C10.7834 4.02308 10.1535 3.53899 9.43524 3.22857C8.71696 2.91814 7.93279 2.79113 7.15326 2.85894C6.37372 2.92676 5.62326 3.18728 4.96939 3.61707C4.31551 4.04687 3.77872 4.63246 3.4073 5.32117C3.03588 6.00988 2.84147 6.78025 2.84157 7.56273ZM15.0314 16.683C15.0526 16.8168 15.0473 16.9534 15.0157 17.0852C14.9841 17.2169 14.9268 17.3411 14.8472 17.4508C14.7676 17.5604 14.6672 17.6532 14.5517 17.724C14.4362 17.7948 14.3079 17.8422 14.1741 17.8634C14.0403 17.8846 13.9036 17.8793 13.7719 17.8477C13.6402 17.8161 13.5159 17.7588 13.4063 17.6792C13.2967 17.5996 13.2038 17.4992 13.133 17.3837C13.0622 17.2682 13.0149 17.1399 12.9937 17.0061C12.7856 15.7155 12.1247 14.5411 11.1295 13.6935C10.1343 12.8458 8.86969 12.3803 7.5624 12.3803C6.25512 12.3803 4.99056 12.8458 3.99532 13.6935C3.00008 14.5411 2.33922 15.7155 2.13115 17.0061C2.10985 17.1399 2.06239 17.2682 1.99151 17.3837C1.92062 17.4991 1.82768 17.5995 1.718 17.679C1.60833 17.7586 1.48406 17.8157 1.35229 17.8473C1.22052 17.8788 1.08383 17.884 0.950029 17.8627C0.816229 17.8414 0.687935 17.794 0.572473 17.7231C0.457011 17.6522 0.356643 17.5593 0.277098 17.4496C0.197553 17.3399 0.140389 17.2156 0.108871 17.0839C0.0773529 16.9521 0.0720973 16.8154 0.0934042 16.6816C0.286365 15.4796 0.766295 14.3418 1.49251 13.3648C2.19928 12.4139 3.11903 11.6425 4.17745 11.1121C4.20658 11.0975 4.23582 11.0831 4.26515 11.0689C4.24139 11.0466 4.21787 11.024 4.19459 11.0013C3.74845 10.5653 3.39136 10.0462 3.14364 9.47299C2.883 8.86986 2.74898 8.21964 2.7499 7.5626C2.74981 6.76493 2.94799 5.97974 3.32662 5.27766C3.70525 4.57557 4.25247 3.97861 4.91904 3.54047C5.58561 3.10233 6.35064 2.83675 7.14531 2.76762C7.93999 2.69849 8.73938 2.82797 9.4716 3.14442C10.2038 3.46087 10.8459 3.95437 11.3401 4.58052C11.8343 5.20667 12.1651 5.94584 12.3027 6.73155C12.4404 7.51726 12.3805 8.32486 12.1287 9.08172C11.887 9.80768 11.476 10.4651 10.9301 10.9999C10.9069 11.0226 10.8834 11.0452 10.8597 11.0675C10.889 11.0817 10.9182 11.0961 10.9473 11.1107C12.0061 11.6414 12.9261 12.4132 13.6329 13.3646C14.3591 14.3422 14.8389 15.4805 15.0314 16.683ZM18.2405 12.3289C18.7427 11.7502 19.0743 11.0425 19.197 10.2849C19.3248 9.49604 19.2208 8.68703 18.8974 7.9562C18.5741 7.22538 18.0455 6.6042 17.3757 6.16818C16.706 5.73216 15.9241 5.50006 15.1249 5.50011C14.8514 5.50011 14.5891 5.60875 14.3957 5.80215C14.2023 5.99555 14.0937 6.25785 14.0937 6.53135C14.0937 6.80486 14.2023 7.06716 14.3957 7.26056C14.5891 7.45396 14.8514 7.5626 15.1249 7.5626C15.5901 7.56263 16.0417 7.71994 16.4062 8.009C16.7708 8.29805 17.0269 8.70186 17.133 9.15484C17.239 9.60781 17.1889 10.0834 16.9906 10.5042C16.7923 10.9251 16.4575 11.2665 16.0407 11.4731C15.8687 11.5586 15.7241 11.6904 15.6231 11.8536C15.522 12.0169 15.4685 12.2051 15.4687 12.3971V12.8811C15.4684 13.1127 15.5461 13.3377 15.6892 13.5198C15.8324 13.7019 16.0327 13.8305 16.2579 13.8849C17.9079 14.2822 19.2307 15.5349 19.7257 17.1464C19.7649 17.2764 19.8295 17.3973 19.9156 17.5023C20.0018 17.6073 20.1078 17.6943 20.2276 17.7582C20.3475 17.8221 20.4787 17.8617 20.6139 17.8747C20.7491 17.8877 20.8855 17.8739 21.0154 17.8341C21.1452 17.7943 21.2659 17.7292 21.3705 17.6426C21.4751 17.556 21.5616 17.4495 21.625 17.3294C21.6883 17.2093 21.7274 17.0779 21.7398 16.9426C21.7522 16.8074 21.7378 16.671 21.6974 16.5414C21.4222 15.6484 20.9683 14.8207 20.3631 14.1088C19.7785 13.4209 19.0646 12.8549 18.2622 12.4427C18.2341 12.4282 18.2058 12.4139 18.1774 12.3999C18.1987 12.3764 18.2197 12.3528 18.2405 12.3289ZM16.2794 13.7957C17.961 14.2008 19.3088 15.4771 19.8133 17.1194C19.8491 17.2379 19.908 17.3485 19.9865 17.4442C20.065 17.5398 20.1616 17.6191 20.2708 17.6773C20.3799 17.7355 20.4996 17.7716 20.6227 17.7835C20.7459 17.7953 20.8702 17.7828 20.9885 17.7465C21.1068 17.7102 21.2167 17.6509 21.312 17.572C21.4074 17.493 21.4861 17.3961 21.5439 17.2866C21.6016 17.1772 21.6372 17.0574 21.6485 16.9342C21.6598 16.811 21.6467 16.6868 21.6099 16.5686C21.3384 15.6876 20.8904 14.8706 20.2933 14.1681C19.6962 13.4656 18.9624 12.8919 18.1366 12.482L18.0279 12.428L18.1096 12.3382C18.6352 11.76 18.9815 11.0416 19.1065 10.2702C19.2315 9.49891 19.1298 8.70788 18.8136 7.99329C18.4975 7.2787 17.9806 6.67133 17.3257 6.245C16.6709 5.81867 15.9063 5.59173 15.1249 5.59177C14.8757 5.59177 14.6367 5.69076 14.4605 5.86697C14.2843 6.04318 14.1853 6.28216 14.1853 6.53135C14.1853 6.78055 14.2843 7.01954 14.4605 7.19574C14.6367 7.37195 14.8757 7.47094 15.1249 7.47094C15.6108 7.47096 16.0824 7.63527 16.4632 7.93717C16.8439 8.23907 17.1114 8.66083 17.2222 9.13394C17.333 9.60705 17.2806 10.1037 17.0735 10.5433C16.8664 10.9828 16.5168 11.3394 16.0815 11.5552C15.9249 11.6331 15.7931 11.7532 15.701 11.9019C15.6089 12.0506 15.5602 12.2221 15.5603 12.397V12.8811C15.5601 13.0922 15.6309 13.2973 15.7613 13.4632C15.8918 13.6291 16.0743 13.7462 16.2794 13.7957ZM5.55304 5.55324C6.08596 5.02033 6.80875 4.72094 7.5624 4.72094C8.31606 4.72094 9.03885 5.02033 9.57177 5.55324C10.1047 6.08616 10.4041 6.80895 10.4041 7.5626C10.4041 8.31626 10.1047 9.03905 9.57177 9.57197C9.03885 10.1049 8.31606 10.4043 7.5624 10.4043C6.80875 10.4043 6.08596 10.1049 5.55304 9.57197C5.02013 9.03905 4.72074 8.31626 4.72074 7.5626C4.72074 6.80895 5.02013 6.08616 5.55304 5.55324ZM5.61786 5.61806C6.13359 5.10234 6.83306 4.8126 7.5624 4.8126C8.29175 4.8126 8.99122 5.10234 9.50695 5.61806C10.0227 6.13379 10.3124 6.83326 10.3124 7.5626C10.3124 8.29195 10.0227 8.99142 9.50695 9.50715C8.99122 10.0229 8.29175 10.3126 7.5624 10.3126C6.83306 10.3126 6.13359 10.0229 5.61786 9.50715C5.10214 8.99142 4.8124 8.29195 4.8124 7.5626C4.8124 6.83326 5.10214 6.13379 5.61786 5.61806Z"
        fill={props.color || "#F5F7FC"}
      />
    </svg>
  );
}

function NavRedemptionIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill={props.color ? props.color : "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M14.9565 3.10244H13.7919C13.9455 2.85931 14.0469 2.58641 14.0758 2.29778C14.1681 1.37538 13.6823 0.548502 12.8553 0.181908C12.0951 -0.155061 11.2408 -0.0173107 10.6257 0.540627L9.15506 1.87344C8.86866 1.56019 8.45694 1.36331 8 1.36331C7.54225 1.36331 7.12988 1.56081 6.84341 1.87503L5.37091 0.540471C4.75475 -0.0174669 3.90081 -0.154686 3.14097 0.182096C2.31416 0.548721 1.82828 1.37588 1.92091 2.29825C1.94987 2.58666 2.05119 2.85944 2.20478 3.10244H1.04347C0.467156 3.10244 0 3.56963 0 4.14591V5.71113C0 5.99925 0.233594 6.23288 0.52175 6.23288H15.4783C15.7664 6.23288 16 5.99928 16 5.71113V4.14591C16 3.56963 15.5328 3.10244 14.9565 3.10244ZM6.43478 2.92853V3.10244H3.98031C3.33181 3.10244 2.82144 2.49788 2.98341 1.82269C3.05475 1.52535 3.26937 1.27188 3.54697 1.14356C3.92816 0.967377 4.35041 1.02394 4.67056 1.31372L6.43522 2.91316C6.43512 2.91831 6.43478 2.92338 6.43478 2.92853ZM13.0404 2.15925C13.0016 2.70153 12.5117 3.1025 11.9681 3.1025H9.56522V2.9286C9.56522 2.92244 9.56484 2.91635 9.56478 2.91019C9.96453 2.54781 10.8317 1.76181 11.3021 1.33547C11.5694 1.09319 11.9434 0.980096 12.2892 1.08322C12.7853 1.23122 13.0767 1.65316 13.0404 2.15925Z"
          fill={props.color ? props.color : "#AFAEAE"}
        />
        <path
          d="M1.04337 7.27637V14.9286C1.04337 15.5049 1.51052 15.972 2.08683 15.972H6.9564V7.27637H1.04337Z"
          fill={props.color ? props.color : "#AFAEAE"}
        />
        <path
          d="M9.04337 7.27637V15.972H13.9129C14.4892 15.972 14.9564 15.5049 14.9564 14.9286V7.27637H9.04337Z"
          fill={props.color ? props.color : "#AFAEAE"}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function NavSettingIcon(props) {
  return (
    <svg
      width={props.width ? props.width : "20"}
      height={props.height ? props.height : "20"}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4137 10.104L13.7257 8.77998C13.7577 8.52397 13.7817 8.26398 13.7817 7.99998C13.7817 7.73598 13.7577 7.47599 13.7257 7.21998L15.4177 5.89597C15.5697 5.77597 15.6137 5.55997 15.5137 5.38398L13.9137 2.61199C13.8137 2.43997 13.6057 2.36797 13.4257 2.43997L11.4337 3.24397C11.0217 2.92796 10.5697 2.65999 10.0817 2.45599L9.78172 0.336C9.74568 0.148012 9.58169 0 9.38171 0H6.18172C5.98173 0 5.81771 0.148012 5.78572 0.336L5.48572 2.45599C4.99773 2.65999 4.54571 2.92399 4.13373 3.24397L2.14174 2.43997C1.96174 2.37199 1.75372 2.43997 1.65375 2.61199L0.0537003 5.38398C-0.0463121 5.556 -0.00228714 5.772 0.1497 5.89597L1.83769 7.21998C1.8057 7.47599 1.7817 7.73598 1.7817 7.99998C1.7817 8.26398 1.8057 8.52397 1.83769 8.77998L0.1497 10.104C-0.00228714 10.224 -0.0463121 10.44 0.0537003 10.616L1.65371 13.388C1.75372 13.56 1.9617 13.632 2.1417 13.56L4.1337 12.756C4.54571 13.072 4.9977 13.34 5.48568 13.544L5.78568 15.664C5.81767 15.852 5.9817 16 6.18168 16H9.38167C9.58166 16 9.74568 15.852 9.77767 15.664L10.0777 13.544C10.5657 13.34 11.0177 13.076 11.4297 12.756L13.4217 13.56C13.6017 13.628 13.8097 13.56 13.9096 13.388L15.5097 10.616C15.6097 10.444 15.5657 10.228 15.4137 10.104ZM7.78169 10.8C6.2337 10.8 4.98168 9.54798 4.98168 7.99998C4.98168 6.45198 6.2337 5.20001 7.78169 5.20001C9.32969 5.20001 10.5817 6.45202 10.5817 8.00002C10.5817 9.54802 9.32969 10.8 7.78169 10.8Z"
        fill={props.color ? props.color : "#AFAEAE"}
      />
    </svg>
  );
}

function NavCommuncationIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.327 1.833h3.746c.919 0 1.66 0 2.262.042.62.042 1.169.131 1.688.346a5.093 5.093 0 012.756 2.756c.215.52.304 1.068.346 1.688.041.602.041 1.343.041 2.262v.072c0 .919 0 1.66-.04 2.262-.043.62-.132 1.169-.347 1.688a5.093 5.093 0 01-2.756 2.756c-.52.215-1.068.304-1.688.346-.603.041-1.343.041-2.262.041h-2.655c-.468 0-.561.005-.638.02a1.018 1.018 0 00-.477.239c-.058.052-.117.124-.398.498l-.022.03c-.617.822-1.109 1.477-1.511 1.951-.378.446-.806.894-1.316 1.105a3.056 3.056 0 01-3.795-1.265c-.282-.475-.355-1.09-.39-1.673-.038-.62-.038-1.44-.038-2.468V9.327c0-1.104 0-1.994.06-2.715.06-.743.188-1.395.496-1.998a5.093 5.093 0 012.225-2.225c.603-.308 1.255-.436 1.998-.497.72-.059 1.61-.059 2.715-.058zm-2.55 2.09c-.616.05-.97.144-1.238.28A3.056 3.056 0 004.204 5.54c-.137.268-.231.622-.281 1.239-.052.628-.053 1.435-.053 2.592v5.122c0 1.073 0 1.83.034 2.382.017.273.04.464.067.6.023.114.043.157.044.16.258.432.794.61 1.26.42.002-.002.044-.024.13-.102.104-.092.237-.232.414-.44.358-.421.812-1.027 1.456-1.885l.044-.059c.212-.283.399-.532.628-.737.405-.361.9-.608 1.431-.715.302-.061.613-.06.967-.06h2.692c.963 0 1.634-.001 2.16-.037.516-.035.817-.101 1.046-.196a3.056 3.056 0 001.654-1.654c.095-.23.16-.53.196-1.046.036-.526.036-1.197.036-2.16 0-.963 0-1.634-.036-2.16-.035-.516-.101-.817-.196-1.046a3.055 3.055 0 00-1.654-1.654c-.23-.095-.53-.16-1.046-.196-.526-.036-1.197-.037-2.16-.037H9.37c-1.157 0-1.964.001-2.592.053z"
        fill={props.color || "#2E3039"}
      />
    </svg>
  );
}

function SubNavWalletPushIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5807 11V7.66667C11.5807 5.62 10.4874 3.90667 8.58071 3.45333V3C8.58071 2.44667 8.12738 2 7.57405 2C7.02071 2 6.58071 2.44667 6.58071 3V3.45333C4.66738 3.90667 3.58071 5.61333 3.58071 7.66667V11L2.71405 11.86C2.29405 12.28 2.58738 13 3.18071 13H11.9607C12.554 13 12.854 12.28 12.434 11.86L11.5807 11ZM7.57405 15C8.30738 15 8.90738 14.4 8.90738 13.6667H6.24071C6.24071 14.4 6.83405 15 7.57405 15ZM4.09405 3.48667C4.37405 3.23333 4.38071 2.8 4.11405 2.53333C3.86071 2.28 3.44738 2.27333 3.18738 2.52C2.04738 3.56 1.26071 4.97333 1.00738 6.56C0.947381 6.96667 1.26071 7.33333 1.67405 7.33333C1.99405 7.33333 2.27405 7.1 2.32738 6.78C2.52738 5.48667 3.16738 4.33333 4.09405 3.48667ZM11.9807 2.52C11.714 2.27333 11.3007 2.28 11.0474 2.53333C10.7807 2.8 10.794 3.22667 11.0674 3.48C11.9874 4.32667 12.634 5.48 12.834 6.77333C12.8807 7.09333 13.1607 7.32667 13.4874 7.32667C13.894 7.32667 14.214 6.96 14.1474 6.55333C13.894 4.97333 13.114 3.56667 11.9807 2.52Z"
        fill="#AFAEAE"
      />
    </svg>
  );
}

function SubNavGeoPushIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1.33331C5.42 1.33331 3.33333 3.41998 3.33333 5.99998C3.33333 8.77998 6.27999 12.6133 7.49333 14.0733C7.75999 14.3933 8.24666 14.3933 8.51333 14.0733C9.72 12.6133 12.6667 8.77998 12.6667 5.99998C12.6667 3.41998 10.58 1.33331 8 1.33331ZM8 7.66665C7.07999 7.66665 6.33333 6.91998 6.33333 5.99998C6.33333 5.07998 7.07999 4.33331 8 4.33331C8.92 4.33331 9.66666 5.07998 9.66666 5.99998C9.66666 6.91998 8.92 7.66665 8 7.66665Z"
        fill="#AFAEAE"
      />
    </svg>
  );
}

function SubNavIBeaconIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C3.58887 0 0 3.60428 0 8.03514C0 12.1104 3.03687 15.4847 6.95652 16V15.2876C3.42261 14.7765 0.695652 11.7236 0.695652 8.03514C0.695652 3.98997 3.97217 0.698708 8 0.698708C12.0278 0.698708 15.3043 3.98997 15.3043 8.03514C15.3043 11.7236 12.5774 14.7765 9.04348 15.2876V16C12.9631 15.4847 16 12.1104 16 8.03514C16 3.60428 12.4111 0 8 0ZM8 1.39742C4.35583 1.39742 1.3913 4.37496 1.3913 8.03514C1.3913 11.3376 3.80765 14.0766 6.95652 14.5814V13.8759C4.1927 13.3791 2.08696 10.9519 2.08696 8.03514C2.08696 4.7603 4.73948 2.09612 8 2.09612C11.2605 2.09612 13.913 4.7603 13.913 8.03514C13.913 10.9519 11.8073 13.3788 9.04348 13.8759V14.5821C12.1923 14.0769 14.6087 11.3376 14.6087 8.03514C14.6087 4.37496 11.6442 1.39742 8 1.39742ZM8 2.79483C5.12313 2.79483 2.78261 5.14563 2.78261 8.03514C2.78261 10.5659 4.57809 12.6827 6.95652 13.1697V12.4498C4.96557 11.9747 3.47826 10.1781 3.47826 8.03514C3.47826 5.53097 5.50678 3.49354 8 3.49354C10.4932 3.49354 12.5217 5.53097 12.5217 8.03514C12.5217 10.1781 11.0344 11.9747 9.04348 12.4498V13.1697C11.4219 12.6827 13.2174 10.5659 13.2174 8.03514C13.2174 5.14563 10.8769 2.79483 8 2.79483ZM8 4.19225C5.89043 4.19225 4.17391 5.91631 4.17391 8.03514C4.17391 9.79029 5.35304 11.2713 6.95652 11.7293V10.9958C5.74261 10.5629 4.86957 9.40111 4.86957 8.03514C4.86957 6.3013 6.27409 4.89095 8 4.89095C9.72591 4.89095 11.1304 6.3013 11.1304 8.03514C11.1304 9.40111 10.2574 10.5629 9.04348 10.9958V11.7293C10.647 11.2713 11.8261 9.79029 11.8261 8.03514C11.8261 5.91631 10.1096 4.19225 8 4.19225ZM8 5.58966C6.65739 5.58966 5.56522 6.68698 5.56522 8.03514C5.56522 9.00809 6.1353 9.8474 6.95652 10.2411V9.42369C6.5367 9.10438 6.26087 8.60387 6.26087 8.03582C6.26087 7.07265 7.04104 6.28905 8 6.28905C8.95896 6.28905 9.73913 7.07265 9.73913 8.03582C9.73913 8.60422 9.4633 9.10473 9.04348 9.42369V10.2411C9.8647 9.8474 10.4348 9.00809 10.4348 8.03514C10.4348 6.68698 9.34261 5.58966 8 5.58966ZM8 6.98708C7.4237 6.98708 6.95652 7.45631 6.95652 8.03514C6.95652 8.61397 7.4237 9.0832 8 9.0832C8.5763 9.0832 9.04348 8.61397 9.04348 8.03514C9.04348 7.45631 8.5763 6.98708 8 6.98708Z"
        fill="#AFAEAE"
      />
    </svg>
  );
}

function AddIcon(props) {
  return (
    <svg
      width={props.width ? props.width : "24"}
      height={props.height ? props.height : "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="12"
        fill={props.background ? props.background : "#E8F3F2"}
      />
      <path
        d="M12.0001 12V6.28571M12.0001 12V17.7143M12.0001 12H17.7143M12.0001 12H6.28577"
        stroke={props.color ? props.color : "#1AC4D1"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function SearchIcon({ width, height, fill }) {
  return (
    <svg
      width={width ? width : 16}
      height={height ? height : 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.91666 7.83334C3.91666 5.67022 5.67021 3.91667 7.83332 3.91667C9.99644 3.91667 11.75 5.67022 11.75 7.83334C11.75 9.99645 9.99644 11.75 7.83332 11.75C5.67021 11.75 3.91666 9.99645 3.91666 7.83334ZM7.83332 2.41667C4.84178 2.41667 2.41666 4.8418 2.41666 7.83334C2.41666 10.8249 4.84178 13.25 7.83332 13.25C9.05864 13.25 10.1889 12.8431 11.0965 12.1572L12.6363 13.697C12.9292 13.9899 13.4041 13.9899 13.697 13.697C13.9899 13.4041 13.9899 12.9292 13.697 12.6363L12.1571 11.0965C12.8431 10.189 13.25 9.05866 13.25 7.83334C13.25 4.8418 10.8249 2.41667 7.83332 2.41667Z"
        fill={fill || ColorSchemeCode.neutral90}
      />
    </svg>
  );
}

function IconSearch({ width, height, fill }) {
  return (
    <svg
      width={width ? width : 16}
      height={height ? height : 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3761_24642)">
        <path
          d="M6.38141 12.8686C7.76285 12.8686 9.03674 12.4218 10.079 11.6774L14 15.5983C14.182 15.7803 14.4218 15.8714 14.6783 15.8714C15.216 15.8714 15.5965 15.4577 15.5965 14.9283C15.5965 14.6802 15.5138 14.4486 15.3317 14.2666L11.4357 10.3622C12.2546 9.28678 12.7427 7.95497 12.7427 6.50736C12.7427 3.00828 9.88045 0.146149 6.38141 0.146149C2.88234 0.146149 0.0202026 3.00828 0.0202026 6.50736C0.0202026 10.0064 2.88234 12.8686 6.38141 12.8686ZM6.38141 11.4954C3.65163 11.4954 1.39337 9.23714 1.39337 6.50736C1.39337 3.77758 3.65163 1.51931 6.38141 1.51931C9.11119 1.51931 11.3695 3.77758 11.3695 6.50736C11.3695 9.23714 9.11119 11.4954 6.38141 11.4954Z"
          fill={fill ? fill : ColorSchemeCode.neutral90}
        />
      </g>
      <defs>
        <clipPath id="clip0_3761_24642">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function FilterIcon() {
  return (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.565 12.566a.791.791 0 00.56 1.351h3.75a.791.791 0 100-1.583h-3.75a.792.792 0 00-.56.232zm4.341-.065H8.125M5.065 8.816a.792.792 0 00.56 1.351h8.75a.792.792 0 100-1.583h-8.75a.792.792 0 00-.56.232zM2.565 5.066a.792.792 0 00.56 1.351h13.75a.791.791 0 100-1.583H3.125a.792.792 0 00-.56.232z"
        fill="#84889B"
      />
    </svg>
  );
}

function QrCodeIcon({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.582" cy="17.582" r="17.582" fill="#E5E5E5" />
      <path
        d="M20.7076 26.9591H18.6238V24.8753H20.7076V26.9591ZM18.6238 19.6658H16.5401V24.8753H18.6238V19.6658ZM26.959 17.582H24.8752V21.7496H26.959V17.582ZM24.8752 15.4982H22.7914V17.582H24.8752V15.4982ZM12.3725 17.582H10.2887V19.6658H12.3725V17.582ZM10.2887 15.4982H8.2049V17.582H10.2887V15.4982ZM17.5819 10.2887H19.6657V8.20496H17.5819V10.2887ZM9.76774 9.7678V12.8935H12.8934V9.7678H9.76774ZM14.4563 14.4563H8.2049V8.20496H14.4563V14.4563ZM9.76774 22.2705V25.3962H12.8934V22.2705H9.76774ZM14.4563 26.9591H8.2049V20.7077H14.4563V26.9591ZM22.2705 9.7678V12.8935H25.3962V9.7678H22.2705ZM26.959 14.4563H20.7076V8.20496H26.959V14.4563ZM24.8752 24.8753V21.7496H20.7076V23.8334H22.7914V26.9591H26.959V24.8753H24.8752ZM22.7914 17.582H18.6238V19.6658H22.7914V17.582ZM18.6238 15.4982H12.3725V17.582H14.4563V19.6658H16.5401V17.582H18.6238V15.4982ZM19.6657 14.4563V12.3725H17.5819V10.2887H15.4982V14.4563H19.6657ZM12.112 10.5492H10.5492V12.1121H12.112V10.5492ZM12.112 23.052H10.5492V24.6148H12.112V23.052ZM24.6147 10.5492H23.0519V12.1121H24.6147V10.5492Z"
        fill="#373737"
      />
    </svg>
  );
}

function SmsIcon({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.582" cy="17.7459" r="17.582" fill="#FDDFC8" />
      <path
        d="M25.0836 8.36884H10.0803C9.04883 8.36884 8.21427 9.21277 8.21427 10.2442L8.2049 27.1229L11.9557 23.3721H25.0836C26.1151 23.3721 26.959 22.5282 26.959 21.4967V10.2442C26.959 9.21277 26.1151 8.36884 25.0836 8.36884ZM22.2705 19.6213H12.8934C12.3777 19.6213 11.9557 19.1993 11.9557 18.6836C11.9557 18.1679 12.3777 17.7459 12.8934 17.7459H22.2705C22.7862 17.7459 23.2082 18.1679 23.2082 18.6836C23.2082 19.1993 22.7862 19.6213 22.2705 19.6213ZM22.2705 16.8082H12.8934C12.3777 16.8082 11.9557 16.3862 11.9557 15.8705C11.9557 15.3547 12.3777 14.9328 12.8934 14.9328H22.2705C22.7862 14.9328 23.2082 15.3547 23.2082 15.8705C23.2082 16.3862 22.7862 16.8082 22.2705 16.8082ZM22.2705 13.9951H12.8934C12.3777 13.9951 11.9557 13.5731 11.9557 13.0574C11.9557 12.5416 12.3777 12.1197 12.8934 12.1197H22.2705C22.7862 12.1197 23.2082 12.5416 23.2082 13.0574C23.2082 13.5731 22.7862 13.9951 22.2705 13.9951Z"
        fill="#FC7B52"
      />
    </svg>
  );
}

function UrlIcon({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.9098" cy="17.582" r="17.582" fill="#F3DCFE" />
      <path
        d="M17.9484 23.0908C18.0038 23.1092 18.0407 23.1462 18.0591 23.2017C18.0776 23.2571 18.0684 23.3126 18.0314 23.3681L15.7335 25.6696C15.3644 26.0394 14.9399 26.3351 14.46 26.557C13.9801 26.7788 13.491 26.9082 12.9927 26.9452C12.4943 26.9822 11.996 26.9452 11.4977 26.8343C10.9993 26.7234 10.5471 26.4923 10.1411 26.141C9.64274 25.7528 9.25515 25.2814 8.97829 24.7268C8.70144 24.1722 8.55378 23.6176 8.53532 23.063C8.51687 22.5084 8.59992 21.9446 8.78449 21.3715C8.96906 20.7984 9.28283 20.2993 9.7258 19.8741L13.2972 16.297C13.8694 15.7239 14.5338 15.2987 15.2906 15.0214C16.0473 14.7441 16.8225 14.6702 17.6162 14.7996C18.3175 14.9105 18.8712 15.1139 19.2773 15.4096C19.6833 15.7054 20.0063 16.0474 20.2463 16.4356C20.2832 16.5281 20.2786 16.5974 20.2324 16.6436C20.1863 16.6898 20.1355 16.7314 20.0802 16.7684C20.0248 16.8054 19.9602 16.8608 19.8864 16.9348L19.6926 17.1289C19.508 17.3322 19.2865 17.4339 19.0281 17.4339C18.7697 17.4339 18.5344 17.3276 18.3221 17.115C18.1099 16.9024 17.8746 16.7407 17.6162 16.6297C17.3578 16.5188 17.0717 16.4726 16.7579 16.4911C16.4441 16.5096 16.1673 16.5558 15.9273 16.6297C15.6874 16.7037 15.4382 16.8701 15.1798 17.1289L11.0824 21.2329C10.8424 21.4732 10.6671 21.7505 10.5564 22.0648C10.4456 22.379 10.4087 22.6933 10.4456 23.0076C10.4825 23.3218 10.5748 23.6361 10.7225 23.9504C10.8701 24.2647 11.1101 24.5142 11.4423 24.6991C11.9037 25.0134 12.4021 25.1243 12.9373 25.0318C13.4726 24.9394 13.9248 24.7176 14.2939 24.3663L16.0658 22.6194C16.1027 22.5639 16.1581 22.5547 16.2319 22.5916C16.7856 22.832 17.3578 22.9983 17.9484 23.0908ZM25.6449 9.05953C26.1433 9.44775 26.5309 9.90991 26.8077 10.446C27.0846 10.9821 27.2415 11.5367 27.2784 12.1098C27.3153 12.6829 27.2322 13.256 27.0292 13.829C26.8262 14.4021 26.5032 14.9013 26.0602 15.3264L22.4888 18.9036C21.9166 19.4767 21.2522 19.8926 20.4954 20.1514C19.7387 20.4102 18.9543 20.4842 18.1422 20.3733C17.4408 20.2808 16.8963 20.0775 16.5087 19.7632C16.1211 19.4489 15.7981 19.1069 15.5397 18.7372C15.5028 18.6633 15.5121 18.5986 15.5674 18.5431L16.0658 18.044C16.2688 17.8591 16.4995 17.7667 16.7579 17.7667C17.0163 17.7667 17.2378 17.8591 17.4224 18.044C17.6438 18.2658 17.893 18.4322 18.1699 18.5431C18.4467 18.654 18.7328 18.7095 19.0281 18.7095C19.3234 18.7095 19.6095 18.654 19.8864 18.5431C20.1632 18.4322 20.4032 18.2658 20.6062 18.044L24.7036 13.9677C24.9436 13.7274 25.1189 13.4408 25.2297 13.1081C25.3404 12.7753 25.3773 12.4518 25.3404 12.1375C25.3035 11.8233 25.202 11.5182 25.0359 11.2225C24.8698 10.9267 24.6298 10.6771 24.316 10.4737C23.8731 10.178 23.384 10.067 22.8487 10.141C22.3135 10.2149 21.852 10.446 21.4644 10.8342L19.7203 12.5812C19.6649 12.6367 19.6095 12.6459 19.5541 12.6089C19.0373 12.3871 18.4652 12.2115 17.8376 12.0821C17.7638 12.0821 17.7269 12.0451 17.7269 11.9712C17.7269 11.8972 17.7361 11.851 17.7546 11.8325L20.0525 9.53094C20.4216 9.16121 20.8461 8.86543 21.326 8.64359C21.8059 8.42175 22.2858 8.2831 22.7657 8.22764C23.2455 8.17218 23.7439 8.2184 24.2607 8.36629C24.7775 8.51418 25.2389 8.74527 25.6449 9.05953Z"
        fill="#C652FC"
      />
    </svg>
  );
}

function ApiIcon({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.7459" cy="17.7459" r="17.582" fill="#FDF5DC" />
      <path
        d="M12.8417 18.4641C13.1313 18.1926 13.2761 17.8079 13.2761 17.3101C13.2761 16.8123 13.1313 16.4314 12.8417 16.1674C12.5521 15.8958 12.2195 15.76 11.8438 15.76C11.4681 15.76 11.1355 15.8958 10.8459 16.1674C10.5563 16.4389 10.4116 16.8236 10.4116 17.3214C10.4116 17.8192 10.5563 18.2039 10.8459 18.4755C11.1355 18.7395 11.4681 18.8715 11.8438 18.8715C12.2195 18.8715 12.5521 18.7357 12.8417 18.4641ZM9.23758 19.6408C8.65842 19.0374 8.36884 18.2643 8.36884 17.3214C8.36884 16.3786 8.65842 15.6054 9.23758 15.002C9.81674 14.391 10.5211 14.0855 11.3507 14.0855C12.1882 14.0855 12.8299 14.3835 13.2761 14.9794V14.1534H15.2836V20.4668H13.2761V19.5503C12.7908 20.2141 12.1412 20.546 11.3273 20.546C10.5133 20.546 9.81674 20.2443 9.23758 19.6408Z"
        fill="#FCC63B"
      />
      <path
        d="M21.3383 18.4755C21.6278 18.2039 21.7726 17.8192 21.7726 17.3214C21.7726 16.8236 21.6278 16.4389 21.3383 16.1674C21.0487 15.8958 20.716 15.76 20.3404 15.76C19.9647 15.76 19.6321 15.8958 19.3425 16.1674C19.0529 16.4314 18.9081 16.8123 18.9081 17.3101C18.9081 17.8079 19.0529 18.1926 19.3425 18.4641C19.6321 18.7357 19.9647 18.8715 20.3404 18.8715C20.716 18.8715 21.0487 18.7395 21.3383 18.4755ZM18.9081 14.9794C19.3542 14.3835 19.9921 14.0855 20.8217 14.0855C21.6591 14.0855 22.3674 14.391 22.9466 15.002C23.5258 15.6054 23.8153 16.3786 23.8153 17.3214C23.8153 18.2643 23.5258 19.0374 22.9466 19.6408C22.3674 20.2443 21.667 20.546 20.8452 20.546C20.0234 20.546 19.3777 20.2141 18.9081 19.5503V23.4764H16.9006V14.1534H18.9081V14.9794Z"
        fill="#FCC63B"
      />
      <path
        d="M26.7825 13.4406C26.5555 13.6594 26.2777 13.7687 25.949 13.7687C25.6202 13.7687 25.3424 13.6594 25.1154 13.4406C24.8885 13.2219 24.775 12.9541 24.775 12.6373C24.775 12.313 24.8885 12.0414 25.1154 11.8227C25.3424 11.6039 25.6202 11.4946 25.949 11.4946C26.2777 11.4946 26.5555 11.6039 26.7825 11.8227C27.0095 12.0414 27.1229 12.313 27.1229 12.6373C27.1229 12.9541 27.0095 13.2219 26.7825 13.4406ZM24.9511 20.4668V14.1534H26.9586V20.4668H24.9511Z"
        fill="#FCC63B"
      />
    </svg>
  );
}

function CampaignIcon({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 53 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <path
          d="M4.00027 20.52C3.98069 22.2211 5.02934 23.7522 6.62259 24.3487V17.0585C6.62259 16.9536 6.67499 16.7963 6.67499 16.6914C5.071 17.2831 4.00418 18.8102 4.00027 20.52Z"
          fill="#1AC4D1"
        />
        <path
          d="M18.3183 29.541H11.4477L14.0176 38.8766C14.3982 40.3013 15.6898 41.2916 17.1644 41.2892C18.2137 41.3017 19.2064 40.815 19.8393 39.9781C20.4782 39.1818 20.6753 38.1182 20.3637 37.146L18.3183 29.541Z"
          fill="#1AC4D1"
        />
        <path
          d="M6.67499 16.6388H6.72739V16.5864C6.72739 16.6388 6.72739 16.6388 6.67499 16.6388Z"
          fill="#1AC4D1"
        />
        <path
          d="M44.2797 15.9048H43.8601V25.3453H44.2797C46.8867 25.3453 48.9999 23.232 48.9999 20.6251C48.9999 18.0181 46.8866 15.9048 44.2797 15.9048Z"
          fill="#1AC4D1"
        />
        <path
          d="M8.19611 17.0584V24.5059C8.25282 26.4346 9.83312 27.9683 11.7625 27.9675H21.3079V13.8066H11.7625C9.87438 13.8066 8.19611 15.1703 8.19611 17.0584Z"
          fill="#1AC4D1"
        />
        <path
          opacity="0.9"
          d="M22.8812 28.1773L42.2867 35.9396V5.625L22.8812 13.3872V28.1773Z"
          fill="#1AC4D1"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="53"
          height="53"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

function EditIcon({ width, height, color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.5143 2.27197C13.9026 1.88397 14.429 1.66602 14.978 1.66602C15.5269 1.66602 16.0533 1.88397 16.4416 2.27197L17.7265 3.55693C18.1145 3.9452 18.3325 4.47165 18.3325 5.02056C18.3325 5.56947 18.1145 6.09591 17.7265 6.48419L7.53912 16.6716C7.29065 16.9201 6.98301 17.1023 6.64462 17.1981L2.79801 18.2985C2.64576 18.342 2.48463 18.344 2.33136 18.3043C2.17808 18.2645 2.03823 18.1845 1.92633 18.0724C1.81442 17.9604 1.73452 17.8205 1.69493 17.6671C1.65534 17.5138 1.6575 17.3527 1.70117 17.2005L2.80037 13.3551C2.89672 13.0162 3.07795 12.7075 3.3269 12.4582L13.5143 2.27078V2.27197ZM15.1874 3.52617C15.1599 3.49862 15.1273 3.47677 15.0913 3.46185C15.0554 3.44694 15.0169 3.43927 14.978 3.43927C14.939 3.43927 14.9005 3.44694 14.8646 3.46185C14.8286 3.47677 14.796 3.49862 14.7685 3.52617L13.2753 5.02056L14.978 6.72438L16.4723 5.22999C16.4999 5.20251 16.5217 5.16987 16.5367 5.13393C16.5516 5.09799 16.5592 5.05947 16.5592 5.02056C16.5592 4.98165 16.5516 4.94313 16.5367 4.90719C16.5217 4.87125 16.4999 4.83861 16.4723 4.81113L15.1874 3.52617V3.52617ZM13.7226 7.97858L12.0199 6.27476L4.58229 13.7136C4.54659 13.7491 4.52052 13.793 4.50656 13.8414L3.84633 16.1522L6.15714 15.492C6.2055 15.478 6.24949 15.452 6.28492 15.4162L13.7226 7.97858Z"
        fill="#3770FB"
      />
    </svg>
  );
}

function EditPencil() {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1009 9.82878C12.2571 9.67257 12.2571 9.41931 12.1009 9.2631C11.9447 9.10689 11.6914 9.10689 11.5352 9.2631L12.1009 9.82878ZM6.23187 14.5664C6.07566 14.7226 6.07566 14.9759 6.23187 15.1321C6.38808 15.2883 6.64135 15.2883 6.79756 15.1321L6.23187 14.5664ZM11.818 3.18198L11.5352 2.89914L11.818 3.18198ZM1.21142 19.8525H1.61142H1.21142ZM1.51142 20.1525V20.5525V20.1525ZM1.21142 13.9128L0.811416 13.9128L1.21142 13.9128ZM20.6569 7.07107L20.9397 7.35391L20.6569 7.07107ZM7.45111 20.1525V20.5525V20.1525ZM11.5352 9.2631L6.23187 14.5664L6.79756 15.1321L12.1009 9.82878L11.5352 9.2631ZM0.811416 13.9128L0.811415 19.8525H1.61142L1.61142 13.9128L0.811416 13.9128ZM7.45111 19.7525L1.51142 19.7525L1.51142 20.5525L7.45111 20.5525V19.7525ZM20.9397 5.37401L15.9899 0.424264L15.4243 0.98995L20.374 5.9397L20.9397 5.37401ZM7.94609 20.3475L18.4648 9.82878L17.8991 9.2631L7.3804 19.7818L7.94609 20.3475ZM18.4648 9.82878L20.9397 7.35391L20.374 6.78822L17.8991 9.2631L18.4648 9.82878ZM1.58213 13.9836L12.1009 3.46482L11.5352 2.89914L1.01644 13.4179L1.58213 13.9836ZM12.1009 3.46482L14.5757 0.989949L14.0101 0.424264L11.5352 2.89914L12.1009 3.46482ZM18.4648 9.2631L12.1009 2.89914L11.5352 3.46482L17.8991 9.82878L18.4648 9.2631ZM0.811415 19.8525C0.811416 20.2391 1.12481 20.5525 1.51142 20.5525L1.51142 19.7525C1.56664 19.7525 1.61141 19.7973 1.61142 19.8525H0.811415ZM1.61142 13.9128C1.61142 13.9394 1.60088 13.9648 1.58213 13.9836L1.01644 13.4179C0.885165 13.5491 0.811416 13.7272 0.811416 13.9128L1.61142 13.9128ZM20.374 5.9397C20.6083 6.17401 20.6083 6.55391 20.374 6.78822L20.9397 7.35391C21.4864 6.80717 21.4864 5.92074 20.9397 5.37401L20.374 5.9397ZM7.45111 20.5525C7.63676 20.5525 7.81481 20.4788 7.94609 20.3475L7.3804 19.7818C7.39916 19.7631 7.42459 19.7525 7.45111 19.7525V20.5525ZM15.9899 0.424264C15.4432 -0.12247 14.5568 -0.12247 14.0101 0.424264L14.5757 0.989949C14.8101 0.755635 15.1899 0.755635 15.4243 0.98995L15.9899 0.424264Z"
        fill="#4F4F4F"
      />
    </svg>
  );
}

function DoneCheck() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10.0801V11.0001C20.9988 13.1565 20.3005 15.2548 19.0093 16.9819C17.7182 18.7091 15.9033 19.9726 13.8354 20.584C11.7674 21.1954 9.55726 21.122 7.53447 20.3747C5.51168 19.6274 3.78465 18.2462 2.61096 16.4372C1.43727 14.6281 0.879791 12.4882 1.02168 10.3364C1.16356 8.18467 1.99721 6.13643 3.39828 4.49718C4.79935 2.85793 6.69279 1.71549 8.79619 1.24025C10.8996 0.765018 13.1003 0.982445 15.07 1.86011M21 3.00011L11 13.0101L8.00001 10.0101"
        stroke="#4F4F4F"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function LeftArrowIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 1.5L11.25 8L4.75 14.5"
        stroke="#4F4F4F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function CopyIcon(props) {
  return (
    <svg
     className="cp"
      width={props.width ? props.width : "20"}
      height={props.height ? props.height : "20"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.842 1.892a.758.758 0 01.54-.226h3.702a3.089 3.089 0 013.084 2.918 3.089 3.089 0 012.918 3.084v7.576a3.089 3.089 0 01-3.088 3.089H9.336a3.089 3.089 0 01-3.084-2.919 3.089 3.089 0 01-2.918-3.084V5.761c0-.199.078-.39.218-.532l3.29-3.337zM4.85 7.26v5.07c0 .87.704 1.574 1.573 1.574h4.662c.87 0 1.574-.705 1.574-1.574V4.755c0-.87-.705-1.574-1.574-1.574H8.928v3.322c0 .418-.34.757-.758.757H4.85zm2.564-3.789L5.17 5.745h2.242V3.471zm6.76 2.634v6.225a3.089 3.089 0 01-3.089 3.089H7.772a1.574 1.574 0 001.564 1.398h4.662c.869 0 1.573-.704 1.573-1.573V7.668c0-.81-.612-1.477-1.398-1.563z"
        fill="#2E3039"
      />
    </svg>
  );
}

function DownloadIcon(props) {
  return (
    <svg
      className="cp"
      width={props.width ? props.width : "20"}
      height={props.height ? props.height : "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0001 1.66602C10.4603 1.66602 10.8334 2.03911 10.8334 2.49935L10.8334 12.026L12.8724 9.98702C13.1978 9.66158 13.7254 9.66158 14.0509 9.98702C14.3763 10.3125 14.3763 10.8401 14.0509 11.1655L10.5893 14.6271C10.4331 14.7833 10.2211 14.8711 10.0001 14.8711C9.77907 14.8711 9.56711 14.7833 9.41083 14.6271L5.94929 11.1655C5.62385 10.8401 5.62385 10.3125 5.94929 9.98702C6.27472 9.66158 6.80236 9.66158 7.1278 9.98702L9.16675 12.026L9.16675 2.49935C9.16675 2.03911 9.53985 1.66602 10.0001 1.66602ZM2.50008 11.4737C2.96032 11.4737 3.33341 11.8468 3.33341 12.307V15.1917C3.33341 16.0059 3.99351 16.666 4.80777 16.666H15.1924C16.0067 16.666 16.6667 16.0059 16.6667 15.1917V12.307C16.6667 11.8468 17.0398 11.4737 17.5001 11.4737C17.9603 11.4737 18.3334 11.8468 18.3334 12.307V15.1917C18.3334 16.9264 16.9271 18.3327 15.1924 18.3327H4.80777C3.07303 18.3327 1.66675 16.9264 1.66675 15.1917V12.307C1.66675 11.8468 2.03984 11.4737 2.50008 11.4737Z"
        fill="#41536C"
      />
    </svg>
  );
}

function ShareIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10.72C11.4933 10.72 11.04 10.92 10.6933 11.2333L5.94 8.46668C5.97333 8.31334 6 8.16001 6 8.00001C6 7.84001 5.97333 7.68668 5.94 7.53334L10.64 4.79334C11 5.12668 11.4733 5.33334 12 5.33334C13.1067 5.33334 14 4.44001 14 3.33334C14 2.22668 13.1067 1.33334 12 1.33334C10.8933 1.33334 10 2.22668 10 3.33334C10 3.49334 10.0267 3.64668 10.06 3.80001L5.36 6.54001C5 6.20668 4.52667 6.00001 4 6.00001C2.89333 6.00001 2 6.89334 2 8.00001C2 9.10668 2.89333 10 4 10C4.52667 10 5 9.79334 5.36 9.46001L10.1067 12.2333C10.0733 12.3733 10.0533 12.52 10.0533 12.6667C10.0533 13.74 10.9267 14.6133 12 14.6133C13.0733 14.6133 13.9467 13.74 13.9467 12.6667C13.9467 11.5933 13.0733 10.72 12 10.72Z"
        fill="#4F4F4F"
      />
    </svg>
  );
}

function ArrowOpen() {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.125 2.25L28.875 12L19.125 21.75"
        stroke="#808080"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.125 2.25L16.875 12L7.125 21.75"
        stroke="#808080"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function ArrowClose() {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.875 21.75L7.125 12L16.875 2.25"
        stroke="#808080"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.875 21.75L19.125 12L28.875 2.25"
        stroke="#808080"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function CloseIcon({ color, width, height }) {
  return (
    <svg
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3 5.7107C17.91 5.3207 17.28 5.3207 16.89 5.7107L12 10.5907L7.10997 5.7007C6.71997 5.3107 6.08997 5.3107 5.69997 5.7007C5.30997 6.0907 5.30997 6.7207 5.69997 7.1107L10.59 12.0007L5.69997 16.8907C5.30997 17.2807 5.30997 17.9107 5.69997 18.3007C6.08997 18.6907 6.71997 18.6907 7.10997 18.3007L12 13.4107L16.89 18.3007C17.28 18.6907 17.91 18.6907 18.3 18.3007C18.69 17.9107 18.69 17.2807 18.3 16.8907L13.41 12.0007L18.3 7.1107C18.68 6.7307 18.68 6.0907 18.3 5.7107V5.7107Z"
        fill={color ? color : "#262626"}
      />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="currentColor"
      className="bi bi-lock-fill"
      viewBox="0 0 16 16"
    >
      <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
    </svg>
  );
}

function RightIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12.1641" r="12" fill="#1AC4D1" />
      <path
        d="M10 14.9649L7.66666 12.6316C7.40666 12.3716 6.99333 12.3716 6.73333 12.6316C6.47333 12.8916 6.47333 13.3049 6.73333 13.5649L9.52666 16.3583C9.78666 16.6183 10.2067 16.6183 10.4667 16.3583L17.5333 9.29826C17.7933 9.03826 17.7933 8.62492 17.5333 8.36492C17.2733 8.10492 16.86 8.10492 16.6 8.36492L10 14.9649Z"
        fill="#F6F6F7"
      />
    </svg>
  );
}

function BarcodeIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.598 11.9065H2.73537C2.49049 11.9065 2.29199 11.708 2.29199 11.4631V6.14259C2.29199 5.89772 2.49049 5.69922 2.73537 5.69922H13.598C13.8429 5.69922 14.0414 5.89772 14.0414 6.14259V11.4631C14.0414 11.708 13.8429 11.9065 13.598 11.9065Z"
        fill="#1AC4D1"
      />
      <path
        d="M4.18157 13.1037H1.26288C0.934004 13.1037 0.666504 12.8362 0.666504 12.5073V9.57966C0.666504 9.42991 0.787879 9.30859 0.937566 9.30859C1.08725 9.30859 1.20863 9.42997 1.20863 9.57966V12.5073C1.20863 12.5372 1.23294 12.5615 1.26282 12.5615H4.1815C4.33125 12.5615 4.45257 12.6829 4.45257 12.8326C4.45257 12.9823 4.33132 13.1037 4.18157 13.1037V13.1037Z"
        fill="#1AC4D1"
      />
      <path
        d="M0.937566 8.29519C0.787816 8.29519 0.666504 8.17381 0.666504 8.02413V5.09638C0.666504 4.7675 0.934004 4.5 1.26288 4.5H4.18157C4.33132 4.5 4.45263 4.62137 4.45263 4.77106C4.45263 4.92075 4.33125 5.04213 4.18157 5.04213H1.26288C1.233 5.04213 1.20869 5.06644 1.20869 5.09631V8.024C1.20869 8.17381 1.08732 8.29519 0.937566 8.29519Z"
        fill="#1AC4D1"
      />
      <path
        d="M15.0698 13.1037H12.1422C11.9924 13.1037 11.8711 12.9823 11.8711 12.8326C11.8711 12.6829 11.9925 12.5615 12.1422 12.5615H15.0698C15.0997 12.5615 15.124 12.5372 15.124 12.5073V9.57966C15.124 9.42991 15.2454 9.30859 15.3951 9.30859C15.5448 9.30859 15.6662 9.42997 15.6662 9.57966V12.5073C15.6662 12.8362 15.3987 13.1037 15.0698 13.1037V13.1037Z"
        fill="#1AC4D1"
      />
      <path
        d="M15.3951 8.29512C15.2453 8.29512 15.124 8.17375 15.124 8.02406V5.09631C15.124 5.06644 15.0997 5.04212 15.0698 5.04212H12.1422C11.9924 5.04212 11.8711 4.92075 11.8711 4.77106C11.8711 4.62137 11.9925 4.5 12.1422 4.5H15.0698C15.3987 4.5 15.6662 4.7675 15.6662 5.09637V8.02406C15.6662 8.17375 15.5448 8.29512 15.3951 8.29512V8.29512Z"
        fill="#1AC4D1"
      />
      <path
        d="M3.40039 10.7435V6.86403C3.40039 6.83341 3.4252 6.80859 3.45583 6.80859H3.9612C3.99183 6.80859 4.01664 6.83341 4.01664 6.86403V10.7435C4.01664 10.7742 3.99183 10.799 3.9612 10.799H3.45583C3.4252 10.799 3.40039 10.7742 3.40039 10.7435Z"
        fill="white"
      />
      <path
        d="M4.55566 10.7435V6.86403C4.55566 6.83341 4.58048 6.80859 4.6111 6.80859H4.88723C4.91785 6.80859 4.94266 6.83341 4.94266 6.86403V10.7435C4.94266 10.7742 4.91785 10.799 4.88723 10.799H4.6111C4.58048 10.799 4.55566 10.7742 4.55566 10.7435Z"
        fill="white"
      />
      <path
        d="M5.32422 10.7435V6.86403C5.32422 6.83341 5.34903 6.80859 5.37966 6.80859H5.86759C5.89822 6.80859 5.92303 6.83341 5.92303 6.86403V10.7435C5.92303 10.7742 5.89822 10.799 5.86759 10.799H5.37966C5.34903 10.799 5.32422 10.7742 5.32422 10.7435Z"
        fill="white"
      />
      <path
        d="M6.28906 10.7435V6.86403C6.28906 6.83341 6.31388 6.80859 6.3445 6.80859H6.62062C6.65125 6.80859 6.67606 6.83341 6.67606 6.86403V10.7435C6.67606 10.7742 6.65125 10.799 6.62062 10.799H6.3445C6.31388 10.799 6.28906 10.7742 6.28906 10.7435Z"
        fill="white"
      />
      <path
        d="M7.05762 10.7435V6.86403C7.05762 6.83341 7.08243 6.80859 7.11305 6.80859H7.60099C7.63162 6.80859 7.65643 6.83341 7.65643 6.86403V10.7435C7.65643 10.7742 7.63162 10.799 7.60099 10.799H7.11305C7.08243 10.799 7.05762 10.7742 7.05762 10.7435Z"
        fill="white"
      />
      <path
        d="M9.38944 6.86403V10.7435C9.38944 10.7742 9.36463 10.799 9.334 10.799H9.05788C9.02725 10.799 9.00244 10.7742 9.00244 10.7435V6.86403C9.00244 6.83341 9.02725 6.80859 9.05788 6.80859H9.334C9.36463 6.80859 9.38944 6.83341 9.38944 6.86403Z"
        fill="white"
      />
      <path
        d="M8.62079 6.86403V10.7435C8.62079 10.7742 8.59597 10.799 8.56535 10.799H8.07741C8.04678 10.799 8.02197 10.7742 8.02197 10.7435V6.86403C8.02197 6.83341 8.04678 6.80859 8.07741 6.80859H8.56535C8.59597 6.80859 8.62079 6.83341 8.62079 6.86403Z"
        fill="white"
      />
      <path
        d="M10.1398 6.86403V10.7435C10.1398 10.7742 10.115 10.799 10.0844 10.799H9.86696C9.83634 10.799 9.81152 10.7742 9.81152 10.7435V6.86403C9.81152 6.83341 9.83634 6.80859 9.86696 6.80859H10.0844C10.115 6.80859 10.1398 6.83341 10.1398 6.86403Z"
        fill="white"
      />
      <path
        d="M11.0113 6.86403V10.7435C11.0113 10.7742 10.9865 10.799 10.9559 10.799H10.531C10.5004 10.799 10.4756 10.7742 10.4756 10.7435V6.86403C10.4756 6.83341 10.5004 6.80859 10.531 6.80859H10.9559C10.9865 6.80859 11.0113 6.83341 11.0113 6.86403Z"
        fill="white"
      />
      <path
        d="M12.0469 6.86403V10.7435C12.0469 10.7742 12.0221 10.799 11.9915 10.799H11.344C11.3134 10.799 11.2886 10.7742 11.2886 10.7435V6.86403C11.2886 6.83341 11.3134 6.80859 11.344 6.80859H11.9915C12.0221 6.80859 12.0469 6.83341 12.0469 6.86403Z"
        fill="white"
      />
      <path
        d="M12.9331 6.86403V10.7435C12.9331 10.7742 12.9083 10.799 12.8776 10.799H12.409C12.3783 10.799 12.3535 10.7742 12.3535 10.7435V6.86403C12.3535 6.83341 12.3783 6.80859 12.409 6.80859H12.8776C12.9083 6.80859 12.9331 6.83341 12.9331 6.86403Z"
        fill="white"
      />
      <path
        d="M13.598 12.0315H2.73537C2.42199 12.0315 2.16699 11.7765 2.16699 11.4631V6.14259C2.16699 5.82922 2.42199 5.57422 2.73537 5.57422H13.5981C13.9114 5.57422 14.1664 5.82922 14.1664 6.14259V11.4631C14.1664 11.7765 13.9114 12.0315 13.598 12.0315ZM2.73537 5.82422C2.5598 5.82422 2.41699 5.96703 2.41699 6.14259V11.4631C2.41699 11.6387 2.5598 11.7815 2.73537 11.7815H13.5981C13.7736 11.7815 13.9164 11.6387 13.9164 11.4631V6.14259C13.9164 5.96703 13.7736 5.82422 13.5981 5.82422H2.73537Z"
        fill="#1AC4D1"
      />
    </svg>
  );
}

function CameraIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10.5C9.10457 10.5 10 9.60457 10 8.5C10 7.39543 9.10457 6.5 8 6.5C6.89543 6.5 6 7.39543 6 8.5C6 9.60457 6.89543 10.5 8 10.5Z"
        fill="#AFAEAE"
      />
      <path
        d="M13.3335 3.16536H11.2202L10.3935 2.26536C10.1468 1.99203 9.78683 1.83203 9.4135 1.83203H6.58683C6.2135 1.83203 5.8535 1.99203 5.60016 2.26536L4.78016 3.16536H2.66683C1.9335 3.16536 1.3335 3.76536 1.3335 4.4987V12.4987C1.3335 13.232 1.9335 13.832 2.66683 13.832H13.3335C14.0668 13.832 14.6668 13.232 14.6668 12.4987V4.4987C14.6668 3.76536 14.0668 3.16536 13.3335 3.16536ZM8.00016 11.832C6.16016 11.832 4.66683 10.3387 4.66683 8.4987C4.66683 6.6587 6.16016 5.16536 8.00016 5.16536C9.84016 5.16536 11.3335 6.6587 11.3335 8.4987C11.3335 10.3387 9.84016 11.832 8.00016 11.832Z"
        fill="#AFAEAE"
      />
    </svg>
  );
}

function CodeInputIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M6.40751 0.5C4.37174 0.5 2.80973 2.33887 3.15885 4.36108C3.20304 4.61694 3.44633 4.78735 3.70048 4.74329C3.9556 4.69922 4.12675 4.45679 4.08268 4.20166C3.83305 2.75513 4.94889 1.4375 6.40751 1.4375C7.86173 1.4375 8.97965 2.7489 8.73343 4.19592C8.68998 4.45117 8.86173 4.69324 9.11686 4.73669C9.37211 4.78027 9.61417 4.6084 9.65763 4.35315C10.0003 2.33911 8.44571 0.5 6.40751 0.5Z"
          fill="#AFAEAE"
        />
        <path
          d="M11.396 8.01987C11.0421 7.32553 10.202 7.0582 9.52099 7.39487C9.19994 6.76498 8.46654 6.47348 7.80724 6.70236V3.832C7.80724 3.06686 7.19237 2.42758 6.43639 2.40683C5.64428 2.38437 4.98791 3.01877 4.98791 3.81259V11.0339L4.43725 10.4572C3.90868 9.9039 3.02367 9.86496 2.46422 10.3707C1.87389 10.9043 1.84447 11.8128 2.38805 12.3839L5.55285 15.7595C5.99425 16.2301 6.61742 16.5001 7.26269 16.5001H11.0797C12.3721 16.5001 13.4235 15.4487 13.4235 14.1563V9.28134C13.4235 8.23971 12.3247 7.56064 11.396 8.01987Z"
          fill="#AFAEAE"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function CustomerInfoIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0002 8.4987C11.9202 8.4987 12.6602 7.75203 12.6602 6.83203C12.6602 5.91203 11.9202 5.16536 11.0002 5.16536C10.0802 5.16536 9.3335 5.91203 9.3335 6.83203C9.3335 7.75203 10.0802 8.4987 11.0002 8.4987ZM6.00016 7.83203C7.10683 7.83203 7.9935 6.9387 7.9935 5.83203C7.9935 4.72536 7.10683 3.83203 6.00016 3.83203C4.8935 3.83203 4.00016 4.72536 4.00016 5.83203C4.00016 6.9387 4.8935 7.83203 6.00016 7.83203ZM11.0002 9.83203C9.78016 9.83203 7.3335 10.4454 7.3335 11.6654V12.4987C7.3335 12.8654 7.6335 13.1654 8.00016 13.1654H14.0002C14.3668 13.1654 14.6668 12.8654 14.6668 12.4987V11.6654C14.6668 10.4454 12.2202 9.83203 11.0002 9.83203ZM6.00016 9.16536C4.44683 9.16536 1.3335 9.94536 1.3335 11.4987V12.4987C1.3335 12.8654 1.6335 13.1654 2.00016 13.1654H6.00016V11.6654C6.00016 11.0987 6.22016 10.1054 7.58016 9.35203C7.00016 9.23203 6.44016 9.16536 6.00016 9.16536Z"
        fill="#AFAEAE"
      />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.631 2.198a1.818 1.818 0 012.719.17L8.22 4.77c.342.44.463 1.015.327 1.556l-.57 2.282a.706.706 0 00.186.67l2.56 2.559a.706.706 0 00.67.185l2.28-.57a1.817 1.817 0 011.557.328l2.402 1.87c.863.67.942 1.947.17 2.719l-1.078 1.077c-.77.77-1.923 1.11-2.997.731a19.41 19.41 0 01-7.301-4.604 19.41 19.41 0 01-4.604-7.3c-.377-1.074-.039-2.227.732-2.998L3.63 2.198z"
        fill="#5F6368"
      />
    </svg>
  );
}

function EmailIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.76752 3.33399L15.2326 3.33398C16.9451 3.33398 18.3334 4.73858 18.3334 6.47124V13.5301C18.3334 15.2627 16.9451 16.6673 15.2326 16.6673L4.76752 16.6673C3.05501 16.6673 1.66675 15.2627 1.66675 13.5301L1.66675 6.47125C1.66675 4.73859 3.05501 3.334 4.76752 3.33399ZM15.2326 4.90261L4.76752 4.90262C4.18846 4.90262 3.68355 5.22381 3.41732 5.69971L9.12828 9.62885C9.65442 9.99084 10.3457 9.99084 10.8719 9.62885L16.5828 5.69971C16.3166 5.2238 15.8117 4.90261 15.2326 4.90261ZM16.783 7.45892L11.7437 10.926C10.6914 11.65 9.30876 11.65 8.25648 10.926L3.21714 7.45892L3.21714 13.5301C3.21714 14.3964 3.91127 15.0987 4.76752 15.0987L15.2326 15.0987C16.0889 15.0987 16.783 14.3964 16.783 13.5301V7.45892Z"
        fill="#41536C"
      />
    </svg>
  );
}

function WalletlyShadedLogoIcon() {
  return (
    <svg
      width="114"
      height="114"
      viewBox="0 0 114 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8" filter="url(#filter0_f)">
        <circle
          cx="56.9545"
          cy="56.9545"
          r="33.9545"
          fill="url(#paint0_linear)"
        />
      </g>
      <circle cx="57" cy="49" r="36" fill="url(#paint1_linear)" />
      <path
        d="M36.5925 38.9853C33.154 42.571 33.5825 48.1213 35.3063 50.429L35.4097 50.5399L35.4808 50.6011C35.7472 50.8186 38.4222 51.2132 40.5223 49.5067L49.7542 39.7223L49.0487 38.9861C47.3282 37.192 45.075 36.2954 42.8202 36.2954C40.567 36.2954 38.3122 37.192 36.5917 38.9861L36.5925 38.9853Z"
        fill="white"
      />
      <path
        d="M64.2194 39.0546L63.7339 39.5591L72.4116 48.8688C70.0939 46.9878 67.9441 47.9763 67.9441 47.9763C67.3899 48.1624 66.6951 48.5942 66.2766 49.0309L56.8768 58.8161L60.3905 62.4722C61.9075 64.0487 64.2509 64.2348 65.9672 63.0388C66.2029 62.875 66.4271 62.6881 66.6356 62.4722L68.7233 60.3009L76.6905 52.0194C77.5362 51.1387 78.1978 50.0983 78.6368 48.9589C79.9147 45.6536 79.267 41.7329 76.6905 39.0546C74.9683 37.2654 72.7118 36.3696 70.4554 36.3696C68.1989 36.3696 65.9416 37.2654 64.2194 39.0546V39.0546Z"
        fill="white"
      />
      <path
        d="M53.9918 36.2374L40.9426 50.0625C39.6275 51.1312 38.1816 51.3553 37.1998 51.3553C37.0484 51.3553 36.897 51.3496 36.749 51.3371L47.0735 62.2109C47.4322 62.5904 47.8646 62.8928 48.3442 63.0994C48.8238 63.3061 49.3405 63.4127 49.8627 63.4128C50.9239 63.4128 51.9223 62.981 52.675 62.1969L65.7962 48.5323C66.2833 48.0218 66.887 47.6372 67.5555 47.4115C68.2479 47.1807 68.9005 47.0624 69.4969 47.0624C69.5887 47.0624 69.6788 47.0657 69.769 47.0707L59.7009 36.2267C59.3349 35.8397 58.8939 35.5314 58.4049 35.3205C57.9158 35.1096 57.3889 35.0005 56.8563 35C55.7735 35 54.7553 35.4409 53.991 36.2366L53.9918 36.2374Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f"
          x="0.363636"
          y="0.363636"
          width="113.182"
          height="113.182"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="11.3182"
            result="effect1_foregroundBlur"
          />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="93.1209"
          y1="37.8198"
          x2="23"
          y2="88.6532"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2FD8E5" />
          <stop offset="1" stop-color="#FF6CD6" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="95.345"
          y1="28.7126"
          x2="21"
          y2="82.6082"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2FD8E5" />
          <stop offset="1" stop-color="#FF6CD6" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function NextarrowIcon() {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6667 0.666748C15.4827 0.666748 15.3333 0.816081 15.3333 1.00008V7.33342H4.66667V4.33341C4.66667 4.20408 4.592 4.08608 4.47467 4.03141C4.35867 3.97741 4.22 3.99475 4.12 4.07675L0.12 7.41008C0.044 7.47341 0 7.56741 0 7.66608C0 7.76475 0.044 7.85875 0.12 7.92208L4.12 11.2554C4.18133 11.3061 4.25733 11.3327 4.33333 11.3327C4.38133 11.3327 4.43 11.3221 4.47467 11.3014C4.592 11.2467 4.66667 11.1287 4.66667 10.9994V7.99941H15.6667C15.8507 7.99941 16 7.85008 16 7.66608V0.999415C16 0.816081 15.8507 0.666748 15.6667 0.666748Z"
        fill="color(neutral80)"
      />
    </svg>
  );
}

function SteparrowIcon() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00001 0.333252L4.17751 1.15575L7.43251 4.41658H0.333344V5.58325H7.43251L4.17751 8.84408L5.00001 9.66658L9.66668 4.99992L5.00001 0.333252Z"
        fill="color(neutral80)"
      />
    </svg>
  );
}

function ColorselectIcon() {
  return (
    <svg
      width="20"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M7.88623 16.947C7.68923 16.9474 7.49409 16.9089 7.31201 16.8337C7.12993 16.7585 6.96449 16.6481 6.82518 16.5088L0.458916 10.1411C0.315482 10.0027 0.201036 9.83719 0.122256 9.65415C0.0434749 9.4711 0.00193725 9.2742 6.61615e-05 9.07493C-0.00180493 8.87567 0.036028 8.67802 0.111358 8.49353C0.186687 8.30904 0.298005 8.1414 0.438815 8.00039C0.579626 7.85938 0.747109 7.74782 0.931493 7.67223C1.11588 7.59664 1.31347 7.55853 1.51274 7.56012C1.71201 7.56171 1.90897 7.60297 2.09212 7.68149C2.27528 7.76001 2.44096 7.87422 2.5795 8.01746L7.88473 13.3227L17.4371 3.77328C17.7185 3.49168 18.1003 3.33339 18.4984 3.33325C18.8965 3.33311 19.2784 3.49112 19.56 3.77253C19.8416 4.05394 19.9999 4.43569 20 4.8338C20.0001 5.23191 19.8421 5.61377 19.5607 5.89537L8.94727 16.5088C8.80797 16.6481 8.64253 16.7585 8.46045 16.8337C8.27837 16.9089 8.08323 16.9474 7.88623 16.947Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function ShopifyIcon() {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width={40} height={40} fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#image0"
            transform="translate(-1.80354 -0.359699) scale(0.00587906)"
          />
        </pattern>
        <image
          id="image0"
          width={810}
          height={456}
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}

function PalletteIcon() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.71 3.63L15.37 1.29C14.98 0.899998 14.35 0.899998 13.96 1.29L10.84 4.41L9.61 3.2C9.22 2.81 8.59 2.82 8.2 3.2C7.81 3.59 7.81 4.22 8.2 4.61L8.92 5.33L0.15 14.1C0.0500001 14.2 0 14.32 0 14.46V18.5C0 18.78 0.22 19 0.5 19H4.54C4.67 19 4.8 18.95 4.89 18.85L13.66 10.08L14.38 10.8C14.77 11.19 15.4 11.19 15.79 10.8C16.18 10.41 16.18 9.78 15.79 9.39L14.57 8.17L17.69 5.05C18.1 4.65 18.1 4.02 17.71 3.63ZM3.92 17L2 15.08L10.06 7.02L11.98 8.94L3.92 17Z"
        fill="#323232"
      />
    </svg>
  );
}

function SelectIconDropDown() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="black" fill-opacity="0.2" />
      <path
        d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
        fill="white"
      />
    </svg>
  );
}

function InviteIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#FDF2F3" />
      <path
        d="M17.332 6.66675H6.66536C5.93203 6.66675 5.3387 7.26675 5.3387 8.00008L5.33203 16.0001C5.33203 16.7334 5.93203 17.3334 6.66536 17.3334H17.332C18.0654 17.3334 18.6654 16.7334 18.6654 16.0001V8.00008C18.6654 7.26675 18.0654 6.66675 17.332 6.66675ZM17.332 9.33341L11.9987 12.6667L6.66536 9.33341V8.00008L11.9987 11.3334L17.332 8.00008V9.33341Z"
        fill="#E75861"
      />
    </svg>
  );
}

function ImpressionIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#FCF3F8" />
      <path
        d="M12.0013 7C8.66797 7 5.8213 9.07333 4.66797 12C5.8213 14.9267 8.66797 17 12.0013 17C15.3346 17 18.1813 14.9267 19.3346 12C18.1813 9.07333 15.3346 7 12.0013 7ZM12.0013 15.3333C10.1613 15.3333 8.66797 13.84 8.66797 12C8.66797 10.16 10.1613 8.66667 12.0013 8.66667C13.8413 8.66667 15.3346 10.16 15.3346 12C15.3346 13.84 13.8413 15.3333 12.0013 15.3333ZM12.0013 10C10.8946 10 10.0013 10.8933 10.0013 12C10.0013 13.1067 10.8946 14 12.0013 14C13.108 14 14.0013 13.1067 14.0013 12C14.0013 10.8933 13.108 10 12.0013 10Z"
        fill="#DD5EA0"
      />
    </svg>
  );
}

function ParticipantIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#F9F5FB" />
      <path
        d="M14.9987 11.9999C15.9187 11.9999 16.6587 11.2533 16.6587 10.3333C16.6587 9.41325 15.9187 8.66659 14.9987 8.66659C14.0787 8.66659 13.332 9.41325 13.332 10.3333C13.332 11.2533 14.0787 11.9999 14.9987 11.9999ZM9.9987 11.3333C11.1054 11.3333 11.992 10.4399 11.992 9.33325C11.992 8.22659 11.1054 7.33325 9.9987 7.33325C8.89203 7.33325 7.9987 8.22659 7.9987 9.33325C7.9987 10.4399 8.89203 11.3333 9.9987 11.3333ZM14.9987 13.3333C13.7787 13.3333 11.332 13.9466 11.332 15.1666V16.6666H18.6654V15.1666C18.6654 13.9466 16.2187 13.3333 14.9987 13.3333ZM9.9987 12.6666C8.44536 12.6666 5.33203 13.4466 5.33203 14.9999V16.6666H9.9987V15.1666C9.9987 14.5999 10.2187 13.6066 11.5787 12.8533C10.9987 12.7333 10.4387 12.6666 9.9987 12.6666Z"
        fill="#AD77D2"
      />
    </svg>
  );
}

function ReferralIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#F2F6FD" />
      <path
        d="M12.748 5.37323L9.05464 9.06656C8.80797 9.31323 8.66797 9.65323 8.66797 10.0066V16.6666C8.66797 17.3999 9.26797 17.9999 10.0013 17.9999H16.0013C16.5346 17.9999 17.0146 17.6799 17.228 17.1932L19.4013 12.1199C19.9613 10.7999 18.9946 9.33323 17.5613 9.33323H13.7946L14.428 6.2799C14.4946 5.94656 14.3946 5.60656 14.1546 5.36656C13.7613 4.9799 13.1346 4.9799 12.748 5.37323ZM6.0013 17.9999C6.73464 17.9999 7.33464 17.3999 7.33464 16.6666V11.3332C7.33464 10.5999 6.73464 9.9999 6.0013 9.9999C5.26797 9.9999 4.66797 10.5999 4.66797 11.3332V16.6666C4.66797 17.3999 5.26797 17.9999 6.0013 17.9999Z"
        fill="#5890E7"
      />
    </svg>
  );
}

function WalletlyHeaderLogoIcon() {
  return (
    <svg
      width="100"
      height="32"
      viewBox="0 0 100 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.4995 11.2903C6.04125 12.811 6.22296 15.1648 6.95402 16.1435L6.99787 16.1906L7.02804 16.2165C7.14099 16.3088 8.27546 16.4761 9.16612 15.7524L13.0813 11.6029L12.7821 11.2907C12.0525 10.5298 11.0969 10.1495 10.1406 10.1495C9.18507 10.1495 8.2288 10.5298 7.49915 11.2907L7.4995 11.2903Z"
        fill="#4F4F4F"
      />
      <path
        d="M19.2159 11.3196L19.01 11.5336L22.6902 15.4818C21.7073 14.6841 20.7955 15.1033 20.7955 15.1033C20.5605 15.1822 20.2658 15.3653 20.0883 15.5506L16.1019 19.7005L17.5921 21.251C18.2355 21.9196 19.2293 21.9985 19.9572 21.4913C20.0571 21.4218 20.1522 21.3425 20.2406 21.251L21.126 20.3301L24.5048 16.818C24.8635 16.4445 25.1441 16.0033 25.3303 15.52C25.8722 14.1183 25.5976 12.4555 24.5048 11.3196C23.7745 10.5609 22.8175 10.181 21.8606 10.181C20.9036 10.181 19.9463 10.5609 19.2159 11.3196V11.3196Z"
        fill="#4F4F4F"
      />
      <path
        d="M14.8784 10.1248L9.34432 15.9879C8.78656 16.4412 8.17337 16.5362 7.75698 16.5362C7.69278 16.5362 7.62859 16.5338 7.5658 16.5285L11.9444 21.14C12.0965 21.301 12.2799 21.4292 12.4833 21.5168C12.6867 21.6045 12.9058 21.6497 13.1273 21.6497C13.5773 21.6497 14.0008 21.4666 14.32 21.1341L19.8846 15.339C20.0912 15.1225 20.3472 14.9594 20.6308 14.8636C20.9244 14.7658 21.2011 14.7156 21.4541 14.7156C21.493 14.7156 21.5312 14.717 21.5695 14.7191L17.2996 10.1202C17.1444 9.9561 16.9574 9.82533 16.75 9.73589C16.5426 9.64645 16.3191 9.6002 16.0932 9.59998C15.634 9.59998 15.2022 9.78695 14.8781 10.1244L14.8784 10.1248Z"
        fill="#4F4F4F"
      />
      <path
        d="M48.032 10.832L44.912 22H42.272L40.176 14.048L37.984 22L35.36 22.016L32.352 10.832H34.752L36.72 19.504L38.992 10.832H41.488L43.632 19.456L45.616 10.832H48.032ZM49.0686 17.536C49.0686 16.64 49.2446 15.8453 49.5966 15.152C49.9593 14.4587 50.4446 13.9253 51.0526 13.552C51.6713 13.1787 52.3593 12.992 53.1166 12.992C53.778 12.992 54.354 13.1253 54.8446 13.392C55.346 13.6587 55.746 13.9947 56.0446 14.4V13.136H58.3006V22H56.0446V20.704C55.7566 21.12 55.3566 21.4667 54.8446 21.744C54.3433 22.0107 53.762 22.144 53.1006 22.144C52.354 22.144 51.6713 21.952 51.0526 21.568C50.4446 21.184 49.9593 20.6453 49.5966 19.952C49.2446 19.248 49.0686 18.4427 49.0686 17.536ZM56.0446 17.568C56.0446 17.024 55.938 16.56 55.7246 16.176C55.5113 15.7813 55.2233 15.4827 54.8606 15.28C54.498 15.0667 54.1086 14.96 53.6926 14.96C53.2766 14.96 52.8926 15.0613 52.5406 15.264C52.1886 15.4667 51.9006 15.7653 51.6766 16.16C51.4633 16.544 51.3566 17.0027 51.3566 17.536C51.3566 18.0693 51.4633 18.5387 51.6766 18.944C51.9006 19.3387 52.1886 19.6427 52.5406 19.856C52.9033 20.0693 53.2873 20.176 53.6926 20.176C54.1086 20.176 54.498 20.0747 54.8606 19.872C55.2233 19.6587 55.5113 19.36 55.7246 18.976C55.938 18.5813 56.0446 18.112 56.0446 17.568ZM62.8784 10.16V22H60.6384V10.16H62.8784ZM67.4815 10.16V22H65.2415V10.16H67.4815ZM78.0846 17.376C78.0846 17.696 78.0633 17.984 78.0206 18.24H71.5406C71.594 18.88 71.818 19.3813 72.2126 19.744C72.6073 20.1067 73.0926 20.288 73.6686 20.288C74.5006 20.288 75.0926 19.9307 75.4446 19.216H77.8606C77.6046 20.0693 77.114 20.7733 76.3886 21.328C75.6633 21.872 74.7726 22.144 73.7166 22.144C72.8633 22.144 72.0953 21.9573 71.4126 21.584C70.7406 21.2 70.2126 20.6613 69.8286 19.968C69.4553 19.2747 69.2686 18.4747 69.2686 17.568C69.2686 16.6507 69.4553 15.8453 69.8286 15.152C70.202 14.4587 70.7246 13.9253 71.3966 13.552C72.0686 13.1787 72.842 12.992 73.7166 12.992C74.5593 12.992 75.3113 13.1733 75.9726 13.536C76.6446 13.8987 77.162 14.416 77.5246 15.088C77.898 15.7493 78.0846 16.512 78.0846 17.376ZM75.7646 16.736C75.754 16.16 75.546 15.7013 75.1406 15.36C74.7353 15.008 74.2393 14.832 73.6526 14.832C73.098 14.832 72.6286 15.0027 72.2446 15.344C71.8713 15.6747 71.642 16.1387 71.5566 16.736H75.7646ZM82.4776 14.976V19.264C82.4776 19.5627 82.547 19.7813 82.6856 19.92C82.835 20.048 83.0803 20.112 83.4216 20.112H84.4616V22H83.0536C81.1656 22 80.2216 21.0827 80.2216 19.248V14.976H79.1656V13.136H80.2216V10.944H82.4776V13.136H84.4616V14.976H82.4776ZM88.4628 10.16V22H86.2228V10.16H88.4628ZM99.3059 13.136L93.8179 26.192H91.4339L93.3539 21.776L89.8019 13.136H92.3139L94.6019 19.328L96.9219 13.136H99.3059Z"
        fill="#4F4F4F"
      />
    </svg>
  );
}

function ProfilePictureIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#DD3BB0" />
    </svg>
  );
}

function IconTick(props) {
  return (
    <svg
      width={props.width ? props.width : "18"}
      height={props.height ? props.height : "18"}
      viewBox="0 0 18 14"
      fill={props ? props.color : "white"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.47039 10.3547L1.3676 6.25187L0 7.61947L5.47039 13.0899L17.1927 1.3676L15.8251 0L5.47039 10.3547Z"
        fill={props ? props.color : "white"}
      />
    </svg>
  );
}

function BackIcon(props) {
  return (
    <svg width={12} height={11} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.28.97a.75.75 0 00-1.06 0L.97 5.22a.75.75 0 000 1.06l4.25 4.25a.75.75 0 001.06-1.06L3.31 6.5h7.44a.75.75 0 100-1.5H3.31l2.97-2.97a.75.75 0 000-1.06z"
        fill={props.color ? props.color : "#84889B"}
      />
    </svg>
  );
}

function ViewMoreIcon(props) {
  return (
    <svg
      className={props.className ? props.className : ""}
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66667 2.66732C9.66667 3.4037 9.06971 4.00065 8.33333 4.00065C7.59695 4.00065 7 3.4037 7 2.66732C7 1.93094 7.59695 1.33398 8.33333 1.33398C9.06971 1.33398 9.66667 1.93094 9.66667 2.66732Z"
        fill={props.color ? props.color : "#5F6368"}
      ></path>
      <path
        d="M9.66667 8.00065C9.66667 8.73703 9.06971 9.33398 8.33333 9.33398C7.59695 9.33398 7 8.73703 7 8.00065C7 7.26427 7.59695 6.66732 8.33333 6.66732C9.06971 6.66732 9.66667 7.26427 9.66667 8.00065Z"
        fill={props.color ? props.color : "#5F6368"}
      ></path>
      <path
        d="M8.33333 14.6673C9.06971 14.6673 9.66667 14.0704 9.66667 13.334C9.66667 12.5976 9.06971 12.0007 8.33333 12.0007C7.59695 12.0007 7 12.5976 7 13.334C7 14.0704 7.59695 14.6673 8.33333 14.6673Z"
        fill={props.color ? props.color : "#5F6368"}
      ></path>
    </svg>
  );
}

function EclipseIcon(props) {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill={props.color} />
    </svg>
  );
}

function UploadIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M19.85 10.04C19.17 6.59 16.14 4 12.5 4C9.61 4 7.1 5.64 5.85 8.04C2.84 8.36 0.5 10.91 0.5 14C0.5 17.31 3.19 20 6.5 20H19.5C22.26 20 24.5 17.76 24.5 15C24.5 12.36 22.45 10.22 19.85 10.04ZM14.5 13V17H10.5V13H7.5L12.15 8.35C12.35 8.15 12.66 8.15 12.86 8.35L17.5 13H14.5Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function DeleteIcon({ color, width, height }) {
  return (
    <svg
      width={width ? width : 20}
      height={height ? height : 20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.333 3.612a.278.278 0 01.278-.277h2.778a.278.278 0 01.278.277v1.39H8.333v-1.39zm5 0v1.39h2.5a.833.833 0 010 1.666H4.167a.833.833 0 110-1.667h2.5V3.612c0-1.073.87-1.944 1.944-1.944h2.778c1.073 0 1.944.871 1.944 1.944zM6.107 9.085a.833.833 0 10-1.658.166l.733 7.334a1.944 1.944 0 001.935 1.75h5.766c1 0 1.836-.757 1.935-1.752l.733-7.333a.834.834 0 00-1.658-.165l-.733 7.333a.278.278 0 01-.277.25H7.117a.278.278 0 01-.277-.25l-.733-7.333z"
        fill={color ? color : "#2E3039"}
      />
    </svg>
  );
}

function DropDownTriangleIcon({ className, ...props }) {
  return (
    <svg
      className={`cp ${className}`}
      width={props.width ? props.width : "14"}
      height={props.height ? props.height : "8"}
      viewBox="0 0 14 8"
      fill={props.color ? props.color : "white"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.23098 8L0.968809 0.5L13.4932 0.500001L7.23098 8Z"
        fill={(props) => props.color || "white"}
      />
    </svg>
  );
}

function DropDownTriangleHorizontalIcon({ className, ...props }) {
  return (
   <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.459 12.631l-3.447-3.94A.719.719 0 016.553 7.5h6.894a.718.718 0 01.541 1.192l-3.447 3.939a.72.72 0 01-1.082 0z"
        fill="#4B4E5B"
      />
    </svg>
  );
}

function HeaderCollapseIcon(props) {
  return (
    <svg
      width={14}
      height={12}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={14} height={2} rx={1} fill="#000" />
      <rect y={5} width={11} height={2} rx={1} fill="#000" />
      <rect y={10} width={14} height={2} rx={1} fill="#000" />
    </svg>
  );
}

function Check() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00009 0.888916C6.59365 0.888916 5.21879 1.30598 4.04937 2.08735C2.87995 2.86873 1.9685 3.97934 1.43028 5.27872C0.892058 6.57811 0.751234 8.00791 1.02562 9.38734C1.3 10.7668 1.97727 12.0338 2.97178 13.0283C3.96628 14.0228 5.23336 14.7001 6.61278 14.9745C7.9922 15.2489 9.42201 15.1081 10.7214 14.5698C12.0208 14.0316 13.1314 13.1202 13.9128 11.9507C14.6941 10.7813 15.1112 9.40647 15.1112 8.00003C15.1112 6.11404 14.362 4.3053 13.0284 2.97171C11.6948 1.63812 9.88608 0.888916 8.00009 0.888916V0.888916ZM12.6445 5.61336L6.80454 11.4489L3.35565 8.00003C3.23777 7.88215 3.17155 7.72228 3.17155 7.55558C3.17155 7.38888 3.23777 7.22901 3.35565 7.11114C3.47352 6.99326 3.63339 6.92704 3.80009 6.92704C3.96679 6.92704 4.12666 6.99326 4.24454 7.11114L6.81342 9.68003L11.7645 4.73336C11.8229 4.67499 11.8922 4.6287 11.9684 4.59711C12.0447 4.56552 12.1264 4.54927 12.209 4.54927C12.2915 4.54927 12.3733 4.56552 12.4495 4.59711C12.5258 4.6287 12.5951 4.67499 12.6534 4.73336C12.7118 4.79173 12.7581 4.86102 12.7897 4.93727C12.8213 5.01353 12.8375 5.09526 12.8375 5.1778C12.8375 5.26035 12.8213 5.34208 12.7897 5.41834C12.7581 5.49459 12.7118 5.56388 12.6534 5.62225L12.6445 5.61336Z"
        fill="#86CC7B"
      />
    </svg>
  );
}

function Failure() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.22183 19.7782C3.20038 18.7567 2.39013 17.5441 1.83733 16.2095C1.28452 14.8749 1 13.4445 1 12C1 10.5555 1.28452 9.12506 1.83733 7.79048C2.39013 6.4559 3.20038 5.24327 4.22183 4.22183C5.24327 3.20038 6.4559 2.39013 7.79048 1.83733C9.12506 1.28452 10.5555 1 12 1C13.4445 1 14.8749 1.28452 16.2095 1.83733C17.5441 2.39013 18.7567 3.20038 19.7782 4.22183C21.8411 6.28473 23 9.08262 23 12C23 14.9174 21.8411 17.7153 19.7782 19.7782C17.7153 21.8411 14.9174 23 12 23C9.08262 23 6.28473 21.8411 4.22183 19.7782V19.7782ZM9.29132 7.83386C9.09583 7.6517 8.83728 7.55254 8.57012 7.55725C8.30296 7.56196 8.04806 7.67019 7.85913 7.85913C7.67019 8.04806 7.56196 8.30296 7.55725 8.57012C7.55254 8.83728 7.6517 9.09583 7.83386 9.29132L10.5425 12L7.83386 14.7087C7.73254 14.8031 7.65128 14.9169 7.59491 15.0434C7.53855 15.1699 7.50825 15.3065 7.5058 15.4449C7.50336 15.5834 7.52883 15.7209 7.58069 15.8493C7.63256 15.9778 7.70976 16.0944 7.80768 16.1923C7.9056 16.2902 8.02225 16.3674 8.15065 16.4193C8.27906 16.4712 8.41659 16.4966 8.55506 16.4942C8.69352 16.4918 8.83007 16.4614 8.95657 16.4051C9.08306 16.3487 9.19691 16.2675 9.29132 16.1661L12 13.4575L14.7087 16.1661C14.8031 16.2675 14.9169 16.3487 15.0434 16.4051C15.1699 16.4614 15.3065 16.4918 15.4449 16.4942C15.5834 16.4966 15.7209 16.4712 15.8493 16.4193C15.9778 16.3674 16.0944 16.2902 16.1923 16.1923C16.2902 16.0944 16.3674 15.9778 16.4193 15.8493C16.4712 15.7209 16.4966 15.5834 16.4942 15.4449C16.4918 15.3065 16.4614 15.1699 16.4051 15.0434C16.3487 14.9169 16.2675 14.8031 16.1661 14.7087L13.4575 12L16.1661 9.29132C16.2675 9.19691 16.3487 9.08306 16.4051 8.95657C16.4614 8.83007 16.4918 8.69352 16.4942 8.55506C16.4966 8.41659 16.4712 8.27906 16.4193 8.15065C16.3674 8.02225 16.2902 7.9056 16.1923 7.80768C16.0944 7.70976 15.9778 7.63256 15.8493 7.58069C15.7209 7.52883 15.5834 7.50336 15.4449 7.5058C15.3065 7.50825 15.1699 7.53855 15.0434 7.59491C14.9169 7.65128 14.8031 7.73254 14.7087 7.83386L12 10.5425L9.29132 7.83386Z"
        fill="#DE245C"
      />
    </svg>
  );
}

function NavLoyatlyIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 6.61L9.777 5.518a3.667 3.667 0 00-6.11 2.733c0 2.75 1.228 4.778 2.78 6.28 1.578 1.527 3.435 2.445 4.448 2.868.07.03.14.03.21 0 1.014-.423 2.87-1.34 4.449-2.869 1.551-1.501 2.78-3.53 2.78-6.279a3.667 3.667 0 00-6.111-2.733L11 6.61zm0-2.46a5.5 5.5 0 00-9.167 4.1c0 6.739 6.116 9.906 8.357 10.84a2.093 2.093 0 001.62 0c2.241-.934 8.357-4.101 8.357-10.84A5.5 5.5 0 0011 4.15z"
        fill={props.color || "#2E3039"}
      />
    </svg>
  );
}

function ArrowUpIcon(props) {
  return (
    <svg
      className={props.className}
      width={props.width ? props.width : "8"}
      height={props.height ? props.height : "10"}
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.35355 0.900109C4.15829 0.704847 3.84171 0.704847 3.64645 0.900109L0.464466 4.08209C0.269204 4.27735 0.269204 4.59393 0.464466 4.7892C0.659728 4.98446 0.976311 4.98446 1.17157 4.7892L4 1.96077L6.82843 4.7892C7.02369 4.98446 7.34027 4.98446 7.53553 4.7892C7.7308 4.59393 7.7308 4.27735 7.53553 4.08209L4.35355 0.900109ZM4.5 9.25366L4.5 1.25366L3.5 1.25366L3.5 9.25366L4.5 9.25366Z"
        fill={props.color ? props.color : "#6FCF97"}
      />
    </svg>
  );
}

function ArrowDownIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <path
          d="M7.64645 8.60722C7.84171 8.80248 8.15829 8.80248 8.35355 8.60722L11.5355 5.42523C11.7308 5.22997 11.7308 4.91339 11.5355 4.71813C11.3403 4.52287 11.0237 4.52287 10.8284 4.71813L8 7.54656L5.17157 4.71813C4.97631 4.52287 4.65973 4.52287 4.46447 4.71813C4.2692 4.91339 4.2692 5.22997 4.46447 5.42524L7.64645 8.60722ZM7.5 0.253662L7.5 8.25366L8.5 8.25366L8.5 0.253662L7.5 0.253662Z"
          fill="#EB5757"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0.318359"
          y="0.253662"
          width="15.364"
          height="16.5"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

function ArrowExpand({ height, width, className, color }) {
  return (
    <svg
      className={className}
      width={width || "16px"}
      height={height || "16px"}
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 1.3335L0.833333 6.00016L5.5 10.6668"
        stroke={color ? color : "#8C94A6"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function ArrowUnExpand(props) {
  return (
    <svg
      width={props.width || "10"}
      height={props.height || "6"}
      viewBox="0 0 10 6"
      fill="none"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1L5 5L1 1"
        stroke={props.color ? props.color : "#14142B"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function PlusIcon(props) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill={props.color ? props.color : "white"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8337 6.83366H6.83366V11.8337H5.16699V6.83366H0.166992V5.16699H5.16699V0.166992H6.83366V5.16699H11.8337V6.83366Z"
        fill={props.color ? props.color : "white"}
      />
    </svg>
  );
}

function CommunicationNotificationIcon(props) {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.6001 21.0537C7.6001 22.3792 8.67461 23.4537 10.0001 23.4537C11.3256 23.4537 12.4001 22.3792 12.4001 21.0537"
        stroke="#14142B"
        stroke-linecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.892 4.25391C6.99323 4.25391 4.55802 6.43353 4.2379 9.31457L3.6002 15.0539L1.47799 18.5909C1.32814 18.8407 1.4219 19.1614 1.68927 19.2769C2.89644 19.7985 6.19723 21.0539 10.0002 21.0539C13.8032 21.0539 17.104 19.7985 18.3111 19.2769C18.5785 19.1614 18.6722 18.8407 18.5224 18.5909L16.4002 15.0539L15.5195 9.10911C15.1062 6.31966 12.7119 4.25391 9.892 4.25391V4.25391Z"
        stroke="#14142B"
        stroke-linecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0004 4.25371C10.884 4.25371 11.6004 3.53737 11.6004 2.65371C11.6004 1.77006 10.884 1.05371 10.0004 1.05371C9.11673 1.05371 8.40039 1.77006 8.40039 2.65371C8.40039 3.53737 9.11673 4.25371 10.0004 4.25371Z"
        stroke="#14142B"
        stroke-linecap="round"
      />
    </svg>
  );
}

function CommunicationChatFlowIcon({ color, className }) {
  return (
    <svg
      className={className}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.6002 6.35371C6.92568 6.35371 8.0002 5.27919 8.0002 3.95371C8.0002 2.62823 6.92568 1.55371 5.6002 1.55371C4.27471 1.55371 3.2002 2.62823 3.2002 3.95371C3.2002 5.27919 4.27471 6.35371 5.6002 6.35371Z"
        stroke={color}
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.4 14.3527C19.7255 14.3527 20.8 13.2782 20.8 11.9527C20.8 10.6273 19.7255 9.55273 18.4 9.55273C17.0745 9.55273 16 10.6273 16 11.9527C16 13.2782 17.0745 14.3527 18.4 14.3527Z"
        stroke={color}
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.4 23.9543C19.7255 23.9543 20.8 22.8798 20.8 21.5543C20.8 20.2288 19.7255 19.1543 18.4 19.1543C17.0745 19.1543 16 20.2288 16 21.5543C16 22.8798 17.0745 23.9543 18.4 23.9543Z"
        stroke={color}
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        d="M8 3.95312H11C11.5523 3.95312 12 4.40084 12 4.95313V20.9531C12 21.5054 12.4477 21.9531 13 21.9531H16"
        stroke={color}
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        d="M12 11.9541H16"
        stroke={color}
        stroke-width="1.2"
        stroke-linecap="round"
      />
    </svg>
  );
}

function CommunicationEmailIcon(props) {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 2.25391L11.6644 9.66336C11.2855 10.0001 10.7145 10.0001 10.3356 9.66336L2 2.25391M8 8.25391L1 15.2539M21 15.2539L14 8.25391M3 15.2539H19C20.1046 15.2539 21 14.3585 21 13.2539V3.25391C21 2.14934 20.1046 1.25391 19 1.25391H3C1.89543 1.25391 1 2.14934 1 3.25391V13.2539C1 14.3585 1.89543 15.2539 3 15.2539Z"
        stroke="#14142B"
      />
    </svg>
  );
}

function CommunicatonSmsIcon(props) {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 6.25391H15M5 9.25391H11M3.5 1.25391H16.5C17.8807 1.25391 19 2.37319 19 3.75391V11.7539C19 13.1346 17.8807 14.2539 16.5 14.2539H9L5.01658 17.7394C5.01012 17.7451 5 17.7405 5 17.7319V14.2539H3.5C2.11929 14.2539 1 13.1346 1 11.7539V3.75391C1 2.37319 2.11929 1.25391 3.5 1.25391Z"
        stroke="#14142B"
        stroke-linecap="round"
      />
    </svg>
  );
}

function CircularTickIcon(props) {
  return (
    <svg
      width={props.width ? props.width : "18"}
      height={props.height ? props.height : "19"}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="9"
        cy="9.25391"
        r="8.5"
        fill={props.backgroundColor ? props.backgroundColor : "#6FCF97"}
        stroke="#F0F0F0"
      />
      <path
        d="M7.3 11.5539L5.2 9.45391L4.5 10.1539L7.3 12.9539L13.3 6.95391L12.6 6.25391L7.3 11.5539Z"
        fill="white"
      />
    </svg>
  );
}

function EyeIcon(props) {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill={props.color ? props.color : "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99967 0.75C5.83301 0.75 2.27467 3.34167 0.833008 7C2.27467 10.6583 5.83301 13.25 9.99967 13.25C14.1663 13.25 17.7247 10.6583 19.1663 7C17.7247 3.34167 14.1663 0.75 9.99967 0.75ZM9.99967 11.1667C7.69967 11.1667 5.83301 9.3 5.83301 7C5.83301 4.7 7.69967 2.83333 9.99967 2.83333C12.2997 2.83333 14.1663 4.7 14.1663 7C14.1663 9.3 12.2997 11.1667 9.99967 11.1667ZM9.99967 4.5C8.61634 4.5 7.49967 5.61667 7.49967 7C7.49967 8.38333 8.61634 9.5 9.99967 9.5C11.383 9.5 12.4997 8.38333 12.4997 7C12.4997 5.61667 11.383 4.5 9.99967 4.5Z"
        fill={props.color ? props.color : "#4F4F4F"}
      />
    </svg>
  );
}

function BrushIcon({ color, height, width }) {
  return (
    <svg
      width={width ? width : "17"}
      height={height ? height : "16"}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.83366 9.6668C3.45033 9.6668 2.33366 10.7835 2.33366 12.1668C2.33366 13.2585 1.36699 13.8335 0.666992 13.8335C1.43366 14.8501 2.74199 15.5001 4.00033 15.5001C5.84199 15.5001 7.33366 14.0085 7.33366 12.1668C7.33366 10.7835 6.21699 9.6668 4.83366 9.6668ZM16.2587 1.85846L15.142 0.741797C14.817 0.416797 14.292 0.416797 13.967 0.741797L6.50033 8.20846L8.79199 10.5001L16.2587 3.03346C16.5837 2.70846 16.5837 2.18346 16.2587 1.85846Z"
        fill={color}
      />
    </svg>
  );
}

function NavigatorIcon() {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 5.83325H2.16667V4.16659H0.5V5.83325ZM0.5 9.16658H2.16667V7.49992H0.5V9.16658ZM0.5 2.49992H2.16667V0.833252H0.5V2.49992ZM3.83333 5.83325H15.5V4.16659H3.83333V5.83325ZM3.83333 9.16658H15.5V7.49992H3.83333V9.16658ZM3.83333 0.833252V2.49992H15.5V0.833252H3.83333ZM0.5 5.83325H2.16667V4.16659H0.5V5.83325ZM0.5 9.16658H2.16667V7.49992H0.5V9.16658ZM0.5 2.49992H2.16667V0.833252H0.5V2.49992ZM3.83333 5.83325H15.5V4.16659H3.83333V5.83325ZM3.83333 9.16658H15.5V7.49992H3.83333V9.16658ZM3.83333 0.833252V2.49992H15.5V0.833252H3.83333Z"
        fill="#4F4F4F"
      />
    </svg>
  );
}

function CursorIcon() {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0004 19L16.3337 25.6667L11.0004 11L25.667 16.3334L19.0004 19ZM19.0004 19L25.667 25.6667M8.58438 1.98535L9.62038 5.84802M5.84838 9.62002L1.98438 8.58402M17.6004 4.40002L14.771 7.22935M7.22838 14.7707L4.40171 17.6"
        stroke="#4F4F4F"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function DesktopViewIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.25 4.5C20.4489 4.5 20.6397 4.57902 20.7803 4.71967C20.921 4.86032 21 5.05109 21 5.25V16.5H3V5.25C3 5.05109 3.07902 4.86032 3.21967 4.71967C3.36032 4.57902 3.55109 4.5 3.75 4.5H20.25ZM3.75 3C3.15326 3 2.58097 3.23705 2.15901 3.65901C1.73705 4.08097 1.5 4.65326 1.5 5.25V18H22.5V5.25C22.5 4.65326 22.2629 4.08097 21.841 3.65901C21.419 3.23705 20.8467 3 20.25 3H3.75ZM0 18.75H24C24 19.3467 23.7629 19.919 23.341 20.341C22.919 20.7629 22.3467 21 21.75 21H2.25C1.65326 21 1.08097 20.7629 0.65901 20.341C0.237053 19.919 0 19.3467 0 18.75H0Z"
        fill="#4F4F4F"
      />
    </svg>
  );
}

function MobileViewIcon() {
  return (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 0.666992H1.33333C0.979711 0.666992 0.640573 0.807468 0.390525 1.05752C0.140476 1.30756 0 1.6467 0 2.00033V18.0003C0 18.3539 0.140476 18.6931 0.390525 18.9431C0.640573 19.1932 0.979711 19.3337 1.33333 19.3337H10.6667C11.0203 19.3337 11.3594 19.1932 11.6095 18.9431C11.8595 18.6931 12 18.3539 12 18.0003V2.00033C12 1.6467 11.8595 1.30756 11.6095 1.05752C11.3594 0.807468 11.0203 0.666992 10.6667 0.666992ZM6.66667 18.0003H5.33333V16.667H6.66667V18.0003ZM1.33333 15.3337V2.00033H10.6667V15.3337H1.33333Z"
        fill="#828282"
      />
    </svg>
  );
}

function ArrowIcon({ color }) {
  return (
    <svg
      width="171"
      height="13"
      viewBox="0 0 171 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.226497 6.5L6 12.2735L11.7735 6.5L6 0.726497L0.226497 6.5ZM171 6.5L161 0.726497V12.2735L171 6.5ZM6 7.5H162V5.5H6V7.5Z"
        fill={color}
      />
    </svg>
  );
}

function AliginCenterEditorIcon(props) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill={props.color ? props.color : ""}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M1.01 1.20898H12.99C13.1227 1.20898 13.2541 1.23514 13.3767 1.28596C13.4993 1.33678 13.6107 1.41127 13.7045 1.50516C13.7983 1.59905 13.8727 1.71051 13.9234 1.83317C13.9741 1.95582 14.0001 2.08727 14 2.21998V2.61998C14 2.75249 13.9739 2.88369 13.9232 3.00611C13.8725 3.12853 13.7982 3.23976 13.7045 3.33346C13.6108 3.42715 13.4995 3.50147 13.3771 3.55218C13.2547 3.60289 13.1235 3.62898 12.991 3.62898H1.009C0.876412 3.62898 0.745125 3.60285 0.622642 3.55208C0.500159 3.50131 0.388883 3.4269 0.295176 3.3331C0.201469 3.2393 0.127167 3.12795 0.0765188 3.00542C0.0258707 2.88289 -0.00013091 2.75157 4.95585e-07 2.61898V2.21898C4.95585e-07 1.95112 0.106411 1.69422 0.295823 1.50481C0.485234 1.31539 0.742132 1.20898 1.01 1.20898Z"
          fill={props.color ? props.color : ""}
        />
        <path
          d="M3.24193 5.78998H10.7579C11.0258 5.78998 11.2827 5.89639 11.4721 6.0858C11.6615 6.27521 11.7679 6.53211 11.7679 6.79998V7.19998C11.7681 7.33257 11.7421 7.46388 11.6914 7.58641C11.6408 7.70895 11.5665 7.8203 11.4728 7.9141C11.3791 8.0079 11.2678 8.08231 11.1453 8.13308C11.0228 8.18385 10.8915 8.20998 10.7589 8.20998H3.24093C3.10835 8.20998 2.97706 8.18385 2.85458 8.13308C2.73209 8.08231 2.62082 8.0079 2.52711 7.9141C2.4334 7.8203 2.3591 7.70895 2.30845 7.58641C2.2578 7.46388 2.2318 7.33257 2.23193 7.19998V6.79998C2.23193 6.53211 2.33834 6.27521 2.52776 6.0858C2.71717 5.89639 2.97407 5.78998 3.24193 5.78998Z"
          fill={props.color ? props.color : ""}
        />
        <path
          d="M8.60016 10.372H5.40016C5.13424 10.373 4.87934 10.4784 4.69027 10.6654C4.50121 10.8524 4.39309 11.1061 4.38916 11.372V11.778C4.3889 11.9109 4.41486 12.0426 4.46555 12.1655C4.51624 12.2884 4.59066 12.4001 4.68457 12.4942C4.77848 12.5883 4.89002 12.6629 5.01281 12.7139C5.1356 12.7648 5.26723 12.791 5.40016 12.791H8.60016C8.86812 12.791 9.12512 12.6846 9.31469 12.4952C9.50426 12.3059 9.6109 12.049 9.61116 11.781V11.374C9.60775 11.1078 9.49986 10.8535 9.31074 10.6661C9.12162 10.4787 8.86643 10.373 8.60016 10.372Z"
          fill={props.color ? props.color : ""}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="14" height="14" fill={props.color ? props.color : ""} />
        </clipPath>
      </defs>
    </svg>
  );
}

function AliginLeftEditorIcon(props) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill={props.color ? props.color : ""}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.995 1.20901H1.011C0.744565 1.21005 0.489219 1.3158 0.300072 1.50345C0.110926 1.6911 0.003148 1.9456 0 2.21201L0 2.61901C0.000529748 2.8868 0.107279 3.14344 0.296821 3.33261C0.486363 3.52177 0.743212 3.62802 1.011 3.62802H9.995C10.2628 3.62802 10.5196 3.52177 10.7092 3.33261C10.8987 3.14344 11.0055 2.8868 11.006 2.61901V2.21101C11.0026 1.94477 10.8947 1.69053 10.7056 1.50309C10.5165 1.31566 10.2613 1.21004 9.995 1.20901Z"
        fill={props.color ? props.color : ""}
      />
      <path
        d="M12.99 5.79001H1.011C0.744644 5.7913 0.489447 5.89713 0.300356 6.08473C0.111265 6.27232 0.00340502 6.52667 0 6.79301L0 7.20001C0.000265045 7.46797 0.106898 7.72486 0.296468 7.91425C0.486039 8.10363 0.743039 8.21001 1.011 8.21001H12.99C13.1226 8.21001 13.254 8.18388 13.3765 8.13313C13.499 8.08237 13.6104 8.00797 13.7042 7.91419C13.798 7.8204 13.8724 7.70906 13.9231 7.58652C13.9739 7.46398 14 7.33264 14 7.20001V6.79201C13.9969 6.52586 13.8892 6.27161 13.7002 6.08415C13.5113 5.89669 13.2562 5.79104 12.99 5.79001Z"
        fill={props.color ? props.color : ""}
      />
      <path
        d="M6.5 10.372H1.011C0.745077 10.373 0.490175 10.4784 0.301112 10.6654C0.11205 10.8524 0.00392797 11.1061 0 11.372L0 11.778C0.000265045 12.046 0.106898 12.3029 0.296468 12.4922C0.486039 12.6816 0.743039 12.788 1.011 12.788H6.5C6.76796 12.788 7.02496 12.6816 7.21453 12.4922C7.4041 12.3029 7.51074 12.046 7.511 11.778V11.371C7.50681 11.1053 7.39858 10.8518 7.20954 10.665C7.02051 10.4782 6.76575 10.373 6.5 10.372Z"
        fill={props.color ? props.color : ""}
      />
    </svg>
  );
}

function AliginRightEditorIcon(props) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M4.00512 1.20898H12.9901C13.1228 1.20898 13.2543 1.23514 13.3769 1.28596C13.4995 1.33678 13.6108 1.41127 13.7046 1.50516C13.7984 1.59905 13.8728 1.71051 13.9235 1.83317C13.9742 1.95582 14.0002 2.08727 14.0001 2.21998V2.61998C14.0001 2.75249 13.974 2.88369 13.9233 3.00611C13.8726 3.12853 13.7983 3.23976 13.7046 3.33346C13.6109 3.42715 13.4997 3.50147 13.3772 3.55218C13.2548 3.60289 13.1236 3.62898 12.9911 3.62898H4.00512C3.73725 3.62898 3.48035 3.52257 3.29094 3.33316C3.10153 3.14375 2.99512 2.88685 2.99512 2.61898V2.21898C2.99512 1.95112 3.10153 1.69422 3.29094 1.50481C3.48035 1.31539 3.73725 1.20898 4.00512 1.20898Z"
          fill={props.color ? props.color : ""}
        />
        <path
          d="M1.01 5.78998H12.99C13.2557 5.79126 13.5104 5.89671 13.6992 6.08369C13.8881 6.27067 13.9961 6.52425 14 6.78998V7.19998C13.9997 7.46777 13.8932 7.72451 13.7039 7.91386C13.5145 8.10322 13.2578 8.20971 12.99 8.20998H1.01C0.742213 8.20971 0.485469 8.10322 0.296115 7.91386C0.10676 7.72451 0.000264743 7.46777 0 7.19998L0 6.79198C0.00340498 6.52591 0.11116 6.27181 0.300063 6.0844C0.488966 5.897 0.743909 5.79127 1.01 5.78998Z"
          fill={props.color ? props.color : ""}
        />
        <path
          d="M7.50521 10.372H12.9902C13.2581 10.372 13.515 10.4784 13.7044 10.6678C13.8938 10.8572 14.0002 11.1141 14.0002 11.382V11.782C14.0002 12.0496 13.8939 12.3062 13.7047 12.4954C13.5155 12.6847 13.2588 12.791 12.9912 12.791H7.50021C7.23261 12.791 6.97596 12.6847 6.78674 12.4954C6.59752 12.3062 6.49121 12.0496 6.49121 11.782V11.382C6.49121 11.249 6.51747 11.1173 6.56847 10.9945C6.61948 10.8717 6.69423 10.7602 6.78845 10.6664C6.88266 10.5725 6.99447 10.4982 7.11747 10.4477C7.24047 10.3972 7.37224 10.3714 7.50521 10.372Z"
          fill={props.color ? props.color : ""}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function BoldEditorIcon(props) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill={props.color ? props.color : ""}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3391 4.093C12.3373 3.00804 11.9055 1.96804 11.1383 1.20086C10.3711 0.433671 9.3311 0.0018508 8.24613 0L2.84613 0C2.53184 0.000529447 2.23059 0.125685 2.00844 0.348017C1.7863 0.570349 1.6614 0.871707 1.66113 1.186V12.814C1.6614 13.1285 1.78644 13.43 2.0088 13.6523C2.23116 13.8747 2.53267 13.9997 2.84713 14H8.24713C9.3321 13.9981 10.3721 13.5663 11.1393 12.7991C11.9065 12.032 12.3383 10.992 12.3401 9.907C12.3388 9.36408 12.2283 8.82697 12.0153 8.32759C11.8023 7.8282 11.4911 7.37673 11.1001 7C11.491 6.62325 11.8021 6.17176 12.0149 5.67236C12.2278 5.17296 12.338 4.63586 12.3391 4.093ZM8.24613 5.814H4.03413V2.373H8.24613C8.69526 2.38383 9.12234 2.56985 9.43616 2.89132C9.74998 3.2128 9.92565 3.64425 9.92565 4.0935C9.92565 4.54275 9.74998 4.9742 9.43616 5.29568C9.12234 5.61715 8.69526 5.80317 8.24613 5.814ZM8.24613 11.627H4.03413V8.186H8.24613C8.69526 8.19683 9.12234 8.38285 9.43616 8.70432C9.74998 9.0258 9.92565 9.45725 9.92565 9.9065C9.92565 10.3558 9.74998 10.7872 9.43616 11.1087C9.12234 11.4302 8.69526 11.6162 8.24613 11.627Z"
        fill={props.color ? props.color : ""}
      />
    </svg>
  );
}

function BulletedEditorIcon(props) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill={props.color ? props.color : ""}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9912 1.21002H5.31518C5.04943 1.2113 4.79478 1.31676 4.60593 1.50373C4.41708 1.69071 4.3091 1.9443 4.30518 2.21002V2.61702C4.30544 2.88481 4.41194 3.14155 4.60129 3.33091C4.79065 3.52026 5.04739 3.62676 5.31518 3.62702H12.9912C13.2584 3.62649 13.5146 3.52016 13.7037 3.33126C13.8928 3.14237 13.9994 2.88629 14.0002 2.61902V2.21202C13.997 1.94604 13.8895 1.69195 13.7008 1.50451C13.512 1.31708 13.2572 1.21132 12.9912 1.21002Z"
        fill={props.color ? props.color : ""}
      />
      <path
        d="M12.9912 5.79102H5.31518C5.04943 5.7923 4.79478 5.89775 4.60593 6.08473C4.41708 6.27171 4.3091 6.52529 4.30518 6.79102V7.20002C4.30544 7.46771 4.41197 7.72435 4.60135 7.91355C4.79073 8.10274 5.04748 8.20902 5.31518 8.20902H12.9912C13.2587 8.20875 13.5152 8.10236 13.7044 7.91319C13.8935 7.72403 13.9999 7.46754 14.0002 7.20002V6.79202C13.9968 6.52621 13.8891 6.27237 13.7004 6.08515C13.5117 5.89793 13.257 5.7923 12.9912 5.79102Z"
        fill={props.color ? props.color : ""}
      />
      <path
        d="M8.14118 10.371H5.31518C5.04943 10.3723 4.79478 10.4778 4.60593 10.6647C4.41708 10.8517 4.3091 11.1053 4.30518 11.371V11.778C4.30571 12.0456 4.41232 12.3021 4.60164 12.4913C4.79097 12.6804 5.04756 12.7868 5.31518 12.787H8.14118C8.40896 12.787 8.66581 12.6808 8.85535 12.4916C9.0449 12.3025 9.15165 12.0458 9.15218 11.778V11.37C9.14799 11.1043 9.03975 10.8508 8.85072 10.664C8.66168 10.4772 8.40693 10.372 8.14118 10.371Z"
        fill={props.color ? props.color : ""}
      />
      <path
        d="M1.21095 3.62802C1.87867 3.62802 2.41995 3.08673 2.41995 2.41902C2.41995 1.75131 1.87867 1.21002 1.21095 1.21002C0.543241 1.21002 0.00195312 1.75131 0.00195312 2.41902C0.00195312 3.08673 0.543241 3.62802 1.21095 3.62802Z"
        fill={props.color ? props.color : ""}
      />
      <path
        d="M1.21095 8.20902C1.87867 8.20902 2.41995 7.66773 2.41995 7.00002C2.41995 6.3323 1.87867 5.79102 1.21095 5.79102C0.543241 5.79102 0.00195312 6.3323 0.00195312 7.00002C0.00195312 7.66773 0.543241 8.20902 1.21095 8.20902Z"
        fill={props.color ? props.color : ""}
      />
      <path
        d="M1.21095 12.79C1.87867 12.79 2.41995 12.2487 2.41995 11.581C2.41995 10.9133 1.87867 10.372 1.21095 10.372C0.543241 10.372 0.00195312 10.9133 0.00195312 11.581C0.00195312 12.2487 0.543241 12.79 1.21095 12.79Z"
        fill={props.color ? props.color : ""}
      />
    </svg>
  );
}

function ItalicEditorIcon(props) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M11.5891 1C11.5865 0.733868 11.4789 0.479532 11.2898 0.292278C11.1007 0.105024 10.8453 -1.30441e-05 10.5791 1.21501e-09L6.07913 1.21501e-09C5.81299 -1.30441e-05 5.5576 0.105024 5.36847 0.292278C5.17934 0.479532 5.07177 0.733868 5.06913 1V1.463C5.06913 1.73087 5.17554 1.98777 5.36496 2.17718C5.55437 2.36659 5.81126 2.473 6.07913 2.473H7.14513L4.57413 11.526H3.42113C3.15499 11.526 2.89959 11.631 2.71047 11.8183C2.52134 12.0055 2.41377 12.2599 2.41113 12.526V12.989C2.411 13.1217 2.43703 13.2532 2.48773 13.3758C2.53843 13.4985 2.6128 13.6099 2.7066 13.7038C2.8004 13.7977 2.91179 13.8722 3.03439 13.923C3.157 13.9738 3.28841 14 3.42113 14H7.99313C8.26048 13.9992 8.51661 13.8924 8.70537 13.7031C8.89414 13.5138 9.00013 13.2573 9.00013 12.99V12.527C8.9975 12.2609 8.88993 12.0065 8.7008 11.8193C8.51167 11.632 8.25628 11.527 7.99013 11.527H6.86113L9.43213 2.474H10.5791C10.847 2.474 11.1039 2.36759 11.2933 2.17818C11.4827 1.98877 11.5891 1.73187 11.5891 1.464V1Z"
          fill={props.color ? props.color : ""}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function UnderlineEditorIcon(props) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M6.88419 10.094C8.24718 10.0924 9.55389 9.55026 10.5177 8.58648C11.4815 7.6227 12.0236 6.31599 12.0252 4.953V1.205C12.0252 0.885414 11.8982 0.578918 11.6723 0.352936C11.4463 0.126955 11.1398 0 10.8202 0C10.5006 0 10.1941 0.126955 9.96812 0.352936C9.74214 0.578918 9.61519 0.885414 9.61519 1.205V4.953C9.61519 5.67731 9.32746 6.37195 8.8153 6.88411C8.30313 7.39627 7.60849 7.684 6.88419 7.684C6.15988 7.684 5.46524 7.39627 4.95308 6.88411C4.44092 6.37195 4.15319 5.67731 4.15319 4.953V1.205C4.14415 0.891292 4.01318 0.593463 3.78809 0.374763C3.563 0.156064 3.26153 0.0337239 2.94769 0.0337239C2.63385 0.0337239 2.33237 0.156064 2.10728 0.374763C1.88219 0.593463 1.75122 0.891292 1.74219 1.205V4.953C1.74378 6.31616 2.28606 7.62303 3.25006 8.58683C4.21406 9.55064 5.52102 10.0927 6.88419 10.094Z"
          fill={props.color ? props.color : ""}
        />
        <path
          d="M12.989 11.581H1.011C0.745078 11.582 0.490176 11.6874 0.301113 11.8744C0.11205 12.0614 0.00392846 12.3151 4.94605e-07 12.581V12.988C-0.000130911 13.1208 0.0259224 13.2524 0.0766711 13.3752C0.12742 13.498 0.201869 13.6095 0.295762 13.7035C0.389655 13.7975 0.501151 13.8721 0.623876 13.9229C0.746602 13.9738 0.87815 14 1.011 14H12.989C13.2568 14 13.5136 13.8938 13.7032 13.7046C13.8927 13.5154 13.9995 13.2588 14 12.991V12.583C13.9966 12.3167 13.8887 12.0625 13.6996 11.8751C13.5105 11.6876 13.2553 11.582 12.989 11.581Z"
          fill={props.color ? props.color : ""}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function LinkEditorIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9141 16.16L10.7463 17.3277C10.1667 17.8503 9.4086 18.1305 8.62841 18.1105C7.84822 18.0905 7.10547 17.7719 6.55337 17.2202C6.00127 16.6686 5.68193 15.9262 5.66125 15.146C5.64056 14.3658 5.92009 13.6075 6.44218 13.0274L7.60993 11.8596C7.84961 11.6203 7.9844 11.2955 7.98464 10.9568C7.98488 10.6181 7.85055 10.2931 7.6112 10.0534C7.37185 9.81374 7.04709 9.67895 6.70836 9.67871C6.36963 9.67847 6.04468 9.8128 5.805 10.0522L4.63852 11.2199C3.58939 12.269 3 13.6919 3 15.1756C3 16.6593 3.58939 18.0823 4.63852 19.1314C5.68765 20.1805 7.11057 20.7699 8.59426 20.7699C10.078 20.7699 11.5009 20.1805 12.55 19.1314L13.7177 17.9649C13.9571 17.7257 14.0916 17.4013 14.0917 17.0629C14.0919 16.7245 13.9576 16.4 13.7184 16.1606C13.4792 15.9213 13.1547 15.7867 12.8164 15.7866C12.478 15.7865 12.1534 15.9208 11.9141 16.16Z"
        fill={props.color ? props.color : ""}
      />
      <path
        d="M12.7878 9.17921L9.17921 12.7878C8.94003 13.027 8.80566 13.3514 8.80566 13.6896C8.80566 14.0279 8.94003 14.3523 9.17921 14.5915C9.41839 14.8306 9.74279 14.965 10.081 14.965C10.4193 14.965 10.7437 14.8306 10.9829 14.5915L14.5915 10.9829C14.8306 10.7437 14.965 10.4193 14.965 10.081C14.965 9.74279 14.8306 9.41839 14.5915 9.17921C14.3523 8.94003 14.0279 8.80566 13.6896 8.80566C13.3514 8.80566 13.027 8.94003 12.7878 9.17921Z"
        fill={props.color ? props.color : ""}
      />
      <path
        d="M19.131 4.63873C18.6115 4.11919 17.9948 3.70707 17.3161 3.4259C16.6374 3.14472 15.9099 3 15.1752 3C14.4406 3 13.7131 3.14472 13.0343 3.4259C12.3556 3.70707 11.7389 4.11919 11.2195 4.63873L10.0517 5.80521C9.81239 6.04439 9.67785 6.36885 9.67773 6.70722C9.67762 7.04559 9.81192 7.37015 10.0511 7.6095C10.2903 7.84885 10.6147 7.98338 10.9531 7.9835C11.2915 7.98362 11.616 7.84932 11.8554 7.61014L13.0231 6.44239C13.6028 5.91979 14.3609 5.63958 15.1411 5.65958C15.9213 5.67958 16.664 5.99825 17.2161 6.54986C17.7682 7.10148 18.0875 7.84395 18.1082 8.62412C18.1289 9.40429 17.8494 10.1626 17.3273 10.7427L16.1596 11.9105C15.9199 12.1498 15.7851 12.4746 15.7848 12.8133C15.7846 13.1521 15.9189 13.477 16.1583 13.7167C16.3976 13.9564 16.7224 14.0912 17.0611 14.0914C17.3998 14.0916 17.7248 13.9573 17.9645 13.718L19.131 12.5502C19.6505 12.0308 20.0626 11.4141 20.3438 10.7353C20.625 10.0566 20.7697 9.32914 20.7697 8.59447C20.7697 7.8598 20.625 7.13233 20.3438 6.4536C20.0626 5.77487 19.6505 5.15817 19.131 4.63873Z"
        fill={props.color ? props.color : ""}
      />
    </svg>
  );
}

function StrikeEditorIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.3484 10.4669H11.885C11.2187 10.5162 10.5597 10.3017 10.0501 9.86953C9.54052 9.43737 9.22124 8.82223 9.16111 8.15679C9.21933 7.49058 9.53807 6.87425 10.0481 6.44171C10.5581 6.00916 11.2182 5.79534 11.885 5.84669C12.3508 5.83826 12.8115 5.9451 13.226 6.15768C13.6406 6.37027 13.9961 6.68202 14.2611 7.06521C14.3609 7.2222 14.4908 7.35787 14.6433 7.4644C14.7958 7.57093 14.9679 7.64621 15.1496 7.68589C15.4245 7.74624 15.7112 7.72362 15.9732 7.6209C16.2353 7.51818 16.4609 7.33998 16.6216 7.10889C16.7823 6.8778 16.8707 6.60421 16.8758 6.32279C16.8808 6.04138 16.8022 5.7648 16.6499 5.5281C16.1313 4.74127 15.423 4.09761 14.5903 3.65641C13.7576 3.21522 12.8273 2.99068 11.885 3.00349C10.4642 2.95229 9.08098 3.46561 8.03757 4.43125C6.99415 5.39689 6.37543 6.73633 6.31664 8.15679C6.31642 8.96625 6.52542 9.76201 6.92336 10.4669H4.4216C4.04457 10.4669 3.68298 10.6167 3.41638 10.8833C3.14978 11.1499 3 11.5115 3 11.8885C3 12.2655 3.14978 12.6271 3.41638 12.8937C3.68298 13.1603 4.04457 13.3101 4.4216 13.3101H11.885C12.5513 13.2608 13.2103 13.4753 13.7199 13.9075C14.2295 14.3396 14.5488 14.9548 14.6089 15.6202C14.5507 16.2864 14.2319 16.9027 13.7219 17.3353C13.2119 17.7678 12.5518 17.9817 11.885 17.9303C11.419 17.9389 10.9581 17.8322 10.5433 17.6196C10.1285 17.407 9.77272 17.0951 9.50763 16.7118C9.40745 16.5525 9.27663 16.4147 9.12278 16.3063C8.96892 16.1979 8.79509 16.1212 8.61135 16.0806C8.42761 16.0399 8.23763 16.0361 8.05242 16.0695C7.86722 16.1028 7.69047 16.1726 7.53244 16.2747C7.3744 16.3769 7.23823 16.5094 7.1318 16.6646C7.02538 16.8198 6.95082 16.9946 6.91247 17.1788C6.87411 17.3631 6.87271 17.5531 6.90836 17.7378C6.944 17.9226 7.01597 18.0985 7.1201 18.2552C7.63944 19.0409 8.34804 19.6833 9.18069 20.1234C10.0133 20.5634 10.9433 20.787 11.885 20.7735C13.3058 20.8247 14.689 20.3114 15.7324 19.3457C16.7758 18.3801 17.3946 17.0407 17.4534 15.6202C17.4536 14.8107 17.2446 14.015 16.8466 13.3101H19.3484C19.7254 13.3101 20.087 13.1603 20.3536 12.8937C20.6202 12.6271 20.77 12.2655 20.77 11.8885C20.77 11.5115 20.6202 11.1499 20.3536 10.8833C20.087 10.6167 19.7254 10.4669 19.3484 10.4669V10.4669Z"
        fill={props.color ? props.color : ""}
      />
    </svg>
  );
}

function AlignHorizontalCenter({}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="7.61719"
        y="0.666992"
        width="0.817996"
        height="14.7239"
        fill="#42526E"
      />
      <rect
        x="15.333"
        y="4.75684"
        width="2.04"
        height="14.6667"
        transform="rotate(90 15.333 4.75684)"
        fill="#42526E"
      />
      <rect
        x="11.2109"
        y="9.52246"
        width="2.04"
        height="6.29039"
        transform="rotate(90 11.2109 9.52246)"
        fill="#42526E"
      />
    </svg>
  );
}

function AlignLeft({ className, color }) {
  return (
    <svg
      className={className}
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="1.5"
        height="13.5"
        transform="matrix(-1 0 0 1 16.832 2.75)"
        fill={color ? color : "#999999"}
      />
      <rect
        width="3.75"
        height="12"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 1.83203 5)"
        fill={color ? color : "#999999"}
      />
      <rect
        width="3.75"
        height="6"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 7.83203 9.80273)"
        fill={color ? color : "#999999"}
      />
    </svg>
  );
}

function AlignVerticalCenter({ className, color }) {
  return (
    <svg
      className={className}
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5.25"
        y="0.75"
        width="1.5"
        height="13.5"
        fill={color ? color : "#999999"}
      />
      <rect
        x="12"
        y="3.75"
        width="3.75"
        height="12"
        transform="rotate(90 12 3.75)"
        fill={color ? color : "#999999"}
      />
      <rect
        x="9"
        y="8.25"
        width="3.75"
        height="6"
        transform="rotate(90 9 8.25)"
        fill={color ? color : "#999999"}
      />
    </svg>
  );
}

function RadiusBottomLeft({}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M14.771 6.10308H13.7433C13.5941 6.10308 13.451 6.04381 13.3455 5.93831C13.24 5.8328 13.1808 5.68971 13.1808 5.54051V3.02099C13.1808 2.96931 13.1602 2.91975 13.1237 2.8832C13.0872 2.84666 13.0376 2.82613 12.9859 2.82613H10.458C10.3091 2.82613 10.1663 2.76697 10.061 2.66167C9.95565 2.55636 9.89649 2.41353 9.89649 2.26461V1.22956C9.89635 1.15573 9.91077 1.0826 9.93893 1.01436C9.96708 0.946107 10.0084 0.884082 10.0606 0.831829C10.1127 0.779575 10.1747 0.73812 10.2429 0.709836C10.3111 0.681551 10.3842 0.666992 10.458 0.666992H14.9135C15.0247 0.666992 15.1312 0.711142 15.2098 0.789728C15.2884 0.868315 15.3326 0.974901 15.3326 1.08604V5.54051C15.3327 5.61434 15.3183 5.68747 15.2901 5.75571C15.262 5.82396 15.2206 5.88599 15.1685 5.93824C15.1163 5.9905 15.0544 6.03195 14.9862 6.06024C14.918 6.08852 14.8449 6.10308 14.771 6.10308V6.10308Z"
        fill="#42526E"
      />
      <path
        opacity="0.5"
        d="M6.10308 1.22852V2.25623C6.1028 2.40535 6.04344 2.54828 5.938 2.65372C5.83256 2.75916 5.68963 2.81852 5.54051 2.8188H3.02099C2.96931 2.8188 2.91975 2.83933 2.8832 2.87587C2.84666 2.91241 2.82613 2.96198 2.82613 3.01365V5.54155C2.82613 5.61538 2.81157 5.68849 2.78329 5.75668C2.755 5.82488 2.71355 5.88683 2.6613 5.93898C2.60904 5.99114 2.54702 6.03248 2.47877 6.06064C2.41052 6.08879 2.33739 6.10322 2.26356 6.10308H1.22852C1.15477 6.10308 1.08176 6.08855 1.01363 6.06033C0.945502 6.03212 0.883601 5.99075 0.831458 5.93861C0.779316 5.88647 0.737955 5.82457 0.709736 5.75644C0.681516 5.68831 0.666992 5.6153 0.666992 5.54155V1.08604C0.666992 0.974901 0.711142 0.868315 0.789728 0.789728C0.868315 0.711142 0.974901 0.666992 1.08604 0.666992H5.54051C5.68953 0.666992 5.83246 0.726119 5.93794 0.831395C6.04341 0.936671 6.1028 1.07949 6.10308 1.22852V1.22852Z"
        fill="#42526E"
      />
      <path
        d="M1.22852 9.89746H2.25623C2.40543 9.89746 2.54852 9.95673 2.65403 10.0622C2.75953 10.1677 2.8188 10.3108 2.8188 10.46V12.9743C2.8188 13.026 2.83933 13.0756 2.87587 13.1121C2.91241 13.1486 2.96198 13.1692 3.01366 13.1692H5.54156C5.6153 13.1692 5.68831 13.1837 5.75644 13.2119C5.82457 13.2401 5.88647 13.2815 5.93861 13.3336C5.99075 13.3858 6.03212 13.4477 6.06034 13.5158C6.08855 13.5839 6.10308 13.657 6.10308 13.7307V14.7657C6.10391 14.84 6.09 14.9137 6.06215 14.9826C6.03431 15.0514 5.99308 15.1141 5.94085 15.1669C5.88863 15.2197 5.82644 15.2616 5.7579 15.2902C5.68936 15.3188 5.61583 15.3336 5.54156 15.3335H1.08604C0.974902 15.3335 0.868316 15.2894 0.789729 15.2108C0.711143 15.1322 0.666993 15.0256 0.666993 14.9145V10.46C0.666855 10.3862 0.681278 10.3131 0.709435 10.2448C0.737593 10.1766 0.778933 10.1146 0.831089 10.0623C0.883244 10.01 0.945193 9.96859 1.01339 9.9403C1.08158 9.91202 1.15469 9.89746 1.22852 9.89746V9.89746Z"
        fill="#42526E"
      />
      <path
        opacity="0.5"
        d="M9.89648 14.772V13.7443C9.89676 13.5952 9.95612 13.4523 10.0616 13.3468C10.167 13.2414 10.3099 13.182 10.4591 13.1818H12.9733C13.025 13.1818 13.0746 13.1612 13.1111 13.1247C13.1477 13.0881 13.1682 13.0386 13.1682 12.9869V10.459C13.1682 10.3852 13.1828 10.3121 13.211 10.2439C13.2393 10.1757 13.2808 10.1137 13.333 10.0616C13.3853 10.0094 13.4473 9.96809 13.5156 9.93993C13.5838 9.91177 13.6569 9.89735 13.7308 9.89749H14.7658C14.84 9.89679 14.9136 9.91081 14.9823 9.93872C15.051 9.96662 15.1136 10.0079 15.1663 10.0601C15.219 10.1123 15.2608 10.1744 15.2893 10.2429C15.3179 10.3114 15.3326 10.3848 15.3326 10.459V14.9145C15.3326 15.0257 15.2884 15.1322 15.2098 15.2108C15.1312 15.2894 15.0247 15.3336 14.9135 15.3336H10.4591C10.31 15.3336 10.1671 15.2744 10.0616 15.1692C9.95615 15.0639 9.89676 14.9211 9.89648 14.772V14.772Z"
        fill="#42526E"
      />
    </svg>
  );
}

function RadiusBottomRight({}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M14.771 6.10308H13.7433C13.5941 6.10308 13.451 6.04381 13.3455 5.93831C13.24 5.8328 13.1808 5.68971 13.1808 5.54051V3.02099C13.1808 2.96931 13.1602 2.91975 13.1237 2.8832C13.0872 2.84666 13.0376 2.82613 12.9859 2.82613H10.458C10.3091 2.82613 10.1663 2.76697 10.061 2.66167C9.95565 2.55636 9.89649 2.41353 9.89649 2.26461V1.22956C9.89635 1.15573 9.91077 1.0826 9.93893 1.01436C9.96708 0.946107 10.0084 0.884082 10.0606 0.831829C10.1127 0.779575 10.1747 0.73812 10.2429 0.709836C10.3111 0.681551 10.3842 0.666992 10.458 0.666992H14.9135C15.0247 0.666992 15.1312 0.711142 15.2098 0.789728C15.2884 0.868315 15.3326 0.974901 15.3326 1.08604V5.54051C15.3327 5.61434 15.3183 5.68747 15.2901 5.75571C15.262 5.82396 15.2206 5.88599 15.1685 5.93824C15.1163 5.9905 15.0544 6.03195 14.9862 6.06024C14.918 6.08852 14.8449 6.10308 14.771 6.10308V6.10308Z"
        fill="#42526E"
      />
      <path
        opacity="0.5"
        d="M6.10308 1.22852V2.25623C6.1028 2.40535 6.04344 2.54828 5.938 2.65372C5.83256 2.75916 5.68963 2.81852 5.54051 2.8188H3.02099C2.96931 2.8188 2.91975 2.83933 2.8832 2.87587C2.84666 2.91241 2.82613 2.96198 2.82613 3.01365V5.54155C2.82613 5.61538 2.81157 5.68849 2.78329 5.75668C2.755 5.82488 2.71355 5.88683 2.6613 5.93898C2.60904 5.99114 2.54702 6.03248 2.47877 6.06064C2.41052 6.08879 2.33739 6.10322 2.26356 6.10308H1.22852C1.15477 6.10308 1.08176 6.08855 1.01363 6.06033C0.945502 6.03212 0.883601 5.99075 0.831458 5.93861C0.779316 5.88647 0.737955 5.82457 0.709736 5.75644C0.681516 5.68831 0.666992 5.6153 0.666992 5.54155V1.08604C0.666992 0.974901 0.711142 0.868315 0.789728 0.789728C0.868315 0.711142 0.974901 0.666992 1.08604 0.666992H5.54051C5.68953 0.666992 5.83246 0.726119 5.93794 0.831395C6.04341 0.936671 6.1028 1.07949 6.10308 1.22852V1.22852Z"
        fill="#42526E"
      />
      <path
        opacity="0.5"
        d="M1.22852 9.89746H2.25623C2.40543 9.89746 2.54852 9.95673 2.65403 10.0622C2.75953 10.1677 2.8188 10.3108 2.8188 10.46V12.9743C2.8188 13.026 2.83933 13.0756 2.87587 13.1121C2.91241 13.1486 2.96198 13.1692 3.01366 13.1692H5.54156C5.6153 13.1692 5.68831 13.1837 5.75644 13.2119C5.82457 13.2401 5.88647 13.2815 5.93861 13.3336C5.99075 13.3858 6.03212 13.4477 6.06034 13.5158C6.08855 13.5839 6.10308 13.657 6.10308 13.7307V14.7657C6.10391 14.84 6.09 14.9137 6.06215 14.9826C6.03431 15.0514 5.99308 15.1141 5.94085 15.1669C5.88863 15.2197 5.82644 15.2616 5.7579 15.2902C5.68936 15.3188 5.61583 15.3336 5.54156 15.3335H1.08604C0.974902 15.3335 0.868316 15.2894 0.789729 15.2108C0.711143 15.1322 0.666993 15.0256 0.666993 14.9145V10.46C0.666855 10.3862 0.681278 10.3131 0.709435 10.2448C0.737593 10.1766 0.778933 10.1146 0.831089 10.0623C0.883244 10.01 0.945193 9.96859 1.01339 9.9403C1.08158 9.91202 1.15469 9.89746 1.22852 9.89746V9.89746Z"
        fill="#42526E"
      />
      <path
        d="M9.89648 14.772V13.7443C9.89676 13.5952 9.95612 13.4523 10.0616 13.3468C10.167 13.2414 10.3099 13.182 10.4591 13.1818H12.9733C13.025 13.1818 13.0746 13.1612 13.1111 13.1247C13.1477 13.0881 13.1682 13.0386 13.1682 12.9869V10.459C13.1682 10.3852 13.1828 10.3121 13.211 10.2439C13.2393 10.1757 13.2808 10.1137 13.333 10.0616C13.3853 10.0094 13.4473 9.96809 13.5156 9.93993C13.5838 9.91177 13.6569 9.89735 13.7308 9.89749H14.7658C14.84 9.89679 14.9136 9.91081 14.9823 9.93872C15.051 9.96662 15.1136 10.0079 15.1663 10.0601C15.219 10.1123 15.2608 10.1744 15.2893 10.2429C15.3179 10.3114 15.3326 10.3848 15.3326 10.459V14.9145C15.3326 15.0257 15.2884 15.1322 15.2098 15.2108C15.1312 15.2894 15.0247 15.3336 14.9135 15.3336H10.4591C10.31 15.3336 10.1671 15.2744 10.0616 15.1692C9.95615 15.0639 9.89676 14.9211 9.89648 14.772V14.772Z"
        fill="#42526E"
      />
    </svg>
  );
}

function RadiusTopLeft({}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M14.771 6.10308H13.7433C13.5941 6.10308 13.451 6.04381 13.3455 5.93831C13.24 5.8328 13.1808 5.68971 13.1808 5.54051V3.02099C13.1808 2.96931 13.1602 2.91975 13.1237 2.8832C13.0872 2.84666 13.0376 2.82613 12.9859 2.82613H10.458C10.3091 2.82613 10.1663 2.76697 10.061 2.66167C9.95565 2.55636 9.89649 2.41353 9.89649 2.26461V1.22956C9.89635 1.15573 9.91077 1.0826 9.93893 1.01436C9.96708 0.946107 10.0084 0.884082 10.0606 0.831829C10.1127 0.779575 10.1747 0.73812 10.2429 0.709836C10.3111 0.681551 10.3842 0.666992 10.458 0.666992H14.9135C15.0247 0.666992 15.1312 0.711142 15.2098 0.789728C15.2884 0.868315 15.3326 0.974901 15.3326 1.08604V5.54051C15.3327 5.61434 15.3183 5.68747 15.2901 5.75571C15.262 5.82396 15.2206 5.88599 15.1685 5.93824C15.1163 5.9905 15.0544 6.03195 14.9862 6.06024C14.918 6.08852 14.8449 6.10308 14.771 6.10308V6.10308Z"
        fill="#42526E"
      />
      <path
        d="M6.10308 1.22852V2.25623C6.1028 2.40535 6.04344 2.54828 5.938 2.65372C5.83256 2.75916 5.68963 2.81852 5.54051 2.8188H3.02099C2.96931 2.8188 2.91975 2.83933 2.8832 2.87587C2.84666 2.91241 2.82613 2.96198 2.82613 3.01365V5.54155C2.82613 5.61538 2.81157 5.68849 2.78329 5.75668C2.755 5.82488 2.71355 5.88683 2.6613 5.93898C2.60904 5.99114 2.54702 6.03248 2.47877 6.06064C2.41052 6.08879 2.33739 6.10322 2.26356 6.10308H1.22852C1.15477 6.10308 1.08176 6.08855 1.01363 6.06033C0.945502 6.03212 0.883601 5.99075 0.831458 5.93861C0.779316 5.88647 0.737955 5.82457 0.709736 5.75644C0.681516 5.68831 0.666992 5.6153 0.666992 5.54155V1.08604C0.666992 0.974901 0.711142 0.868315 0.789728 0.789728C0.868315 0.711142 0.974901 0.666992 1.08604 0.666992H5.54051C5.68953 0.666992 5.83246 0.726119 5.93794 0.831395C6.04341 0.936671 6.1028 1.07949 6.10308 1.22852V1.22852Z"
        fill="#42526E"
      />
      <path
        opacity="0.4"
        d="M1.22852 9.89746H2.25623C2.40543 9.89746 2.54852 9.95673 2.65403 10.0622C2.75953 10.1677 2.8188 10.3108 2.8188 10.46V12.9743C2.8188 13.026 2.83933 13.0756 2.87587 13.1121C2.91241 13.1486 2.96198 13.1692 3.01366 13.1692H5.54156C5.6153 13.1692 5.68831 13.1837 5.75644 13.2119C5.82457 13.2401 5.88647 13.2815 5.93861 13.3336C5.99075 13.3858 6.03212 13.4477 6.06034 13.5158C6.08855 13.5839 6.10308 13.657 6.10308 13.7307V14.7657C6.10391 14.84 6.09 14.9137 6.06215 14.9826C6.03431 15.0514 5.99308 15.1141 5.94085 15.1669C5.88863 15.2197 5.82644 15.2616 5.7579 15.2902C5.68936 15.3188 5.61583 15.3336 5.54156 15.3335H1.08604C0.974902 15.3335 0.868316 15.2894 0.789729 15.2108C0.711143 15.1322 0.666993 15.0256 0.666993 14.9145V10.46C0.666855 10.3862 0.681278 10.3131 0.709435 10.2448C0.737593 10.1766 0.778933 10.1146 0.831089 10.0623C0.883244 10.01 0.945193 9.96859 1.01339 9.9403C1.08158 9.91202 1.15469 9.89746 1.22852 9.89746V9.89746Z"
        fill="#42526E"
      />
      <path
        opacity="0.4"
        d="M9.89648 14.772V13.7443C9.89676 13.5952 9.95612 13.4523 10.0616 13.3468C10.167 13.2414 10.3099 13.182 10.4591 13.1818H12.9733C13.025 13.1818 13.0746 13.1612 13.1111 13.1247C13.1477 13.0881 13.1682 13.0386 13.1682 12.9869V10.459C13.1682 10.3852 13.1828 10.3121 13.211 10.2439C13.2393 10.1757 13.2808 10.1137 13.333 10.0616C13.3853 10.0094 13.4473 9.96809 13.5156 9.93993C13.5838 9.91177 13.6569 9.89735 13.7308 9.89749H14.7658C14.84 9.89679 14.9136 9.91081 14.9823 9.93872C15.051 9.96662 15.1136 10.0079 15.1663 10.0601C15.219 10.1123 15.2608 10.1744 15.2893 10.2429C15.3179 10.3114 15.3326 10.3848 15.3326 10.459V14.9145C15.3326 15.0257 15.2884 15.1322 15.2098 15.2108C15.1312 15.2894 15.0247 15.3336 14.9135 15.3336H10.4591C10.31 15.3336 10.1671 15.2744 10.0616 15.1692C9.95615 15.0639 9.89676 14.9211 9.89648 14.772V14.772Z"
        fill="#42526E"
      />
    </svg>
  );
}

function RaduisTopRight({}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.771 6.10308H13.7433C13.5941 6.10308 13.451 6.04381 13.3455 5.93831C13.24 5.8328 13.1808 5.68971 13.1808 5.54051V3.02099C13.1808 2.96931 13.1602 2.91975 13.1237 2.8832C13.0872 2.84666 13.0376 2.82613 12.9859 2.82613H10.458C10.3091 2.82613 10.1663 2.76697 10.061 2.66167C9.95565 2.55636 9.89649 2.41353 9.89649 2.26461V1.22956C9.89635 1.15573 9.91077 1.0826 9.93893 1.01436C9.96708 0.946107 10.0084 0.884082 10.0606 0.831829C10.1127 0.779575 10.1747 0.73812 10.2429 0.709836C10.3111 0.681551 10.3842 0.666992 10.458 0.666992H14.9135C15.0247 0.666992 15.1312 0.711142 15.2098 0.789728C15.2884 0.868315 15.3326 0.974901 15.3326 1.08604V5.54051C15.3327 5.61434 15.3183 5.68747 15.2901 5.75571C15.262 5.82396 15.2206 5.88599 15.1685 5.93824C15.1163 5.9905 15.0544 6.03195 14.9862 6.06024C14.918 6.08852 14.8449 6.10308 14.771 6.10308V6.10308Z"
        fill="#42526E"
      />
      <path
        opacity="0.5"
        d="M6.10308 1.22852V2.25623C6.1028 2.40535 6.04344 2.54828 5.938 2.65372C5.83256 2.75916 5.68963 2.81852 5.54051 2.8188H3.02099C2.96931 2.8188 2.91975 2.83933 2.8832 2.87587C2.84666 2.91241 2.82613 2.96198 2.82613 3.01365V5.54155C2.82613 5.61538 2.81157 5.68849 2.78329 5.75668C2.755 5.82488 2.71355 5.88683 2.6613 5.93898C2.60904 5.99114 2.54702 6.03248 2.47877 6.06064C2.41052 6.08879 2.33739 6.10322 2.26356 6.10308H1.22852C1.15477 6.10308 1.08176 6.08855 1.01363 6.06033C0.945502 6.03212 0.883601 5.99075 0.831458 5.93861C0.779316 5.88647 0.737955 5.82457 0.709736 5.75644C0.681516 5.68831 0.666992 5.6153 0.666992 5.54155V1.08604C0.666992 0.974901 0.711142 0.868315 0.789728 0.789728C0.868315 0.711142 0.974901 0.666992 1.08604 0.666992H5.54051C5.68953 0.666992 5.83246 0.726119 5.93794 0.831395C6.04341 0.936671 6.1028 1.07949 6.10308 1.22852V1.22852Z"
        fill="#42526E"
      />
      <path
        opacity="0.5"
        d="M1.22852 9.89746H2.25623C2.40543 9.89746 2.54852 9.95673 2.65403 10.0622C2.75953 10.1677 2.8188 10.3108 2.8188 10.46V12.9743C2.8188 13.026 2.83933 13.0756 2.87587 13.1121C2.91241 13.1486 2.96198 13.1692 3.01366 13.1692H5.54156C5.6153 13.1692 5.68831 13.1837 5.75644 13.2119C5.82457 13.2401 5.88647 13.2815 5.93861 13.3336C5.99075 13.3858 6.03212 13.4477 6.06034 13.5158C6.08855 13.5839 6.10308 13.657 6.10308 13.7307V14.7657C6.10391 14.84 6.09 14.9137 6.06215 14.9826C6.03431 15.0514 5.99308 15.1141 5.94085 15.1669C5.88863 15.2197 5.82644 15.2616 5.7579 15.2902C5.68936 15.3188 5.61583 15.3336 5.54156 15.3335H1.08604C0.974902 15.3335 0.868316 15.2894 0.789729 15.2108C0.711143 15.1322 0.666993 15.0256 0.666993 14.9145V10.46C0.666855 10.3862 0.681278 10.3131 0.709435 10.2448C0.737593 10.1766 0.778933 10.1146 0.831089 10.0623C0.883244 10.01 0.945193 9.96859 1.01339 9.9403C1.08158 9.91202 1.15469 9.89746 1.22852 9.89746V9.89746Z"
        fill="#42526E"
      />
      <path
        opacity="0.5"
        d="M9.89648 14.772V13.7443C9.89676 13.5952 9.95612 13.4523 10.0616 13.3468C10.167 13.2414 10.3099 13.182 10.4591 13.1818H12.9733C13.025 13.1818 13.0746 13.1612 13.1111 13.1247C13.1477 13.0881 13.1682 13.0386 13.1682 12.9869V10.459C13.1682 10.3852 13.1828 10.3121 13.211 10.2439C13.2393 10.1757 13.2808 10.1137 13.333 10.0616C13.3853 10.0094 13.4473 9.96809 13.5156 9.93993C13.5838 9.91177 13.6569 9.89735 13.7308 9.89749H14.7658C14.84 9.89679 14.9136 9.91081 14.9823 9.93872C15.051 9.96662 15.1136 10.0079 15.1663 10.0601C15.219 10.1123 15.2608 10.1744 15.2893 10.2429C15.3179 10.3114 15.3326 10.3848 15.3326 10.459V14.9145C15.3326 15.0257 15.2884 15.1322 15.2098 15.2108C15.1312 15.2894 15.0247 15.3336 14.9135 15.3336H10.4591C10.31 15.3336 10.1671 15.2744 10.0616 15.1692C9.95615 15.0639 9.89676 14.9211 9.89648 14.772V14.772Z"
        fill="#42526E"
      />
    </svg>
  );
}

function TextAlignCenter({ color }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.72411 1.93311H14.2746C14.4136 1.93311 14.5513 1.96051 14.6797 2.01375C14.8082 2.06699 14.9249 2.14502 15.0231 2.24338C15.1214 2.34175 15.1993 2.45852 15.2524 2.58701C15.3056 2.71551 15.3328 2.85321 15.3327 2.99225V3.4113C15.3327 3.55011 15.3053 3.68756 15.2522 3.81581C15.1991 3.94406 15.1212 4.06059 15.0231 4.15874C14.9249 4.2569 14.8084 4.33476 14.6801 4.38788C14.5519 4.441 14.4144 4.46834 14.2756 4.46834H1.72306C1.58416 4.46834 1.44662 4.44097 1.31831 4.38778C1.18999 4.33459 1.07342 4.25664 0.975248 4.15837C0.877078 4.0601 0.799238 3.94345 0.746178 3.81508C0.693118 3.68672 0.665878 3.54915 0.666016 3.41025V2.9912C0.666016 2.71058 0.777494 2.44145 0.975925 2.24301C1.17436 2.04458 1.44349 1.93311 1.72411 1.93311V1.93311Z"
        fill={color ? color : "#42526E"}
      />
      <path
        d="M4.062 6.73242H11.9359C12.2165 6.73242 12.4857 6.8439 12.6841 7.04233C12.8825 7.24076 12.994 7.50989 12.994 7.79052V8.20956C12.9941 8.34847 12.9669 8.48603 12.9138 8.6144C12.8608 8.74277 12.7829 8.85942 12.6848 8.95769C12.5866 9.05596 12.47 9.13391 12.3417 9.1871C12.2134 9.24028 12.0759 9.26766 11.937 9.26766H4.06095C3.92205 9.26766 3.78451 9.24028 3.6562 9.1871C3.52788 9.13391 3.41131 9.05596 3.31314 8.95769C3.21497 8.85942 3.13713 8.74277 3.08407 8.6144C3.03101 8.48603 3.00377 8.34847 3.00391 8.20956V7.79052C3.00391 7.50989 3.11538 7.24076 3.31382 7.04233C3.51225 6.8439 3.78138 6.73242 4.062 6.73242Z"
        fill={color ? color : "#42526E"}
      />
      <path
        d="M9.6752 11.5327H6.32282C6.04423 11.5338 5.77719 11.6441 5.57913 11.84C5.38106 12.036 5.26779 12.3018 5.26367 12.5803V13.0057C5.2634 13.1449 5.29059 13.2829 5.34369 13.4116C5.3968 13.5404 5.47477 13.6574 5.57315 13.7559C5.67153 13.8545 5.78838 13.9327 5.91702 13.9861C6.04565 14.0394 6.18355 14.0669 6.32282 14.0669H9.6752C9.95592 14.0669 10.2252 13.9555 10.4238 13.7571C10.6224 13.5587 10.7341 13.2895 10.7343 13.0088V12.5824C10.7308 12.3035 10.6177 12.0372 10.4196 11.8408C10.2215 11.6444 9.95414 11.5338 9.6752 11.5327V11.5327Z"
        fill={color ? color : "#42526E"}
      />
    </svg>
  );
}

function TextAlign({ color }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.137 1.93311H1.72516C1.44604 1.93419 1.17853 2.04497 0.980377 2.24156C0.782224 2.43815 0.669314 2.70476 0.666016 2.98387L0.666016 3.41025C0.666571 3.69079 0.778404 3.95965 0.976971 4.15782C1.17554 4.356 1.44462 4.4673 1.72516 4.4673H11.137C11.4175 4.4673 11.6866 4.356 11.8852 4.15782C12.0837 3.95965 12.1956 3.69079 12.1961 3.41025V2.98282C12.1925 2.7039 12.0795 2.43755 11.8814 2.24119C11.6833 2.04483 11.4159 1.93418 11.137 1.93311V1.93311Z"
        fill={color ? color : "#42526E"}
      />
      <path
        d="M14.2746 6.73242H1.72516C1.44612 6.73377 1.17877 6.84465 0.980674 7.04118C0.782579 7.2377 0.669583 7.50416 0.666016 7.78318L0.666016 8.20956C0.666293 8.49029 0.778004 8.75941 0.976602 8.95781C1.1752 9.15622 1.44444 9.26766 1.72516 9.26766H14.2746C14.4135 9.26766 14.5511 9.24029 14.6795 9.18712C14.8079 9.13394 14.9245 9.056 15.0228 8.95775C15.121 8.8595 15.199 8.74285 15.2521 8.61448C15.3053 8.48611 15.3327 8.34852 15.3327 8.20956V7.78214C15.3294 7.50331 15.2166 7.23696 15.0186 7.04057C14.8207 6.84418 14.5534 6.7335 14.2746 6.73242Z"
        fill={color ? color : "#42526E"}
      />
      <path
        d="M7.47554 11.5327H1.72516C1.44657 11.5338 1.17953 11.6441 0.981467 11.84C0.783401 12.036 0.670131 12.3018 0.666016 12.5803L0.666016 13.0057C0.666293 13.2864 0.778004 13.5555 0.976602 13.7539C1.1752 13.9523 1.44444 14.0638 1.72516 14.0638H7.47554C7.75626 14.0638 8.0255 13.9523 8.2241 13.7539C8.42269 13.5555 8.53441 13.2864 8.53468 13.0057V12.5793C8.5303 12.3009 8.41691 12.0354 8.21887 11.8397C8.02083 11.644 7.75395 11.5338 7.47554 11.5327V11.5327Z"
        fill={color ? color : "#42526E"}
      />
    </svg>
  );
}

function TextBulletedList({}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2766 1.93311H6.23401C5.95557 1.93445 5.68876 2.04494 5.4909 2.24084C5.29303 2.43675 5.17989 2.70245 5.17578 2.98086V3.40729C5.17606 3.68787 5.28764 3.95687 5.48604 4.15527C5.68443 4.35366 5.95344 4.46524 6.23401 4.46552H14.2766C14.5566 4.46497 14.825 4.35355 15.0231 4.15564C15.2212 3.95773 15.3329 3.68942 15.3337 3.40939V2.98295C15.3304 2.70427 15.2178 2.43804 15.02 2.24166C14.8223 2.04527 14.5553 1.93446 14.2766 1.93311Z"
        fill="#42526E"
      />
      <path
        d="M14.2766 6.73291H6.23401C5.95557 6.73425 5.68876 6.84474 5.4909 7.04065C5.29303 7.23656 5.17989 7.50225 5.17578 7.78066V8.20919C5.17606 8.48967 5.28767 8.75857 5.4861 8.9568C5.68453 9.15503 5.95353 9.26637 6.23401 9.26637H14.2766C14.5569 9.2661 14.8256 9.15463 15.0238 8.95643C15.222 8.75823 15.3335 8.48949 15.3337 8.20919V7.78171C15.3302 7.50321 15.2174 7.23725 15.0197 7.04109C14.8219 6.84493 14.5551 6.73426 14.2766 6.73291V6.73291Z"
        fill="#42526E"
      />
      <path
        d="M9.19496 11.5317H6.23401C5.95557 11.5331 5.68876 11.6436 5.4909 11.8395C5.29303 12.0354 5.17989 12.3011 5.17578 12.5795V13.0059C5.17634 13.2863 5.28804 13.5551 5.48641 13.7532C5.68477 13.9514 5.95362 14.0628 6.23401 14.0631H9.19496C9.47553 14.0631 9.74465 13.9518 9.94324 13.7536C10.1418 13.5554 10.2537 13.2865 10.2542 13.0059V12.5784C10.2498 12.3 10.1364 12.0344 9.93838 11.8387C9.74032 11.643 9.4734 11.5328 9.19496 11.5317V11.5317Z"
        fill="#42526E"
      />
      <path
        d="M1.93275 4.46657C2.63234 4.46657 3.19948 3.89943 3.19948 3.19984C3.19948 2.50024 2.63234 1.93311 1.93275 1.93311C1.23315 1.93311 0.666016 2.50024 0.666016 3.19984C0.666016 3.89943 1.23315 4.46657 1.93275 4.46657Z"
        fill="#42526E"
      />
      <path
        d="M1.93275 9.26637C2.63234 9.26637 3.19948 8.69924 3.19948 7.99964C3.19948 7.30005 2.63234 6.73291 1.93275 6.73291C1.23315 6.73291 0.666016 7.30005 0.666016 7.99964C0.666016 8.69924 1.23315 9.26637 1.93275 9.26637Z"
        fill="#42526E"
      />
      <path
        d="M1.93275 14.0657C2.63234 14.0657 3.19948 13.4986 3.19948 12.799C3.19948 12.0994 2.63234 11.5322 1.93275 11.5322C1.23315 11.5322 0.666016 12.0994 0.666016 12.799C0.666016 13.4986 1.23315 14.0657 1.93275 14.0657Z"
        fill="#42526E"
      />
    </svg>
  );
}

function TextItalic({ color }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8143 1.71412C12.8115 1.43532 12.6988 1.16887 12.5007 0.9727C12.3025 0.776529 12.035 0.66649 11.7562 0.666504L7.04189 0.666504C6.76307 0.66649 6.49551 0.776529 6.29738 0.9727C6.09925 1.16887 5.98655 1.43532 5.98379 1.71412V2.19917C5.98379 2.47979 6.09527 2.74893 6.2937 2.94736C6.49213 3.14579 6.76126 3.25727 7.04189 3.25727H8.15865L5.46522 12.7414H4.25731C3.9785 12.7413 3.71094 12.8514 3.51281 13.0476C3.31467 13.2437 3.20198 13.5102 3.19922 13.789V14.274C3.19908 14.4131 3.22635 14.5508 3.27946 14.6793C3.33257 14.8078 3.41049 14.9245 3.50876 15.0229C3.60702 15.1213 3.72371 15.1993 3.85216 15.2525C3.9806 15.3058 4.11828 15.3332 4.25731 15.3332H9.04703C9.32711 15.3323 9.59543 15.2205 9.79318 15.0222C9.99094 14.8238 10.102 14.5552 10.102 14.2751V13.79C10.0992 13.5112 9.98653 13.2448 9.78839 13.0486C9.59026 12.8524 9.3227 12.7424 9.04389 12.7424H7.86112L10.5546 3.25831H11.7562C12.0368 3.25831 12.3059 3.14684 12.5044 2.9484C12.7028 2.74997 12.8143 2.48084 12.8143 2.20022V1.71412Z"
        fill={color ? color : "#42526E"}
      />
    </svg>
  );
}

function TextStrikeThrough({ color }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1593 6.82696H7.99935C7.44939 6.86767 6.90546 6.69066 6.48489 6.33412C6.06431 5.97757 5.80079 5.47006 5.75116 4.92105C5.7992 4.3714 6.06228 3.86291 6.48324 3.50604C6.90419 3.14917 7.44902 2.97276 7.99935 3.01513C8.3838 3.00818 8.76402 3.09632 9.10617 3.27171C9.44832 3.4471 9.74179 3.70431 9.96049 4.02045C10.0429 4.14997 10.1501 4.26191 10.2759 4.3498C10.4018 4.43769 10.5438 4.4998 10.6938 4.53253C10.9207 4.58232 11.1573 4.56366 11.3736 4.47891C11.5899 4.39417 11.7761 4.24715 11.9088 4.05649C12.0414 3.86583 12.1144 3.64011 12.1185 3.40793C12.1227 3.17575 12.0578 2.94756 11.9321 2.75228C11.5041 2.10312 10.9195 1.57207 10.2322 1.20807C9.54494 0.844065 8.77707 0.658815 7.99935 0.669386C6.82671 0.627144 5.68502 1.05065 4.82383 1.84734C3.96263 2.64403 3.45197 3.74911 3.40344 4.92105C3.40326 5.58888 3.57576 6.24541 3.90421 6.82696H1.83935C1.52816 6.82696 1.22972 6.95053 1.00968 7.17049C0.789634 7.39045 0.666016 7.68877 0.666016 7.99984C0.666016 8.3109 0.789634 8.60923 1.00968 8.82918C1.22972 9.04914 1.52816 9.17271 1.83935 9.17271H7.99935C8.54931 9.132 9.09323 9.30901 9.51381 9.66556C9.93439 10.0221 10.1979 10.5296 10.2475 11.0786C10.1995 11.6283 9.93641 12.1368 9.51546 12.4936C9.0945 12.8505 8.54968 13.0269 7.99935 12.9845C7.61472 12.9917 7.23429 12.9036 6.89195 12.7282C6.5496 12.5528 6.25596 12.2955 6.03716 11.9792C5.95447 11.8478 5.84651 11.7341 5.71952 11.6447C5.59253 11.5553 5.44905 11.492 5.2974 11.4584C5.14575 11.4249 4.98895 11.4218 4.83609 11.4493C4.68323 11.4768 4.53735 11.5344 4.40691 11.6186C4.27648 11.7029 4.16408 11.8123 4.07624 11.9403C3.9884 12.0684 3.92687 12.2126 3.89521 12.3646C3.86356 12.5166 3.8624 12.6733 3.89182 12.8258C3.92124 12.9782 3.98064 13.1233 4.06659 13.2526C4.49523 13.9008 5.08008 14.4308 5.76732 14.7939C6.45456 15.157 7.22211 15.3414 7.99935 15.3303C9.17199 15.3725 10.3137 14.949 11.1749 14.1523C12.0361 13.3556 12.5467 12.2506 12.5953 11.0786C12.5954 10.4108 12.4229 9.75426 12.0945 9.17271H14.1593C14.4705 9.17271 14.769 9.04914 14.989 8.82918C15.2091 8.60923 15.3327 8.3109 15.3327 7.99984C15.3327 7.68877 15.2091 7.39045 14.989 7.17049C14.769 6.95053 14.4705 6.82696 14.1593 6.82696V6.82696Z"
        fill={color ? color : "#42526E"}
      />
    </svg>
  );
}

function TextUnderline({ color }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.87709 11.2412C9.30498 11.2395 10.6739 10.6715 11.6836 9.66187C12.6933 8.65219 13.2612 7.28326 13.2629 5.85536V1.92888C13.2629 1.59408 13.1299 1.27299 12.8932 1.03625C12.6564 0.799504 12.3353 0.666504 12.0005 0.666504C11.6657 0.666504 11.3446 0.799504 11.1079 1.03625C10.8711 1.27299 10.7381 1.59408 10.7381 1.92888V5.85536C10.7381 6.61416 10.4367 7.34188 9.90016 7.87843C9.36361 8.41498 8.63589 8.71641 7.87709 8.71641C7.11829 8.71641 6.39058 8.41498 5.85402 7.87843C5.31747 7.34188 5.01604 6.61416 5.01604 5.85536V1.92888C5.00658 1.60024 4.86937 1.28823 4.63356 1.05911C4.39775 0.83 4.08192 0.701834 3.75314 0.701834C3.42436 0.701834 3.10852 0.83 2.87272 1.05911C2.63691 1.28823 2.4997 1.60024 2.49023 1.92888V5.85536C2.4919 7.28344 3.06001 8.65253 4.06991 9.66224C5.07981 10.6719 6.44901 11.2398 7.87709 11.2412V11.2412Z"
        fill={color ? color : "#42526E"}
      />
      <path
        d="M14.2735 12.7988H1.72516C1.44657 12.7999 1.17953 12.9103 0.981467 13.1062C0.783401 13.3021 0.670131 13.5679 0.666016 13.8464V14.2728C0.665878 14.412 0.693172 14.5498 0.746338 14.6785C0.799503 14.8071 0.877497 14.924 0.975861 15.0224C1.07423 15.1209 1.19103 15.199 1.3196 15.2523C1.44817 15.3056 1.58598 15.333 1.72516 15.333H14.2735C14.5541 15.333 14.8232 15.2217 15.0217 15.0235C15.2203 14.8254 15.3321 14.5565 15.3327 14.276V13.8485C15.3291 13.5696 15.2161 13.3033 15.018 13.1069C14.8198 12.9105 14.5525 12.7999 14.2735 12.7988Z"
        fill={color ? color : "#42526E"}
      />
    </svg>
  );
}

function JustifyCenterIcon({ className, height, color, width }) {
  return (
    <svg
      className={className}
      width={width ? width : "12"}
      height={height ? height : "12"}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="2"
        height="18"
        transform="matrix(1 0 0 -1 7 18)"
        fill={color ? color : "#999999"}
      />
      <rect
        width="12"
        height="6"
        transform="matrix(1.31134e-07 1 1 -1.31134e-07 0 3)"
        fill={color ? color : "#999999"}
      />
      <rect
        width="12"
        height="6"
        transform="matrix(1.31134e-07 1 1 -1.31134e-07 10 3)"
        fill={color ? color : "#999999"}
      />
    </svg>
  );
}

function JustifyLeftIcon({ className, height, color, width }) {
  return (
    <svg
      className={className}
      width={width ? width : "12"}
      height={height ? height : "12"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="2"
        height="18"
        transform="matrix(1 0 0 -1 0.5 18)"
        fill={color ? color : "#999999"}
      />
      <rect
        width="12"
        height="6"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 10.5 15)"
        fill={color ? color : "#999999"}
      />
      <rect
        width="12"
        height="6"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 17.5 15)"
        fill={color ? color : "#999999"}
      />
    </svg>
  );
}

function CustomDropDownReplacedTriangleIcon({ height, width, color }) {
  return (
    <svg
      width={width ? width : "8"}
      height={height ? height : "6"}
      viewBox="0 0 8 6"
      fill={"none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.625 1.625L4 4.25L1.375 1.625"
        stroke={color ? color : "#A0A3BD"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function WidgetHeadingIcon(props) {
  return (
    <svg
      width={62}
      height={50}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.76 8.728V18.5H7.8v-4.158H3.614V18.5h-1.96V8.728h1.96v4.018H7.8V8.728h1.96zm9.139 5.726c0 .28-.019.532-.056.756h-5.67c.046.56.242.999.588 1.316.345.317.77.476 1.274.476.728 0 1.246-.313 1.554-.938h2.114a3.569 3.569 0 01-1.288 1.848c-.635.476-1.414.714-2.338.714-.747 0-1.419-.163-2.016-.49a3.606 3.606 0 01-1.386-1.414c-.327-.607-.49-1.307-.49-2.1 0-.803.163-1.507.49-2.114a3.419 3.419 0 011.372-1.4c.588-.327 1.264-.49 2.03-.49.737 0 1.395.159 1.974.476.588.317 1.04.77 1.358 1.358.326.579.49 1.246.49 2.002zm-2.03-.56c-.01-.504-.192-.905-.546-1.204-.355-.308-.789-.462-1.302-.462-.486 0-.896.15-1.232.448-.327.29-.528.695-.602 1.218h3.682zm2.956.7c0-.784.154-1.48.462-2.086.318-.607.742-1.073 1.274-1.4a3.428 3.428 0 011.806-.49c.579 0 1.083.117 1.512.35.439.233.789.527 1.05.882v-1.106h1.974V18.5H25.93v-1.134c-.252.364-.602.667-1.05.91-.438.233-.947.35-1.526.35-.653 0-1.25-.168-1.792-.504-.532-.336-.956-.807-1.274-1.414-.308-.616-.462-1.32-.462-2.114zm6.104.028c0-.476-.093-.882-.28-1.218a1.916 1.916 0 00-.756-.784 1.982 1.982 0 00-1.022-.28c-.364 0-.7.089-1.008.266a2.04 2.04 0 00-.756.784c-.186.336-.28.737-.28 1.204 0 .467.094.877.28 1.232.196.345.448.611.756.798.318.187.654.28 1.008.28.364 0 .705-.089 1.022-.266.318-.187.57-.448.756-.784.187-.345.28-.756.28-1.232zm3.385-.028c0-.784.154-1.48.462-2.086.317-.607.746-1.073 1.288-1.4a3.428 3.428 0 011.806-.49c.504 0 .984.112 1.442.336.457.215.82.504 1.092.868V8.14h1.988V18.5h-1.988v-1.148c-.243.383-.584.69-1.022.924-.44.233-.948.35-1.526.35-.654 0-1.251-.168-1.792-.504a3.569 3.569 0 01-1.288-1.414c-.308-.616-.462-1.32-.462-2.114zm6.104.028c0-.476-.094-.882-.28-1.218a1.916 1.916 0 00-.756-.784 1.982 1.982 0 00-1.022-.28c-.364 0-.7.089-1.008.266a2.04 2.04 0 00-.756.784c-.187.336-.28.737-.28 1.204 0 .467.093.877.28 1.232.196.345.448.611.756.798.317.187.653.28 1.008.28.364 0 .704-.089 1.022-.266.317-.187.569-.448.756-.784.186-.345.28-.756.28-1.232zM40.3 9.82c-.345 0-.635-.107-.868-.322a1.123 1.123 0 01-.336-.826c0-.327.112-.597.336-.812.233-.224.523-.336.868-.336s.63.112.854.336c.233.215.35.485.35.812a1.1 1.1 0 01-.35.826c-.224.215-.509.322-.854.322zm.966.924V18.5h-1.96v-7.756h1.96zm6.234-.112c.924 0 1.671.294 2.24.882.57.579.854 1.39.854 2.436v4.55h-1.96v-4.284c0-.616-.154-1.087-.462-1.414-.308-.336-.728-.504-1.26-.504-.541 0-.97.168-1.288.504-.308.327-.462.798-.462 1.414V18.5h-1.96v-7.756h1.96v.966c.262-.336.593-.597.994-.784a3.08 3.08 0 011.344-.294zm7.996-.014c.579 0 1.087.117 1.526.35.439.224.784.518 1.036.882v-1.106h1.974v7.812c0 .719-.144 1.358-.434 1.918a3.169 3.169 0 01-1.302 1.344c-.578.336-1.279.504-2.1.504-1.101 0-2.006-.257-2.716-.77-.7-.513-1.096-1.213-1.19-2.1h1.946c.103.355.322.635.658.84.346.215.76.322 1.246.322.57 0 1.032-.173 1.386-.518.355-.336.532-.85.532-1.54v-1.204c-.252.364-.602.667-1.05.91-.439.243-.943.364-1.512.364-.653 0-1.25-.168-1.792-.504a3.57 3.57 0 01-1.288-1.414c-.308-.616-.462-1.32-.462-2.114 0-.784.154-1.48.462-2.086.318-.607.742-1.073 1.274-1.4a3.428 3.428 0 011.806-.49zm2.562 4.004c0-.476-.093-.882-.28-1.218a1.916 1.916 0 00-.756-.784A1.981 1.981 0 0056 12.34c-.364 0-.7.089-1.008.266a2.04 2.04 0 00-.756.784c-.186.336-.28.737-.28 1.204 0 .467.093.877.28 1.232.196.345.448.611.756.798.318.187.654.28 1.008.28.364 0 .705-.089 1.022-.266.318-.187.57-.448.756-.784.187-.345.28-.756.28-1.232z"
        fill="#262626"
      />
      <rect x={0.334} y={25.5} width={57} height={2.5} rx={1} fill="#999" />
      <rect x={0.334} y={31} width={59} height={2.5} rx={1} fill="#999" />
      <rect x={0.334} y={36.5} width={33} height={2.5} rx={1} fill="#999" />
      <rect x={0.334} y={42} width={52} height={2.5} rx={1} fill="#999" />
    </svg>
  );
}

function WidgetParagraphIcon(props) {
  return (
    <svg
      width={65}
      height={50}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="#262626"
        stroke="#DBDBDB"
        strokeWidth={0.5}
        d="M.75 15.25h57.5v3H.75zM.75 20.75h59.5v3H.75zM.75 26.25h33.5v3H.75zM.75 31.75h52.5v3H.75z"
      />
    </svg>
  );
}

function WidgetLinkIcon(props) {
  return (
    <svg
      width={65}
      height={50}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.386 19.228h1.974v8.274h3.136V29h-5.11v-9.772zm8.623.042c0 .336-.116.62-.35.854-.233.233-.518.35-.854.35-.326 0-.606-.117-.84-.35a1.162 1.162 0 01-.35-.854c0-.336.117-.62.35-.854.234-.233.514-.35.84-.35.336 0 .621.117.854.35.234.233.35.518.35.854zM25.825 29v-7.756H27.8V29h-1.974zm6.049-7.756v1.162c.494-.85 1.297-1.274 2.408-1.274.886 0 1.61.294 2.17.882.56.579.84 1.386.84 2.422V29h-1.96v-4.284c0-.607-.154-1.069-.462-1.386-.308-.327-.728-.49-1.26-.49s-.957.163-1.274.49c-.308.317-.462.78-.462 1.386V29H29.9v-7.756h1.974zM41.294 29H39.32V18.64h1.974v5.922l2.617-3.318h2.675l-3.444 3.92L46.586 29h-2.633l-2.66-3.234V29z"
        fill="#262626"
      />
      <path
        d="M19.386 19.228v-.5h-.5v.5h.5zm1.974 0h.5v-.5h-.5v.5zm0 8.274h-.5v.5h.5v-.5zm3.136 0h.5v-.5h-.5v.5zm0 1.498v.5h.5V29h-.5zm-5.11 0h-.5v.5h.5V29zm0-9.272h1.974v-1h-1.974v1zm1.474-.5v8.274h1v-8.274h-1zm.5 8.774h3.136v-1H21.36v1zm2.636-.5V29h1v-1.498h-1zm.5.998h-5.11v1h5.11v-1zm-4.61.5v-9.772h-1V29h1zm7.773-8.876l.354.354-.354-.354zm-1.694 0l-.353.354.353-.354zm0-1.708l-.353-.354.353.354zm1.694 0l.354-.354-.354.354zM25.825 29h-.5v.5h.5V29zm0-7.756v-.5h-.5v.5h.5zm1.974 0h.5v-.5h-.5v.5zm0 7.756v.5h.5V29h-.5zm-.29-9.73a.663.663 0 01-.203.5l.707.708c.329-.33.496-.742.496-1.208h-1zm-.203.5a.663.663 0 01-.5.204v1c.465 0 .878-.167 1.207-.496l-.707-.708zm-.5.204a.647.647 0 01-.487-.204l-.707.708c.326.326.733.496 1.193.496v-1zm-.487-.204a.663.663 0 01-.204-.5h-1c0 .466.168.879.497 1.208l.707-.708zm-.204-.5c0-.206.066-.363.204-.5l-.707-.708a1.661 1.661 0 00-.497 1.208h1zm.204-.5a.647.647 0 01.486-.204v-1c-.46 0-.867.17-1.193.496l.707.708zm.486-.204c.207 0 .363.066.5.204l.708-.708a1.661 1.661 0 00-1.208-.496v1zm.5.204a.663.663 0 01.204.5h1c0-.466-.167-.879-.496-1.208l-.707.708zM26.326 29v-7.756h-1V29h1zm-.5-7.256H27.8v-1h-1.974v1zm1.474-.5V29h1v-7.756h-1zm.5 7.256h-1.974v1H27.8v-1zm4.075-7.256h.5v-.5h-.5v.5zm0 1.162h-.5v1.852l.932-1.6-.432-.252zm4.578-.392l-.362.345.002.003.36-.348zm.84 6.986v.5h.5V29h-.5zm-1.96 0h-.5v.5h.5V29zm-.462-5.67l-.364.343.005.005.359-.348zm-2.534 0l-.359-.348.359.348zM31.874 29v.5h.5V29h-.5zM29.9 29h-.5v.5h.5V29zm0-7.756v-.5h-.5v.5h.5zm1.474 0v1.162h1v-1.162h-1zm.932 1.414c.392-.673 1.015-1.026 1.976-1.026v-1c-1.261 0-2.243.497-2.84 1.522l.864.504zm1.976-1.026c.763 0 1.351.248 1.808.727l.724-.69c-.664-.697-1.523-1.037-2.532-1.037v1zm1.81.73c.446.46.7 1.13.7 2.074h1c0-1.127-.307-2.073-.981-2.77l-.719.696zm.7 2.074V29h1v-4.564h-1zm.5 4.064h-1.96v1h1.96v-1zm-1.46.5v-4.284h-1V29h1zm0-4.284c0-.688-.176-1.293-.604-1.734l-.717.696c.188.194.32.512.32 1.038h1zm-.599-1.729c-.42-.445-.981-.647-1.623-.647v1c.422 0 .7.125.896.333l.727-.686zm-1.623-.647c-.643 0-1.206.202-1.633.642l.717.696c.207-.213.494-.338.916-.338v-1zm-1.633.642c-.428.44-.603 1.047-.603 1.734h1c0-.526.132-.844.32-1.038l-.717-.696zm-.603 1.734V29h1v-4.284h-1zm.5 3.784H29.9v1h1.974v-1zM30.4 29v-7.756h-1V29h1zm-.5-7.256h1.974v-1H29.9v1zM41.294 29v.5h.5V29h-.5zm-1.974 0h-.5v.5h.5V29zm0-10.36v-.5h-.5v.5h.5zm1.974 0h.5v-.5h-.5v.5zm0 5.922h-.5v1.44l.892-1.13-.392-.31zm2.617-3.318v-.5h-.242l-.15.19.392.31zm2.675 0l.375.33.73-.83h-1.105v.5zm-3.444 3.92l-.376-.33-.293.334.297.33.371-.334zM46.586 29v.5h1.12l-.748-.834-.372.334zm-2.633 0l-.386.318.15.182h.236V29zm-2.66-3.234l.387-.318-.886-1.077v1.395h.5zm0 2.734H39.32v1h1.974v-1zm-1.474.5V18.64h-1V29h1zm-.5-9.86h1.974v-1H39.32v1zm1.474-.5v5.922h1V18.64h-1zm.893 6.232l2.618-3.318-.785-.62-2.618 3.318.785.62zm2.225-3.128h2.675v-1H43.91v1zm2.299-.83l-3.444 3.92.751.66 3.444-3.92-.751-.66zm-3.44 4.584l3.444 3.836.744-.668-3.444-3.836-.745.668zm3.816 3.002h-2.633v1h2.633v-1zm-2.246.182l-2.66-3.234-.773.636 2.66 3.234.773-.636zm-3.547-2.916V29h1v-3.234h-1z"
        fill="#DBDBDB"
      />
      <path
        d="M47 34.75h.25v-2h-29.5v2H47z"
        fill="#262626"
        stroke="#DBDBDB"
        strokeWidth={0.5}
      />
    </svg>
  );
}

function WidgetButtonIcon(props) {
  return (
    <svg
      width={65}
      height={25}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={0.584}
        y={0.75}
        width={63.5}
        height={23.5}
        rx={1.75}
        fill="#262626"
      />
      <path
        d="M13.37 8.16h3.18c.857 0 1.52.208 1.993.624.472.416.708.944.708 1.584 0 .936-.54 1.552-1.62 1.848.544.088.98.332 1.308.732.336.392.504.844.504 1.356 0 .64-.248 1.168-.744 1.584-.496.408-1.16.612-1.992.612H13.37V8.16zm1.369 1.068V11.7h1.692c.448 0 .796-.108 1.044-.324.256-.216.384-.516.384-.9 0-.392-.128-.696-.384-.912-.248-.224-.596-.336-1.044-.336h-1.692zm0 6.204h1.848c.464 0 .828-.116 1.092-.348.264-.232.396-.552.396-.96 0-.416-.14-.744-.42-.984-.28-.248-.652-.372-1.116-.372h-1.8v2.664zm10.81-5.544h1.368V16.5H25.55v-1.044c-.432.76-1.136 1.14-2.112 1.14-.744 0-1.36-.244-1.848-.732-.48-.496-.72-1.188-.72-2.076v-3.9h1.356v3.696c0 .592.148 1.048.444 1.368.296.312.7.468 1.212.468s.916-.156 1.212-.468c.304-.32.456-.776.456-1.368V9.888zm6.377 1.116h-1.608v3.66c0 .248.056.428.168.54.12.104.32.156.6.156h.84v1.14h-1.08c-1.272 0-1.908-.612-1.908-1.836v-3.66h-.78V9.888h.78V8.244h1.38v1.644h1.608v1.116zm4.465 0h-1.608v3.66c0 .248.056.428.168.54.12.104.32.156.6.156h.84v1.14h-1.08c-1.272 0-1.908-.612-1.908-1.836v-3.66h-.78V9.888h.78V8.244h1.38v1.644h1.608v1.116zm5.557 3.852c.4-.4.6-.956.6-1.668s-.196-1.264-.588-1.656c-.384-.4-.852-.6-1.404-.6-.552 0-1.016.2-1.392.6-.376.392-.564.948-.564 1.668 0 .712.184 1.268.552 1.668a1.8 1.8 0 001.368.588c.552 0 1.028-.2 1.428-.6zm-1.428 1.752c-.96 0-1.752-.312-2.376-.936-.624-.632-.936-1.456-.936-2.472 0-1.024.32-1.848.96-2.472.648-.632 1.452-.948 2.412-.948s1.76.316 2.4.948c.648.624.972 1.444.972 2.46s-.332 1.84-.996 2.472c-.656.632-1.468.948-2.436.948zm6.152-6.72v1.044c.44-.768 1.144-1.152 2.112-1.152.744 0 1.356.248 1.836.744.488.496.732 1.188.732 2.076v3.9h-1.356v-3.696c0-.592-.148-1.044-.444-1.356-.296-.32-.7-.48-1.212-.48s-.92.16-1.224.48c-.296.312-.444.764-.444 1.356V16.5h-1.368V9.888h1.368z"
        fill="#EEE"
      />
      <rect
        x={0.584}
        y={0.75}
        width={63.5}
        height={23.5}
        rx={1.75}
        stroke="#DBDBDB"
        strokeWidth={0.5}
      />
    </svg>
  );
}

function WidgetInputIcon(props) {
  return (
    <svg
      width={64}
      height={25}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={0.5} y={1} width={63} height={23} rx={1.5} fill="#999" />
      <path stroke="#262626" d="M8.5 6v13" />
      <rect x={0.5} y={1} width={63} height={23} rx={1.5} stroke="#262626" />
    </svg>
  );
}

function WidgetImageIcon(props) {
  return (
    <svg
      width={41}
      height={41}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0)">
        <g clipPath="url(#prefix__clip1)">
          <path
            d="M1.006 8.5a5 5 0 015-5h30a5 5 0 015 5v25a5 5 0 01-5 5h-30a5 5 0 01-5-5v-25zm2.5 22.5v2.5a2.5 2.5 0 002.5 2.5h30a2.5 2.5 0 002.5-2.5v-8.75l-9.443-4.867a1.25 1.25 0 00-1.442.232l-9.275 9.275-6.65-4.43a1.25 1.25 0 00-1.575.155L3.506 31zm12.5-16.25a3.75 3.75 0 10-7.5 0 3.75 3.75 0 007.5 0z"
            fill="#262626"
          />
        </g>
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <rect x={0.668} y={0.5} width={40} height={40} rx={4} fill="#fff" />
        </clipPath>
        <clipPath id="prefix__clip1">
          <path fill="#fff" transform="translate(1 1)" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function WidgetFormIcon(props) {
  return (
    <svg
      width={60}
      height={46}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={0.5} y={0.5} width={59} height={13} rx={1.5} fill="#999" />
      <rect x={0.5} y={0.5} width={59} height={13} rx={1.5} stroke="#262626" />
      <rect x={0.5} y={16.5} width={59} height={13} rx={1.5} fill="#999" />
      <rect x={0.5} y={16.5} width={59} height={13} rx={1.5} stroke="#262626" />
      <rect x={0.5} y={32.5} width={28} height={13} rx={1.5} fill="#262626" />
      <rect x={0.5} y={32.5} width={28} height={13} rx={1.5} stroke="#DBDBDB" />
    </svg>
  );
}

function WidgetBlockIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={1} y={1} width={38} height={38} rx={1} fill="#E6E6E6" />
      <rect
        x={1}
        y={1}
        width={38}
        height={38}
        rx={1}
        stroke="#262626"
        strokeWidth={2}
        strokeMiterlimit={5.759}
        strokeLinecap="square"
        strokeDasharray="6 6"
      />
    </svg>
  );
}

function WidgetDividerIcon(props) {
  return (
    <svg
      width={40}
      height={50}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0)">
        <path
          stroke="#262626"
          strokeWidth={2}
          strokeDasharray="4 4"
          d="M.668 24h64"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" transform="translate(.668)" d="M0 0h64v50H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function SendIcon(props) {
  return (
    <svg width={19} height={18} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.336 15.957l3.606-13.702A1.797 1.797 0 0015.746.059L2.044 3.667c-1.676.44-1.82 2.762-.21 3.406l5.528 2.21 3.046-3.047a.96.96 0 111.357 1.357l-3.048 3.046 2.211 5.528c.644 1.61 2.967 1.466 3.408-.21zM3.196 9.352a.959.959 0 010 1.357l-1.558 1.558A.96.96 0 11.28 10.91l1.558-1.558a.959.959 0 011.357 0z"
        fill="#202124"
      />
      <path
        d="M6.892 12.462a.959.959 0 00-1.354-1.354l-4.059 4.056a.958.958 0 101.357 1.356l4.056-4.058zm1.757 3.699a.96.96 0 10-1.357-1.357l-1.558 1.558a.96.96 0 101.357 1.357l1.558-1.558z"
        fill="#202124"
      />
    </svg>
  );
}

function Link(props) {
  return (
    <svg
      width={props.width ? props.width : "14"}
      height={props.height ? props.height : "14"}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.93557 10.12L6.05976 10.9958C5.62503 11.3877 5.05645 11.5979 4.47131 11.5829C3.88617 11.5679 3.3291 11.3289 2.91503 10.9152C2.50095 10.5015 2.26145 9.94462 2.24593 9.35949C2.23042 8.77437 2.44007 8.2056 2.83164 7.77053L3.70745 6.89472C3.88721 6.7152 3.9883 6.47163 3.98848 6.21759C3.98866 5.96354 3.88791 5.71983 3.7084 5.54007C3.52889 5.3603 3.28532 5.25921 3.03127 5.25903C2.77722 5.25885 2.53351 5.3596 2.35375 5.53911L1.47889 6.41492C0.692045 7.20177 0.25 8.26896 0.25 9.38173C0.25 10.4945 0.692045 11.5617 1.47889 12.3485C2.26574 13.1354 3.33293 13.5774 4.4457 13.5774C5.55846 13.5774 6.62566 13.1354 7.4125 12.3485L8.28831 11.4737C8.46782 11.2943 8.56872 11.0509 8.56881 10.7972C8.5689 10.5434 8.46817 10.3 8.28879 10.1205C8.1094 9.94095 7.86605 9.84005 7.61228 9.83996C7.3585 9.83987 7.11508 9.9406 6.93557 10.12Z"
        fill={props.color ? props.color : "#AOA3BD"}
      />
      <path
        d="M7.59061 4.88417L4.88417 7.59061C4.70478 7.76999 4.604 8.01329 4.604 8.26698C4.604 8.52067 4.70478 8.76397 4.88417 8.94336C5.06355 9.12274 5.30685 9.22352 5.56054 9.22352C5.81423 9.22352 6.05753 9.12274 6.23691 8.94336L8.94335 6.23691C9.12274 6.05753 9.22352 5.81423 9.22352 5.56054C9.22352 5.30685 9.12274 5.06355 8.94335 4.88417C8.76397 4.70478 8.52067 4.604 8.26698 4.604C8.01329 4.604 7.76999 4.70478 7.59061 4.88417Z"
        fill={props.color ? props.color : "#AOA3BD"}
      />
      <path
        d="M12.3485 1.47905C11.9589 1.0894 11.4964 0.780304 10.9873 0.569422C10.4783 0.35854 9.93266 0.25 9.38166 0.25C8.83066 0.25 8.28505 0.35854 7.77601 0.569422C7.26696 0.780304 6.80443 1.0894 6.41485 1.47905L5.53904 2.3539C5.35953 2.53329 5.25863 2.77664 5.25854 3.03042C5.25846 3.2842 5.35918 3.52761 5.53857 3.70713C5.71795 3.88664 5.9613 3.98754 6.21508 3.98763C6.46886 3.98771 6.71228 3.88699 6.89179 3.7076L7.7676 2.83179C8.20233 2.43984 8.7709 2.22969 9.35605 2.24468C9.94119 2.25968 10.4983 2.49869 10.9123 2.9124C11.3264 3.32611 11.5659 3.88296 11.5814 4.46809C11.5969 5.05322 11.3873 5.62198 10.9957 6.05706L10.1199 6.93287C9.94015 7.11238 9.83905 7.35595 9.83888 7.60999C9.8387 7.86404 9.93945 8.10775 10.119 8.28752C10.2985 8.46728 10.542 8.56837 10.7961 8.56855C11.0501 8.56873 11.2938 8.46798 11.4736 8.28847L12.3485 7.41266C12.7381 7.02308 13.0472 6.56055 13.2581 6.05151C13.469 5.54246 13.5775 4.99685 13.5775 4.44585C13.5775 3.89485 13.469 3.34925 13.2581 2.8402C13.0472 2.33115 12.7381 1.86863 12.3485 1.47905V1.47905Z"
        fill={props.color ? props.color : "#AOA3BD"}
      />
    </svg>
  );
}

function GiftSolid(props) {
  return (
    <svg
      width={41}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.375 31.875c0 1.037.838 1.875 1.875 1.875h9.375v-9.375H7.375v7.5zm15 1.875h9.375a1.873 1.873 0 001.875-1.875v-7.5h-11.25v9.375zM33.625 15h-2.467c.363-.709.592-1.494.592-2.344A5.164 5.164 0 0026.594 7.5c-2.438 0-4.014 1.248-6.035 4.002C18.537 8.748 16.96 7.5 14.523 7.5a5.164 5.164 0 00-5.156 5.156c0 .85.223 1.635.592 2.344H7.375A1.873 1.873 0 005.5 16.875v4.688a.94.94 0 00.938.937h28.125a.94.94 0 00.937-.938v-4.687A1.873 1.873 0 0033.625 15zm-19.107 0a2.343 2.343 0 110-4.688c1.166 0 2.027.194 5.044 4.688h-5.044zm12.076 0h-5.045c3.012-4.482 3.85-4.688 5.045-4.688a2.343 2.343 0 110 4.688z"
        fill={props.color ? props.color : "#000"}
      />
    </svg>
  );
}

function DollarSolid(props) {
  return (
    <svg
      width={props.width ? props.width : 23}
      height={props.height ? props.height : 40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.006 18.676l-6.328-1.852a1.728 1.728 0 01.486-3.387h3.885c.715 0 1.418.217 2.004.616a.913.913 0 001.142-.118l2.04-1.992c.415-.404.357-1.078-.106-1.435A8.285 8.285 0 0013.06 8.75V5.937A.94.94 0 0012.123 5h-1.875a.94.94 0 00-.938.938V8.75h-.146c-3.733 0-6.733 3.205-6.387 7.008.246 2.701 2.309 4.898 4.91 5.66l6.006 1.758a1.728 1.728 0 01-.486 3.387H9.322a3.577 3.577 0 01-2.004-.616.913.913 0 00-1.142.117l-2.04 1.993c-.415.404-.357 1.078.106 1.435A8.286 8.286 0 009.31 31.25v2.813a.94.94 0 00.938.937h1.875a.94.94 0 00.937-.938v-2.824c2.73-.052 5.291-1.675 6.194-4.26 1.26-3.609-.856-7.312-4.248-8.302z"
        fill={props.color ? props.color : "#000"}
      />
    </svg>
  );
}

function PercentSolid(props) {
  return (
    <svg
      width={22}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.438 10.875a3.936 3.936 0 003.937-3.938A3.936 3.936 0 007.437 3 3.936 3.936 0 003.5 6.938a3.936 3.936 0 003.938 3.937zm0-5.625a1.688 1.688 0 11-.001 3.376 1.688 1.688 0 010-3.376zm7.875 7.875a3.935 3.935 0 00-3.938 3.938A3.935 3.935 0 0015.313 21a3.935 3.935 0 003.937-3.938 3.935 3.935 0 00-3.938-3.937zm0 5.625a1.688 1.688 0 110-3.376 1.688 1.688 0 010 3.376zm1.979-15.743l1.11-.003a.844.844 0 01.693 1.328L6.221 20.634a.842.842 0 01-.689.359l-1.174.004a.844.844 0 01-.693-1.33L16.603 3.367a.842.842 0 01.689-.359z"
        fill="#42526E"
      />
    </svg>
  );
}

function NoUserFoundIcon() {
  return (
    <svg
      width="158"
      height="146"
      viewBox="0 0 158 146"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="71.9436" cy="71.7747" r="71.7747" fill="#F1F1F1" />
      <circle
        cx="71.357"
        cy="71.897"
        r="41.9195"
        fill="#F1F1F1"
        stroke="#C4C4C4"
        stroke-width="2"
      />
      <circle
        cx="71.357"
        cy="71.897"
        r="29.6568"
        fill="#FFFEFF"
        stroke="#C4C4C4"
        stroke-width="2"
      />
      <path
        d="M71.3566 49.3581C71.3566 48.9079 70.9914 48.5415 70.5415 48.5572C64.9089 48.7538 59.5264 50.9823 55.3981 54.8461C51.2699 58.7099 48.6905 63.9334 48.1221 69.5407C48.0767 69.9886 48.4181 70.3772 48.8674 70.4069C49.3166 70.4367 49.7033 70.0963 49.7498 69.6485C50.2901 64.4541 52.686 59.6175 56.5121 56.0364C60.3383 52.4553 65.3227 50.3843 70.5415 50.1885C70.9914 50.1716 71.3566 49.8083 71.3566 49.3581Z"
        fill="#C4C4C4"
      />
      <rect
        x="104.033"
        y="117.411"
        width="14"
        height="42"
        rx="7"
        transform="rotate(-45 104.033 117.411)"
        fill="#F1F1F1"
        stroke="#C4C4C4"
        stroke-width="2"
      />
      <rect
        x="118.81"
        y="120.781"
        width="1.94836"
        height="16.3364"
        rx="0.974179"
        transform="rotate(-45 118.81 120.781)"
        fill="white"
      />
      <rect
        x="102.61"
        y="107.504"
        width="2"
        height="8"
        transform="rotate(-45 102.61 107.504)"
        fill="#C4C4C4"
      />
      <rect
        x="123.832"
        y="66.8613"
        width="20"
        height="2"
        rx="1"
        fill="#C4C4C4"
      />
      <rect
        x="0.168945"
        y="83.4053"
        width="20"
        height="2"
        rx="1"
        fill="#C4C4C4"
      />
      <rect
        x="147.832"
        y="66.8613"
        width="10"
        height="2"
        rx="1"
        fill="#C4C4C4"
      />
      <rect
        x="128.832"
        y="74.1992"
        width="10"
        height="2"
        rx="1"
        fill="#C4C4C4"
      />
      <rect
        x="5.16895"
        y="90.7441"
        width="10"
        height="2"
        rx="1"
        fill="#C4C4C4"
      />
    </svg>
  );
}

function CalanderIcon({ height, width }) {
  return (
    <svg
      width={width ? width : "14"}
      height={width ? width : "14"}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.74927 3.08822C1.74927 2.67126 2.08728 2.33325 2.50424 2.33325H11.4943C11.9113 2.33325 12.2493 2.67126 12.2493 3.08822V12.0783C12.2493 12.4952 11.9113 12.8333 11.4943 12.8333H2.50424C2.08728 12.8333 1.74927 12.4952 1.74927 12.0783V3.08822Z"
        stroke="#A0A3BD"
        stroke-width="0.754973"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33276 1.1665V3.49984"
        stroke="#A0A3BD"
        stroke-width="0.754973"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.66626 1.1665V3.49984"
        stroke="#A0A3BD"
        stroke-width="0.754973"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.74927 5.83301H12.2493"
        stroke="#A0A3BD"
        stroke-width="0.754973"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function AndroidIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.87144 9.54343C3.87144 9.72529 3.79919 9.89971 3.6706 10.0283C3.542 10.1569 3.36758 10.2291 3.18572 10.2291C3.00386 10.2291 2.82944 10.1569 2.70084 10.0283C2.57225 9.89971 2.5 9.72529 2.5 9.54343V6.45769C2.5 6.27583 2.57225 6.10141 2.70084 5.97282C2.82944 5.84422 3.00386 5.77197 3.18572 5.77197C3.36758 5.77197 3.542 5.84422 3.6706 5.97282C3.79919 6.10141 3.87144 6.27583 3.87144 6.45769V9.54343Z"
        fill="#7CB342"
      />
      <path
        d="M13.471 9.54343C13.471 9.72529 13.3988 9.89971 13.2702 10.0283C13.1416 10.1569 12.9672 10.2291 12.7853 10.2291C12.6035 10.2291 12.429 10.1569 12.3005 10.0283C12.1719 9.89971 12.0996 9.72529 12.0996 9.54343V6.45769C12.0996 6.27583 12.1719 6.10141 12.3005 5.97282C12.429 5.84422 12.6035 5.77197 12.7853 5.77197C12.9672 5.77197 13.1416 5.84422 13.2702 5.97282C13.3988 6.10141 13.471 6.27583 13.471 6.45769V9.54343Z"
        fill="#7CB342"
      />
      <path
        d="M7.29917 13.3144C7.29917 13.4963 7.22693 13.6707 7.09833 13.7993C6.96973 13.9279 6.79532 14.0001 6.61345 14.0001C6.43159 14.0001 6.25717 13.9279 6.12858 13.7993C5.99998 13.6707 5.92773 13.4963 5.92773 13.3144V10.2287C5.92773 10.0468 5.99998 9.87241 6.12858 9.74381C6.25717 9.61521 6.43159 9.54297 6.61345 9.54297C6.79532 9.54297 6.96973 9.61521 7.09833 9.74381C7.22693 9.87241 7.29917 10.0468 7.29917 10.2287V13.3144Z"
        fill="#7CB342"
      />
      <path
        d="M10.0433 13.3144C10.0433 13.4963 9.97107 13.6707 9.84247 13.7993C9.71387 13.9279 9.53946 14.0001 9.35759 14.0001C9.17573 14.0001 9.00131 13.9279 8.87272 13.7993C8.74412 13.6707 8.67188 13.4963 8.67188 13.3144V10.2287C8.67188 10.0468 8.74412 9.87241 8.87272 9.74381C9.00131 9.61521 9.17573 9.54297 9.35759 9.54297C9.53946 9.54297 9.71387 9.61521 9.84247 9.74381C9.97107 9.87241 10.0433 10.0468 10.0433 10.2287V13.3144Z"
        fill="#7CB342"
      />
      <path
        d="M4.55664 5.77197V10.9145C4.55664 11.0964 4.62889 11.2708 4.75748 11.3994C4.88608 11.528 5.0605 11.6002 5.24236 11.6002H10.7281C10.91 11.6002 11.0844 11.528 11.213 11.3994C11.3416 11.2708 11.4138 11.0964 11.4138 10.9145V5.77197H4.55664Z"
        fill="#7CB342"
      />
      <path
        d="M7.98524 2.34302C5.92808 2.34302 4.67493 3.59274 4.55664 5.08589H11.4138C11.2952 3.59274 10.0424 2.34302 7.98524 2.34302ZM6.6138 4.26235C6.52287 4.26235 6.43566 4.22622 6.37136 4.16192C6.30706 4.09763 6.27094 4.01042 6.27094 3.91949C6.27094 3.82855 6.30706 3.74135 6.37136 3.67705C6.43566 3.61275 6.52287 3.57663 6.6138 3.57663C6.70473 3.57663 6.79194 3.61275 6.85624 3.67705C6.92053 3.74135 6.95666 3.82855 6.95666 3.91949C6.95666 4.01042 6.92053 4.09763 6.85624 4.16192C6.79194 4.22622 6.70473 4.26235 6.6138 4.26235ZM9.35667 4.26235C9.26574 4.26235 9.17853 4.22622 9.11423 4.16192C9.04994 4.09763 9.01381 4.01042 9.01381 3.91949C9.01381 3.82855 9.04994 3.74135 9.11423 3.67705C9.17853 3.61275 9.26574 3.57663 9.35667 3.57663C9.4476 3.57663 9.53481 3.61275 9.59911 3.67705C9.66341 3.74135 9.69953 3.82855 9.69953 3.91949C9.69953 4.01042 9.66341 4.09763 9.59911 4.16192C9.53481 4.22622 9.4476 4.26235 9.35667 4.26235Z"
        fill="#7CB342"
      />
      <path
        d="M10.0419 2.00024L9.4707 2.85705"
        stroke="#7CB342"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M5.92773 2.00024L6.38477 2.71408"
        stroke="#7CB342"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2614 2.00625C10.2359 1.97775 9.31716 2.0175 8.51767 2.88524C7.71817 3.75224 7.84117 4.74674 7.85917 4.77224C7.87717 4.79774 8.99916 4.83748 9.71541 3.82874C10.4317 2.82 10.2869 2.0355 10.2614 2.00625ZM12.7469 10.806C12.7109 10.734 11.0032 9.88046 11.1622 8.23947C11.3212 6.59773 12.4184 6.14773 12.4356 6.09898C12.4529 6.05023 11.9879 5.50648 11.4952 5.23123C11.1334 5.03717 10.733 4.92599 10.3229 4.90573C10.2419 4.90348 9.96066 4.83448 9.38241 4.99273C9.00141 5.09698 8.14267 5.43448 7.90642 5.44798C7.66942 5.46148 6.96442 5.05648 6.20618 4.94923C5.72093 4.85548 5.20643 5.04748 4.83819 5.19523C4.47069 5.34223 3.77169 5.76073 3.28269 6.87297C2.7937 7.98447 3.04944 9.74546 3.23244 10.293C3.41544 10.8397 3.70119 11.7359 4.18719 12.3899C4.61919 13.1279 5.19218 13.6402 5.43143 13.8142C5.67068 13.9882 6.34568 14.1037 6.81367 13.8644C7.19017 13.6334 7.86967 13.5007 8.13817 13.5104C8.40592 13.5202 8.93391 13.6259 9.47466 13.9147C9.90291 14.0624 10.3079 14.0009 10.7137 13.8359C11.1194 13.6702 11.7066 13.0417 12.3921 11.7674C12.6524 11.175 12.7709 10.8547 12.7469 10.806Z"
        fill="black"
      />
      <path
        d="M10.2614 2.00625C10.2359 1.97775 9.31716 2.0175 8.51767 2.88524C7.71817 3.75224 7.84117 4.74674 7.85917 4.77224C7.87717 4.79774 8.99916 4.83748 9.71541 3.82874C10.4317 2.82 10.2869 2.0355 10.2614 2.00625ZM12.7469 10.806C12.7109 10.734 11.0032 9.88046 11.1622 8.23947C11.3212 6.59773 12.4184 6.14773 12.4356 6.09898C12.4529 6.05023 11.9879 5.50648 11.4952 5.23123C11.1334 5.03717 10.733 4.92599 10.3229 4.90573C10.2419 4.90348 9.96066 4.83448 9.38241 4.99273C9.00141 5.09698 8.14267 5.43448 7.90642 5.44798C7.66942 5.46148 6.96442 5.05648 6.20618 4.94923C5.72093 4.85548 5.20643 5.04748 4.83819 5.19523C4.47069 5.34223 3.77169 5.76073 3.28269 6.87297C2.7937 7.98447 3.04944 9.74546 3.23244 10.293C3.41544 10.8397 3.70119 11.7359 4.18719 12.3899C4.61919 13.1279 5.19218 13.6402 5.43143 13.8142C5.67068 13.9882 6.34568 14.1037 6.81367 13.8644C7.19017 13.6334 7.86967 13.5007 8.13817 13.5104C8.40592 13.5202 8.93391 13.6259 9.47466 13.9147C9.90291 14.0624 10.3079 14.0009 10.7137 13.8359C11.1194 13.6702 11.7066 13.0417 12.3921 11.7674C12.6524 11.175 12.7709 10.8547 12.7469 10.806Z"
        fill="black"
      />
    </svg>
  );
}

function ExportIcon() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.125 5.36659C15.5583 2.49159 13.0333 0.333252 10 0.333252C7.59167 0.333252 5.5 1.69992 4.45833 3.69992C1.95 3.96659 0 6.09159 0 8.66658C0 11.4249 2.24167 13.6666 5 13.6666H15.8333C18.1333 13.6666 20 11.7999 20 9.49992C20 7.29992 18.2917 5.51659 16.125 5.36659ZM15.8333 11.9999H5C3.15833 11.9999 1.66667 10.5083 1.66667 8.66658C1.66667 6.95825 2.94167 5.53325 4.63333 5.35825L5.525 5.26659L5.94167 4.47492C6.73333 2.94992 8.28333 1.99992 10 1.99992C12.1833 1.99992 14.0667 3.54992 14.4917 5.69159L14.7417 6.94159L16.0167 7.03325C17.3167 7.11659 18.3333 8.20825 18.3333 9.49992C18.3333 10.8749 17.2083 11.9999 15.8333 11.9999ZM11.2083 5.33325H8.79167V7.83325H6.66667L10 11.1666L13.3333 7.83325H11.2083V5.33325Z"
        fill="black"
      />
    </svg>
  );
}

function AgencyInviteUserIcon() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="80" height="80" rx="40" fill="#2F80ED" />
      <path
        d="M28.75 26.25C28.75 32.4525 33.7975 37.5 40 37.5C46.2025 37.5 51.25 32.4525 51.25 26.25C51.25 20.0475 46.2025 15 40 15C33.7975 15 28.75 20.0475 28.75 26.25ZM60 62.5H62.5V60C62.5 50.3525 54.6475 42.5 45 42.5H35C25.35 42.5 17.5 50.3525 17.5 60V62.5H60Z"
        fill="white"
      />
    </svg>
  );
}

function QrCodePreviewIcon({ width, height, color }) {
  let fillColor = color ? color : "#4F4F4F";
  return (
    <svg
      width={width ? width : "16"}
      height={height ? height : "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 0H0V5H5V0ZM4 4H1V1H4V4Z" fill={fillColor} />
      <path d="M3 2H2V3H3V2Z" fill={fillColor} />
      <path d="M11 0V5H16V0H11ZM15 4H12V1H15V4Z" fill={fillColor} />
      <path d="M14 2H13V3H14V2Z" fill={fillColor} />
      <path d="M0 16H5V11H0V16ZM1 12H4V15H1V12Z" fill={fillColor} />
      <path d="M3 13H2V14H3V13Z" fill={fillColor} />
      <path d="M10 0H8V1H10V0Z" fill={fillColor} />
      <path d="M8 4H9V3H10V2H7V1H6V2V2.5V3H8V4Z" fill={fillColor} />
      <path d="M7 4H6V5H7V4Z" fill={fillColor} />
      <path d="M10 5H9V6H6V7H10V5Z" fill={fillColor} />
      <path d="M1 9H2V8H1V6H0V10H1V9Z" fill={fillColor} />
      <path d="M3 6H2V7H3V6Z" fill={fillColor} />
      <path d="M6 10H8V9H7V8H5V6H4V8H3V10H4V9H4.5H5H6V10Z" fill={fillColor} />
      <path d="M10 8H9V10H10V8Z" fill={fillColor} />
      <path d="M9 11H6V12H8V15H6V16H9V15H11V14H9V11Z" fill={fillColor} />
      <path d="M7 13H6V14H7V13Z" fill={fillColor} />
      <path d="M11 11H10V13H11V11Z" fill={fillColor} />
      <path d="M15 13H12V16H13V14H15V13Z" fill={fillColor} />
      <path d="M16 15H14V16H16V15Z" fill={fillColor} />
      <path d="M16 11H15V12H16V11Z" fill={fillColor} />
      <path d="M12 12H13V9H11V10H12V12Z" fill={fillColor} />
      <path d="M14 7H13V6H12V7H11V8H15V7H16V6H14V7Z" fill={fillColor} />
      <path d="M16 9H14V10H16V9Z" fill={fillColor} />
    </svg>
  );
}

function ImagePlus(props) {
  return (
    <svg
      width={props.width ? props.width : "41"}
      height={props.height ? props.height : "40"}
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5003 20.0001V6.66675M20.5003 20.0001V33.3334M20.5003 20.0001H33.8337M20.5003 20.0001H7.16699"
        stroke="color(neutral90)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function AvalibilityIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="6" fill="#828282" />
    </svg>
  );
}

function DeclineIcon() {
  return (
    <svg
      className="cp"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33301 3.33398L7.99967 8.00065M12.6663 12.6673L7.99967 8.00065M7.99967 8.00065L12.6663 3.33398L3.33301 12.6673"
        stroke="#42526E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function WalletlyLoaderIcon({ height, width }) {
  return (
    <svg
      width={width ? width : 128}
      height={height ? height : 128}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.4987 43.2152C36.4533 45.3253 36.7082 48.5915 37.7336 49.9495L37.7951 50.0147L37.8374 50.0507C37.9958 50.1787 39.5871 50.4109 40.8364 49.4067L46.3281 43.6489L45.9083 43.2157C44.8849 42.16 43.5446 41.6323 42.2033 41.6323C40.863 41.6323 39.5217 42.16 38.4982 43.2157L38.4987 43.2152Z"
        fill="#EFEFEF"
      />
      <path
        d="M54.9328 43.2558L54.644 43.5527L59.806 49.0311C58.4273 47.9242 57.1485 48.5059 57.1485 48.5059C56.8188 48.6154 56.4055 48.8695 56.1565 49.1265L50.5649 54.8848L52.6551 57.0363C53.5576 57.964 54.9515 58.0735 55.9725 57.3697C56.1127 57.2733 56.2461 57.1633 56.3701 57.0363L62.3514 50.8852C62.8544 50.3669 63.248 49.7547 63.5091 49.0842C64.2693 47.1391 63.8841 44.8319 62.3514 43.2558C61.3269 42.2029 59.9846 41.6758 58.6423 41.6758C57.3 41.6758 55.9573 42.2029 54.9328 43.2558Z"
        fill="#EFEFEF"
      />
      <path
        d="M48.8488 41.5978L41.0863 49.7334C40.304 50.3623 39.4439 50.4942 38.8598 50.4942C38.7698 50.4942 38.6798 50.4908 38.5917 50.4835L44.7333 56.8823C44.9467 57.1057 45.204 57.2836 45.4893 57.4052C45.7745 57.5268 46.0819 57.5896 46.3925 57.5896C47.0238 57.5896 47.6177 57.3355 48.0655 56.8741L55.8707 48.8329C56.1605 48.5325 56.5197 48.3062 56.9173 48.1733C57.3292 48.0376 57.7174 47.968 58.0722 47.968C58.1268 47.968 58.1804 47.9699 58.234 47.9728L52.2449 41.5915C52.0272 41.3638 51.7649 41.1823 51.474 41.0582C51.183 40.9341 50.8696 40.8699 50.5527 40.8696C49.9087 40.8696 49.303 41.1291 48.8483 41.5973L48.8488 41.5978Z"
        fill="#EFEFEF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50 21.25C34.1218 21.25 21.25 34.1218 21.25 50C21.25 65.8782 34.1218 78.75 50 78.75C65.8782 78.75 78.75 65.8782 78.75 50C78.75 34.1218 65.8782 21.25 50 21.25ZM50 20C33.4315 20 20 33.4315 20 50C20 66.5685 33.4315 80 50 80C66.5685 80 80 66.5685 80 50C80 33.4315 66.5685 20 50 20Z"
        fill="url(#paint0_linear)"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="1s"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"
        />
      </path>
      /&gt;
      <defs>
        <linearGradient
          id="paint0_linear"
          x1={80}
          y1={50}
          x2={20}
          y2={50}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEAC5E" />
          <stop offset="0.5" stopColor="#C779D0" />
          <stop offset={1} stopColor="#4BC0C8" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function Error(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={10} cy={10} r={9.5} fill="#EB5757" stroke="#fff" />
      <path
        d="M6.667 6.668L10 10.001m3.334 3.334L10 10m0 0l3.334-3.333-6.667 6.667"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function NavNewSettingIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id="prefix__a" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.033 11a4.033 4.033 0 11-8.067 0 4.033 4.033 0 018.067 0zm-2.016 0a2.017 2.017 0 11-4.034 0 2.017 2.017 0 014.034 0z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.285 1.653a2.513 2.513 0 00-1.781-.736h-1.008a2.513 2.513 0 00-1.833.79 2.512 2.512 0 00-.686 1.62v.022a2.56 2.56 0 00-.002.088v.015a.101.101 0 01-.173.072l-.01-.01a2.583 2.583 0 00-.064-.062l-.016-.015a2.512 2.512 0 00-1.706-.662c-.644 0-1.288.247-1.78.738l-.713.713a2.513 2.513 0 00-.737 1.855c.017.587.237 1.169.661 1.631l.015.016.061.063.01.01a.101.101 0 01-.071.174h-.015l-.088.001-.022.001a2.512 2.512 0 00-1.674.738 2.513 2.513 0 00-.736 1.78v1.009a2.513 2.513 0 00.79 1.833c.426.403.994.659 1.62.686h.022l.088.002h.015a.102.102 0 01.072.173l-.01.01a2.656 2.656 0 00-.062.064l-.015.016a2.511 2.511 0 00-.662 1.705c0 .645.247 1.289.738 1.78l.713.713a2.513 2.513 0 001.855.738 2.511 2.511 0 001.631-.662l.016-.014.063-.062.01-.01a.101.101 0 01.174.072v.014l.001.089.001.021a2.512 2.512 0 00.738 1.675 2.513 2.513 0 001.78.736h1.009a2.513 2.513 0 001.833-.79c.403-.427.659-.994.686-1.62v-.022a2.61 2.61 0 00.002-.089v-.014a.102.102 0 01.173-.072l.01.01.064.062.016.014a2.511 2.511 0 001.705.663c.645-.001 1.289-.247 1.78-.739l.713-.713a2.513 2.513 0 00.738-1.854 2.511 2.511 0 00-.662-1.631l-.014-.016a2.64 2.64 0 00-.062-.064l-.01-.01a.101.101 0 01.072-.173h.014c.03 0 .06 0 .089-.002h.021a2.512 2.512 0 001.675-.738 2.513 2.513 0 00.736-1.781v-1.008a2.513 2.513 0 00-.79-1.833 2.512 2.512 0 00-1.62-.686h-.022a2.56 2.56 0 00-.089-.002h-.014a.102.102 0 01-.072-.173l.01-.01.062-.064.014-.016a2.511 2.511 0 00.663-1.706c-.001-.644-.247-1.288-.739-1.78l-.713-.713a2.513 2.513 0 00-1.854-.737 2.511 2.511 0 00-1.631.661l-.016.015-.064.061-.01.01a.101.101 0 01-.173-.071v-.015c0-.03 0-.059-.002-.088v-.022a2.512 2.512 0 00-.738-1.674zm-2.79 17.413a.504.504 0 01-.503-.504v-.014a2.118 2.118 0 00-3.616-1.498l-.01.01a.504.504 0 01-.714 0l-.713-.713a.504.504 0 010-.713l.01-.01a2.118 2.118 0 00-1.497-3.616h-.015a.504.504 0 01-.504-.504v-1.008c0-.279.226-.505.504-.505h.015A2.118 2.118 0 004.95 6.377l-.01-.01a.504.504 0 010-.714l.712-.713a.504.504 0 01.713 0l.01.01a2.118 2.118 0 003.617-1.497v-.015c0-.278.225-.504.504-.504h1.008c.278 0 .504.226.504.504v.015a2.118 2.118 0 003.616 1.498l.01-.01a.504.504 0 01.713 0l.713.712a.504.504 0 010 .713l-.01.01a2.118 2.118 0 001.498 3.617h.014c.279 0 .505.225.505.504v1.008a.504.504 0 01-.505.504h-.014a2.118 2.118 0 00-1.498 3.616l.01.01a.504.504 0 010 .713l-.713.713a.504.504 0 01-.713 0l-.01-.01a2.118 2.118 0 00-3.616 1.498v.014a.504.504 0 01-.504.505h-1.008z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.033 11a4.033 4.033 0 11-8.067 0 4.033 4.033 0 018.067 0zm-2.016 0a2.017 2.017 0 11-4.034 0 2.017 2.017 0 014.034 0z"
        fill={props.color || "#2E3039"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.285 1.653a2.513 2.513 0 00-1.781-.736h-1.008a2.513 2.513 0 00-1.833.79 2.512 2.512 0 00-.686 1.62v.022a2.56 2.56 0 00-.002.088v.015a.101.101 0 01-.173.072l-.01-.01a2.583 2.583 0 00-.064-.062l-.016-.015a2.512 2.512 0 00-1.706-.662c-.644 0-1.288.247-1.78.738l-.713.713a2.513 2.513 0 00-.737 1.855c.017.587.237 1.169.661 1.631l.015.016.061.063.01.01a.101.101 0 01-.071.174h-.015l-.088.001-.022.001a2.512 2.512 0 00-1.674.738 2.513 2.513 0 00-.736 1.78v1.009a2.513 2.513 0 00.79 1.833c.426.403.994.659 1.62.686h.022l.088.002h.015a.102.102 0 01.072.173l-.01.01a2.656 2.656 0 00-.062.064l-.015.016a2.511 2.511 0 00-.662 1.705c0 .645.247 1.289.738 1.78l.713.713a2.513 2.513 0 001.855.738 2.511 2.511 0 001.631-.662l.016-.014.063-.062.01-.01a.101.101 0 01.174.072v.014l.001.089.001.021a2.512 2.512 0 00.738 1.675 2.513 2.513 0 001.78.736h1.009a2.513 2.513 0 001.833-.79c.403-.427.659-.994.686-1.62v-.022a2.61 2.61 0 00.002-.089v-.014a.102.102 0 01.173-.072l.01.01.064.062.016.014a2.511 2.511 0 001.705.663c.645-.001 1.289-.247 1.78-.739l.713-.713a2.513 2.513 0 00.738-1.854 2.511 2.511 0 00-.662-1.631l-.014-.016a2.64 2.64 0 00-.062-.064l-.01-.01a.101.101 0 01.072-.173h.014c.03 0 .06 0 .089-.002h.021a2.512 2.512 0 001.675-.738 2.513 2.513 0 00.736-1.781v-1.008a2.513 2.513 0 00-.79-1.833 2.512 2.512 0 00-1.62-.686h-.022a2.56 2.56 0 00-.089-.002h-.014a.102.102 0 01-.072-.173l.01-.01.062-.064.014-.016a2.511 2.511 0 00.663-1.706c-.001-.644-.247-1.288-.739-1.78l-.713-.713a2.513 2.513 0 00-1.854-.737 2.511 2.511 0 00-1.631.661l-.016.015-.064.061-.01.01a.101.101 0 01-.173-.071v-.015c0-.03 0-.059-.002-.088v-.022a2.512 2.512 0 00-.738-1.674zm-2.79 17.413a.504.504 0 01-.503-.504v-.014a2.118 2.118 0 00-3.616-1.498l-.01.01a.504.504 0 01-.714 0l-.713-.713a.504.504 0 010-.713l.01-.01a2.118 2.118 0 00-1.497-3.616h-.015a.504.504 0 01-.504-.504v-1.008c0-.279.226-.505.504-.505h.015A2.118 2.118 0 004.95 6.377l-.01-.01a.504.504 0 010-.714l.712-.713a.504.504 0 01.713 0l.01.01a2.118 2.118 0 003.617-1.497v-.015c0-.278.225-.504.504-.504h1.008c.278 0 .504.226.504.504v.015a2.118 2.118 0 003.616 1.498l.01-.01a.504.504 0 01.713 0l.713.712a.504.504 0 010 .713l-.01.01a2.118 2.118 0 001.498 3.617h.014c.279 0 .505.225.505.504v1.008a.504.504 0 01-.505.504h-.014a2.118 2.118 0 00-1.498 3.616l.01.01a.504.504 0 010 .713l-.713.713a.504.504 0 01-.713 0l-.01-.01a2.118 2.118 0 00-3.616 1.498v.014a.504.504 0 01-.504.505h-1.008z"
        fill={props.color || "#2E3039"}
      />
      <path
        clipRule="evenodd"
        d="M15.033 11a4.033 4.033 0 11-8.067 0 4.033 4.033 0 018.067 0zm-2.016 0a2.017 2.017 0 11-4.034 0 2.017 2.017 0 014.034 0z"
        stroke="#F5F7FC"
        strokeWidth={0.2}
        mask="url(#prefix__a)"
      />
      <path
        clipRule="evenodd"
        d="M13.285 1.653a2.513 2.513 0 00-1.781-.736h-1.008a2.513 2.513 0 00-1.833.79 2.512 2.512 0 00-.686 1.62v.022a2.56 2.56 0 00-.002.088v.015a.101.101 0 01-.173.072l-.01-.01a2.583 2.583 0 00-.064-.062l-.016-.015a2.512 2.512 0 00-1.706-.662c-.644 0-1.288.247-1.78.738l-.713.713a2.513 2.513 0 00-.737 1.855c.017.587.237 1.169.661 1.631l.015.016.061.063.01.01a.101.101 0 01-.071.174h-.015l-.088.001-.022.001a2.512 2.512 0 00-1.674.738 2.513 2.513 0 00-.736 1.78v1.009a2.513 2.513 0 00.79 1.833c.426.403.994.659 1.62.686h.022l.088.002h.015a.102.102 0 01.072.173l-.01.01a2.656 2.656 0 00-.062.064l-.015.016a2.511 2.511 0 00-.662 1.705c0 .645.247 1.289.738 1.78l.713.713a2.513 2.513 0 001.855.738 2.511 2.511 0 001.631-.662l.016-.014.063-.062.01-.01a.101.101 0 01.174.072v.014l.001.089.001.021a2.512 2.512 0 00.738 1.675 2.513 2.513 0 001.78.736h1.009a2.513 2.513 0 001.833-.79c.403-.427.659-.994.686-1.62v-.022a2.61 2.61 0 00.002-.089v-.014a.102.102 0 01.173-.072l.01.01.064.062.016.014a2.511 2.511 0 001.705.663c.645-.001 1.289-.247 1.78-.739l.713-.713a2.513 2.513 0 00.738-1.854 2.511 2.511 0 00-.662-1.631l-.014-.016a2.64 2.64 0 00-.062-.064l-.01-.01a.101.101 0 01.072-.173h.014c.03 0 .06 0 .089-.002h.021a2.512 2.512 0 001.675-.738 2.513 2.513 0 00.736-1.781v-1.008a2.513 2.513 0 00-.79-1.833 2.512 2.512 0 00-1.62-.686h-.022a2.56 2.56 0 00-.089-.002h-.014a.102.102 0 01-.072-.173l.01-.01.062-.064.014-.016a2.511 2.511 0 00.663-1.706c-.001-.644-.247-1.288-.739-1.78l-.713-.713a2.513 2.513 0 00-1.854-.737 2.511 2.511 0 00-1.631.661l-.016.015-.064.061-.01.01a.101.101 0 01-.173-.071v-.015c0-.03 0-.059-.002-.088v-.022a2.512 2.512 0 00-.738-1.674zm-2.79 17.413a.504.504 0 01-.503-.504v-.014a2.118 2.118 0 00-3.616-1.498l-.01.01a.504.504 0 01-.714 0l-.713-.713a.504.504 0 010-.713l.01-.01a2.118 2.118 0 00-1.497-3.616h-.015a.504.504 0 01-.504-.504v-1.008c0-.279.226-.505.504-.505h.015A2.118 2.118 0 004.95 6.377l-.01-.01a.504.504 0 010-.714l.712-.713a.504.504 0 01.713 0l.01.01a2.118 2.118 0 003.617-1.497v-.015c0-.278.225-.504.504-.504h1.008c.278 0 .504.226.504.504v.015a2.118 2.118 0 003.616 1.498l.01-.01a.504.504 0 01.713 0l.713.712a.504.504 0 010 .713l-.01.01a2.118 2.118 0 001.498 3.617h.014c.279 0 .505.225.505.504v1.008a.504.504 0 01-.505.504h-.014a2.118 2.118 0 00-1.498 3.616l.01.01a.504.504 0 010 .713l-.713.713a.504.504 0 01-.713 0l-.01-.01a2.118 2.118 0 00-3.616 1.498v.014a.504.504 0 01-.504.505h-1.008z"
        stroke="#F5F7FC"
        strokeWidth={0.2}
        mask="url(#prefix__a)"
      />
    </svg>
  );
}

function AddCustomerIcon() {
  return (
    <svg
      className="cp"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.3652 5.14C16.3652 7.84068 14.1759 10.03 11.4752 10.03C8.77454 10.03 6.58521 7.84068 6.58521 5.14C6.58521 2.43933 8.77454 0.25 11.4752 0.25C14.1759 0.25 16.3652 2.43933 16.3652 5.14ZM14.7352 5.14C14.7352 6.94045 13.2757 8.40001 11.4752 8.40001C9.67476 8.40001 8.21521 6.94045 8.21521 5.14C8.21521 3.33955 9.67476 1.88 11.4752 1.88C13.2757 1.88 14.7352 3.33955 14.7352 5.14Z"
        fill="#4F4F4F"
      />
      <path
        d="M5.93234 1.94505C6.37345 1.85551 6.65846 1.42533 6.56892 0.984212C6.47938 0.543096 6.04919 0.258089 5.60808 0.347631C3.3757 0.800779 1.6952 2.77314 1.6952 5.13983C1.6952 7.50652 3.3757 9.47888 5.60808 9.93203C6.04919 10.0216 6.47938 9.73656 6.56892 9.29545C6.65846 8.85433 6.37345 8.42415 5.93234 8.33461C4.44466 8.03262 3.3252 6.71604 3.3252 5.13983C3.3252 3.56362 4.44466 2.24704 5.93234 1.94505Z"
        fill="#4F4F4F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.154 12.1274C8.15878 11.3562 9.55919 10.845 11.4752 10.845C13.3913 10.845 14.7917 11.3562 15.7965 12.1275C16.7938 12.893 17.3363 13.8646 17.6305 14.6825C17.8895 15.4025 17.708 16.1072 17.2738 16.6066C16.8544 17.089 16.2194 17.365 15.5502 17.365H7.40023C6.731 17.365 6.09604 17.089 5.67665 16.6066C5.24239 16.1072 5.06096 15.4024 5.31994 14.6825C5.61418 13.8646 6.15673 12.8929 7.154 12.1274ZM8.14651 13.4204C7.46016 13.9473 7.07294 14.6249 6.85373 15.2342C6.80798 15.3614 6.83315 15.4525 6.9067 15.5371C6.99513 15.6388 7.16923 15.735 7.40023 15.735H15.5502C15.7812 15.735 15.9553 15.6388 16.0437 15.5371C16.1173 15.4525 16.1425 15.3614 16.0967 15.2343C15.8775 14.6249 15.4903 13.9473 14.804 13.4204C14.1251 12.8994 13.0881 12.475 11.4752 12.475C9.86242 12.475 8.82535 12.8994 8.14651 13.4204Z"
        fill="#4F4F4F"
      />
      <path
        d="M1.89971 15.1457C2.06654 14.5033 2.35289 13.8278 2.82545 13.323C3.27458 12.8432 3.92873 12.475 4.95521 12.475C5.40532 12.475 5.77021 12.1101 5.77021 11.66C5.77021 11.2099 5.40532 10.845 4.95521 10.845C3.47136 10.845 2.38839 11.4047 1.63547 12.209C0.90597 12.9883 0.525314 13.9532 0.322044 14.7359C-0.0717643 16.2523 1.21802 17.365 2.51018 17.365H3.1371C3.58721 17.365 3.9521 17.0001 3.9521 16.55C3.9521 16.0999 3.58721 15.735 3.1371 15.735H2.51018C2.27992 15.735 2.09655 15.6404 1.9923 15.5252C1.89788 15.4209 1.86032 15.2973 1.89971 15.1457Z"
        fill="#4F4F4F"
      />
    </svg>
  );
}

function Facebook() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 35.9789 8.77641 45.908 20.25 47.7084V30.9375H14.1562V24H20.25V18.7125C20.25 12.6975 23.8331 9.375 29.3152 9.375C31.9402 9.375 34.6875 9.84375 34.6875 9.84375V15.75H31.6613C28.68 15.75 27.75 17.6002 27.75 19.5V24H34.4062L33.3422 30.9375H27.75V47.7084C39.2236 45.908 48 35.9789 48 24Z"
        fill="#1877F2"
      />
      <path
        d="M33.3422 30.9375L34.4062 24H27.75V19.5C27.75 17.602 28.68 15.75 31.6613 15.75H34.6875V9.84375C34.6875 9.84375 31.9411 9.375 29.3152 9.375C23.8331 9.375 20.25 12.6975 20.25 18.7125V24H14.1562V30.9375H20.25V47.7084C22.7349 48.0972 25.2651 48.0972 27.75 47.7084V30.9375H33.3422Z"
        fill="white"
      />
    </svg>
  );
}

function Instagram() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0039 0.900391C6.99403 0.900391 5.52883 0.90556 5.24402 0.929193C4.2159 1.01468 3.57615 1.1766 2.87917 1.5237C2.34204 1.7905 1.91843 2.09975 1.50035 2.53327C0.738959 3.32386 0.277507 4.29649 0.110461 5.45265C0.0292458 6.01393 0.00561946 6.1284 0.000820359 8.99535C-0.00102545 9.951 0.000820359 11.2087 0.000820359 12.8957C0.000820359 17.9029 0.00635778 19.367 0.0303533 19.6513C0.113415 20.652 0.270308 21.2816 0.602553 21.9703C1.23751 23.2886 2.45021 24.2782 3.87886 24.6474C4.37354 24.7748 4.9199 24.845 5.6213 24.8782C5.91848 24.8912 8.94745 24.9004 11.9783 24.9004C15.0091 24.9004 18.0399 24.8967 18.3297 24.8819C19.1418 24.8437 19.6134 24.7804 20.1349 24.6456C20.8433 24.4639 21.5035 24.1297 22.0693 23.6663C22.6352 23.203 23.0932 22.6216 23.4112 21.9629C23.737 21.2909 23.9022 20.6373 23.9769 19.6888C23.9932 19.482 24 16.1851 24 12.8925C24 9.59947 23.9926 6.3086 23.9764 6.10182C23.9007 5.13804 23.7355 4.48999 23.3992 3.80501C23.1232 3.24428 22.8168 2.82554 22.372 2.39738C21.5783 1.63891 20.6074 1.17734 19.4503 1.01043C18.8897 0.929378 18.778 0.905376 15.9096 0.900391H12.0039Z"
        fill="url(#paint0_radial_7311:9749)"
      />
      <path
        d="M12.0039 0.900391C6.99403 0.900391 5.52883 0.90556 5.24402 0.929193C4.2159 1.01468 3.57615 1.1766 2.87917 1.5237C2.34204 1.7905 1.91843 2.09975 1.50035 2.53327C0.738959 3.32386 0.277507 4.29649 0.110461 5.45265C0.0292458 6.01393 0.00561946 6.1284 0.000820359 8.99535C-0.00102545 9.951 0.000820359 11.2087 0.000820359 12.8957C0.000820359 17.9029 0.00635778 19.367 0.0303533 19.6513C0.113415 20.652 0.270308 21.2816 0.602553 21.9703C1.23751 23.2886 2.45021 24.2782 3.87886 24.6474C4.37354 24.7748 4.9199 24.845 5.6213 24.8782C5.91848 24.8912 8.94745 24.9004 11.9783 24.9004C15.0091 24.9004 18.0399 24.8967 18.3297 24.8819C19.1418 24.8437 19.6134 24.7804 20.1349 24.6456C20.8433 24.4639 21.5035 24.1297 22.0693 23.6663C22.6352 23.203 23.0932 22.6216 23.4112 21.9629C23.737 21.2909 23.9022 20.6373 23.9769 19.6888C23.9932 19.482 24 16.1851 24 12.8925C24 9.59947 23.9926 6.3086 23.9764 6.10182C23.9007 5.13804 23.7355 4.48999 23.3992 3.80501C23.1232 3.24428 22.8168 2.82554 22.372 2.39738C21.5783 1.63891 20.6074 1.17734 19.4503 1.01043C18.8897 0.929378 18.778 0.905376 15.9096 0.900391H12.0039Z"
        fill="url(#paint1_radial_7311:9749)"
      />
      <path
        d="M11.9984 4.03906C9.59217 4.03906 9.2902 4.04959 8.34515 4.09261C7.40194 4.13581 6.75812 4.28518 6.19478 4.50433C5.61206 4.73069 5.11775 5.03349 4.62529 5.52627C4.13246 6.01886 3.82975 6.5133 3.60271 7.096C3.38306 7.65968 3.23355 8.30385 3.1911 9.24695C3.14901 10.1923 3.13794 10.4945 3.13794 12.9014C3.13794 15.3082 3.14865 15.6093 3.19147 16.5546C3.23484 17.4981 3.38417 18.1421 3.60308 18.7056C3.82956 19.2885 4.13228 19.7829 4.62492 20.2755C5.1172 20.7685 5.61151 21.072 6.19386 21.2984C6.75757 21.5175 7.40157 21.6669 8.34459 21.7101C9.28964 21.7531 9.59143 21.7636 11.9974 21.7636C14.4038 21.7636 14.7049 21.7531 15.6499 21.7101C16.5931 21.6669 17.2377 21.5175 17.8014 21.2984C18.3839 21.072 18.8775 20.7685 19.3698 20.2755C19.8626 19.7829 20.1653 19.2885 20.3924 18.7058C20.6102 18.1421 20.7597 17.4979 20.804 16.5548C20.8464 15.6095 20.8575 15.3082 20.8575 12.9014C20.8575 10.4945 20.8464 10.1924 20.804 9.24713C20.7597 8.30367 20.6102 7.65968 20.3924 7.09618C20.1653 6.5133 19.8626 6.01886 19.3698 5.52627C18.877 5.0333 18.3841 4.73051 17.8008 4.50433C17.236 4.28518 16.5918 4.13581 15.6486 4.09261C14.7036 4.04959 14.4027 4.03906 11.9958 4.03906H11.9984ZM11.2036 5.63612C11.4395 5.63575 11.7027 5.63612 11.9984 5.63612C14.364 5.63612 14.6443 5.64461 15.5785 5.68708C16.4423 5.72659 16.9112 5.87097 17.2235 5.99227C17.6369 6.1529 17.9317 6.34492 18.2416 6.6551C18.5517 6.96528 18.7437 7.26069 18.9046 7.67426C19.0259 7.98629 19.1704 8.45525 19.2097 9.31932C19.2522 10.2536 19.2614 10.5342 19.2614 12.8993C19.2614 15.2644 19.2522 15.5451 19.2097 16.4793C19.1702 17.3434 19.0259 17.8124 18.9046 18.1244C18.7441 18.538 18.5517 18.8324 18.2416 19.1424C17.9315 19.4526 17.6371 19.6446 17.2235 19.8053C16.9115 19.9271 16.4423 20.0711 15.5785 20.1106C14.6445 20.1531 14.364 20.1623 11.9984 20.1623C9.6326 20.1623 9.35222 20.1531 8.41824 20.1106C7.5544 20.0708 7.08557 19.9264 6.77307 19.8051C6.35961 19.6444 6.06428 19.4524 5.75419 19.1422C5.44409 18.8321 5.25213 18.5374 5.09117 18.1236C4.9699 17.8116 4.82538 17.3426 4.78606 16.4786C4.74361 15.5443 4.73512 15.2637 4.73512 12.8971C4.73512 10.5305 4.74361 10.2513 4.78606 9.31711C4.82556 8.45304 4.9699 7.98407 5.09117 7.67168C5.25176 7.2581 5.44409 6.96269 5.75419 6.65251C6.06428 6.34233 6.35961 6.15032 6.77307 5.98932C7.08538 5.86746 7.5544 5.72345 8.41824 5.68376C9.23556 5.64683 9.5523 5.63575 11.2036 5.63391V5.63612ZM16.7277 7.10763C16.5174 7.10763 16.3118 7.17001 16.137 7.28688C15.9621 7.40376 15.8259 7.56987 15.7454 7.76422C15.6649 7.95856 15.6439 8.17241 15.685 8.37871C15.726 8.58502 15.8273 8.77451 15.976 8.92323C16.1248 9.07194 16.3142 9.1732 16.5205 9.21419C16.7268 9.25518 16.9405 9.23407 17.1348 9.15352C17.3291 9.07297 17.4951 8.93661 17.6119 8.76167C17.7287 8.58673 17.791 8.38109 17.7909 8.17073C17.7909 7.58361 17.3147 7.10726 16.7277 7.10726V7.10763ZM11.9984 8.3502C9.48567 8.3502 7.44845 10.388 7.44845 12.9014C7.44845 15.4147 9.48567 17.4516 11.9984 17.4516C14.5111 17.4516 16.5477 15.4147 16.5477 12.9014C16.5477 10.388 14.5109 8.3502 11.9982 8.3502H11.9984ZM11.9984 9.94725C13.6293 9.94725 14.9517 11.2698 14.9517 12.9014C14.9517 14.5328 13.6293 15.8554 11.9984 15.8554C10.3672 15.8554 9.04508 14.5328 9.04508 12.9014C9.04508 11.2698 10.3672 9.94725 11.9984 9.94725V9.94725Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_7311:9749"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.37503 26.7489) rotate(-90) scale(23.7858 22.1226)"
        >
          <stop stop-color="#FFDD55" />
          <stop offset="0.1" stop-color="#FFDD55" />
          <stop offset="0.5" stop-color="#FF543E" />
          <stop offset="1" stop-color="#C837AB" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_7311:9749"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-4.02013 2.62931) rotate(78.6806) scale(10.6323 43.827)"
        >
          <stop stop-color="#3771C8" />
          <stop offset="0.128" stop-color="#3771C8" />
          <stop offset="1" stop-color="#6600FF" stop-opacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
}

function Website() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9743 16.7453L20.5097 16.4984C20.3853 16.4342 20.2786 16.3404 20.1988 16.2254C20.119 16.1103 20.0686 15.9775 20.052 15.8384L19.8943 14.4979C19.8667 14.2632 19.7751 14.0406 19.6293 13.8546C19.4835 13.6686 19.2893 13.5264 19.068 13.4436L17.0057 12.6756C16.8936 12.6333 16.7915 12.568 16.7062 12.4838C16.6209 12.3997 16.5541 12.2986 16.5103 12.187L15.6 9.86587C15.5676 9.78549 15.5451 9.70144 15.5331 9.61559C15.4935 9.32999 15.5683 9.0403 15.7414 8.80971C15.9146 8.57912 16.1718 8.42635 16.4571 8.38473L18.048 8.1653C18.2216 8.14098 18.3885 8.08163 18.5385 7.99087C18.6885 7.90011 18.8185 7.77982 18.9206 7.6373L19.6543 6.60873C18.7349 5.46257 17.5698 4.53767 16.2449 3.90238C14.92 3.26709 13.4693 2.93766 12 2.93844H11.8423L12.1851 4.80359C12.206 4.91436 12.2048 5.02815 12.1816 5.13845C12.1584 5.24875 12.1136 5.35339 12.0499 5.44639C11.9863 5.53938 11.9048 5.6189 11.8104 5.68038C11.7159 5.74187 11.6103 5.78413 11.4994 5.80473C11.4041 5.82016 11.3068 5.82016 11.2114 5.80473C10.9467 5.74922 10.6708 5.78894 10.4325 5.91689C10.1941 6.04484 10.0086 6.25281 9.90858 6.50416L9.46972 7.72301C9.39559 7.92907 9.24541 8.09893 9.05 8.19776C8.85459 8.29658 8.62876 8.31686 8.41886 8.25444L7.62344 8.01787C7.39724 7.94473 7.15152 7.96193 6.93772 8.06587C6.77415 8.14556 6.629 8.25849 6.51155 8.39746C6.3941 8.53643 6.30694 8.69838 6.25563 8.87294C6.20432 9.04751 6.19 9.23086 6.21359 9.41128C6.23717 9.5917 6.29813 9.76521 6.39258 9.92073L7.26858 11.3607C7.38385 11.5488 7.54535 11.7043 7.73769 11.8123C7.93004 11.9203 8.14683 11.9773 8.36744 11.9779H9.97886C10.1135 11.9774 10.2464 12.0091 10.3663 12.0704L12 12.8984C12.1249 12.9617 12.2324 13.0547 12.3131 13.1691C12.3938 13.2836 12.4452 13.4161 12.4629 13.555L12.5109 13.9304C12.5319 14.0983 12.5887 14.2597 12.6774 14.4037C12.7661 14.5477 12.8847 14.671 13.0251 14.7653L13.9406 15.3773C14.1811 15.5378 14.348 15.7873 14.4046 16.0708C14.4611 16.3544 14.4028 16.6488 14.2423 16.8893C14.206 16.9445 14.1647 16.9961 14.1189 17.0436L12.8074 18.3979C12.6554 18.5544 12.5462 18.7475 12.4903 18.9584L11.5183 22.5584C13.4969 22.6564 15.4589 22.1537 17.1465 21.1162C18.8341 20.0787 20.1685 18.555 20.9743 16.7453ZM7.47258 21.6122L7.57886 20.7447C7.6271 20.3453 7.52706 19.9421 7.29772 19.6116L5.70001 17.311C5.56637 17.1188 5.50495 16.8856 5.5266 16.6526C5.54824 16.4195 5.65156 16.2016 5.81829 16.0373C5.87743 15.9782 5.92435 15.9081 5.95636 15.8309C5.98837 15.7537 6.00485 15.6709 6.00485 15.5873C6.00485 15.5037 5.98837 15.4209 5.95636 15.3437C5.92435 15.2665 5.87743 15.1964 5.81829 15.1373C5.77845 15.0968 5.7335 15.0616 5.68458 15.0327L2.18229 13.0064C2.20151 14.7856 2.70388 16.5261 3.63569 18.0419C4.5675 19.5577 5.89372 20.7917 7.47258 21.6122ZM12 24.8984C9.62663 24.8984 7.30655 24.1947 5.33316 22.8761C3.35977 21.5575 1.8217 19.6834 0.913451 17.4906C0.0051995 15.2979 -0.232441 12.8851 0.230582 10.5574C0.693605 8.22959 1.83649 6.09139 3.51472 4.41316C5.19295 2.73493 7.33115 1.59204 9.65892 1.12902C11.9867 0.665997 14.3995 0.903637 16.5922 1.81189C18.7849 2.72014 20.6591 4.25821 21.9776 6.2316C23.2962 8.20499 24 10.5251 24 12.8984C24 16.081 22.7357 19.1333 20.4853 21.3837C18.2348 23.6342 15.1826 24.8984 12 24.8984Z"
        fill="url(#paint0_linear_7311:9765)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7311:9765"
          x1="0"
          y1="12.8984"
          x2="24"
          y2="12.8984"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0F2027" />
          <stop offset="0.5" stop-color="#203A43" />
          <stop offset="1" stop-color="#2C5364" />
        </linearGradient>
      </defs>
    </svg>
  );
}
function CrossIcon(props) {
  return (
    <svg width={props.width || "10"} height={props.height || "10"} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.560261 0.578556C0.705802 0.433506 0.903091 0.352034 1.10879 0.352034C1.31449 0.352034 1.51178 0.433506 1.65732 0.578556L4.9899 3.90399L8.32247 0.578556C8.39354 0.502456 8.47923 0.441419 8.57445 0.399085C8.66966 0.35675 8.77245 0.333987 8.87667 0.332152C8.9809 0.330317 9.08442 0.349448 9.18107 0.388404C9.27773 0.42736 9.36553 0.485343 9.43923 0.558894C9.51294 0.632445 9.57105 0.720056 9.61009 0.816502C9.64913 0.912948 9.6683 1.01625 9.66646 1.12025C9.66463 1.22425 9.64181 1.32682 9.59939 1.42183C9.55696 1.51684 9.49579 1.60235 9.41953 1.67326L6.08696 4.9987L9.41953 8.32413C9.49579 8.39504 9.55696 8.48055 9.59939 8.57556C9.64181 8.67058 9.66463 8.77314 9.66646 8.87714C9.6683 8.98114 9.64913 9.08445 9.61009 9.18089C9.57105 9.27734 9.51294 9.36495 9.43923 9.4385C9.36553 9.51205 9.27773 9.57003 9.18107 9.60899C9.08442 9.64795 8.9809 9.66708 8.87667 9.66524C8.77245 9.66341 8.66966 9.64064 8.57445 9.59831C8.47923 9.55598 8.39354 9.49494 8.32247 9.41884L4.9899 6.09341L1.65732 9.41884C1.51017 9.55566 1.31555 9.63014 1.11446 9.6266C0.913365 9.62306 0.721498 9.54177 0.579281 9.39986C0.437064 9.25795 0.3556 9.06649 0.352052 8.86583C0.348504 8.66516 0.423149 8.47096 0.560261 8.32413L3.89284 4.9987L0.560261 1.67326C0.4149 1.52803 0.333252 1.33117 0.333252 1.12591C0.333252 0.920651 0.4149 0.723786 0.560261 0.578556Z" fill={props.color ? props.color : "#84889B"}/>
    </svg>

  );
}

function BellIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.995 3.13a2 2 0 10-3.99 0c-1.564.222-2.757.729-3.653 1.508C5.11 5.72 4.608 7.182 4.332 8.601c-.139.71-.228 1.451-.312 2.16l-.003.025c-.085.712-.166 1.395-.29 2.06-.248 1.346-.65 2.503-1.472 3.421a1 1 0 00.263 1.543c1.63.899 3.536 1.514 5.538 1.859a4.023 4.023 0 00.685 1.65 4 4 0 007.203-1.65c2.002-.345 3.908-.96 5.539-1.859a1 1 0 00.262-1.543c-.822-.918-1.224-2.075-1.473-3.42-.123-.666-.204-1.349-.289-2.06l-.003-.027c-.085-.708-.173-1.448-.312-2.16-.276-1.418-.778-2.88-2.02-3.962-.896-.78-2.089-1.286-3.653-1.508zm-.227 16.805a23.883 23.883 0 01-3.536 0 2.006 2.006 0 00.843.838 2 2 0 002.693-.838zM12 18c-2.683 0-5.327-.49-7.488-1.436.646-1.066.975-2.232 1.182-3.354.135-.73.223-1.468.306-2.16l.006-.053c.086-.72.167-1.388.289-2.014.244-1.256.627-2.19 1.37-2.836C8.405 5.503 9.671 5 12 5s3.595.503 4.335 1.147c.742.646 1.126 1.58 1.37 2.836.122.626.203 1.293.289 2.014l.006.053c.083.692.17 1.43.305 2.16.208 1.122.537 2.288 1.183 3.354C17.328 17.51 14.683 18 12 18z"
        fill={props.color ? props.color : "#2F80ED"}
      />
    </svg>
  );
}

function Image(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.583 19.25h12.834a1.833 1.833 0 001.833-1.833V4.583a1.833 1.833 0 00-1.833-1.833H4.583A1.833 1.833 0 002.75 4.583v12.834a1.833 1.833 0 001.833 1.833zm2.75-6.417L9.5 15l3.334-4.916 4.584 6.417H4.583l2.75-3.667z"
        fill="#000"
      />
    </svg>
  );
}

function TimeIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.2 4.35a.75.75 0 10-.9-1.2l-3 2.25a.75.75 0 00.9 1.2l3-2.25zM16.15 3.3a.75.75 0 011.05-.15l3 2.25a.75.75 0 11-.9 1.2l-3-2.25a.75.75 0 01-.15-1.05zM13 9a.75.75 0 10-1.5 0v3.75c0 .414.336.75.75.75H16a.75.75 0 100-1.5h-3V9z"
        fill={props.color ? props.color : "#fff"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 4.5a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM5.5 12.75a6.75 6.75 0 1113.5 0 6.75 6.75 0 01-13.5 0z"
        fill={props.color ? props.color : "#fff"}
      />
    </svg>
  );
}

function RedeemCameraIcon(props) {
  return (
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.977 14.875a3.977 3.977 0 11-7.954 0 3.977 3.977 0 017.954 0zm-1.59 0a2.386 2.386 0 11-4.773 0 2.386 2.386 0 014.772 0z"
        fill="#4F4F4F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.818 6.125a.796.796 0 00-.755.544L9.45 8.51H7.636a2.386 2.386 0 00-2.386 2.387v8.75a2.386 2.386 0 002.386 2.386h12.728a2.386 2.386 0 002.386-2.386v-8.75a2.386 2.386 0 00-2.386-2.387H18.55l-.614-1.842a.796.796 0 00-.755-.544h-6.364zm-.04 3.433l.614-1.842h5.216l.615 1.842a.796.796 0 00.754.544h2.387c.439 0 .795.356.795.796v8.75c0 .439-.356.795-.795.795H7.636a.796.796 0 01-.795-.795v-8.75c0-.44.356-.796.795-.796h2.387c.342 0 .646-.219.754-.544z"
        fill="#4F4F4F"
      />
    </svg>
  );
}

function DashboardMemberIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28 9.33331C28 13.7516 24.4182 17.3333 20 17.3333C15.5817 17.3333 12 13.7516 12 9.33331C12 4.91504 15.5817 1.33331 20 1.33331C24.4182 1.33331 28 4.91504 28 9.33331ZM25.3333 9.33331C25.3333 12.2788 22.9455 14.6666 20 14.6666C17.0544 14.6666 14.6666 12.2788 14.6666 9.33331C14.6666 6.38779 17.0544 3.99998 20 3.99998C22.9455 3.99998 25.3333 6.38779 25.3333 9.33331Z"
        fill="#1E1E1E"
      />
      <path
        d="M10.9319 4.1064C11.6535 3.95991 12.1198 3.25614 11.9733 2.53448C11.8268 1.81282 11.123 1.34655 10.4014 1.49304C6.74924 2.23438 3.99996 5.46115 3.99996 9.33303C3.99996 13.2049 6.74924 16.4317 10.4014 17.173C11.123 17.3195 11.8268 16.8532 11.9733 16.1316C12.1198 15.4099 11.6535 14.7061 10.9319 14.5597C8.49804 14.0656 6.66663 11.9117 6.66663 9.33303C6.66663 6.75436 8.49804 4.60045 10.9319 4.1064Z"
        fill="#1E1E1E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.9305 20.7647C14.5743 19.5029 16.8654 18.6666 20 18.6666C23.1347 18.6666 25.4257 19.5029 27.0695 20.7647C28.7011 22.0171 29.5886 23.6066 30.07 24.9448C30.4936 26.1226 30.1968 27.2755 29.4864 28.0926C28.8003 28.8817 27.7615 29.3333 26.6666 29.3333H13.3333C12.2385 29.3333 11.1997 28.8817 10.5136 28.0926C9.80312 27.2755 9.50631 26.1226 9.93 24.9448C10.4114 23.6066 11.299 22.0171 12.9305 20.7647ZM14.5542 22.88C13.4314 23.7419 12.7979 24.8504 12.4393 25.8474C12.3644 26.0554 12.4056 26.2045 12.5259 26.3429C12.6706 26.5092 12.9554 26.6666 13.3333 26.6666H26.6666C27.0445 26.6666 27.3294 26.5093 27.474 26.3429C27.5944 26.2045 27.6355 26.0554 27.5607 25.8474C27.2021 24.8505 26.5686 23.7419 25.4458 22.88C24.3352 22.0275 22.6386 21.3333 20 21.3333C17.3615 21.3333 15.6648 22.0275 14.5542 22.88Z"
        fill="#1E1E1E"
      />
      <path
        d="M4.33452 25.7025C4.60747 24.6515 5.07593 23.5464 5.84903 22.7206C6.58381 21.9356 7.65398 21.3333 9.33329 21.3333C10.0697 21.3333 10.6666 20.7364 10.6666 20C10.6666 19.2636 10.0697 18.6666 9.33329 18.6666C6.90573 18.6666 5.13401 19.5823 3.90223 20.8982C2.70878 22.1731 2.08603 23.7517 1.75348 25.0321C1.10922 27.5129 3.21929 29.3333 5.33326 29.3333H6.35888C7.09526 29.3333 7.69221 28.7364 7.69221 28C7.69221 27.2636 7.09526 26.6666 6.35888 26.6666H5.33326C4.95655 26.6666 4.65656 26.5118 4.48601 26.3234C4.33154 26.1527 4.27009 25.9506 4.33452 25.7025Z"
        fill="#1E1E1E"
      />
    </svg>
  );
}

function DashboardPointsIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.88589 2.86647C2.25941 4.44236 0.333313 6.80516 0.333313 9.66665V20.3333C0.333313 23.1948 2.25941 25.5576 4.88589 27.1335C7.53892 28.7253 11.118 29.6666 15 29.6666C18.882 29.6666 22.461 28.7253 25.1141 27.1335C27.7405 25.5576 29.6666 23.1948 29.6666 20.3333V9.66665C29.6666 6.80516 27.7405 4.44236 25.1141 2.86647C22.461 1.27465 18.882 0.333313 15 0.333313C11.118 0.333313 7.53892 1.27465 4.88589 2.86647ZM6.25788 5.15312C4.05865 6.47265 2.99998 8.10985 2.99998 9.66665C2.99998 11.2234 4.05865 12.8606 6.25788 14.1802C8.43058 15.4838 11.5182 16.3333 15 16.3333C18.4818 16.3333 21.5694 15.4838 23.7421 14.1802C25.9413 12.8606 27 11.2234 27 9.66665C27 8.10985 25.9413 6.47265 23.7421 5.15312C21.5694 3.8495 18.4818 2.99998 15 2.99998C11.5182 2.99998 8.43058 3.8495 6.25788 5.15312ZM26.999 15.0833C26.4324 15.5943 25.7969 16.0571 25.1141 16.4668C22.461 18.0586 18.882 19 15 19C11.118 19 7.53892 18.0586 4.88589 16.4668C4.20308 16.0571 3.5676 15.5943 3.00099 15.0833C3.03807 16.615 4.09783 18.2175 6.25788 19.5135C8.43058 20.8171 11.5182 21.6666 15 21.6666C18.4818 21.6666 21.5694 20.8171 23.7421 19.5135C25.9021 18.2175 26.9619 16.615 26.999 15.0833ZM3.00099 20.4166C3.5676 20.9276 4.20308 21.3905 4.88589 21.8002C7.53892 23.392 11.118 24.3333 15 24.3333C18.882 24.3333 22.461 23.392 25.1141 21.8002C25.7969 21.3905 26.4324 20.9276 26.999 20.4166C26.9619 21.9483 25.9021 23.5508 23.7421 24.8468C21.5694 26.1505 18.4818 27 15 27C11.5182 27 8.43058 26.1505 6.25788 24.8468C4.09783 23.5508 3.03806 21.9483 3.00099 20.4166Z"
        fill="#1E1E1E"
      />
    </svg>
  );
}

function DashboardSpendingIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 22.9047C28 28.8221 22.6274 29.3333 16 29.3333C9.37258 29.3333 4 28.8221 4 22.9047C4 16.9874 9.37258 9.33331 16 9.33331C22.6274 9.33331 28 16.9874 28 22.9047Z"
        stroke="#1E1E1E"
        stroke-width="2"
      />
      <path
        d="M9.33329 4.8095C9.33329 2.83706 12.3181 2.66665 16 2.66665C19.6819 2.66665 22.6666 2.83706 22.6666 4.8095C22.6666 6.78195 19.6819 9.33331 16 9.33331C12.3181 9.33331 9.33329 6.78195 9.33329 4.8095Z"
        stroke="#1E1E1E"
        stroke-width="2"
      />
      <circle cx="16" cy="20" r="4" stroke="#1E1E1E" stroke-width="2" />
    </svg>
  );
}

function HelperTextIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99967 1.33301C4.31967 1.33301 1.33301 4.31967 1.33301 7.99967C1.33301 11.6797 4.31967 14.6663 7.99967 14.6663C11.6797 14.6663 14.6663 11.6797 14.6663 7.99967C14.6663 4.31967 11.6797 1.33301 7.99967 1.33301ZM8.66634 11.333H7.33301V9.99967H8.66634V11.333ZM8.66634 8.66634H7.33301V4.66634H8.66634V8.66634Z"
        fill="#D93025"
      />
    </svg>
  );
}

function RefreshIcon({ height, width, color }) {
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.19824 10.2213C5.00661 6.65879 8.19401 4 12 4C14.9031 4 17.4466 5.5462 18.8492 7.8636L16.3054 7.04775C15.7795 6.87909 15.2164 7.16868 15.0478 7.69458C14.8791 8.22048 15.1687 8.78354 15.6946 8.9522L20.6946 10.5558C20.9988 10.6533 21.3313 10.5997 21.5893 10.4115C21.8474 10.2232 22 9.92299 22 9.60355V3.99998C22 3.44769 21.5523 2.99998 21 2.99998C20.4477 2.99998 20 3.44769 20 3.99998V5.99928C18.1764 3.57194 15.2724 2 12 2C7.23966 2 3.25836 5.32525 2.24782 9.77871C2.12561 10.3173 2.46315 10.853 3.00174 10.9752C3.54033 11.0974 4.07602 10.7599 4.19824 10.2213Z"
        fill={color || "#222222"}
      />
      <path
        d="M21.7522 14.2213C21.8744 13.6827 21.5369 13.147 20.9983 13.0248C20.4597 12.9026 19.924 13.2401 19.8018 13.7787C18.9934 17.3412 15.806 20 12 20C9.06371 20 6.49525 18.4182 5.10306 16.0565L8.75746 16.9701C9.29326 17.1041 9.83619 16.7783 9.97014 16.2425C10.1041 15.7067 9.77833 15.1638 9.24253 15.0298L3.24253 13.5298C2.94379 13.4551 2.6273 13.5223 2.38459 13.7118C2.14187 13.9013 2 14.192 2 14.5V20C2 20.5523 2.44771 21 3 21C3.55228 21 4 20.5523 4 20L4 18.0007C5.82361 20.428 8.7276 22 12 22C16.7604 22 20.7417 18.6747 21.7522 14.2213Z"
        fill={color || "#222222"}
      />
    </svg>
  );
}

function EyeIconPassword() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.28124 12C9.28124 12.6962 9.55781 13.3639 10.0501 13.8562C10.5424 14.3484 11.2101 14.625 11.9062 14.625C12.6024 14.625 13.2701 14.3484 13.7624 13.8562C14.2547 13.3639 14.5313 12.6962 14.5313 12C14.5313 11.3038 14.2547 10.6361 13.7624 10.1438C13.2701 9.65156 12.6024 9.375 11.9062 9.375C11.2101 9.375 10.5424 9.65156 10.0501 10.1438C9.55781 10.6361 9.28124 11.3038 9.28124 12V12ZM22.0828 11.3953C19.8609 6.71484 16.5023 4.35938 12 4.35938C7.4953 4.35938 4.13905 6.71484 1.91717 11.3977C1.82805 11.5864 1.78183 11.7925 1.78183 12.0012C1.78183 12.2099 1.82805 12.416 1.91717 12.6047C4.13905 17.2852 7.49765 19.6406 12 19.6406C16.5047 19.6406 19.8609 17.2852 22.0828 12.6023C22.2633 12.2227 22.2633 11.782 22.0828 11.3953V11.3953ZM11.9062 16.125C9.62812 16.125 7.78124 14.2781 7.78124 12C7.78124 9.72188 9.62812 7.875 11.9062 7.875C14.1844 7.875 16.0313 9.72188 16.0313 12C16.0313 14.2781 14.1844 16.125 11.9062 16.125Z"
        fill="#5F6368"
      />
    </svg>
  );
}

function CrossEyeIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9062 14.6241C12.6024 14.6241 13.2701 14.3475 13.7624 13.8552C14.2546 13.363 14.5312 12.6953 14.5312 11.9991C14.5312 11.9222 14.5277 11.846 14.5211 11.7708L11.6779 14.614C11.7532 14.6206 11.8291 14.6241 11.9062 14.6241ZM20.595 3.87941L19.5937 2.87909C19.5585 2.84396 19.5109 2.82422 19.4612 2.82422C19.4115 2.82422 19.3638 2.84396 19.3286 2.87909L16.7664 5.44198C15.353 4.71964 13.7642 4.35847 12 4.35847C7.49526 4.35847 4.13433 6.70456 1.91714 11.3967C1.82802 11.5855 1.7818 11.7916 1.7818 12.0003C1.7818 12.209 1.82802 12.4151 1.91714 12.6038C2.80308 14.4699 3.86987 15.9656 5.11753 17.0909L2.63808 19.5694C2.60294 19.6046 2.5832 19.6522 2.5832 19.7019C2.5832 19.7517 2.60294 19.7993 2.63808 19.8345L3.63862 20.835C3.67378 20.8702 3.72146 20.8899 3.77116 20.8899C3.82087 20.8899 3.86854 20.8702 3.9037 20.835L20.595 4.14472C20.6124 4.1273 20.6262 4.10662 20.6357 4.08386C20.6451 4.0611 20.6499 4.0367 20.6499 4.01206C20.6499 3.98742 20.6451 3.96302 20.6357 3.94026C20.6262 3.9175 20.6124 3.89682 20.595 3.87941ZM7.7812 11.9991C7.78114 11.2866 7.96562 10.5863 8.31667 9.96625C8.66773 9.34626 9.17339 8.82776 9.78439 8.46127C10.3954 8.09478 11.0909 7.8928 11.8032 7.875C12.5154 7.85721 13.2202 8.0242 13.8487 8.35972L12.7092 9.49925C12.2496 9.3521 11.7584 9.33438 11.2894 9.44803C10.8204 9.56168 10.3918 9.80231 10.0506 10.1435C9.70942 10.4847 9.46879 10.9133 9.35514 11.3823C9.24149 11.8513 9.25921 12.3425 9.40636 12.8021L8.26683 13.9416C7.94705 13.3441 7.78021 12.6768 7.7812 11.9991V11.9991Z"
        fill="#5F6368"
      />
      <path
        d="M22.0828 11.3949C21.2578 9.65742 20.2759 8.24063 19.1369 7.14453L15.7587 10.523C16.0434 11.2675 16.1066 12.0784 15.9404 12.8579C15.7742 13.6374 15.3859 14.3521 14.8223 14.9157C14.2588 15.4793 13.544 15.8676 12.7645 16.0338C11.985 16.1999 11.1741 16.1368 10.4297 15.852L7.56421 18.7175C8.89358 19.3327 10.3722 19.6402 12 19.6402C16.5047 19.6402 19.8656 17.2941 22.0828 12.602C22.1719 12.4132 22.2182 12.2071 22.2182 11.9984C22.2182 11.7897 22.1719 11.5836 22.0828 11.3949V11.3949Z"
        fill="#5F6368"
      />
    </svg>
  );
}

function IconStop(props) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule = "evenodd"
        clipRule = "evenodd"
        d        = "M9 2.625a6.375 6.375 0 00-5.238 10.01l8.87-8.875A6.342 6.342 0 009 2.625zm5.226 2.722L5.35 14.228a6.375 6.375 0 008.875-8.88zM.375 9a8.625 8.625 0 1117.25 0A8.625 8.625 0 01.375 9z"
        fill     = "red"
      />
    </svg>
  );
}

function IconInformation(props) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id="prefix__a" fill="#fff">
        <path d="M8.25 12.75h1.5v-4.5h-1.5v4.5zM9 1.5C4.86 1.5 1.5 4.86 1.5 9c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5zM9 15c-3.308 0-6-2.693-6-6 0-3.308 2.692-6 6-6 3.307 0 6 2.692 6 6 0 3.307-2.693 6-6 6zm-.75-8.25h1.5v-1.5h-1.5v1.5z" />
      </mask>
      <path
        d="M8.25 12.75h1.5v-4.5h-1.5v4.5zM9 1.5C4.86 1.5 1.5 4.86 1.5 9c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5zM9 15c-3.308 0-6-2.693-6-6 0-3.308 2.692-6 6-6 3.307 0 6 2.692 6 6 0 3.307-2.693 6-6 6zm-.75-8.25h1.5v-1.5h-1.5v1.5z"
        fill="#2F80ED"
      />
      <path
        d="M8.25 12.75h-2v2h2v-2zm1.5 0v2h2v-2h-2zm0-4.5h2v-2h-2v2zm-1.5 0v-2h-2v2h2zm0-1.5h-2v2h2v-2zm1.5 0v2h2v-2h-2zm0-1.5h2v-2h-2v2zm-1.5 0v-2h-2v2h2zm0 9.5h1.5v-4h-1.5v4zm3.5-2v-4.5h-4v4.5h4zm-2-6.5h-1.5v4h1.5v-4zm-3.5 2v4.5h4v-4.5h-4zM9-.5C3.755-.5-.5 3.755-.5 9h4c0-3.035 2.465-5.5 5.5-5.5v-4zM-.5 9c0 5.245 4.255 9.5 9.5 9.5v-4A5.503 5.503 0 013.5 9h-4zM9 18.5c5.245 0 9.5-4.255 9.5-9.5h-4c0 3.035-2.465 5.5-5.5 5.5v4zM18.5 9c0-5.245-4.255-9.5-9.5-9.5v4c3.035 0 5.5 2.465 5.5 5.5h4zM9 13c-2.203 0-4-1.797-4-4H1c0 4.412 3.588 8 8 8v-4zM5 9c0-2.203 1.797-4 4-4V1C4.588 1 1 4.588 1 9h4zm4-4c2.203 0 4 1.797 4 4h4c0-4.412-3.588-8-8-8v4zm4 4c0 2.203-1.797 4-4 4v4c4.412 0 8-3.588 8-8h-4zm-4.75-.25h1.5v-4h-1.5v4zm3.5-2v-1.5h-4v1.5h4zm-2-3.5h-1.5v4h1.5v-4zm-3.5 2v1.5h4v-1.5h-4z"
        fill="#6FCF97"
        mask="url(#prefix__a)"
      />
      <path
        d="M8.25 5.25h1.5v1.5h-1.5v-1.5zm0 3h1.5v4.5h-1.5v-4.5z"
        fill="#2F80ED"
      />
      <path
        d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5zM9 15c-3.308 0-6-2.693-6-6 0-3.308 2.692-6 6-6 3.307 0 6 2.692 6 6 0 3.307-2.693 6-6 6z"
        fill="#2F80ED"
      />
    </svg>
  );
}

function IconCheckList(props) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 8.31V9a7.5 7.5 0 11-4.447-6.855M16.5 3L9 10.508l-2.25-2.25"
        stroke="#6FCF97"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function FilterSearch() {
  return (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.565 12.566a.791.791 0 00.56 1.351h3.75a.791.791 0 100-1.583h-3.75a.792.792 0 00-.56.232zm4.341-.065H8.125M5.065 8.816a.792.792 0 00.56 1.351h8.75a.792.792 0 100-1.583h-8.75a.792.792 0 00-.56.232zM2.565 5.066a.792.792 0 00.56 1.351h13.75a.791.791 0 100-1.583H3.125a.792.792 0 00-.56.232z"
        fill="#84889B"
      />
    </svg>
  );
}

// function Search(props) {
//   return (
//     <svg
//       width={props.width ? props.width : 24}
//       height={props.height ? props.height : 24}
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//       {...props}
//     >
//       <path
//         d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z"
//         fill="#fff"
//         fillOpacity={0.01}
//       />
//       <path
//         d="M15.188 13.582l5.303 5.303c.482.482.509 1.259.082 1.715-.457.402-1.207.375-1.688-.107l-5.304-5.303c-1.098.75-2.438 1.312-3.883 1.312C6 16.502 3 13.421 3 9.725s3-6.723 6.697-6.723c3.695 0 6.695 3.027 6.695 6.723 0 1.473-.456 2.758-1.206 3.857zM5.25 9.723a4.44 4.44 0 004.446 4.473c2.465 0 4.5-1.981 4.5-4.473 0-2.437-2.035-4.473-4.5-4.473S5.25 7.286 5.25 9.723z"
//         fill={props.color || "#5F6368"}
//       />
//     </svg>
//   );
// }

function Deactivate({ color, height, width }) {
  return (
    <svg
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="6" fill={color || "#4BD964"} />
    </svg>
  );
}

function CheckBoxUnCheckIcon() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7726:9476)">
        <path
          d="M1 3.5C1 2.39543 1.89543 1.5 3 1.5H12C13.1046 1.5 14 2.39543 14 3.5V12.5C14 13.6046 13.1046 14.5 12 14.5H3C1.89543 14.5 1 13.6046 1 12.5V3.5Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.7579 4.36763C12.9695 4.57917 12.9695 4.92213 12.7579 5.13367L6.25794 11.6337C6.0464 11.8452 5.70344 11.8452 5.4919 11.6337L2.2419 8.38367C2.03037 8.17213 2.03037 7.82917 2.2419 7.61764C2.45344 7.4061 2.7964 7.4061 3.00793 7.61764L5.87492 10.4846L11.9919 4.36763C12.2034 4.1561 12.5464 4.1561 12.7579 4.36763Z"
          fill="white"
        />
      </g>
      <path
        d="M3 2.5H12V0.5H3V2.5ZM13 3.5V12.5H15V3.5H13ZM12 13.5H3V15.5H12V13.5ZM2 12.5V3.5H0V12.5H2ZM3 13.5C2.44772 13.5 2 13.0523 2 12.5H0C0 14.1569 1.34315 15.5 3 15.5V13.5ZM13 12.5C13 13.0523 12.5523 13.5 12 13.5V15.5C13.6569 15.5 15 14.1569 15 12.5H13ZM12 2.5C12.5523 2.5 13 2.94772 13 3.5H15C15 1.84315 13.6569 0.5 12 0.5V2.5ZM3 0.5C1.34315 0.5 0 1.84315 0 3.5H2C2 2.94772 2.44772 2.5 3 2.5V0.5Z"
        fill="#DADCE0"
      />
      <defs>
        <clipPath id="clip0_7726:9476">
          <path
            d="M1 3.5C1 2.39543 1.89543 1.5 3 1.5H12C13.1046 1.5 14 2.39543 14 3.5V12.5C14 13.6046 13.1046 14.5 12 14.5H3C1.89543 14.5 1 13.6046 1 12.5V3.5Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function CheckBoxCheckIcon() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7742:9476)">
        <path
          d="M1 3.5C1 2.39543 1.89543 1.5 3 1.5H12C13.1046 1.5 14 2.39543 14 3.5V12.5C14 13.6046 13.1046 14.5 12 14.5H3C1.89543 14.5 1 13.6046 1 12.5V3.5Z"
          fill="#2F80ED"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.7579 4.36763C12.9695 4.57917 12.9695 4.92213 12.7579 5.13367L6.25794 11.6337C6.0464 11.8452 5.70344 11.8452 5.4919 11.6337L2.2419 8.38367C2.03037 8.17213 2.03037 7.82917 2.2419 7.61764C2.45344 7.4061 2.7964 7.4061 3.00793 7.61764L5.87492 10.4846L11.9919 4.36763C12.2034 4.1561 12.5464 4.1561 12.7579 4.36763Z"
          fill="white"
        />
      </g>
      <path
        d="M3 2.5H12V0.5H3V2.5ZM13 3.5V12.5H15V3.5H13ZM12 13.5H3V15.5H12V13.5ZM2 12.5V3.5H0V12.5H2ZM3 13.5C2.44772 13.5 2 13.0523 2 12.5H0C0 14.1569 1.34315 15.5 3 15.5V13.5ZM13 12.5C13 13.0523 12.5523 13.5 12 13.5V15.5C13.6569 15.5 15 14.1569 15 12.5H13ZM12 2.5C12.5523 2.5 13 2.94772 13 3.5H15C15 1.84315 13.6569 0.5 12 0.5V2.5ZM3 0.5C1.34315 0.5 0 1.84315 0 3.5H2C2 2.94772 2.44772 2.5 3 2.5V0.5Z"
        fill="#2F80ED"
      />
      <defs>
        <clipPath id="clip0_7742:9476">
          <path
            d="M1 3.5C1 2.39543 1.89543 1.5 3 1.5H12C13.1046 1.5 14 2.39543 14 3.5V12.5C14 13.6046 13.1046 14.5 12 14.5H3C1.89543 14.5 1 13.6046 1 12.5V3.5Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function Point(props) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0_7870:71730)" fill="#F2C94C">
        <path d="M8 15A7 7 0 118 1a7 7 0 010 14zm0 1A8 8 0 108-.001 8 8 0 008 16z" />
        <path d="M8 13.5a5.5 5.5 0 110-11 5.5 5.5 0 010 11zm0 .5A6 6 0 108 1.999 6 6 0 008 14z" />
        <path d="M6.153 10.667h.992V8.638h.746c1.142 0 1.955-.5 1.955-1.626v-.03c0-1.118-.784-1.648-1.977-1.648H6.153v5.333zm.992-2.745v-1.82h.724c.634 0 1.007.246 1.007.88v.03c0 .59-.35.91-1.007.91h-.724z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_7870:71730">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

//latesttickicon

function TickIconSub() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8537 3.64592C13.9002 3.69236 13.9372 3.74754 13.9624 3.80828C13.9876 3.86903 14.0005 3.93415 14.0005 3.99992C14.0005 4.06568 13.9876 4.13081 13.9624 4.19155C13.9372 4.2523 13.9002 4.30747 13.8537 4.35392L6.85365 11.3539C6.80721 11.4005 6.75203 11.4374 6.69129 11.4626C6.63054 11.4878 6.56542 11.5008 6.49965 11.5008C6.43389 11.5008 6.36877 11.4878 6.30802 11.4626C6.24728 11.4374 6.1921 11.4005 6.14565 11.3539L2.64565 7.85392C2.55177 7.76003 2.49902 7.63269 2.49902 7.49992C2.49902 7.36714 2.55177 7.2398 2.64565 7.14592C2.73954 7.05203 2.86688 6.99929 2.99966 6.99929C3.13243 6.99929 3.25977 7.05203 3.35366 7.14592L6.49965 10.2929L13.1457 3.64592C13.1921 3.59935 13.2473 3.56241 13.308 3.5372C13.3688 3.512 13.4339 3.49902 13.4997 3.49902C13.5654 3.49902 13.6305 3.512 13.6913 3.5372C13.752 3.56241 13.8072 3.59935 13.8537 3.64592V3.64592Z"
        fill="#2F80ED"
      />
    </svg>
  );
}

function InventoryIcon({ color }) {
  return (
  <svg width="25px" height="25px"  viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <title>product</title>
    <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
      <g id="icon" fill="#000000" transform="translate(64.000000, 34.346667)">
        <path d="M192,7.10542736e-15 L384,110.851252 L384,332.553755 L192,443.405007 L1.42108547e-14,332.553755 L1.42108547e-14,110.851252 L192,7.10542736e-15 Z M127.999,206.918 L128,357.189 L170.666667,381.824 L170.666667,231.552 L127.999,206.918 Z M42.6666667,157.653333 L42.6666667,307.920144 L85.333,332.555 L85.333,182.286 L42.6666667,157.653333 Z M275.991,97.759 L150.413,170.595 L192,194.605531 L317.866667,121.936377 L275.991,97.759 Z M192,49.267223 L66.1333333,121.936377 L107.795,145.989 L233.374,73.154 L192,49.267223 Z" id="Combined-Shape">
        </path>
      </g>
    </g>
  </svg>
  );
}

function DealIcon(props) {
  return (
    <svg
      width={18}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.023 8.353l-.663 5.07a2.33 2.33 0 01-.825 1.483 2.583 2.583 0 01-1.656.594H5.117c-.61 0-1.2-.211-1.656-.594a2.33 2.33 0 01-.825-1.484l-.66-5.069a1.683 1.683 0 01-.941-.552 1.526 1.526 0 01-.368-.99V5.234c0-.419.175-.82.488-1.116a1.715 1.715 0 011.178-.462h.906a2.019 2.019 0 01-.074-.545c0-.58.202-1.144.573-1.606.217-.27.49-.498.8-.667a2.826 2.826 0 012.074-.24c.346.094.668.252.947.465l.08.07L9 2.48l1.36-1.346.08-.07c.28-.213.601-.37.946-.464a2.826 2.826 0 012.075.24c.31.169.583.396.8.667.373.46.574 1.024.572 1.604a2 2 0 01-.075.545h.909c.442 0 .866.166 1.178.462.313.296.488.697.488 1.116V6.81c0 .36-.13.71-.368.99s-.57.475-.942.552zm-1.683.036H9.833v5.533h3.046c.203 0 .4-.07.552-.198a.777.777 0 00.275-.494l.633-4.84h.001zm-6.173 5.533V8.39H3.66l.63 4.84a.777.777 0 00.275.495.86.86 0 00.552.198h3.05zm0-8.688H2.333V6.81h5.834V5.234zm0 0h3.046-1.38V6.81h5.834V5.234h-7.5zm-2.76-1.578H7.81l.035-.035-1.368-1.355a1.058 1.058 0 00-.752-.177 1.026 1.026 0 00-.665.376c-.15.185-.231.413-.23.646 0 .301.258.545.576.545zm7.185 0a.592.592 0 00.406-.16.53.53 0 00.169-.385 1.037 1.037 0 00-.894-1.022 1.058 1.058 0 00-.752.177l-1.404 1.39h2.475z"
        fill="#41536C"
      />
    </svg>
  );
}

function GripIcon(props) {
  return (
    <svg
      width={24}
      height={25}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 3.6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm4.5 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-4.5 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm4.5 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-4.5 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm4.5 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-4.5 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm4.5 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-4.5 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm4.5 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
        fill="#DADCE0"
      />
    </svg>
  );
}

function CheckInIcon(props) {
  return (
    <svg
      width={36}
      height={37}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y={0.6} width={36} height={36} rx={4} fill="#E2FAEC" />
      <g clipPath="url(#prefix__clip0_8415_73557)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 12.6a6 6 0 116.75 5.954v8.296a.75.75 0 11-1.5 0v-8.295A6 6 0 0112 12.598v.002zm3.74 12.861a.75.75 0 01-.617.863c-1.068.176-1.92.442-2.482.739-.207.1-.395.234-.556.398a.451.451 0 00-.085.135v.004l.003.012a.22.22 0 00.024.05c.06.086.133.162.218.225.247.194.652.404 1.219.592 1.127.375 2.73.621 4.536.621 1.806 0 3.41-.245 4.536-.621.567-.189.972-.398 1.22-.592a.929.929 0 00.218-.226.219.219 0 00.023-.049L24 27.6v-.006a.451.451 0 00-.085-.135 1.98 1.98 0 00-.555-.396c-.564-.297-1.415-.563-2.483-.74a.751.751 0 11.246-1.479c1.155.191 2.178.492 2.935.891.692.365 1.442.965 1.442 1.865 0 .639-.39 1.128-.816 1.465-.435.342-1.02.62-1.674.837-1.317.44-3.088.698-5.01.698-1.922 0-3.693-.258-5.01-.698-.654-.217-1.239-.495-1.674-.837-.426-.337-.816-.826-.816-1.465 0-.899.75-1.5 1.441-1.865.758-.398 1.781-.7 2.936-.89a.75.75 0 01.862.616z"
          fill="#23C96F"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_8415_73557">
          <path fill="#fff" transform="translate(6 6.6)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function VisitIcon(props) {
  return (
    <svg
      width={36}
      height={37}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y={0.6} width={36} height={36} rx={4} fill="#FBEDDF" />
      <g clipPath="url(#prefix__clip0_8415_73491)">
        <path
          d="M19.749 11.1a2.25 2.25 0 10-.001-4.501 2.25 2.25 0 000 4.501zm4.43 6.989l-1.093-.553-.454-1.378c-.69-2.09-2.611-3.553-4.791-3.558-1.688-.005-2.62.473-4.373 1.181a4.471 4.471 0 00-2.33 2.166l-.314.637c-.366.741-.07 1.641.665 2.011a1.48 1.48 0 001.993-.67l.314-.637a1.49 1.49 0 01.773-.722l1.256-.507-.712 2.846a3.01 3.01 0 00.698 2.756l2.808 3.066c.338.37.577.815.699 1.298l.857 3.436a1.503 1.503 0 001.82 1.092 1.503 1.503 0 001.091-1.819l-1.04-4.172a2.998 2.998 0 00-.699-1.298l-2.133-2.33.807-3.22.258.774a2.99 2.99 0 001.486 1.734l1.092.553a1.48 1.48 0 001.992-.67 1.518 1.518 0 00-.67-2.016zm-10.73 6.595a2.91 2.91 0 01-.666 1.008l-2.343 2.349a1.502 1.502 0 000 2.123 1.496 1.496 0 002.118 0l2.785-2.784a3.05 3.05 0 00.665-1.008l.633-1.584c-2.592-2.827-1.814-1.96-2.222-2.518l-.97 2.414z"
          fill="#E68C31"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_8415_73491">
          <path fill="#fff" transform="translate(6 6.6)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function PointIcon(props) {
  return (
    <svg
      width={36}
      height={37}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y={0.6} width={36} height={36} rx={4} fill="#FBEDDF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 18.6c0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11 11 4.925 11 11zm-11 8.708a8.708 8.708 0 100-17.416 8.708 8.708 0 000 17.416zm0 .917a9.625 9.625 0 100-19.25 9.625 9.625 0 000 19.25zm-3.53-4.915c-.053.305.248.543.513.407L18 22.167l3.019 1.55c.265.136.566-.102.513-.407l-.57-3.252 2.42-2.307c.227-.216.11-.61-.193-.653l-3.368-.479-1.501-2.974a.353.353 0 00-.638 0l-1.501 2.974-3.368.479c-.303.043-.42.437-.194.653l2.422 2.307-.57 3.252z"
        fill="#E68C31"
      />
    </svg>
  );
}

function EventIcon(props) {
  return (
    <svg
      width={36}
      height={37}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y={0.6} width={36} height={36} rx={4} fill="#FBEDDF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.299 7.801a.687.687 0 01.201.487v.687h11v-.687a.687.687 0 111.375 0v.687h1.375a2.75 2.75 0 012.75 2.75V26.85a2.75 2.75 0 01-2.75 2.75H9.75A2.75 2.75 0 017 26.85V11.725a2.75 2.75 0 012.75-2.75h1.375v-.687a.687.687 0 011.174-.487zM25.5 11.725H10.499c-.414 0-.749.308-.749.688v1.375c0 .38.337.687.75.687h15c.415 0 .75-.308.75-.687v-1.375c0-.38-.337-.688-.75-.688zm-7.216 5.92a.3.3 0 00-.57 0l-.883 2.715a.3.3 0 01-.285.207h-2.854a.3.3 0 00-.177.543l2.31 1.678a.3.3 0 01.109.335l-.883 2.715a.3.3 0 00.462.336l2.31-1.678a.3.3 0 01.352 0l2.31 1.678a.3.3 0 00.462-.336l-.883-2.715a.3.3 0 01.11-.335l2.309-1.678a.3.3 0 00-.177-.543h-2.854a.3.3 0 01-.285-.207l-.883-2.715z"
        fill="#E68C31"
      />
    </svg>
  );
}

function GiveDealIcon(props) {
  return (
    <svg
      width={36}
      height={37}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y={0.6} width={36} height={36} rx={4} fill="#E8EFF7" />
      <g clipPath="url(#prefix__clip0_8415_73499)">
        <path
          d="M10.5 10.35a3.75 3.75 0 017.5 0 3.75 3.75 0 017.5 0v.009c0 .105 0 .405-.057.741H28.5a1.5 1.5 0 011.5 1.5v1.5a1.5 1.5 0 01-1.5 1.5h-21A1.5 1.5 0 016 14.1v-1.5a1.5 1.5 0 011.5-1.5h3.057a4.453 4.453 0 01-.057-.741v-.009zm1.602.75H16.5v-.75a2.25 2.25 0 10-4.5 0c0 .127.003.411.068.645.008.036.02.07.034.105zm7.398 0h4.398a.842.842 0 00.035-.105c.064-.234.067-.518.067-.645a2.25 2.25 0 00-4.5 0v.75zm9 6v11.25a2.25 2.25 0 01-2.25 2.25H19.5V17.1h9zM9.75 30.6a2.25 2.25 0 01-2.25-2.25V17.1h9v13.5H9.75z"
          fill="#2F80ED"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_8415_73499">
          <path fill="#fff" transform="translate(6 6.6)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function QrIcon(props) {
  return (
    <svg
      width={32}
      height={33}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0_8435_74249)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 2.5H2v8h8v-8zm-8 20v8h8v-8H2zm28-20h-8v8h8v-8zm-20-2h2v12H0V.5h10zm0 20h2v12H0v-12h10zm12-20h-2v12h12V.5H22zm-6 2v-2h2v4h-2v4h-2v-6h2zm0 10v-4h2v4h-2zm-4 4v-2h2v-2h2v4h2v-2h10v2h-8v2h-6v-2h-2zm0 0v2H4v-2H2v2H0v-4h6v2h6zm20 2h-2v-4h2v4zm-2 0h-2v4h4v-2h-2v-2zm-8 0h4v2h-2v2h-2v-4zm4 6v-2h-2v2h-2v2h-4v2h6v-4h2zm0 0h6v2h-4v2h-2v-4zm-8-2v2h2v-4h-6v2h4zm-4 9v-7h2v6h8v2H14v-1zm18-3v4h-6v-2h4v-2h2zM4 4.5h4v4H4v-4zm20 0h4v4h-4v-4zm-16 20H4v4h4v-4z"
          fill="#23C96F"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_8435_74249">
          <path fill="#fff" transform="translate(0 .5)" d="M0 0h32v32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function HorizontalIcon(props) {
  return (
    <svg
      width={27}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={0.3}
        y={0.8}
        width={26.4}
        height={26.4}
        rx={13.2}
        fill="#F0F1F3"
        fillOpacity={0.01}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 17a2.25 2.25 0 01-2.25-2.25v-1.5A2.25 2.25 0 016.75 11h1.5a2.25 2.25 0 012.25 2.25H12V9.5a.75.75 0 01.75-.75h1.5a.75.75 0 110 1.5h-.75v7.5h.75a.75.75 0 110 1.5h-1.5a.75.75 0 01-.75-.75v-3.75h-1.5A2.25 2.25 0 018.25 17h-1.5zM9 13.25a.75.75 0 00-.75-.75h-1.5a.75.75 0 00-.75.75v1.5a.75.75 0 00.75.75h1.5a.75.75 0 00.75-.75v-1.5zm9.75 8.25a2.25 2.25 0 01-2.25-2.25v-1.5a2.25 2.25 0 012.25-2.25h1.5a2.25 2.25 0 012.25 2.25v1.5a2.25 2.25 0 01-2.25 2.25h-1.5zM18 19.25a.75.75 0 00.75.75h1.5a.75.75 0 00.75-.75v-1.5a.75.75 0 00-.75-.75h-1.5a.75.75 0 00-.75.75v1.5zm.75-6.75a2.25 2.25 0 01-2.25-2.25v-1.5a2.25 2.25 0 012.25-2.25h1.5a2.25 2.25 0 012.25 2.25v1.5a2.25 2.25 0 01-2.25 2.25h-1.5zM18 10.25a.75.75 0 00.75.75h1.5a.75.75 0 00.75-.75v-1.5a.75.75 0 00-.75-.75h-1.5a.75.75 0 00-.75.75v1.5z"
        fill="#5F6368"
      />
    </svg>
  );
}

function VerticalIcon(props) {
  return (
    <svg
      width={27}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={0.3}
        y={0.8}
        width={26.4}
        height={26.4}
        rx={13.2}
        fill="#F0F1F3"
        fillOpacity={0.01}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 7.25A2.25 2.25 0 0112.75 5h1.5a2.25 2.25 0 012.25 2.25v1.5A2.25 2.25 0 0114.25 11v1.5H18a.75.75 0 01.75.75v1.5a.75.75 0 11-1.5 0V14h-7.5v.75a.75.75 0 11-1.5 0v-1.5A.75.75 0 019 12.5h3.75V11a2.25 2.25 0 01-2.25-2.25v-1.5zm3.75 2.25a.75.75 0 00.75-.75v-1.5a.75.75 0 00-.75-.75h-1.5a.75.75 0 00-.75.75v1.5a.75.75 0 00.75.75h1.5zM6 19.25A2.25 2.25 0 018.25 17h1.5A2.25 2.25 0 0112 19.25v1.5A2.25 2.25 0 019.75 23h-1.5A2.25 2.25 0 016 20.75v-1.5zm2.25-.75a.75.75 0 00-.75.75v1.5a.75.75 0 00.75.75h1.5a.75.75 0 00.75-.75v-1.5a.75.75 0 00-.75-.75h-1.5zm6.75.75A2.25 2.25 0 0117.25 17h1.5A2.25 2.25 0 0121 19.25v1.5A2.25 2.25 0 0118.75 23h-1.5A2.25 2.25 0 0115 20.75v-1.5zm2.25-.75a.75.75 0 00-.75.75v1.5a.75.75 0 00.75.75h1.5a.75.75 0 00.75-.75v-1.5a.75.75 0 00-.75-.75h-1.5z"
        fill="#5F6368"
      />
    </svg>
  );
}

function SignUpIcon(props) {
  return (
    <svg
      width={36}
      height={37}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y={0.6} width={36} height={36} rx={4} fill="#E2FAEC" />
      <g clipPath="url(#prefix__clip0_8481_74247)" fill="#23C96F">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.781 14.32a.75.75 0 010 1.061l-4.5 4.5a.749.749 0 01-1.062 0l-2.25-2.25a.75.75 0 011.062-1.062l1.719 1.72 3.969-3.97a.753.753 0 011.062 0z"
        />
        <path d="M7.5 27.6S6 27.6 6 26.1s1.5-6 9-6 9 4.5 9 6-1.5 1.5-1.5 1.5h-15zm7.5-9a4.5 4.5 0 100-9 4.5 4.5 0 000 9z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_8481_74247">
          <path fill="#fff" transform="translate(6 6.6)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function ConditionalActionIcon(props) {
  return (
    <svg
      width={36}
      height={37}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y={0.6} width={36} height={36} rx={4} fill="#FBEDDF" />
      <path
        d="M26.573 7.6h-6.829a.428.428 0 00-.394.284.482.482 0 00.092.5l1.905 2.045-6.173 6.629a.476.476 0 00-.125.325v11.759c0 .253.191.458.427.458h3.414c.236 0 .427-.205.427-.458v-10.05l5.049-5.422 1.905 2.046a.4.4 0 00.465.099.46.46 0 00.264-.423V8.059c0-.253-.191-.459-.427-.459z"
        fill="#E68C31"
      />
      <path
        d="M18.338 14.15l-5.976-6.416a.407.407 0 00-.603 0l-2.634 2.829a.476.476 0 00-.125.324.48.48 0 00.125.325l6.049 6.494a.41.41 0 00.604 0 .483.483 0 000-.648l-.009-.01 1.977-2.242c.167.17.429.169.593-.007a.482.482 0 00-.001-.649z"
        fill="#E68C31"
      />
    </svg>
  );
}

function YesIcon(props) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_1707_14968)">
        <path
          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
          fill="#23C96F"
        />
      </g>
      <path
        d="M10.318 25.136H12.194V20.81L15.33 15.126H13.51L11.312 19.27L9.058 15.126H7L10.318 20.796V25.136Z"
        fill="white"
      />
      <path
        d="M16.8145 25.136H23.3105V23.666H18.6765V20.74H22.2045V19.34H18.6765V16.596H23.0725V15.126H16.8145V25.136Z"
        fill="white"
      />
      <path
        d="M28.4926 25.276C30.7046 25.276 32.1746 23.918 32.1746 22.182C32.1746 20.18 30.9566 19.508 28.6046 19.186C26.8686 18.934 26.5326 18.528 26.5326 17.716C26.5326 16.946 27.1206 16.4 28.2546 16.4C29.4026 16.4 30.0046 16.848 30.1866 17.898H31.8946C31.6986 15.98 30.4106 15 28.2546 15C26.1686 15 24.7686 16.232 24.7686 17.87C24.7686 19.746 25.9026 20.474 28.2966 20.796C29.9206 21.062 30.3826 21.412 30.3826 22.336C30.3826 23.26 29.5986 23.876 28.4926 23.876C26.7986 23.876 26.3926 23.036 26.2666 22.028H24.4746C24.6146 23.918 25.7626 25.276 28.4926 25.276Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_i_1707_14968"
          x="0"
          y="0"
          width="40"
          height="48"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.016684 0 0 0 0 0.093815 0 0 0 0 0.241649 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1707_14968"
          />
        </filter>
      </defs>
    </svg>
  );
}
function FillNavDashboardIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.0191 5.48449C5.77706 5.33474 5.49233 5.26373 5.20607 5.2817C4.91981 5.29968 4.64684 5.40571 4.42659 5.58448L1.9747 7.57216C1.79752 7.72294 1.68798 7.93514 1.66948 8.16343C1.65098 8.39172 1.72499 8.61799 1.8757 8.79391C2.02641 8.96983 2.24186 9.08145 2.47604 9.10491C2.71021 9.12838 2.94454 9.06184 3.12895 8.9195L5.32926 7.13708L9.43769 9.68089C9.69109 9.83757 9.99087 9.90778 10.2898 9.88047C10.5888 9.85315 10.8698 9.72986 11.0888 9.53002L18.0477 3.18453C18.2223 3.02541 18.3248 2.80533 18.3325 2.57273C18.3403 2.34012 18.2528 2.11403 18.0892 1.94421C17.9256 1.77438 17.6994 1.67472 17.4602 1.66715C17.2211 1.65958 16.9887 1.74473 16.8141 1.90386L10.1104 8.01777L6.0191 5.48449ZM14.2747 10.4388C14.2747 10.2061 14.3698 9.98302 14.5389 9.81852C14.708 9.65401 14.9373 9.5616 15.1765 9.5616H16.98C17.2192 9.5616 17.4486 9.65401 17.6177 9.81852C17.7868 9.98302 17.8818 10.2061 17.8818 10.4388V17.4562C17.8818 17.6888 17.7868 17.9119 17.6177 18.0764C17.4486 18.2409 17.2192 18.3334 16.98 18.3334H15.1765C14.9373 18.3334 14.708 18.2409 14.5389 18.0764C14.3698 17.9119 14.2747 17.6888 14.2747 17.4562V10.4388ZM4.35535 11.3159C4.11619 11.3159 3.88682 11.4084 3.71771 11.5729C3.5486 11.7374 3.45359 11.9605 3.45359 12.1931V17.4562C3.45359 17.6888 3.5486 17.9119 3.71771 18.0764C3.88682 18.2409 4.11619 18.3334 4.35535 18.3334H6.15888C6.39804 18.3334 6.62741 18.2409 6.79652 18.0764C6.96563 17.9119 7.06064 17.6888 7.06064 17.4562V12.1931C7.06064 11.9605 6.96563 11.7374 6.79652 11.5729C6.62741 11.4084 6.39804 11.3159 6.15888 11.3159H4.35535ZM9.76593 13.9475C9.52677 13.9475 9.2974 14.0399 9.12829 14.2044C8.95917 14.3689 8.86417 14.592 8.86417 14.8246V17.4562C8.86417 17.6888 8.95917 17.9119 9.12829 18.0764C9.2974 18.2409 9.52677 18.3334 9.76593 18.3334H11.5695C11.8086 18.3334 12.038 18.2409 12.2071 18.0764C12.3762 17.9119 12.4712 17.6888 12.4712 17.4562V14.8246C12.4712 14.592 12.3762 14.3689 12.2071 14.2044C12.038 14.0399 11.8086 13.9475 11.5695 13.9475H9.76593Z"
        fill="#3770FB"
      />
    </svg>
  );
}

function FillNavLoyalityIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.309 7.826a1.66 1.66 0 011.144-1.114 1.672 1.672 0 011.558.359l6.252 5.54a1.661 1.661 0 01-.598 2.824l-8.823 2.819a1.672 1.672 0 01-1.68-.4 1.66 1.66 0 01-.422-1.669l2.57-8.359h-.001zm1.595.487l-2.57 8.358 8.821-2.818-6.252-5.54zM8.826 4.99a.83.83 0 01-.834.83.835.835 0 01-.833-.83V2.497a.83.83 0 01.833-.83.835.835 0 01.834.83V4.99zm5.604 2.516c-.025.175.031.232.23.239.285.01.533-.172.608-.528.057-.266-.037-.536-.227-.772-.366.393-.567.751-.611 1.061zm2.469.057c-.248 1.164-1.222 1.878-2.295 1.842-1.137-.039-1.996-.92-1.825-2.131.076-.535.316-1.056.713-1.573a1.796 1.796 0 00-.627.08c-.708.228-1.105.85-1.2 2.044a.829.829 0 01-.897.762.835.835 0 01-.765-.894c.144-1.81.93-3.036 2.35-3.492.84-.271 1.76-.187 2.554.144.39-.297.834-.596 1.327-.895a.836.836 0 011.133.284.829.829 0 01-.267 1.135c-.28.17-.54.338-.775.502.499.602.75 1.364.575 2.192h-.001zm-1.065 4.904a.835.835 0 01-.833-.831.83.83 0 01.833-.83H17.5a.835.835 0 01.834.83.83.83 0 01-.834.83h-1.666z"
        fill="#3770FB"
      />
    </svg>
  );
}

function FillNavInventoryIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_8218_71267)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.69 0.0822984C9.78442 0.0283669 9.89127 0 10 0C10.1087 0 10.2156 0.0283669 10.31 0.0822984L14.9975 2.76105C15.0932 2.81569 15.1727 2.89465 15.228 2.98992C15.2833 3.08518 15.3125 3.19338 15.3125 3.30355V8.2973L19.685 10.7973C19.7803 10.8517 19.8596 10.9303 19.9149 11.0251C19.9702 11.1199 19.9995 11.2276 20 11.3373V16.6948C20 16.805 19.9708 16.9132 19.9155 17.0084C19.8602 17.1037 19.7807 17.1827 19.685 17.2373L14.9975 19.916C14.9031 19.97 14.7962 19.9983 14.6875 19.9983C14.5788 19.9983 14.4719 19.97 14.3775 19.916L10 17.416L5.6225 19.9173C5.52808 19.9712 5.42123 19.9996 5.3125 19.9996C5.20377 19.9996 5.09692 19.9712 5.0025 19.9173L0.315 17.2385C0.219341 17.1839 0.139825 17.105 0.0845069 17.0097C0.0291891 16.9144 3.55338e-05 16.8062 0 16.696L0 11.3385C3.55338e-05 11.2284 0.0291891 11.1202 0.0845069 11.0249C0.139825 10.9296 0.219341 10.8507 0.315 10.796L4.6875 8.2973V3.30355C4.68754 3.19338 4.71669 3.08518 4.77201 2.98992C4.82732 2.89465 4.90684 2.81569 5.0025 2.76105L9.69 0.0822984ZM5.3125 9.3798L1.885 11.3385L5.3125 13.2973L8.74 11.3385L5.3125 9.3798ZM9.375 12.416L5.9375 14.3798V18.2973L9.375 16.3335V12.416ZM10.625 16.3335L14.0625 18.2973V14.3798L10.625 12.416V16.3335ZM11.26 11.3385L14.6875 13.2973L18.115 11.3385L14.6875 9.3798L11.26 11.3385ZM14.0625 8.2973V4.3798L10.625 6.3448V10.2623L14.0625 8.2973V8.2973ZM9.375 10.2623V6.3448L5.9375 4.3798V8.2973L9.375 10.2623ZM6.5725 3.30355L10 5.2623L13.4275 3.30355L10 1.3448L6.5725 3.30355ZM18.75 12.416L15.3125 14.3798V18.2973L18.75 16.3335V12.416ZM4.6875 18.2973V14.3798L1.25 12.416V16.3335L4.6875 18.2973Z"
          fill="#2F80ED"
        />
      </g>
      <defs>
        <clipPath id="clip0_8218_71267">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function FillNavDealIcon(props) {
  return (
    <svg
      width={18}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.023 8.353l-.663 5.07a2.33 2.33 0 01-.825 1.483 2.583 2.583 0 01-1.656.594H5.117c-.61 0-1.2-.211-1.656-.594a2.33 2.33 0 01-.825-1.484l-.66-5.069a1.683 1.683 0 01-.941-.552 1.526 1.526 0 01-.368-.99V5.234c0-.419.175-.82.488-1.116a1.715 1.715 0 011.178-.462h.906a2.019 2.019 0 01-.074-.545c0-.58.202-1.144.573-1.606.217-.27.49-.498.8-.667a2.826 2.826 0 012.074-.24c.346.094.668.252.947.465l.08.07L9 2.48l1.36-1.346.08-.07c.28-.213.601-.37.946-.464a2.826 2.826 0 012.075.24c.31.169.583.396.8.667.373.46.574 1.024.572 1.604a2 2 0 01-.075.545h.909c.442 0 .866.166 1.178.462.313.296.488.697.488 1.116V6.81c0 .36-.13.71-.368.99s-.57.475-.942.552zm-1.683.036H9.833v5.533h3.046c.203 0 .4-.07.552-.198a.777.777 0 00.275-.494l.633-4.84h.001zm-6.173 5.533V8.39H3.66l.63 4.84a.777.777 0 00.275.495.86.86 0 00.552.198h3.05zm0-8.688H2.333V6.81h5.834V5.234zm0 0h3.046-1.38V6.81h5.834V5.234h-7.5zm-2.76-1.578H7.81l.035-.035-1.368-1.355a1.058 1.058 0 00-.752-.177 1.026 1.026 0 00-.665.376c-.15.185-.231.413-.23.646 0 .301.258.545.576.545zm7.185 0a.592.592 0 00.406-.16.53.53 0 00.169-.385 1.037 1.037 0 00-.894-1.022 1.058 1.058 0 00-.752.177l-1.404 1.39h2.475z"
        fill="#3770FB"
      />
    </svg>
  );
}

function FillNavWalletScanIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 1.25h-5v5h5v-5zm-5 12.5v5h5v-5h-5zm17.5-12.5h-5v5h5v-5zM6.25 0H7.5v7.5H0V0h6.25zm0 12.5H7.5V20H0v-7.5h6.25zM13.75 0H12.5v7.5H20V0h-6.25zM10 1.25V0h1.25v2.5H10V5H8.75V1.25H10zm0 6.25V5h1.25v2.5H10zM7.5 10V8.75h1.25V7.5H10V10h1.25V8.75h6.25V10h-5v1.25H8.75V10H7.5zm0 0v1.25h-5V10H1.25v1.25H0v-2.5h3.75V10H7.5zM20 11.25h-1.25v-2.5H20v2.5zm-1.25 0H17.5v2.5H20V12.5h-1.25v-1.25zm-5 0h2.5v1.25H15v1.25h-1.25v-2.5zm2.5 3.75v-1.25H15V15h-1.25v1.25h-2.5v1.25H15V15h1.25zm0 0H20v1.25h-2.5v1.25h-1.25V15zm-5-1.25V15h1.25v-2.5H8.75v1.25h2.5zm-2.5 5.625V15H10v3.75h5V20H8.75v-.625zM20 17.5V20h-3.75v-1.25h2.5V17.5H20zM2.5 2.5H5V5H2.5V2.5zm12.5 0h2.5V5H15V2.5zM5 15H2.5v2.5H5V15z"
        fill="#3770FB"
      />
    </svg>
  );
}
function FillNavSettingIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.583 2.75a.417.417 0 11.834 0c0 .798.477 1.52 1.213 1.83l.404.17a1.964 1.964 0 002.153-.42.417.417 0 01.59.59c-.617.617-.665 1.51-.374 2.187.03.068.057.136.084.205.255.68.905 1.271 1.763 1.271a.417.417 0 110 .834c-.857 0-1.508.591-1.764 1.27-.048.128-.1.252-.159.373-.308.647-.271 1.513.325 2.108a.417.417 0 11-.59.59c-.606-.605-1.483-.654-2.149-.364-.074.034-.15.063-.225.092-.68.256-1.271.906-1.271 1.764a.417.417 0 01-.834 0c0-.857-.591-1.508-1.271-1.764a4.677 4.677 0 01-.225-.092c-.666-.29-1.543-.242-2.149.364a.418.418 0 11-.589-.589c.596-.596.632-1.462.324-2.108a4.754 4.754 0 01-.159-.373c-.256-.68-.906-1.271-1.764-1.271a.417.417 0 110-.834c.8 0 1.523-.486 1.824-1.227l.095-.234a2.033 2.033 0 00-.446-2.203.417.417 0 11.59-.589 1.964 1.964 0 002.153.42l.404-.17a1.986 1.986 0 001.213-1.83zM9 .667A2.083 2.083 0 006.917 2.75a.32.32 0 01-.195.294l-.405.171a.298.298 0 01-.325-.063 2.084 2.084 0 00-2.947 2.946.367.367 0 01.08.397l-.095.233a.302.302 0 01-.28.189 2.083 2.083 0 100 4.166.15.15 0 01.093.037.365.365 0 01.111.155c.064.172.136.34.214.503.026.055.033.11.028.15-.005.037-.017.054-.025.063a2.084 2.084 0 102.946 2.946.173.173 0 01.103-.046.374.374 0 01.2.031c.1.044.202.085.305.124.06.022.114.06.155.11a.153.153 0 01.037.094 2.083 2.083 0 004.166 0c0-.023.007-.055.037-.093a.354.354 0 01.155-.111c.102-.038.204-.08.305-.123a.38.38 0 01.2-.032.181.181 0 01.103.046 2.083 2.083 0 002.947-2.946c-.008-.008-.02-.025-.026-.063a.28.28 0 01.028-.15c.078-.164.15-.331.214-.503a.352.352 0 01.11-.155.151.151 0 01.094-.037 2.083 2.083 0 100-4.166.153.153 0 01-.093-.037.352.352 0 01-.111-.155 6.398 6.398 0 00-.112-.277.432.432 0 01-.034-.226.209.209 0 01.055-.124 2.084 2.084 0 10-2.946-2.946.298.298 0 01-.326.063l-.405-.17a.32.32 0 01-.195-.295A2.083 2.083 0 009 .667zM7.333 9a1.667 1.667 0 113.334 0 1.667 1.667 0 01-3.334 0zM9 5.667a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666z"
        fill="#3770FB"
      />
    </svg>
  );
}

function FillNavCommunicationIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.169 1.279a.833.833 0 011.024-.582c2.67.735 4.568 3.652 3.804 6.598a.833.833 0 01-1.613-.418c.523-2.02-.797-4.068-2.633-4.574a.833.833 0 01-.582-1.024zm-8.338 0a.833.833 0 01-.582 1.024c-1.836.506-3.156 2.555-2.633 4.574a.833.833 0 11-1.613.418C.239 4.35 2.138 1.432 4.807.697a.833.833 0 011.024.582zm4.319 2.208c-.51 0-.838.378-.838.74V5.1l-.555.197c-1.143.405-1.968 1.277-2.235 2.29a8.33 8.33 0 00-.162.855l-.008.05c-.045.295-.097.63-.179.963l-.002.011-1.073 3.893h10.103l-1.072-3.893-.003-.011c-.082-.333-.133-.668-.178-.962a8.311 8.311 0 00-.17-.905c-.268-1.014-1.093-1.886-2.236-2.291l-.555-.197v-.873c0-.362-.327-.74-.837-.74zm-2.488.462c.145-1.234 1.244-2.128 2.488-2.128 1.243 0 2.342.894 2.487 2.128 1.342.64 2.377 1.791 2.752 3.214.094.357.15.713.198 1.025l.004.028c.048.309.089.574.15.83l1.183 4.294.003.011c.225.916-.519 1.675-1.352 1.675H12.18v.32c0 1.126-.938 1.987-2.03 1.987-1.093 0-2.03-.861-2.03-1.987v-.32H4.724c-.833 0-1.577-.759-1.352-1.675l.003-.011 1.182-4.293c.063-.257.104-.522.151-.831l.004-.028c.048-.312.104-.668.198-1.025.375-1.423 1.41-2.575 2.752-3.214z"
        fill="#3770FB"
      />
    </svg>
  );
}
function FillNavGrowthIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.71 1.546A2.125 2.125 0 019.3.833h5.243c1.828 0 2.772 2.128 1.626 3.476a7.447 7.447 0 01-.083.096c-.028.032-.043.05-.064.077l-2.996 4.04a5.617 5.617 0 01-.204.247.23.23 0 00-.025.255.255.255 0 00.087.104c.032.02.076.039.143.039 1.898 0 2.65 2.46 1.067 3.508L6.176 18.89l-.036.023a1.647 1.647 0 01-.879.254c-1.215 0-1.95-1.23-1.523-2.262.05-.118.108-.224.143-.288l.005-.009c.043-.077.058-.107.068-.131l1.887-4.492a4.17 4.17 0 01.233-.444c.014-.024.025-.042.03-.053.154-.28-.051-.655-.405-.655h-.241c-1.8 0-2.784-2.097-1.63-3.47L7.672 1.59l.039-.043zm1.277 1.076L5.154 8.379l-.039.043a.448.448 0 00.343.745h.24c1.649 0 2.62 1.757 1.867 3.125-.053.096-.088.155-.114.198-.033.056-.051.087-.074.14l-1.886 4.492c-.048.115-.105.218-.14.282l-.007.01-.009.017 7.792-6.117.037-.023a.233.233 0 00.106-.122.26.26 0 000-.155.265.265 0 00-.084-.133.24.24 0 00-.16-.048c-1.642 0-2.495-1.895-1.495-3.118a3.15 3.15 0 01.104-.124.699.699 0 00.051-.062l2.997-4.04a3.963 3.963 0 01.215-.26c.234-.275.04-.729-.356-.729H9.3a.459.459 0 00-.312.122z"
        fill="#3770FB"
      />
    </svg>
  );
}

function GiveawayIcon() {
  return (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.75 3.125a3.125 3.125 0 116.25 0 3.125 3.125 0 116.25 0v.007c0 .088 0 .338-.047.618h2.547A1.25 1.25 0 0120 5v2.5a1.25 1.25 0 01-1.25 1.25v9.375A1.875 1.875 0 0116.875 20H3.125a1.875 1.875 0 01-1.875-1.875V8.75A1.25 1.25 0 010 7.5V5a1.25 1.25 0 011.25-1.25h2.547a3.71 3.71 0 01-.047-.618v-.007zm1.335.625H8.75v-.625a1.875 1.875 0 10-3.75 0c0 .106.003.342.056.538.008.03.017.059.029.087zm6.165 0h3.665a.707.707 0 00.029-.087c.053-.196.056-.432.056-.538a1.875 1.875 0 10-3.75 0v.625zM1.25 5v2.5h7.5V5h-7.5zm10 0v2.5h7.5V5h-7.5zm6.25 3.75h-6.25v10h5.625a.624.624 0 00.625-.625V8.75zm-8.75 10v-10H2.5v9.375a.625.625 0 00.625.625H8.75z"
        fill="#5F6368"
      />
    </svg>
  );
}

function FillGiveawayIcon() {
  return (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.75 3.125a3.125 3.125 0 116.25 0 3.125 3.125 0 116.25 0v.007c0 .088 0 .338-.047.618h2.547A1.25 1.25 0 0120 5v1.25a1.25 1.25 0 01-1.25 1.25H1.25A1.25 1.25 0 010 6.25V5a1.25 1.25 0 011.25-1.25h2.547a3.71 3.71 0 01-.047-.618v-.007zm1.335.625H8.75v-.625a1.875 1.875 0 10-3.75 0c0 .106.003.342.056.538.008.03.017.059.029.087zm6.165 0h3.665a.707.707 0 00.029-.087c.053-.196.056-.432.056-.538a1.875 1.875 0 10-3.75 0v.625zm7.5 5v9.375A1.875 1.875 0 0116.875 20H11.25V8.75h7.5zM3.125 20a1.875 1.875 0 01-1.875-1.875V8.75h7.5V20H3.125z"
        fill="#2F80ED"
      />
    </svg>
  );
}

function FlowCollapseIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.557 2.057a.625.625 0 01.885 0l7.5 7.5a.626.626 0 010 .885l-7.5 7.5a.626.626 0 11-.885-.885L11.615 10 4.557 2.942a.625.625 0 010-.885z"
        fill="#B2B2B2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.557 2.057a.625.625 0 01.885 0l7.5 7.5a.626.626 0 010 .885l-7.5 7.5a.626.626 0 01-.885-.885L16.615 10 9.557 2.942a.625.625 0 010-.885z"
        fill="#B2B2B2"
      />
    </svg>
  );
}

function GrowthToolFlowIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={32} height={32} rx={16} fill="#23C96F" />
      <path
        d="M8 22.666h16V24H8v-1.334zM22.407 10.373l.28 1.122 1.293-.323-.666-2.667a.667.667 0 00-.808-.485l-2.667.667.323 1.293 1.08-.27C17.463 15.172 11.06 16.667 8 16.667V18c1.636 0 4.362-.43 7.103-1.64 3.082-1.36 5.532-3.37 7.304-5.986zM9.999 18.666a.666.666 0 00-.667.667V22h4v-2.667a.667.667 0 00-.667-.666H10zM14.667 17.333A.666.666 0 0014 18v4h4v-4a.666.666 0 00-.667-.667h-2.666zM19.335 14.666a.667.667 0 00-.667.667V22h4v-6.667a.667.667 0 00-.667-.667h-2.666z"
        fill="#fff"
      />
    </svg>
  );
}

function FlowDealIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={32} height={32} rx={16} fill="#DD3BB0" />
      <path
        d="M11 10.5a2.5 2.5 0 015 0 2.5 2.5 0 015 0v.006c0 .07 0 .27-.038.494H23a1 1 0 011 1v1a1 1 0 01-1 1H9a1 1 0 01-1-1v-1a1 1 0 011-1h2.038a2.972 2.972 0 01-.038-.494V10.5zm1.068.5H15v-.5a1.5 1.5 0 00-3 0c0 .085.002.274.045.43a.526.526 0 00.023.07zM17 11h2.932a.556.556 0 00.023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 10-3 0v.5zm6 4v7.5a1.5 1.5 0 01-1.5 1.5H17v-9h6zm-12.5 9A1.5 1.5 0 019 22.5V15h6v9h-4.5z"
        fill="#FDF2FA"
      />
    </svg>
  );
}

function VisitDealIcon(props) {
  return (
    <svg
      width={14}
      height={15}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0_8997_69545)">
        <path
          d="M8.02 3.071a1.313 1.313 0 100-2.625 1.313 1.313 0 000 2.625zm2.585 4.077l-.637-.322-.266-.804C9.3 4.802 8.18 3.949 6.908 3.946c-.984-.002-1.529.276-2.551.69-.59.237-1.075.688-1.36 1.263l-.182.372a.878.878 0 00.388 1.173.863.863 0 001.162-.391l.183-.372A.87.87 0 015 6.26l.733-.296-.415 1.66c-.143.569.01 1.173.407 1.608l1.638 1.788c.197.216.336.476.407.758l.5 2.004a.877.877 0 001.062.637.876.876 0 00.637-1.061l-.607-2.434a1.75 1.75 0 00-.408-.757L7.71 8.808l.47-1.879.15.452c.146.44.457.804.868 1.011l.637.323a.863.863 0 001.162-.391.885.885 0 00-.391-1.176zm-6.26 3.848a1.697 1.697 0 01-.387.587l-1.368 1.37a.876.876 0 000 1.239.873.873 0 001.236 0l1.624-1.624c.167-.167.299-.367.389-.588l.369-.924C4.696 9.406 5.15 9.913 4.912 9.587l-.566 1.409z"
          fill={props.color ? props.color : "#F5805D"}
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_8997_69545">
          <path fill="#fff" transform="translate(0 .446)" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function PointDealIcon(props) {
  return (
    <svg
      width={14}
      height={15}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M14 7.5a7 7 0 11-14 0 7 7 0 0114 0z" fill="#FDDC91" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 13.1A5.6 5.6 0 107 1.9a5.6 5.6 0 000 11.2zm0 1.4a7 7 0 100-14 7 7 0 000 14z"
        fill="#F5B85D"
      />
      <circle cx={7} cy={7.5} r={3.5} fill="#F5B85D" />
    </svg>
  );
}

function AutomationIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.69 2.69l-.376-.626a.73.73 0 00-.25.25l.626.376zm14.62 14.62l.376.626a.73.73 0 00.25-.25l-.627-.377zm0-14.62l.626-.376-.094-.156-.156-.094-.377.626zM2.69 17.31l-.626.376.094.156.156.094.376-.627zm4.873-9.747l-.516-.516.516.516zM3.067 3.317c.361-.217.916-.264 1.71-.05.78.21 1.672.643 2.587 1.204 1.828 1.12 3.61 2.664 4.556 3.61l1.033-1.034c-1.004-1.005-2.876-2.628-4.825-3.822-.973-.597-2-1.108-2.97-1.37-.958-.258-1.987-.305-2.844.209l.753 1.253zM11.92 8.08c.945.945 2.489 2.728 3.609 4.556.561.915.994 1.807 1.204 2.587.214.794.167 1.349-.05 1.71l1.253.753c.514-.857.467-1.886.209-2.843-.262-.971-.773-1.998-1.37-2.971-1.194-1.95-2.817-3.821-3.822-4.825L11.92 8.08zm5.013 8.603c-.36.217-.916.264-1.71.05-.78-.21-1.672-.643-2.587-1.204-1.828-1.12-3.61-2.664-4.556-3.61l-1.033 1.034c1.004 1.004 2.876 2.628 4.825 3.822.973.597 2 1.108 2.97 1.37.958.258 1.987.305 2.844-.209l-.753-1.253zM8.08 11.92c-.945-.945-2.489-2.728-3.609-4.556-.561-.915-.994-1.807-1.204-2.587-.214-.794-.167-1.35.05-1.71l-1.253-.753c-.514.857-.467 1.886-.209 2.843.262.971.773 1.998 1.37 2.971 1.194 1.95 2.818 3.821 3.822 4.825L8.08 11.92zm8.603-8.854c.217.362.264.917.05 1.71-.21.781-.643 1.673-1.204 2.588-1.12 1.828-2.664 3.61-3.61 4.556l1.034 1.033c1.005-1.004 2.628-2.876 3.823-4.825.596-.973 1.107-2 1.369-2.97.258-.958.305-1.987-.209-2.844l-1.253.752zM11.92 11.92c-.945.945-2.728 2.489-4.556 3.609-.915.561-1.807.994-2.587 1.204-.794.214-1.349.167-1.71-.05l-.753 1.253c.857.514 1.886.467 2.843.209.971-.262 1.998-.773 2.971-1.37 1.95-1.194 3.821-2.818 4.825-3.822L11.92 11.92zm-8.603 5.013c-.217-.361-.264-.916-.05-1.71.21-.78.643-1.672 1.204-2.587 1.12-1.828 2.664-3.61 3.61-4.556L7.046 7.047C6.042 8.05 4.419 9.923 3.225 11.872c-.597.973-1.108 2-1.37 2.97-.258.958-.305 1.987.209 2.844l1.253-.753zM8.08 8.08c.945-.945 2.728-2.489 4.556-3.609.915-.561 1.807-.994 2.587-1.204.794-.214 1.35-.167 1.71.05l.753-1.253c-.857-.514-1.886-.467-2.843-.209-.971.262-1.998.773-2.971 1.37-1.95 1.194-3.821 2.817-4.825 3.822L8.08 8.08zM10 10h1.462c0-.807-.655-1.462-1.462-1.462V10zm0 0v1.462c.807 0 1.462-.655 1.462-1.462H10zm0 0H8.538c0 .807.655 1.462 1.462 1.462V10zm0 0V8.538c-.807 0-1.462.655-1.462 1.462H10z"
        fill={props.color || "#41536C"}
      />
    </svg>
  );
}

function FilledAutomationIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.69 2.69l-.376-.626a.73.73 0 00-.25.25l.626.376zm14.62 14.62l.376.626a.73.73 0 00.25-.25l-.627-.377zm0-14.62l.626-.376-.094-.156-.156-.094-.377.626zM2.69 17.31l-.626.376.094.156.156.094.376-.627zm4.873-9.747l-.516-.516.516.516zM3.067 3.317c.361-.217.916-.264 1.71-.05.78.21 1.672.643 2.587 1.204 1.828 1.12 3.61 2.664 4.556 3.61l1.033-1.034c-1.004-1.005-2.876-2.628-4.825-3.822-.973-.597-2-1.108-2.97-1.37-.958-.258-1.987-.305-2.844.209l.753 1.253zM11.92 8.08c.945.945 2.489 2.728 3.609 4.556.561.915.994 1.807 1.204 2.587.214.794.167 1.349-.05 1.71l1.253.753c.514-.857.467-1.886.209-2.843-.262-.971-.773-1.998-1.37-2.971-1.194-1.95-2.817-3.821-3.822-4.825L11.92 8.08zm5.013 8.603c-.36.217-.916.264-1.71.05-.78-.21-1.672-.643-2.587-1.204-1.828-1.12-3.61-2.664-4.556-3.61l-1.033 1.034c1.004 1.004 2.876 2.628 4.825 3.822.973.597 2 1.108 2.97 1.37.958.258 1.987.305 2.844-.209l-.753-1.253zM8.08 11.92c-.945-.945-2.489-2.728-3.609-4.556-.561-.915-.994-1.807-1.204-2.587-.214-.794-.167-1.35.05-1.71l-1.253-.753c-.514.857-.467 1.886-.209 2.843.262.971.773 1.998 1.37 2.971 1.194 1.95 2.818 3.821 3.822 4.825L8.08 11.92zm8.603-8.854c.217.362.264.917.05 1.71-.21.781-.643 1.673-1.204 2.588-1.12 1.828-2.664 3.61-3.61 4.556l1.034 1.033c1.005-1.004 2.628-2.876 3.823-4.825.596-.973 1.107-2 1.369-2.97.258-.958.305-1.987-.209-2.844l-1.253.752zM11.92 11.92c-.945.945-2.728 2.489-4.556 3.609-.915.561-1.807.994-2.587 1.204-.794.214-1.349.167-1.71-.05l-.753 1.253c.857.514 1.886.467 2.843.209.971-.262 1.998-.773 2.971-1.37 1.95-1.194 3.821-2.818 4.825-3.822L11.92 11.92zm-8.603 5.013c-.217-.361-.264-.916-.05-1.71.21-.78.643-1.672 1.204-2.587 1.12-1.828 2.664-3.61 3.61-4.556L7.046 7.047C6.042 8.05 4.419 9.923 3.225 11.872c-.597.973-1.108 2-1.37 2.97-.258.958-.305 1.987.209 2.844l1.253-.753zM8.08 8.08c.945-.945 2.728-2.489 4.556-3.609.915-.561 1.807-.994 2.587-1.204.794-.214 1.35-.167 1.71.05l.753-1.253c-.857-.514-1.886-.467-2.843-.209-.971.262-1.998.773-2.971 1.37-1.95 1.194-3.821 2.817-4.825 3.822L8.08 8.08zM10 10h1.462c0-.807-.655-1.462-1.462-1.462V10zm0 0v1.462c.807 0 1.462-.655 1.462-1.462H10zm0 0H8.538c0 .807.655 1.462 1.462 1.462V10zm0 0V8.538c-.807 0-1.462.655-1.462 1.462H10z"
        fill="#3770FB"
      />
    </svg>
  );
}

function RuleCheckInIcon(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#prefix__clip0_9159_34978)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 4a4 4 0 114.5 3.97v5.53a.5.5 0 01-1 0V7.97A4 4 0 014 4zm2.493 8.574a.5.5 0 01-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 00-.37.265.302.302 0 00-.057.09V14l.002.008c.004.012.01.023.016.033.04.058.088.109.145.15.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.62.62 0 00.146-.15.147.147 0 00.015-.033L12 14v-.004a.302.302 0 00-.057-.09 1.319 1.319 0 00-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 11.164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.427 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 01.575.411z"
          fill={props.color ? props.color : "#202124"}
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_9159_34978">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function RulePointsIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.335 8A7.333 7.333 0 11.668 8a7.333 7.333 0 0114.667 0z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.001 13.867a5.867 5.867 0 100-11.734 5.867 5.867 0 000 11.733zm0 1.466a7.333 7.333 0 100-14.666 7.333 7.333 0 000 14.666z"
        fill={props.color ? props.color : "#202124"}
      />
      <circle
        cx={8.003}
        cy={8}
        r={3.667}
        fill={props.color ? props.color : "#202124"}
      />
    </svg>
  );
}

function RuleDealIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 2a1 1 0 011-1h4.586a1 1 0 01.707.293l7 7a1 1 0 010 1.414l-4.586 4.586a1 1 0 01-1.414 0l-7-7A1 1 0 012 6.586V2zm3.5 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
        fill={props.color ? props.color : "#202124"}
      />
      <path
        d="M1.293 7.793A1 1 0 011 7.086V2a1 1 0 00-1 1v4.586a1 1 0 00.293.707l7 7a1 1 0 001.414 0l.043-.043-7.457-7.457z"
        fill={props.color ? props.color : "#202124"}
      />
    </svg>
  );
}

function RuleFlowIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.716.667H9.163A.285.285 0 008.9.855a.321.321 0 00.061.333l1.27 1.364-4.115 4.42a.317.317 0 00-.083.216v7.84c0 .168.127.305.284.305h2.277c.157 0 .284-.137.284-.305v-6.7l3.366-3.615 1.27 1.364a.267.267 0 00.31.066.306.306 0 00.176-.282V.972c0-.168-.127-.305-.284-.305z"
        fill={props.color ? props.color : "#202124"}
      />
      <path
        d="M8.225 5.033L4.242.756a.271.271 0 00-.403 0L2.083 2.642A.317.317 0 002 2.858c0 .081.03.159.083.216l4.033 4.33a.274.274 0 00.403 0 .322.322 0 000-.432l-.006-.006L7.83 5.47a.27.27 0 00.396-.005.321.321 0 000-.432z"
        fill={props.color ? props.color : "#202124"}
      />
    </svg>
  );
}

function RuleContactIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0_9163_34999)">
        <path
          d="M.965 13.656v-1.15a2.3 2.3 0 011.332-1.971 15.297 15.297 0 0111.404 0 2.3 2.3 0 011.332 1.971v1.15A2.343 2.343 0 0112.685 16H3.313a2.346 2.346 0 01-2.348-2.344zM7.999 0a3.909 3.909 0 10-.002 7.817A3.909 3.909 0 007.999 0z"
          fill="#202124"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_9163_34999">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function RuleDaysIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 4.5a.5.5 0 00-1 0V8a.5.5 0 00.146.354l1.75 1.75a.5.5 0 00.708-.708L8.5 7.793V4.5z"
        fill={props.color ? props.color : "#202124"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2a6 6 0 100 12A6 6 0 008 2zM3 8a5 5 0 1110 0A5 5 0 013 8z"
        fill={props.color ? props.color : "#202124"}
      />
    </svg>
  );
}

function LoyaltyIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z"
        fill="#FDDC91"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24 43.2C34.6039 43.2 43.2 34.6039 43.2 24C43.2 13.3961 34.6039 4.8 24 4.8C13.3961 4.8 4.8 13.3961 4.8 24C4.8 34.6039 13.3961 43.2 24 43.2ZM24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
        fill="#F5B85D"
      />
      <circle cx="24" cy="24" r="12" fill="#F5B85D" />
    </svg>
  );
}

function CardIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="25px" height="25px"  viewBox="0 0 24 24"><path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg>
  );
}

function ImageDropIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="#E6E6E6" />
      <path
        d="M16.2496 18.8088C16.6916 18.8088 17.1155 18.6317 17.4281 18.3166C17.7407 18.0014 17.9163 17.5739 17.9163 17.1282C17.9163 16.6825 17.7407 16.2551 17.4281 15.9399C17.1155 15.6247 16.6916 15.4477 16.2496 15.4477C15.8076 15.4477 15.3836 15.6247 15.0711 15.9399C14.7585 16.2551 14.5829 16.6825 14.5829 17.1282C14.5829 17.5739 14.7585 18.0014 15.0711 18.3166C15.3836 18.6317 15.8076 18.8088 16.2496 18.8088Z"
        fill="#202124"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.833 15.0276V25.1109C10.833 26.0024 11.1842 26.8573 11.8093 27.4876C12.4344 28.1179 13.2823 28.4721 14.1663 28.4721H25.833C26.7171 28.4721 27.5649 28.1179 28.19 27.4876C28.8151 26.8573 29.1663 26.0024 29.1663 25.1109V15.0276C29.1663 14.1362 28.8151 13.2813 28.19 12.651C27.5649 12.0206 26.7171 11.6665 25.833 11.6665H14.1663C13.2823 11.6665 12.4344 12.0206 11.8093 12.651C11.1842 13.2813 10.833 14.1362 10.833 15.0276ZM25.833 13.7672H14.1663C13.8348 13.7672 13.5169 13.9 13.2825 14.1364C13.048 14.3727 12.9163 14.6933 12.9163 15.0276V23.0489C12.9163 23.0858 12.9258 23.1221 12.9441 23.1541C12.9624 23.1861 12.9886 23.2127 13.0203 23.2311C13.052 23.2496 13.088 23.2594 13.1246 23.2594C13.1612 23.2594 13.1971 23.2497 13.2288 23.2312L17.4997 20.744C18.2598 20.3015 19.122 20.0686 19.9997 20.0686C20.8774 20.0686 21.7396 20.3015 22.4997 20.744L26.7705 23.2312C26.8022 23.2497 26.8382 23.2594 26.8748 23.2594C26.9114 23.2594 26.9473 23.2496 26.979 23.2311C27.0107 23.2127 27.037 23.1861 27.0553 23.1541C27.0735 23.1221 27.0831 23.0858 27.083 23.0489V15.0276C27.083 14.6933 26.9513 14.3727 26.7169 14.1364C26.4825 13.9 26.1645 13.7672 25.833 13.7672Z"
        fill="#202124"
      />
    </svg>
  );
}

function WelcomeAvatarIcon() {
  return (
    <svg
      width={88}
      height={87}
      viewBox="0 0 88 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width={87} height={87} rx="43.5" fill="#FFE5CC" />
      <path
        d="M44 69C58.0833 69 69.5 57.5833 69.5 43.5C69.5 29.4167 58.0833 18 44 18C29.9167 18 18.5 29.4167 18.5 43.5C18.5 57.5833 29.9167 69 44 69Z"
        fill="url(#paint0_radial_9466_110905)"
      />
      <g style={{ mixBlendMode: "soft-light" }}>
        <path
          d="M44 69C58.0833 69 69.5 57.5833 69.5 43.5C69.5 29.4167 58.0833 18 44 18C29.9167 18 18.5 29.4167 18.5 43.5C18.5 57.5833 29.9167 69 44 69Z"
          fill="url(#paint1_radial_9466_110905)"
        />
      </g>
      <g style={{ mixBlendMode: "soft-light" }}>
        <path
          d="M44 69C58.0833 69 69.5 57.5833 69.5 43.5C69.5 29.4167 58.0833 18 44 18C29.9167 18 18.5 29.4167 18.5 43.5C18.5 57.5833 29.9167 69 44 69Z"
          fill="url(#paint2_radial_9466_110905)"
        />
      </g>
      <g style={{ mixBlendMode: "overlay" }}>
        <path
          d="M44 69C58.0833 69 69.5 57.5833 69.5 43.5C69.5 29.4167 58.0833 18 44 18C29.9167 18 18.5 29.4167 18.5 43.5C18.5 57.5833 29.9167 69 44 69Z"
          fill="url(#paint3_radial_9466_110905)"
          fillOpacity="0.7"
        />
      </g>
      <mask
        id="mask0_9466_110905"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={18}
        y={18}
        width={52}
        height={51}
      >
        <path
          d="M44 69C58.0833 69 69.5 57.5833 69.5 43.5C69.5 29.4167 58.0833 18 44 18C29.9167 18 18.5 29.4167 18.5 43.5C18.5 57.5833 29.9167 69 44 69Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_9466_110905)">
        <g filter="url(#filter0_f_9466_110905)">
          <path
            d="M18.355 42.7722C18.3827 42.4099 18.5019 42.3736 18.5367 42.7415C18.5754 43.1502 18.5002 43.972 18.5183 44.4677C18.5662 45.7801 18.7674 46.9213 18.9748 47.8495C19.6432 50.8408 20.5687 52.7683 21.4321 54.4014C24.2698 59.7696 27.3783 62.4879 30.4107 64.5365C34.8558 67.5395 39.337 68.4948 43.8218 68.6974C43.935 68.7025 43.9538 69.4393 43.8425 69.5353C43.6418 69.7082 43.3932 69.5366 43.1879 69.5294C42.5979 69.5087 42.008 69.4682 41.4181 69.4069C39.669 69.2251 37.92 68.855 36.1745 68.2595C31.4286 66.6402 26.3115 63.8677 21.8425 56.0586C21.5614 55.5673 21.2825 55.0501 21.0075 54.4943C20.7876 54.0498 20.5699 53.5839 20.356 53.0856C19.6524 51.4466 18.0127 47.2508 18.355 42.7722ZM43.825 69.5432C43.7171 69.5465 43.6897 68.8596 43.7926 68.717C43.9481 68.5014 44.1811 68.6789 44.345 68.6687C45.0258 68.6261 45.7064 68.563 46.3868 68.4776C48.2524 68.2433 50.1167 67.8433 51.9768 67.2273C56.5905 65.6994 61.5506 63.3702 65.8998 56.2139C66.1766 55.7584 66.451 55.2753 66.7218 54.7559C67.5444 53.1775 69.6064 48.9876 69.368 43.779C69.3479 43.3399 69.4816 43.0769 69.5414 43.4536C69.6176 43.9331 69.5867 44.933 69.5657 45.465C69.4985 47.1689 69.2368 48.6099 68.9609 49.7735C68.0865 53.4615 66.859 55.5998 65.7348 57.3852C62.0808 63.1885 58.1121 65.528 54.2537 67.2091C50.793 68.717 47.306 69.4357 43.825 69.5432Z"
            fill="#401C02"
          />
        </g>
        <g filter="url(#filter1_f_9466_110905)">
          <path
            d="M18.355 42.7722C18.3827 42.4099 18.5019 42.3736 18.5367 42.7415C18.5754 43.1502 18.5002 43.972 18.5183 44.4677C18.5662 45.7801 18.7674 46.9213 18.9748 47.8495C19.6432 50.8408 20.5687 52.7683 21.4321 54.4014C24.2698 59.7696 27.3783 62.4879 30.4107 64.5365C34.8558 67.5395 39.337 68.4948 43.8218 68.6974C43.935 68.7025 43.9538 69.4393 43.8425 69.5353C43.6418 69.7082 43.3932 69.5366 43.1879 69.5294C42.5979 69.5087 42.008 69.4682 41.4181 69.4069C39.669 69.2251 37.92 68.855 36.1745 68.2595C31.4286 66.6402 26.3115 63.8677 21.8425 56.0586C21.5614 55.5673 21.2825 55.0501 21.0075 54.4943C20.7876 54.0498 20.5699 53.5839 20.356 53.0856C19.6524 51.4466 18.0127 47.2508 18.355 42.7722ZM43.825 69.5432C43.7171 69.5465 43.6897 68.8596 43.7926 68.717C43.9481 68.5014 44.1811 68.6789 44.345 68.6687C45.0258 68.6261 45.7064 68.563 46.3868 68.4776C48.2524 68.2433 50.1167 67.8433 51.9768 67.2273C56.5905 65.6994 61.5506 63.3702 65.8998 56.2139C66.1766 55.7584 66.451 55.2753 66.7218 54.7559C67.5444 53.1775 69.6064 48.9876 69.368 43.779C69.3479 43.3399 69.4816 43.0769 69.5414 43.4536C69.6176 43.9331 69.5867 44.933 69.5657 45.465C69.4985 47.1689 69.2368 48.6099 68.9609 49.7735C68.0865 53.4615 66.859 55.5998 65.7348 57.3852C62.0808 63.1885 58.1121 65.528 54.2537 67.2091C50.793 68.717 47.306 69.4357 43.825 69.5432Z"
            fill="#401C02"
          />
        </g>
      </g>
      <path
        d="M39.814 40.1194C39.8179 41.0436 39.6733 41.9625 39.3858 42.8408C39.3559 42.9401 39.2955 43.0274 39.2131 43.0902C39.1307 43.1531 39.0305 43.1883 38.9269 43.1908C38.8086 43.1871 38.6956 43.1414 38.6078 43.062C38.5201 42.9826 38.4634 42.8746 38.448 42.7573C38.1223 40.8066 36.8557 39.3517 35.3416 39.3517C33.8275 39.3517 32.5609 40.8066 32.2352 42.7573C32.2198 42.8746 32.1631 42.9826 32.0754 43.062C31.9876 43.1414 31.8746 43.1871 31.7563 43.1908V43.1908C31.6527 43.1881 31.5526 43.1529 31.4703 43.09C31.3879 43.0272 31.3274 42.94 31.2974 42.8408C31.0099 41.9625 30.8653 41.0436 30.8692 40.1194C30.8692 36.6038 32.8717 33.7544 35.3416 33.7544C37.8115 33.7544 39.814 36.6038 39.814 40.1194Z"
        fill="url(#paint4_radial_9466_110905)"
      />
      <path
        d="M39.814 40.1194C39.8179 41.0436 39.6733 41.9625 39.3858 42.8408C39.3559 42.9401 39.2955 43.0274 39.2131 43.0902C39.1307 43.1531 39.0305 43.1883 38.9269 43.1908C38.8086 43.1871 38.6956 43.1414 38.6078 43.062C38.5201 42.9826 38.4634 42.8746 38.448 42.7573C38.1223 40.8066 36.8557 39.3517 35.3416 39.3517C33.8275 39.3517 32.5609 40.8066 32.2352 42.7573C32.2198 42.8746 32.1631 42.9826 32.0754 43.062C31.9876 43.1414 31.8746 43.1871 31.7563 43.1908V43.1908C31.6527 43.1881 31.5526 43.1529 31.4703 43.09C31.3879 43.0272 31.3274 42.94 31.2974 42.8408C31.0099 41.9625 30.8653 41.0436 30.8692 40.1194C30.8692 36.6038 32.8717 33.7544 35.3416 33.7544C37.8115 33.7544 39.814 36.6038 39.814 40.1194Z"
        stroke="url(#paint5_linear_9466_110905)"
        strokeWidth="0.21146"
        strokeMiterlimit={10}
      />
      <path
        d="M57.1935 40.1194C57.199 41.0433 57.0562 41.9622 56.7705 42.8408C56.7407 42.9401 56.6803 43.0274 56.5979 43.0902C56.5155 43.1531 56.4153 43.1883 56.3117 43.1908C56.1934 43.1871 56.0803 43.1414 55.9926 43.062C55.9049 42.9826 55.8482 42.8746 55.8327 42.7573C55.5071 40.8066 54.2404 39.3517 52.7264 39.3517C51.2123 39.3517 49.9457 40.8066 49.62 42.7573C49.6045 42.8746 49.5479 42.9826 49.4601 43.062C49.3724 43.1414 49.2593 43.1871 49.1411 43.1908V43.1908C49.0374 43.1883 48.9373 43.1531 48.8549 43.0902C48.7725 43.0274 48.712 42.9401 48.6822 42.8408C48.3947 41.9625 48.2501 41.0436 48.254 40.1194C48.254 36.6038 50.2565 33.7544 52.7264 33.7544C55.1962 33.7544 57.1935 36.6038 57.1935 40.1194Z"
        fill="url(#paint6_radial_9466_110905)"
      />
      <path
        d="M57.1935 40.1194C57.199 41.0433 57.0562 41.9622 56.7705 42.8408C56.7407 42.9401 56.6803 43.0274 56.5979 43.0902C56.5155 43.1531 56.4153 43.1883 56.3117 43.1908C56.1934 43.1871 56.0803 43.1414 55.9926 43.062C55.9049 42.9826 55.8482 42.8746 55.8327 42.7573C55.5071 40.8066 54.2404 39.3517 52.7264 39.3517C51.2123 39.3517 49.9457 40.8066 49.62 42.7573C49.6045 42.8746 49.5479 42.9826 49.4601 43.062C49.3724 43.1414 49.2593 43.1871 49.1411 43.1908V43.1908C49.0374 43.1883 48.9373 43.1531 48.8549 43.0902C48.7725 43.0274 48.712 42.9401 48.6822 42.8408C48.3947 41.9625 48.2501 41.0436 48.254 40.1194C48.254 36.6038 50.2565 33.7544 52.7264 33.7544C55.1962 33.7544 57.1935 36.6038 57.1935 40.1194Z"
        stroke="url(#paint7_linear_9466_110905)"
        strokeWidth="0.21146"
        strokeMiterlimit={10}
      />
      <path
        d="M60.8412 50.3457C59.305 53.5041 56.9114 56.1668 53.9338 58.0296C50.9563 59.8924 47.5149 60.8802 44.0026 60.8802C40.4904 60.8802 37.049 59.8924 34.0715 58.0296C31.0939 56.1668 28.7003 53.5041 27.1641 50.3457C32.0752 52.0606 37.8428 53.0482 44.0026 53.0482C50.1625 53.0482 55.9301 52.0606 60.8412 50.3457Z"
        fill="url(#paint8_linear_9466_110905)"
      />
      <path
        d="M62.433 45.4424C62.4139 45.5481 62.3939 45.6538 62.3727 45.7649C62.3516 45.8759 62.3347 45.9594 62.3135 46.0556C62.3135 46.0746 62.3061 46.0926 62.3019 46.1106C62.2818 46.2089 62.2596 46.3062 62.2374 46.4035C62.2152 46.5007 62.1951 46.58 62.1729 46.6678C62.1602 46.7207 62.1475 46.7735 62.1327 46.8264C62.1274 46.8497 62.1211 46.874 62.1147 46.8972C62.101 46.9522 62.0862 47.003 62.0714 47.0611C62.0714 47.0823 62.0608 47.1034 62.0545 47.1245C62.034 47.1993 62.0129 47.2743 61.991 47.3498C61.9625 47.4555 61.9318 47.5528 61.9012 47.6543V47.6606C61.8716 47.7558 61.8419 47.852 61.8102 47.9471C61.7415 48.1586 61.6696 48.3701 61.5988 48.5815C61.5618 48.6872 61.5237 48.7835 61.4856 48.8828C61.4476 48.9822 61.4201 49.052 61.3862 49.1366C61.3355 49.2635 61.2805 49.3893 61.2298 49.5141C61.1949 49.5965 61.1589 49.679 61.124 49.7604L61.1188 49.771C61.0839 49.8503 61.0479 49.9285 61.013 50.0068L60.9559 50.1294C60.921 50.2034 60.8861 50.2774 60.8502 50.3504C55.939 52.0653 50.1715 53.0528 44.0116 53.0528C37.8518 53.0528 32.0842 52.0653 27.173 50.3504C27.1371 50.2774 27.1022 50.2034 27.0673 50.1294L27.0102 50.0068C26.9743 49.9285 26.9383 49.8503 26.9045 49.771L26.8992 49.7604C26.8632 49.679 26.8273 49.5965 26.7935 49.5141C26.7395 49.3893 26.6877 49.2635 26.637 49.1366C26.6031 49.052 26.5704 48.9674 26.5376 48.8828C26.5048 48.7983 26.4615 48.683 26.4245 48.5815C26.3483 48.3701 26.2764 48.1639 26.2077 47.9471C26.176 47.852 26.1464 47.7558 26.1168 47.6606V47.6543C26.0861 47.5485 26.0555 47.4513 26.0269 47.3498C26.0044 47.275 25.9832 47.2 25.9635 47.1245C25.9571 47.1034 25.9518 47.0823 25.9466 47.0611C25.9318 47.0072 25.917 46.9554 25.9032 46.8972C25.8969 46.874 25.8905 46.8497 25.8852 46.8264C25.8704 46.7735 25.8577 46.7207 25.8451 46.6678C25.8229 46.58 25.8017 46.4912 25.7806 46.4035C25.7594 46.3157 25.7362 46.2089 25.7161 46.1106C25.7161 46.0926 25.7076 46.0746 25.7044 46.0556C25.6833 45.9594 25.6643 45.8621 25.6452 45.7649C25.6262 45.6676 25.604 45.5534 25.585 45.4424C30.8228 47.52 37.173 48.7369 44.0158 48.7369C50.8587 48.7369 57.1951 47.52 62.433 45.4424Z"
        fill="url(#paint9_linear_9466_110905)"
      />
      <path
        d="M60.8412 50.3457C55.9301 52.0606 50.1625 53.0482 44.0026 53.0482C37.8428 53.0482 32.0752 52.0606 27.1641 50.3457"
        stroke="url(#paint10_radial_9466_110905)"
        strokeWidth="0.634381"
        strokeMiterlimit={10}
      />
      <mask
        id="mask1_9466_110905"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={25}
        y={45}
        width={38}
        height={16}
      >
        <path
          d="M61.8464 45.5642C61.9048 45.542 61.968 45.536 62.0295 45.5466C62.091 45.5573 62.1486 45.5843 62.196 45.6249C62.2435 45.6654 62.2792 45.718 62.2993 45.7771C62.3195 45.8362 62.3234 45.8996 62.3106 45.9607C61.4158 50.1529 59.1096 53.9111 55.7771 56.6074C52.4447 59.3037 48.2879 60.7747 44.0013 60.7747C39.7146 60.7747 35.5578 59.3037 32.2254 56.6074C28.8929 53.9111 26.5867 50.1529 25.692 45.9607C25.6792 45.8996 25.683 45.8362 25.7032 45.7771C25.7233 45.718 25.759 45.6654 25.8065 45.6249C25.854 45.5843 25.9115 45.5573 25.973 45.5466C26.0345 45.536 26.0978 45.542 26.1561 45.5642C31.2788 47.5033 37.4111 48.6304 44.0013 48.6304C50.5914 48.6304 56.7238 47.5033 61.8464 45.5642Z"
          fill="url(#paint11_linear_9466_110905)"
        />
      </mask>
      <g mask="url(#mask1_9466_110905)">
        <g filter="url(#filter2_f_9466_110905)">
          <path
            d="M61.8464 45.5642C61.9048 45.542 61.968 45.536 62.0295 45.5466C62.091 45.5573 62.1486 45.5843 62.196 45.6249C62.2435 45.6654 62.2792 45.718 62.2993 45.7771C62.3195 45.8362 62.3234 45.8996 62.3106 45.9607C61.4158 50.1529 59.1096 53.9111 55.7771 56.6074C52.4447 59.3037 48.2879 60.7747 44.0013 60.7747C39.7146 60.7747 35.5578 59.3037 32.2254 56.6074C28.8929 53.9111 26.5867 50.1529 25.692 45.9607C25.6792 45.8996 25.683 45.8362 25.7032 45.7771C25.7233 45.718 25.759 45.6654 25.8065 45.6249C25.854 45.5843 25.9115 45.5573 25.973 45.5466C26.0345 45.536 26.0978 45.542 26.1561 45.5642C31.2788 47.5033 37.4111 48.6304 44.0013 48.6304C50.5914 48.6304 56.7238 47.5033 61.8464 45.5642Z"
            stroke="url(#paint12_linear_9466_110905)"
            strokeWidth="1.26876"
            strokeMiterlimit={10}
          />
        </g>
      </g>
      <path
        d="M62.8031 46.1697L62.8027 46.1715C61.884 50.4762 59.5159 54.3352 56.094 57.1038C52.6722 59.8724 48.4039 61.3829 44.0022 61.3829C39.6006 61.3829 35.3323 59.8724 31.9105 57.1038C28.4886 54.3352 26.1205 50.4762 25.2018 46.1715L25.2014 46.1697L25.2014 46.1697C25.1701 46.0204 25.1796 45.8654 25.2288 45.721C25.2781 45.5766 25.3653 45.4481 25.4813 45.349C25.5973 45.2498 25.7378 45.1838 25.8882 45.1577C26.0384 45.1317 26.1928 45.1465 26.3353 45.2007M62.8031 46.1697L26.1571 45.6702M62.8031 46.1697C62.8344 46.0204 62.8249 45.8654 62.7757 45.721C62.7264 45.5765 62.6392 45.4481 62.5232 45.349C62.4072 45.2498 62.2666 45.1838 62.1163 45.1577C61.9663 45.1317 61.812 45.1465 61.6696 45.2005M62.8031 46.1697L61.8474 45.6702M26.3353 45.2007C26.3354 45.2007 26.3356 45.2008 26.3357 45.2008L26.1571 45.6702M26.3353 45.2007C26.3352 45.2006 26.335 45.2006 26.3349 45.2005L26.1571 45.6702M26.3353 45.2007C31.3962 47.1163 37.4676 48.2342 44.0022 48.2342C50.5371 48.2342 56.6086 47.1163 61.6696 45.2005M26.1571 45.6702C31.2797 47.6093 37.4121 48.7364 44.0022 48.7364C50.5924 48.7364 56.7248 47.6093 61.8474 45.6702M61.6696 45.2005C61.6693 45.2006 61.669 45.2007 61.6688 45.2008L61.8474 45.6702M61.6696 45.2005L61.8474 45.6702"
        stroke="url(#paint13_linear_9466_110905)"
        strokeWidth="1.00444"
        strokeMiterlimit={10}
      />
      <path
        d="M61.8474 45.6702C61.9057 45.648 61.969 45.6419 62.0305 45.6526C62.092 45.6632 62.1495 45.6903 62.197 45.7308C62.2445 45.7714 62.2802 45.824 62.3003 45.8831C62.3205 45.9421 62.3243 46.0056 62.3115 46.0667C61.4168 50.2589 59.1106 54.0171 55.7781 56.7134C52.4457 59.4097 48.2889 60.8807 44.0022 60.8807C39.7156 60.8807 35.5588 59.4097 32.2264 56.7134C28.8939 54.0171 26.5877 50.2589 25.6929 46.0667C25.6801 46.0056 25.684 45.9421 25.7042 45.8831C25.7243 45.824 25.76 45.7714 25.8075 45.7308C25.8549 45.6903 25.9125 45.6632 25.974 45.6526C26.0355 45.6419 26.0987 45.648 26.1571 45.6702C31.2797 47.6093 37.4121 48.7364 44.0022 48.7364C50.5924 48.7364 56.7248 47.6093 61.8474 45.6702Z"
        stroke="url(#paint14_linear_9466_110905)"
        strokeWidth="1.26876"
        strokeMiterlimit={10}
      />
      <defs>
        <filter
          id="filter0_f_9466_110905"
          x="15.6653"
          y="39.8392"
          width="56.5678"
          height="32.4164"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.32163"
            result="effect1_foregroundBlur_9466_110905"
          />
        </filter>
        <filter
          id="filter1_f_9466_110905"
          x="14.0794"
          y="38.2532"
          width="59.7397"
          height="35.5883"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.1146"
            result="effect1_foregroundBlur_9466_110905"
          />
        </filter>
        <filter
          id="filter2_f_9466_110905"
          x="23.9925"
          y="43.8499"
          width="40.0169"
          height="18.6166"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.528651"
            result="effect1_foregroundBlur_9466_110905"
          />
        </filter>
        <radialGradient
          id="paint0_radial_9466_110905"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(43.981 18) rotate(90) scale(50.9619)"
        >
          <stop stopColor="#FFDE43" />
          <stop offset={1} stopColor="#FFBC00" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_9466_110905"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(43.981 24.8196) rotate(90) scale(44.1423)"
        >
          <stop stopColor="white" stopOpacity="0.5" />
          <stop offset="0.782278" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_9466_110905"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(43.981 24.8196) rotate(90) scale(44.1423)"
        >
          <stop stopColor="white" stopOpacity="0.5" />
          <stop offset="0.782278" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_9466_110905"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(43.981 12.4492) rotate(90) scale(56.5128 76.4254)"
        >
          <stop offset="0.0922635" stopColor="white" />
          <stop offset="0.670207" stopColor="white" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint4_radial_9466_110905"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(35.3354 38.4695) scale(5.7013 4.72639)"
        >
          <stop stopColor="#743C1C" />
          <stop offset={1} stopColor="#401C02" />
        </radialGradient>
        <linearGradient
          id="paint5_linear_9466_110905"
          x1="35.3416"
          y1="43.4563"
          x2="35.3416"
          y2="33.4507"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDE43" />
          <stop offset="0.22" stopColor="#FED93F" />
          <stop offset="0.51" stopColor="#FCC934" />
          <stop offset="0.82" stopColor="#F9AF21" />
          <stop offset={1} stopColor="#F79D14" />
        </linearGradient>
        <radialGradient
          id="paint6_radial_9466_110905"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(52.7176 38.4695) scale(5.69798 4.72639)"
        >
          <stop stopColor="#743C1C" />
          <stop offset={1} stopColor="#401C02" />
        </radialGradient>
        <linearGradient
          id="paint7_linear_9466_110905"
          x1="52.7238"
          y1="43.4563"
          x2="52.7238"
          y2="33.4507"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDE43" />
          <stop offset="0.22" stopColor="#FED93F" />
          <stop offset="0.51" stopColor="#FCC934" />
          <stop offset="0.82" stopColor="#F9AF21" />
          <stop offset={1} stopColor="#F79D14" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_9466_110905"
          x1="27.1512"
          y1="55.6149"
          x2="60.8412"
          y2="55.6149"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCCCCC" />
          <stop offset="0.05" stopColor="#D5D5D5" />
          <stop offset="0.2" stopColor="#E9E9E9" />
          <stop offset="0.35" stopColor="#F6F6F6" />
          <stop offset="0.5" stopColor="#FAFAFA" />
          <stop offset="0.65" stopColor="#F6F6F6" />
          <stop offset="0.8" stopColor="#E9E9E9" />
          <stop offset="0.95" stopColor="#D5D5D5" />
          <stop offset={1} stopColor="#CCCCCC" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_9466_110905"
          x1="25.5708"
          y1="49.249"
          x2="62.433"
          y2="49.249"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCCCCC" />
          <stop offset="0.05" stopColor="#D5D5D5" />
          <stop offset="0.2" stopColor="#E9E9E9" />
          <stop offset="0.35" stopColor="#F6F6F6" />
          <stop offset="0.5" stopColor="#FAFAFA" />
          <stop offset="0.65" stopColor="#F6F6F6" />
          <stop offset="0.8" stopColor="#E9E9E9" />
          <stop offset="0.95" stopColor="#D5D5D5" />
          <stop offset={1} stopColor="#CCCCCC" />
        </linearGradient>
        <radialGradient
          id="paint10_radial_9466_110905"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(44.0026 51.7054) scale(12.0384)"
        >
          <stop stopColor="#401C02" />
          <stop offset={1} stopColor="#401C02" />
        </radialGradient>
        <linearGradient
          id="paint11_linear_9466_110905"
          x1="18426.4"
          y1="9812.64"
          x2="18426.4"
          y2="7434.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401C02" />
          <stop offset={1} stopColor="#401C02" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_9466_110905"
          x1="18426.4"
          y1="9812.64"
          x2="18426.4"
          y2="7434.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401C02" />
          <stop offset={1} stopColor="#401C02" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_9466_110905"
          x1="44.0022"
          y1="61.3093"
          x2="44.0022"
          y2="45.1573"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.265625" stopColor="#FFDE43" />
          <stop offset={1} stopColor="#F79D14" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_9466_110905"
          x1="18426.4"
          y1="9812.75"
          x2="18426.4"
          y2="7434.99"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401C02" />
          <stop offset={1} stopColor="#401C02" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const InfoIcon = () => {
  return (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#prefix__clip0_9662_80688)">
        <path
          d="M10 20a10 10 0 100-20 10 10 0 000 20zm1.162-11.765l-1.25 5.881c-.087.425.037.667.38.667.243 0 .61-.088.858-.308l-.11.52c-.359.433-1.15.748-1.831.748-.879 0-1.253-.528-1.01-1.65L9.12 9.76c.08-.367.008-.499-.359-.588L8.2 9.07l.102-.476 2.863-.359h-.002zM10 6.875a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z"
          fill="#5F6368"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_9662_80688">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

function LandingPagePoinIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
        fill="#FDDC91"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="#F5B85D"
      />
      <circle cx="10" cy="10" r="5" fill="#F5B85D" />
    </svg>
  );
}

function LandingPageTitleIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" fill="#202124" />
      <path
        d="M12 6L13.7634 9.57295L17.7063 10.1459L14.8532 12.9271L15.5267 16.8541L12 15L8.47329 16.8541L9.14683 12.9271L6.29366 10.1459L10.2366 9.57295L12 6Z"
        fill="white"
      />
    </svg>
  );
}

function SubBrandPageSeperator() {
  return (
    <svg
      width="568"
      height="4"
      viewBox="0 0 568 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="268" cy="2" r="2" fill="#5F6368" />
      <circle cx="284" cy="2" r="2" fill="#5F6368" />
      <circle cx="300" cy="2" r="2" fill="#5F6368" />
    </svg>
  );
}

function OrdersIcon() {
  return (
    <svg fill="#000000" width="25px" height="25px" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><path d="M624 62H374v84h250V62zM457 603h84V353h-84v250zm334-275l59-59q-28-34-58-59l-59 59q-50-39-108-60-61-22-126-22-102 0-189 51-85 50-134 134-51 88-51 189.5T176 750q49 85 134 135 87 51 189 51t189-51q85-50 134-135 51-87 51-189 0-64-22-125-20-59-60-108zM499 852q-79 0-147-39-66-39-104-105-40-67-40-146.5T248 414q38-65 104-104 68-40 147-40t147 40q66 38 104 104 40 68 40 147t-40 147q-38 66-104 105-68 39-147 39z"/></svg>
  );
}

function ExpirationIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={32} height={32} rx={4} fill="#E68C31" fillOpacity={0.1} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.572 8.848A1.623 1.623 0 0116 8c.597 0 1.145.326 1.428.848l7.241 13.373c.653 1.206-.225 2.668-1.602 2.668H8.933c-1.376 0-2.254-1.462-1.602-2.668l7.241-13.373zM16 9.206a.41.41 0 00-.36.214L8.4 22.793a.603.603 0 00.533.89h14.134a.603.603 0 00.534-.89L16.361 9.42a.41.41 0 00-.36-.214zm0 4.223c.335 0 .607.27.607.603v4.524a.605.605 0 01-.607.603.605.605 0 01-.606-.603v-4.524c0-.333.271-.603.606-.603zm0 6.635c.335 0 .607.27.607.603v.603a.605.605 0 01-.607.603.605.605 0 01-.606-.603v-.603c0-.334.271-.604.606-.604z"
        fill="#E68C31"
      />
    </svg>
  );
}

function Tooltip(props) {
  return (
    <svg
      width={10}
      height={10}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 .714a4.286 4.286 0 100 8.572A4.286 4.286 0 005 .714zM0 5a5 5 0 1110 0A5 5 0 010 5zm5-2.857c.197 0 .357.16.357.357v.714a.357.357 0 01-.714 0V2.5c0-.197.16-.357.357-.357zm0 2.143c.197 0 .357.16.357.357V7.5a.357.357 0 01-.714 0V4.643c0-.197.16-.357.357-.357z"
        fill="#6A778A"
      />
    </svg>
  );
}

function NavAudienceFillIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.148 13.333c0-1.534 1.074-2.5 2.778-2.5 1.705 0 2.777.966 2.777 2.5H8.148zm4.63-5c0 .92-.83 1.667-1.852 1.667-1.023 0-1.852-.747-1.852-1.667s.83-1.666 1.852-1.666c1.022 0 1.851.746 1.851 1.666z"
        fill="#3770FB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.37 16.667V15h.927v-1.667H5.37v-2.5h.927V9.167H5.37v-2.5h.927V5H5.37V3.333h11.112v13.334H5.37zm11.112-15H5.37c-1.02 0-1.852.746-1.852 1.666V5H1.667v1.667h1.851v2.5H1.667v1.666h1.851v2.5H1.667V15h1.851v1.667c0 .919.831 1.666 1.852 1.666h11.112c1.02 0 1.851-.747 1.851-1.666V3.333c0-.92-.83-1.666-1.851-1.666z"
        fill="#3770FB"
      />
    </svg>
  );
}

function InfoIconEarnPoint() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0001 2.85722C6.05519 2.85722 2.85722 6.05519 2.85722 10.0001C2.85722 13.945 6.05519 17.1429 10.0001 17.1429C13.945 17.1429 17.1429 13.945 17.1429 10.0001C17.1429 6.05519 13.945 2.85722 10.0001 2.85722ZM1.66675 10.0001C1.66675 5.39771 5.39771 1.66675 10.0001 1.66675C14.6025 1.66675 18.3334 5.39771 18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001ZM10.0001 5.23818C10.3288 5.23818 10.5953 5.50467 10.5953 5.83342V7.02389C10.5953 7.35263 10.3288 7.61913 10.0001 7.61913C9.67134 7.61913 9.40484 7.35263 9.40484 7.02389V5.83342C9.40484 5.50467 9.67134 5.23818 10.0001 5.23818ZM10.0001 8.80961C10.3288 8.80961 10.5953 9.0761 10.5953 9.40484V14.1667C10.5953 14.4955 10.3288 14.762 10.0001 14.762C9.67134 14.762 9.40484 14.4955 9.40484 14.1667V9.40484C9.40484 9.0761 9.67134 8.80961 10.0001 8.80961Z"
        fill="#41536C"
      />
    </svg>
  );
}

function IconPlus(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 17.292a7.292 7.292 0 110-14.584 7.292 7.292 0 010 14.584zm0 1.041a8.333 8.333 0 100-16.666 8.333 8.333 0 000 16.666z"
        fill="#27323F"
      />
      <path
        d="M10 5.833a.52.52 0 01.52.521V9.48h3.126a.52.52 0 110 1.042H10.52v3.125a.52.52 0 01-1.042 0V10.52H6.354a.521.521 0 010-1.042H9.48V6.354a.52.52 0 01.521-.52z"
        fill="#27323F"
      />
    </svg>
  );
}

function ChatraceIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 651 786"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M624.883 0.858581C494.404 16.5969 355.438 103.02 274.482 219.776C183.65 232.577 99.5477 280.692 42.2254 353.904C38.8788 358.113 38.2073 363.882 40.4865 368.75C42.7972 373.643 47.6414 376.799 53.0297 376.915L163.485 379.248L151.905 395.895C147.598 402.079 148.882 410.528 154.823 415.179L357.901 574.182C360.966 576.581 364.74 577.523 368.374 577.081C371.726 576.673 374.933 575.08 377.318 572.36L390.7 557.124L419.464 663.794C420.869 668.997 425.512 672.376 430.76 673.453C432.107 673.717 433.484 673.752 434.864 673.583C438.864 673.096 442.735 670.851 445.213 667.72C501.743 595.519 528.276 502.329 518.912 411.078C614.417 302.574 665.651 143.659 646.537 12.2316C645.428 4.76268 638.635 -0.555757 631.09 0.162613C629.023 0.376687 626.954 0.608157 624.883 0.857982L624.883 0.858581Z"
        fill="#2D8CFE"
      />
      <path
        d="M136.336 494.349C136.263 494.358 136.115 494.375 135.894 494.401C61.212 503.209 7.64035 571.105 16.4476 645.787C20.0419 676.265 33.937 704.63 55.7874 726.22L41.4883 774.371C40.3086 778.326 42.5932 782.472 46.4658 783.586C47.8637 784.02 49.357 783.993 50.7331 783.607L121.482 762.394C136.564 765.927 152.08 766.791 167.421 764.907C242.102 756.1 295.674 688.203 286.867 613.522C278.233 539.044 210.805 485.642 136.336 494.349V494.349ZM102.751 608L142.601 603.3C146.659 602.821 150.372 605.751 150.851 609.809C151.329 613.868 148.4 617.581 144.341 618.059L104.491 622.759C100.433 623.237 96.7202 620.308 96.2415 616.249C95.7629 612.191 98.6921 608.478 102.751 608V608ZM200.35 648.865L108.843 659.657C104.784 660.135 101.072 657.206 100.593 653.147C100.114 649.089 103.043 645.376 107.102 644.898L198.609 634.106C202.668 633.627 206.381 636.557 206.859 640.615C207.338 644.674 204.409 648.387 200.35 648.865Z"
        fill="#2D8CFE"
      />
    </svg>
  );
}

function profileIcon(props) {
  return (
    <svg
      width={16}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.214 5.788c0 .849-.339 1.663-.942 2.263a3.222 3.222 0 01-4.546 0 3.194 3.194 0 010-4.527 3.222 3.222 0 014.546 0c.603.6.942 1.415.942 2.264zm.079 3.935a5.102 5.102 0 001.543-5.678 5.125 5.125 0 00-1.884-2.45 5.16 5.16 0 00-5.907 0 5.125 5.125 0 00-1.883 2.45 5.101 5.101 0 001.542 5.678 7.712 7.712 0 00-3.122 2.683 7.666 7.666 0 00-1.29 3.901.958.958 0 00.92.983.967.967 0 001.006-.893c.07-1.48.71-2.876 1.787-3.898a5.8 5.8 0 013.994-1.593 5.8 5.8 0 013.994 1.593 5.751 5.751 0 011.787 3.898.957.957 0 00.632.878.97.97 0 001.052-.263.96.96 0 00.242-.705 7.667 7.667 0 00-1.29-3.901 7.713 7.713 0 00-3.123-2.683z"
        fill="#84889B"
      />
    </svg>
  );
}

function GoogleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="30px"
      height="30px"
    >
      <path
        fill="#FFC107"
        d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
      />
      <path
        fill="#FF3D00"
        d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
      />
      <path
        fill="#4CAF50"
        d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
      />
      <path
        fill="#1976D2"
        d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
      />
    </svg>
  );
}

function GiftIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={40} height={40} rx={20} fill="#3770FB" />
      <path
        d="M12.5 11.75a3.75 3.75 0 017.5 0 3.75 3.75 0 017.5 0v.009c0 .105 0 .405-.057.741H30.5A1.5 1.5 0 0132 14v3a1.5 1.5 0 01-1.5 1.5v11.25A2.25 2.25 0 0128.25 32h-16.5a2.25 2.25 0 01-2.25-2.25V18.5A1.5 1.5 0 018 17v-3a1.5 1.5 0 011.5-1.5h3.057a4.452 4.452 0 01-.057-.741v-.009zm1.602.75H18.5v-.75a2.249 2.249 0 10-4.5 0c0 .127.003.411.068.645.008.036.02.07.034.105zm7.398 0h4.398a.842.842 0 00.035-.105c.064-.234.067-.518.067-.645a2.25 2.25 0 00-4.5 0v.75zM9.5 14v3h9v-3h-9zm12 0v3h9v-3h-9zm7.5 4.5h-7.5v12h6.75a.75.75 0 00.75-.75V18.5zm-10.5 12v-12H11v11.25a.75.75 0 00.75.75h6.75z"
        fill="#FCFCFD"
      />
    </svg>
  );
}

function Star(props) {
  return (
    <svg
      width={48}
      height={48}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={48} height={48} rx={24} fill="#FEF4E2" />
      <path
        d="M24.53 12.388c-.066.01-.148.028-.183.042a1.99 1.99 0 01-.173.05c-.174.039-.265.096-.437.279-.51.53-1.16 1.643-1.778 3.037-.192.435-.498 1.162-1.335 3.187l-.229.548h-.34c-.188 0-.974-.016-1.746-.034-2.474-.06-3.253-.048-3.703.057-.597.142-.7.192-.798.389-.144.29-.073.578.32 1.291.386.7.793 1.115 3.34 3.41.372.336.683.62.69.631.007.012-.071.26-.172.556-.448 1.31-.614 1.858-1.154 3.814-.65 2.343-.7 2.583-.704 3.214l-.002.368.098.192c.055.105.121.208.146.229.046.034.044.039-.055.194-.226.357-.544.896-.544.926.003.178.47.263.926.169.656-.137 1.6-.565 2.2-.999.191-.137.822-.645 2.523-2.03a246.07 246.07 0 012.132-1.725c.002 0 .245.221.54.491.608.562.72.663 1.408 1.291.274.25.74.682 1.035.96 1.001.94 1.408 1.297 1.982 1.729.32.24.468.329.649.39.125.044.153.046.247.02.21-.054.347-.193.44-.436a1.25 1.25 0 01.097-.192.489.489 0 00.073-.166.35.35 0 01.037-.113c.009-.013.045-.12.08-.24.132-.468.086-1.554-.14-3.289-.128-.985-.389-2.4-.79-4.317a12.15 12.15 0 01-.113-.576c0-.04.247-.224 1.2-.908.215-.153.476-.343.583-.418.702-.508 1.228-.88 1.909-1.358 1.122-.786 1.25-.898 1.442-1.28.203-.4.29-.713.279-1.01-.01-.29-.046-.334-.455-.54-.361-.18-.709-.278-1.266-.356-.556-.078-.85-.091-2.595-.128a261.42 261.42 0 01-2.1-.053l-.444-.016-.214-.822c-.618-2.375-.92-3.395-1.372-4.63-.386-1.05-.71-1.633-.96-1.713a.984.984 0 01-.162-.083c-.085-.06-.178-.066-.412-.032zm.265 1.596c.302.77.677 2.062 1 3.456.134.58.49 2.176.49 2.2 0 .015-.397.02-1.135.008-1.509-.02-3.56-.062-3.57-.073a.988.988 0 01.077-.197l.677-1.52c.324-.731.672-1.497.77-1.703.31-.647.702-1.34 1.07-1.892.192-.293.455-.604.489-.583.011.007.07.144.133.304zM18 20.868c1.415.028 1.822.046 1.808.078a91.931 91.931 0 00-.736 1.893 8.676 8.676 0 01-.24.612c-.007 0-.11-.089-.229-.199a119.78 119.78 0 00-2.125-1.897l-.551-.475.167-.014c.28-.02.754-.02 1.906.002zm3.513.149c.281.02.994.078 1.584.128 1.623.137 2.437.199 3.017.229.316.016.537.036.551.052.028.025.092.327.512 2.39l.22 1.084-.25.16a88.91 88.91 0 00-3.2 2.172c-.315.224-.587.413-.603.418-.016.007-.25-.197-.517-.452a185.04 185.04 0 00-2.358-2.215c-.478-.444-.867-.816-.862-.832.005-.014.11-.293.238-.62.333-.86.658-1.634 1.024-2.441.032-.073.061-.107.091-.107.025 0 .274.016.553.034zm7.721.526c.42.018 1.07.043 1.44.057 1.386.05 1.72.066 1.728.075.02.018-1.005.72-1.91 1.308-.501.322-1.735 1.085-1.758 1.085-.007 0-.044-.13-.078-.292-.09-.398-.519-2.222-.535-2.263-.011-.028.014-.03.167-.018.098.009.526.03.946.048zm-9.35 5.289c.818.736 1.515 1.371 1.894 1.723.069.062.115.121.103.128a48.12 48.12 0 00-1.424 1.026c-1.015.768-2.407 1.946-2.855 2.419-.178.19-.59.688-.738.9-.041.055-.041.053-.027-.114.02-.251.093-.665.16-.914.073-.27.827-2.791 1.026-3.429.352-1.127.875-2.612.912-2.59.011.01.439.391.949.85zm7.887-.09c0 .014.062.346.138.737.404 2.098.567 3.22.692 4.8l.03.358-.757-.747a47.105 47.105 0 00-1.245-1.193 210.213 210.213 0 01-1.62-1.479l-.147-.135.44-.375c.98-.832 2.4-1.988 2.447-1.988.013 0 .023.011.023.023z"
        fill="#FFA610"
      />
    </svg>
  );
}

function PresentIcon(props) {
  return (
    <svg
      width={80}
      height={80}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M53.534 8.907c-.654.06-1.914.246-2.167.326-.147.047-.713.2-1.26.327-.547.133-1.027.267-1.067.3-.04.027-.373.154-.74.273-.366.12-.753.254-.866.307-.107.047-.487.207-.834.353-1.24.507-1.573.66-2.3 1.034-1.486.76-2.16 1.226-3.073 2.133-.48.48-1.107 1.287-1.36 1.747-.3.54-.56.96-.607.96-.026 0-.08-.08-.113-.187-.1-.28-.82-1.253-1.393-1.88-1.067-1.16-2.24-2.153-3.22-2.7-1.727-.967-3.6-1.607-5.334-1.84-.813-.107-2.613-.113-3.3-.007-.753.12-1.853.354-1.933.414-.033.026-.22.1-.407.153-1.006.293-1.88.987-2.513 1.98-.28.44-.46.9-.727 1.867-.106.386-.033 1.633.134 2.233.233.834.366 1.133.913 2.1.74 1.313 1.08 1.72 2.167 2.6a11.91 11.91 0 003.5 1.933c.493.174.52.187.366.254-.093.04-1.273.133-2.633.213-3.393.187-5.307.327-5.467.4-.073.027-.48.087-.9.127-1.093.106-3.073.4-3.233.473-.073.033-.747.18-1.5.327-1.88.36-2.44.526-2.807.82-.16.133-.426.286-.593.34-.58.193-.567.14-.553 2.7.006 2.613.053 2.953.513 3.833.927 1.767 1.067 1.98 1.52 2.287.16.106.44.313.62.46.187.153.44.313.567.36.126.053.366.153.533.226.38.167 1.333.36 2.053.42l.56.047-.04.773c-.02.427-.006 1.46.034 2.307.033.84.093 4.413.12 7.933.033 3.52.086 6.82.126 7.334.04.513.14 1.76.214 2.766.08 1.007.166 1.94.2 2.067.033.127.106 1.207.166 2.4.054 1.193.114 2.373.134 2.633.086 1.12.253 2.607.3 2.667.026.033.073.367.093.733.067.894.18 1.42.407 1.807.1.18.346.627.546.993.354.654.447.76 1.26 1.454.327.28.394.313.58.28.12-.027.307-.107.427-.174.267-.166 1.027-.18 4.487-.1 2.826.067 6.233-.053 11.3-.393.733-.053 2.746-.18 4.466-.293a333.6 333.6 0 004.167-.3c2.333-.214 6.313-.64 6.533-.7.127-.04.534-.1.9-.14 1.38-.154 3.274-.407 3.5-.474.127-.033 1.134-.18 2.234-.326 3.24-.42 4.5-.64 6-1.054.78-.213 1.08-.326 1.22-.46.046-.046.12-.086.153-.086.08 0 .593-.467.593-.547 0-.033.06-.12.127-.193a.885.885 0 00.173-.307c.06-.26.32-.78.42-.853.047-.04.107-.207.127-.367.02-.167.073-.347.12-.4.047-.053.153-.353.24-.667.167-.633.253-2.06.133-2.3-.06-.12-.12-.58-.473-3.733-.12-1.053-.62-5.093-.833-6.713-.1-.794-.34-3.487-.407-4.62-.027-.407-.067-.767-.093-.8-.027-.04-.067-.487-.094-1-.133-2.674-.393-6.094-.506-6.5-.08-.3-.574-4.454-.534-4.494.02-.013.514-.106 1.1-.206.587-.1 1.1-.2 1.134-.234.04-.026.2-.073.366-.1a5.25 5.25 0 00.68-.146c.474-.127.8-.454 1.027-1.034.087-.226.207-.46.26-.52.053-.06.1-.213.1-.346 0-.147.047-.274.127-.347.146-.133.253-.513.34-1.2.086-.707.02-1.18-.234-1.607-.12-.193-.193-.38-.166-.413.026-.027.14-.507.24-1.053.16-.874.186-1.167.186-2.3.007-1.16-.006-1.354-.146-1.82a5.253 5.253 0 00-.334-.867 2.337 2.337 0 01-.213-.667c-.033-.313-.04-.326-.367-.46a16.86 16.86 0 01-.806-.366c-.594-.294-.787-.28-.814.053l-.02.233-2.313.187c-1.273.1-2.42.207-2.547.24-.406.107-5.086.373-8.033.467-1.247.04-2.393.1-2.553.133-.36.087-.747.087-.747.007 0-.034.16-.12.353-.194.72-.273 3.827-1.973 4.047-2.213.02-.02.147-.107.293-.187.807-.473 2.054-1.64 2.814-2.64.526-.706.726-1.053 1.426-2.54.16-.34.38-1.153.474-1.74.2-1.253-.04-2.126-.734-2.7-.64-.52-1.926-1.006-3.086-1.153-.794-.1-2.414-.173-2.92-.133zm3.6 3.22c.166.046.393.12.513.173.113.053.24.1.287.1.093 0 .08.073-.127.767-.14.46-.707 1.4-1.073 1.773-.094.093-.26.273-.374.4-.566.627-1.46 1.213-3.026 1.98-.68.327-1.307.62-1.4.647a4.054 4.054 0 00-.487.213c-.18.087-.587.253-.9.36-.32.113-.667.24-.78.293a8.4 8.4 0 01-.667.234c-.253.08-.766.246-1.133.366a21.62 21.62 0 01-1.167.367c-.273.08-.586.18-.7.233-.106.047-.546.18-.966.3-.42.12-.794.24-.834.267-.033.033-.473.153-.966.267a35.49 35.49 0 00-1.334.34c-.506.146-1.68.406-1.7.38a3.44 3.44 0 01.027-.4c.033-.294.107-.46.327-.774.153-.22.28-.42.28-.44 0-.073 1.253-1.866 1.673-2.4.407-.506 1.253-1.306 1.64-1.546.1-.067.22-.147.253-.187.32-.347 2.874-1.747 3.967-2.187.273-.106.533-.22.567-.253.04-.027.4-.167.8-.3.406-.14.766-.28.806-.313.04-.027.487-.16.987-.28.5-.127.94-.254.973-.274.04-.026.36-.086.72-.133.76-.113 3.34-.086 3.814.027zm-29.22 1.14c.466.04.913.1.986.133.074.027.327.093.567.133.627.114 1.533.334 1.767.434.113.046.44.173.733.273.633.22 1.74.787 2.28 1.16 1.173.813 2.68 2.42 3.413 3.633l.227.374.007 1.313c.006.72.033 1.36.066 1.42.027.073.014.12-.046.147-.094.033-1.914-.374-2.147-.487-.073-.033-.6-.167-1.167-.3-.566-.133-1.093-.267-1.166-.3-.154-.073-1.36-.34-2.067-.46-.253-.047-.527-.107-.6-.14-.073-.033-.327-.087-.567-.133-.686-.12-1.94-.407-2.06-.467-.06-.033-.42-.153-.806-.273-1.56-.487-2.72-1.267-3.454-2.34-.12-.174-.213-.327-.213-.347 0-.02-.093-.227-.207-.453-.233-.48-.413-1.287-.346-1.594.046-.233.58-.813.986-1.073.434-.273 1.38-.586 1.947-.647.753-.08.92-.08 1.867-.006zm38.52 10.646c-.027.14-.074.287-.1.32-.034.04-.12.447-.2.9-.154.907-.334 1.68-.394 1.734-.113.086-.426 1.56-.46 2.12-.02.366-.06.633-.106.646-.04.014-1.574.107-3.407.2-1.833.094-3.827.2-4.433.24a125.48 125.48 0 01-5.9.254c-6.654.18-7.72.206-8.674.246l-1.006.04-.247-1.78c-.133-.98-.273-1.84-.307-1.9-.033-.066-.073-.34-.08-.606l-.02-.487.4-.087c.22-.046 1.214-.126 2.2-.18.994-.06 2.134-.133 2.534-.166.406-.04 1.046-.087 1.433-.107 1.727-.087 6.48-.38 7.06-.433.353-.027 1.673-.147 2.94-.26 1.267-.114 2.72-.254 3.233-.307 1.847-.187 4.034-.433 4.707-.527.38-.046.733-.093.787-.1.066-.006.08.054.04.24zm-28.62 4.4c-.014 1.347-.047 2.4-.08 2.42-.034.02-2.154.094-4.714.16-4.6.12-10.593.367-10.72.454-.033.02-1.266.08-2.74.126-2.113.067-2.853.067-3.56 0-.493-.046-.926-.106-.966-.133-.034-.033-.174-.073-.294-.1-.586-.107-.746-.18-.813-.36-.08-.2-.207-1.56-.22-2.373l-.007-.527.334-.08c.186-.04.373-.093.413-.12.1-.06 1.893-.287 3.62-.447.787-.073 1.733-.16 2.1-.2.367-.033 1.553-.106 2.633-.166 4.207-.214 5.714-.307 6.134-.367.24-.033 1.993-.173 3.9-.3 1.906-.127 3.6-.26 3.766-.293a7.15 7.15 0 01.767-.067l.467-.007-.02 2.38zm23.92 7.214c0 .293.046 1.273.1 2.186.14 2.287.233 5.26.233 7.3 0 .947.027 1.847.067 2 .033.16.093 1.14.133 2.187.06 1.647.32 5.773.433 6.867.167 1.606.254 7.206.114 7.346-.147.147-1.354.354-3.48.587-.974.107-2.26.253-2.867.327-1.34.166-3.933.406-4.36.406-.167 0-.36.027-.427.06-.06.034-.726.094-1.48.134-.753.04-2.22.12-3.266.173-1.047.053-2.134.113-2.414.127l-.513.033.073-.18c.04-.1.094-.24.12-.313.38-.96.414-2.76.1-5.167-.053-.387-.22-1.72-.366-2.967-.154-1.246-.307-2.326-.334-2.4-.126-.306-.313-2.986-.466-6.833-.034-.933-.094-1.853-.134-2.033-.06-.327-.133-1.44-.4-6.267-.073-1.32-.166-2.493-.2-2.607a1.882 1.882 0 01-.066-.513v-.313l.353-.007c.187-.007.78-.033 1.313-.067 2.454-.14 5.627-.253 8.694-.32 5.073-.113 8.8-.213 8.833-.246.013-.014.067-.027.12-.027.067 0 .087.133.087.527zM37.76 38.68c-.046 3.293.067 12.4.18 14.133.074 1.1.147 1.847.46 4.42.074.62.207 1.794.3 2.6.22 2 .347 2.927.467 3.54.107.527.613 1.754.813 1.974.087.1.087.12.014.146-.054.02-.92.1-1.927.174-1.007.08-2.22.186-2.7.233-.473.053-1.707.187-2.733.293-1.027.114-2.214.247-2.634.307-.42.06-1.846.233-3.166.393-1.32.154-2.447.3-2.5.327-.054.02-.56.08-1.12.127l-1.014.093-.066-.24c-.12-.467-.367-3.353-.5-5.867-.02-.42-.067-.873-.1-1-.034-.126-.167-1.553-.3-3.166-.127-1.614-.267-3.067-.3-3.234-.087-.44-.127-1.546-.2-5.733-.087-4.78-.254-8.413-.4-8.767-.04-.106-.274-2.453-.267-2.74 0-.046.333-.086.953-.113 2.627-.12 7.4-.393 7.78-.453.24-.034 2.294-.12 4.567-.187s4.2-.127 4.287-.133l.146-.007-.04 2.88z"
        fill="#8338EC"
      />
    </svg>
  );
}

function Present(props) {
  return (
    <svg
      width={48}
      height={48}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={48} height={48} rx={24} fill="#F3ECFD" />
      <path
        d="M28.64 13.34c-.224.02-.656.084-.743.111a7.96 7.96 0 01-.432.112 2.996 2.996 0 00-.365.103c-.014.01-.128.053-.254.094a4.25 4.25 0 00-.297.105l-.286.121c-.425.174-.54.226-.789.354-.51.261-.74.421-1.053.732-.165.165-.38.441-.466.599-.103.185-.192.329-.208.329-.01 0-.028-.027-.04-.064-.034-.096-.28-.43-.477-.645-.366-.397-.768-.738-1.104-.925a5.272 5.272 0 00-1.829-.631c-.279-.037-.896-.04-1.131-.002-.258.04-.636.12-.663.141a.689.689 0 01-.14.053c-.345.1-.644.338-.861.679-.096.15-.158.308-.25.64-.036.132-.01.56.047.765.08.286.125.389.313.72.253.45.37.59.743.892.345.279.779.519 1.2.663.169.059.178.064.125.086-.032.014-.436.046-.903.074-1.163.064-1.82.112-1.874.137a2.45 2.45 0 01-.308.043c-.375.037-1.054.137-1.11.162a7.069 7.069 0 01-.513.113c-.645.123-.837.18-.963.28a.74.74 0 01-.203.117c-.199.067-.194.048-.19.926.002.896.018 1.012.176 1.314.318.606.366.679.521.784.055.037.151.108.213.158.064.052.15.107.194.123l.183.078c.13.057.457.123.704.144l.192.016-.014.265c-.007.146-.002.5.012.791.011.288.032 1.513.04 2.72.012 1.207.03 2.338.044 2.514.014.176.048.604.073.949.028.345.058.665.069.709.012.043.037.413.057.822.019.41.039.814.046.903.03.384.087.894.103.914.009.012.025.126.032.252.023.306.062.487.14.62l.187.34c.12.224.153.26.432.498.112.096.134.108.198.096a.656.656 0 00.147-.06c.091-.056.352-.061 1.538-.033.97.022 2.137-.019 3.874-.135.252-.019.942-.062 1.532-.101.592-.039 1.234-.087 1.428-.103.8-.073 2.165-.22 2.24-.24.044-.014.183-.034.309-.048.473-.052 1.122-.14 1.2-.162.043-.011.389-.062.766-.112 1.11-.144 1.543-.22 2.057-.361.267-.073.37-.112.418-.158.016-.016.041-.03.053-.03.027 0 .203-.16.203-.187 0-.011.02-.041.044-.066a.304.304 0 00.059-.105c.02-.09.11-.268.144-.293.016-.014.037-.071.043-.126a.336.336 0 01.041-.137c.017-.018.053-.121.083-.229.057-.217.087-.706.046-.788-.021-.041-.042-.199-.163-1.28-.041-.361-.212-1.746-.285-2.302a38.952 38.952 0 01-.14-1.584 1.502 1.502 0 00-.032-.274 2.316 2.316 0 01-.032-.343c-.046-.916-.135-2.09-.174-2.229-.027-.102-.196-1.526-.182-1.54.006-.005.175-.037.377-.071.2-.034.377-.069.388-.08a.472.472 0 01.126-.034 1.8 1.8 0 00.233-.05c.162-.044.274-.156.352-.355a.828.828 0 01.09-.178.21.21 0 00.034-.119.16.16 0 01.043-.119c.05-.046.087-.176.116-.411.03-.242.007-.405-.08-.551-.04-.066-.066-.13-.057-.142.01-.009.048-.174.083-.361.054-.3.064-.4.064-.788.002-.398-.003-.465-.05-.625a1.797 1.797 0 00-.115-.297.799.799 0 01-.073-.228c-.011-.108-.014-.112-.126-.158a5.743 5.743 0 01-.276-.126c-.204-.1-.27-.096-.28.019l-.006.08-.793.064c-.437.034-.83.07-.873.082-.14.037-1.744.128-2.755.16-.427.014-.82.034-.875.046-.123.03-.256.03-.256.002 0-.012.055-.041.121-.066.247-.094 1.312-.677 1.387-.76a.73.73 0 01.101-.063c.277-.163.704-.563.965-.905.18-.243.249-.361.489-.871a2.86 2.86 0 00.162-.597c.069-.43-.014-.729-.251-.925-.22-.179-.661-.346-1.059-.396a7.666 7.666 0 00-1-.046zm1.235 1.103a1.6 1.6 0 01.175.06.357.357 0 00.099.034c.032 0 .027.025-.044.263a2.072 2.072 0 01-.496.745c-.194.215-.5.416-1.037.679a9.199 9.199 0 01-.48.222c-.032.009-.108.043-.167.073-.062.03-.201.087-.309.123-.11.039-.228.082-.267.1-.037.017-.14.053-.229.08-.087.028-.263.085-.388.127-.126.043-.307.1-.4.125a2.39 2.39 0 00-.24.08 4.827 4.827 0 01-.332.103 2.877 2.877 0 00-.286.091 2.253 2.253 0 01-.331.092c-.17.041-.375.091-.457.116-.174.05-.576.14-.583.13a1.178 1.178 0 01.01-.136.497.497 0 01.111-.265c.053-.076.096-.145.096-.151 0-.026.43-.64.574-.823.14-.174.43-.448.562-.53.035-.023.076-.05.087-.065.11-.118.985-.598 1.36-.75.094-.036.183-.075.194-.086.014-.01.137-.057.275-.103.139-.048.262-.096.276-.107.014-.01.167-.055.338-.096.172-.044.323-.087.334-.094.014-.01.124-.03.247-.046.26-.039 1.145-.03 1.308.01zm-10.019.391c.16.014.313.034.338.046.026.009.113.032.195.046.215.038.526.114.605.148.04.016.151.06.252.094.217.075.597.27.782.398.402.278.919.83 1.17 1.245l.078.128.002.45c.002.248.011.467.023.488.009.025.004.04-.016.05-.032.011-.656-.128-.736-.167a5.742 5.742 0 00-.4-.103 5.801 5.801 0 01-.4-.103 6.574 6.574 0 00-.709-.157 1.483 1.483 0 01-.206-.048 1.456 1.456 0 00-.194-.046 7.312 7.312 0 01-.706-.16 3.364 3.364 0 00-.277-.094c-.535-.167-.932-.434-1.184-.802a.763.763 0 01-.073-.12c0-.006-.032-.077-.07-.154-.08-.165-.142-.442-.12-.547.017-.08.2-.279.339-.368a1.98 1.98 0 01.667-.222c.258-.027.316-.027.64-.002zm13.207 3.65a.382.382 0 01-.034.11 1.959 1.959 0 00-.069.309c-.052.31-.114.576-.135.594-.039.03-.146.535-.157.727-.007.126-.021.217-.037.222-.014.004-.54.036-1.168.068-.629.032-1.312.069-1.52.082-.866.053-1.109.064-2.023.087-2.281.062-2.647.071-2.974.085l-.345.014-.084-.61a7.716 7.716 0 00-.105-.652.774.774 0 01-.028-.208l-.007-.167.138-.03c.075-.016.415-.043.754-.061a58.724 58.724 0 001.36-.094c.592-.03 2.221-.13 2.42-.149.122-.009.574-.05 1.008-.089.435-.039.933-.087 1.109-.105a65.73 65.73 0 001.614-.18l.27-.035c.022-.002.027.018.013.082zm-9.813 1.509c-.004.462-.015.823-.027.83-.011.007-.738.032-1.616.055-1.577.04-3.632.125-3.675.155-.012.007-.435.027-.94.043-.724.023-.978.023-1.22 0a2.26 2.26 0 01-.332-.045.312.312 0 00-.1-.034c-.201-.037-.256-.062-.28-.124-.027-.069-.07-.535-.075-.814l-.002-.18.114-.028a.71.71 0 00.142-.04c.034-.021.65-.1 1.241-.154.27-.025.595-.055.72-.069.126-.011.533-.036.903-.057 1.442-.073 1.959-.105 2.103-.125.082-.012.683-.06 1.337-.103.654-.044 1.234-.09 1.291-.1.058-.01.177-.021.263-.024l.16-.002-.007.816zm8.202 2.473c0 .1.016.437.034.75.048.784.08 1.803.08 2.503 0 .324.009.633.023.685.011.055.032.391.046.75.02.565.11 1.98.148 2.355.057.55.087 2.47.039 2.518-.05.05-.464.121-1.193.201-.334.037-.775.087-.983.112-.46.058-1.349.14-1.495.14a.441.441 0 00-.146.02c-.02.012-.25.032-.508.046l-1.12.06-.827.043-.176.011.025-.061a4.49 4.49 0 00.041-.108c.13-.329.142-.946.034-1.771a75.2 75.2 0 01-.125-1.017 16.185 16.185 0 00-.114-.823c-.044-.105-.108-1.024-.16-2.343a7.817 7.817 0 00-.046-.697c-.02-.112-.046-.494-.137-2.149a13.027 13.027 0 00-.069-.893.646.646 0 01-.023-.176v-.108l.121-.002a90.103 90.103 0 013.43-.133c1.74-.039 3.018-.073 3.03-.084.004-.005.023-.01.04-.01.024 0 .03.046.03.181zm-8.22 1.081c-.016 1.13.023 4.252.062 4.846.025.377.05.633.158 1.515l.102.892c.076.686.12 1.003.16 1.214.037.18.21.6.28.676.029.035.029.041.004.05a11.56 11.56 0 01-.66.06c-.346.027-.762.064-.926.08-.163.018-.585.064-.938.1-.352.04-.758.085-.902.106-.144.02-.633.08-1.086.135-.453.052-.839.102-.857.112a4.254 4.254 0 01-.384.043l-.348.032-.022-.082c-.042-.16-.126-1.15-.172-2.012a2.571 2.571 0 00-.034-.343 25.008 25.008 0 01-.103-1.085 26.084 26.084 0 00-.103-1.109c-.03-.15-.043-.53-.069-1.966-.03-1.639-.086-2.884-.137-3.005a13.533 13.533 0 01-.091-.94c0-.016.114-.03.327-.039.9-.04 2.537-.135 2.667-.155.082-.012.787-.041 1.566-.064.78-.023 1.44-.044 1.47-.046l.05-.002-.014.987z"
        fill="#8338EC"
      />
    </svg>
  );
}

function Crown(props) {
  return (
    <svg
      width={48}
      height={48}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={48} height={48} rx={24} fill="#FEECE2" />
      <path
        d="M24.32 13.42a.913.913 0 01-.206.036 1.01 1.01 0 00-.221.041 1.675 1.675 0 01-.26.069c-.332.068-.5.169-.755.459-.199.226-.354.462-.924 1.415a128.906 128.906 0 00-1.686 2.868c-.364.636-.764 1.324-.885 1.532a27.275 27.275 0 00-.862 1.543l-.171.34-.128-.134c-.071-.076-.293-.314-.494-.526a25.99 25.99 0 01-1.35-1.543c-.94-1.14-1.205-1.397-1.68-1.628-.202-.1-.261-.118-.366-.116-.158 0-.435.039-.494.069a.938.938 0 01-.192.052c-.334.062-.466.206-.636.688-.287.818-.34 2.037-.187 4.41.075 1.135.313 2.996.528 4.09.105.545.33 1.326.469 1.642.038.087.045.123.025.13-.016.005-.085.02-.153.037a.787.787 0 00-.396.2c-.19.179-.196.282-.045.579.137.265.317.462.67.725.292.219.429.288.669.333.47.09.617.092 5.125.094 4.37 0 5.316.014 7.897.1 1.312.046 3.652.177 5.348.298 1.079.075 1.422.039 1.76-.188.183-.12.3-.279.498-.68.316-.63.467-1.187.714-2.664.265-1.57.338-2.246.445-4.16.062-1.092.055-2.052-.034-3.926-.055-1.198-.082-1.594-.128-1.936-.085-.657-.256-.972-.544-1.015-.057-.01-.119-.037-.142-.064a.666.666 0 00-.354-.156.85.85 0 00-.194.034.956.956 0 01-.227.035c-.061 0-.19.025-.285.055-.094.03-.254.073-.352.093-.416.092-.967.48-1.888 1.34-.482.45-.647.592-1.04.898-.563.439-.885.702-1.152.937-.68.601-1.029.887-1.054.871-.027-.016-.14-.224-.411-.754a49.554 49.554 0 00-1.269-2.332c-.117-.2-.398-.69-.624-1.085l-.617-1.077a28.48 28.48 0 01-.496-.926c-.407-.793-.482-.896-.686-.932a.405.405 0 01-.167-.087c-.125-.11-.26-.137-.393-.085zm.245 2.454c.114.188.354.59.537.892.663 1.092.987 1.728 2.084 4.066.06.126.181.361.275.526.091.164.206.37.254.459.203.373.523.768.717.885.046.027.126.086.176.134.151.138.224.165.389.151a.745.745 0 00.308-.096c.229-.114.755-.466 1.05-.697.267-.212.283-.224.781-.681.448-.41.665-.583 1.246-1.001.256-.183.606-.441.777-.574.892-.69 1.303-.983 1.335-.95.009.009.023.553.032 1.206.016 1.292.002 1.826-.092 3.315-.116 1.862-.173 2.42-.434 4.24-.128.9-.201 1.275-.274 1.385l-.039.061-1.079-.013a47.484 47.484 0 01-1.453-.037c-.54-.034-2.087-.09-3.59-.128-.71-.018-1.43-.039-1.6-.046-.168-.006-.78-.032-1.36-.057-1.412-.06-2.173-.084-3.76-.126-.735-.018-1.65-.043-2.033-.057-2.617-.082-3.93-.087-4.336-.011a.983.983 0 01-.243.027c-.06-.023-.173-.763-.221-1.433-.06-.864-.087-3.307-.046-4.413l.046-1.381c.013-.416.038-.924.059-1.131.034-.369.13-1.008.16-1.054.02-.035.14-.003.295.08.251.132.66.56 1.728 1.808.514.6.894 1.058 1.243 1.497.375.466.816.885 1.031.974.19.08.466-.035.702-.288a4.46 4.46 0 00.336-.455c.107-.167.546-.819.978-1.45.8-1.17 1.139-1.684 1.895-2.889.57-.907.75-1.209 1.056-1.766.626-1.134.789-1.397.839-1.342.014.016.119.18.23.37z"
        fill="#FF6810"
      />
    </svg>
  );
}

function DesignIcon() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="24" fill="#FDECF6" />
      <g clip-path="url(#clip0_2816_22581)">
        <path
          d="M33.8205 12L17.6602 27.4916C12.6094 28.2188 14.1562 33.0469 12 36C16.4704 36.0229 20.6074 34.7801 21.6686 30.3127L36 13.7854L33.8205 12ZM13.5705 34.5938C14.7893 32.8826 13.9691 29.1623 17.4037 28.4141C17.9396 28.917 18.4706 29.4832 19.2938 30.5141C18.6008 32.8744 16.1486 34.3594 13.5705 34.5938ZM21.1346 29.8556C20.5072 29.3269 19.9553 28.8971 19.4565 28.5469L33.3919 13.2761L34.1996 13.6223L21.1346 29.8556Z"
          fill="#E8178A"
        />
      </g>
      <defs>
        <clipPath id="clip0_2816_22581">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function ReportsIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="25px" height="25px"  viewBox="0 0 36 36"><rect x="6.48" y="18" width="5.76" height="11.52" rx="1" ry="1"/><rect x="15.12" y="6.48" width="5.76" height="23.04" rx="1" ry="1"/><rect x="23.76" y="14.16" width="5.76" height="15.36" rx="1" ry="1"/></svg>
  );
}

function Connection(props) {
  return (
    <svg
      width={48}
      height={48}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={48} height={48} rx={24} fill="#FCE8EA" />
      <path
        d="M32.336 28.831a4.3 4.3 0 00-.349.015l-7.563-6.51-.23-3.277c1.371-.313 2.534-1.282 2.534-2.698 0-1.743-1.065-3.504-2.808-3.504-1.742 0-3.504 1.761-3.504 3.504 0 1.742 1.065 2.807 2.808 2.808l-.07 2.698-6.219 7.021a2.934 2.934 0 00-.574-.056c-1.743 0-3.504 1.76-3.504 3.503s1.065 2.808 2.808 2.808c1.743 0 3.504-1.414 3.504-3.156 0-1.198-.338-2.012-1.22-2.547l5.127-4.558-.104 3.986c-1.421.222-2.019 1.53-2.019 3.118 0 1.743.717 3.156 2.46 3.156 1.742 0 3.852-1.413 3.852-3.156 0-1.675-1.155-2.23-1.966-2.664l-.772-5.54 5.165 5.996c-.374.326-.86.981-.86 1.86 0 1.743 1.065 3.504 2.808 3.504 1.743 0 3.503-1.761 3.503-3.503 0-1.742-1.065-2.808-2.807-2.808zm-16.078 5.216c-.754-.181-1.39-1.15-1.39-2.102 0-.951.502-1.713 1.27-1.713s1.815.957 1.891 2.139c.062.948-.596 1.96-1.77 1.676zm5.16-18.034c0-.998.808-1.807 1.806-1.807s1.756.692 1.545 1.807c-.203 1.08-.896 1.806-1.893 1.806-.998 0-1.459-.809-1.459-1.806zm4.326 15.822c0 .904-.41 1.637-1.313 1.637-.904 0-1.798-.627-1.96-1.96-.108-.896.41-1.636 1.314-1.636.903 0 1.96 1.056 1.96 1.96zm6.592 1.958c-.998 0-1.755-.691-1.546-1.806.204-1.081.896-1.807 1.894-1.807.998 0 1.458.808 1.458 1.807 0 .998-.809 1.806-1.806 1.806z"
        fill="#E63946"
      />
    </svg>
  );
}

function SettingIcon(props) {
  return (
    <svg
    width={props.width ? props.width : "20"}
    height={props.height ? props.height : "20"}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4137 10.104L13.7257 8.77998C13.7577 8.52397 13.7817 8.26398 13.7817 7.99998C13.7817 7.73598 13.7577 7.47599 13.7257 7.21998L15.4177 5.89597C15.5697 5.77597 15.6137 5.55997 15.5137 5.38398L13.9137 2.61199C13.8137 2.43997 13.6057 2.36797 13.4257 2.43997L11.4337 3.24397C11.0217 2.92796 10.5697 2.65999 10.0817 2.45599L9.78172 0.336C9.74568 0.148012 9.58169 0 9.38171 0H6.18172C5.98173 0 5.81771 0.148012 5.78572 0.336L5.48572 2.45599C4.99773 2.65999 4.54571 2.92399 4.13373 3.24397L2.14174 2.43997C1.96174 2.37199 1.75372 2.43997 1.65375 2.61199L0.0537003 5.38398C-0.0463121 5.556 -0.00228714 5.772 0.1497 5.89597L1.83769 7.21998C1.8057 7.47599 1.7817 7.73598 1.7817 7.99998C1.7817 8.26398 1.8057 8.52397 1.83769 8.77998L0.1497 10.104C-0.00228714 10.224 -0.0463121 10.44 0.0537003 10.616L1.65371 13.388C1.75372 13.56 1.9617 13.632 2.1417 13.56L4.1337 12.756C4.54571 13.072 4.9977 13.34 5.48568 13.544L5.78568 15.664C5.81767 15.852 5.9817 16 6.18168 16H9.38167C9.58166 16 9.74568 15.852 9.77767 15.664L10.0777 13.544C10.5657 13.34 11.0177 13.076 11.4297 12.756L13.4217 13.56C13.6017 13.628 13.8097 13.56 13.9096 13.388L15.5097 10.616C15.6097 10.444 15.5657 10.228 15.4137 10.104ZM7.78169 10.8C6.2337 10.8 4.98168 9.54798 4.98168 7.99998C4.98168 6.45198 6.2337 5.20001 7.78169 5.20001C9.32969 5.20001 10.5817 6.45202 10.5817 8.00002C10.5817 9.54802 9.32969 10.8 7.78169 10.8Z"
      fill={props.color ? props.color : "#000000"}
    />
  </svg>
  );
}

function TeamMembersIcon() {
  return (
    <svg width={18} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.404 6.628a3.751 3.751 0 10-4.809 0c-.077.079-.15.161-.22.247H1.5a.938.938 0 100 1.875h4.125l-.723 6.454-.452 3.746a.938.938 0 101.862.225l.353-2.925h4.67l.352 2.925a.938.938 0 001.863-.225l-.453-3.746-.722-6.454H16.5a.938.938 0 000-1.875h-4.874a3.378 3.378 0 00-.222-.247zm-.529-2.878a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zM10.5 8.842l.619 5.533H6.88l.62-5.533a1.509 1.509 0 012.998 0h.001z"
        fill="#686C7C"
      />
    </svg>
  );
}

function ActivityLogsIcon(props) {
  return (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.552 10a7.448 7.448 0 1114.896 0 7.448 7.448 0 01-14.896 0zM10 .835a9.167 9.167 0 100 18.333A9.167 9.167 0 0010 .834zm.573 5.443a.86.86 0 10-1.719 0v4.01a.86.86 0 00.54.798l2.864 1.145a.859.859 0 00.639-1.595l-2.324-.93V6.277z"
        fill="#686C7C"
      />
    </svg>
  );
}

function CustomFieldsIcon(props) {
  return (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#prefix__clip0_2576_1239)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.866 1.5a2.278 2.278 0 013.22 0l1.413 1.414a2.278 2.278 0 010 3.22L7.293 17.34a2.266 2.266 0 01-.984.58l-4.231 1.21A.976.976 0 01.87 17.922l1.21-4.23c.105-.373.305-.712.578-.987L13.866 1.5v.002zm1.84 1.38a.325.325 0 00-.46 0l-1.643 1.644 1.873 1.874 1.643-1.644a.327.327 0 000-.46L15.706 2.88zm-1.611 4.898l-1.873-1.874-8.182 8.182a.325.325 0 00-.083.14l-.726 2.543 2.542-.726a.324.324 0 00.14-.084l8.182-8.181z"
          fill="#686C7C"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_2576_1239">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function APIIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.9 4.025A.937.937 0 017.225 5.35L2.575 10l4.65 4.65A.939.939 0 115.9 15.975L.587 10.662a.937.937 0 010-1.325L5.9 4.025zm8.2 0a.937.937 0 10-1.325 1.325l4.65 4.65-4.65 4.65a.938.938 0 101.325 1.325l5.312-5.313a.937.937 0 000-1.325L14.1 4.025z"
        fill="#686C7C"
      />
    </svg>
  );
}

function IntegrationIcon(props) {
  return (
    <svg width={18} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.045 1.11a2.113 2.113 0 00-2.09 0l-6.25 3.558c-.316.18-.578.438-.76.749-.182.31-.278.662-.278 1.02v7.127c0 .729.395 1.402 1.038 1.769l6.25 3.558a2.113 2.113 0 002.09 0l6.25-3.558a2.038 2.038 0 001.038-1.77V6.439a2.04 2.04 0 00-1.038-1.77l-6.25-3.558zM8.851 2.627a.302.302 0 01.298 0l5.512 3.138L9 8.986 3.338 5.764l5.512-3.137zM2.452 7.286v6.278c0 .105.056.2.15.252l5.505 3.135v-6.446L2.452 7.287zm7.44 9.665l5.507-3.135a.295.295 0 00.149-.252V7.286l-5.655 3.22v6.445z"
        fill="#686C7C"
      />
    </svg>
  );
}

function BillingIcon(props) {
  return (
    <svg width={20} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.438 9.25a.937.937 0 000 1.875h1.874a.938.938 0 000-1.875h-1.874z"
        fill="#686C7C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.688C0 1.48.98.5 2.188.5h15.624C19.02.5 20 1.48 20 2.688v10.624a2.188 2.188 0 01-2.188 2.188H2.188A2.188 2.188 0 010 13.312V2.688zm18.125 0V4.25H1.875V2.687a.312.312 0 01.313-.312h15.624a.313.313 0 01.313.313zm0 3.437H1.875v7.188c0 .172.14.312.313.312h15.624a.313.313 0 00.313-.313V6.125z"
        fill="#686C7C"
      />
    </svg>
  );
}

function TagsIcon(props) {
  return (
    <svg width={19} height={19} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.125 8.719V2.438a.312.312 0 01.313-.313h6.28a.313.313 0 01.222.091l7.813 7.813a.313.313 0 010 .442l-6.282 6.282a.313.313 0 01-.442 0L2.216 8.94a.312.312 0 01-.091-.221zm-1.875 0V2.438C.25 1.23 1.23.25 2.438.25h6.28c.58 0 1.138.23 1.548.641l7.813 7.813a2.187 2.187 0 010 3.092l-6.283 6.283a2.187 2.187 0 01-3.092 0L.89 10.266A2.187 2.187 0 01.25 8.72zM6.5 5.25a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"
        fill="#686C7C"
      />
    </svg>
  );
}

function BusinessProfileIcon(props) {
  return (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#prefix__clip0_2576_11949)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.552 17.162c0 .158.128.287.286.287h2.579v-1.433a.86.86 0 01.859-.86h2.865a.86.86 0 01.859.86v1.433h2.578a.287.287 0 00.287-.287V2.84a.287.287 0 00-.287-.286h-9.74a.286.286 0 00-.286.286v14.323zm.286 2.005a2.005 2.005 0 01-2.005-2.005V2.84c0-1.107.899-2.005 2.005-2.005h9.74c1.107 0 2.005.898 2.005 2.005v14.323c0 .098-.007.193-.02.287h2.598a.287.287 0 00.287-.287v-6.835a.286.286 0 00-.127-.238l-1.21-.806a.859.859 0 11.954-1.43l1.209.806c.558.372.893.998.893 1.668v6.835a2.005 2.005 0 01-2.006 2.005h-4.01a.86.86 0 01-.226-.03c-.113.02-.229.03-.347.03H9.141a.86.86 0 01-.86-.86v-1.431H7.135v1.432a.86.86 0 01-.859.86H2.838zM4.271 5.131a.86.86 0 01.86-.86h.572a.86.86 0 110 1.72H5.13a.86.86 0 01-.86-.86zm.86 2.578a.86.86 0 100 1.719h.572a.86.86 0 100-1.719H5.13zm-.86 4.297a.86.86 0 01.86-.86h.572a.86.86 0 110 1.72H5.13a.86.86 0 01-.86-.86zm5.442-.86a.86.86 0 100 1.72h.573a.859.859 0 100-1.72h-.573zm-.859-2.578a.86.86 0 01.86-.859h.572a.86.86 0 110 1.719h-.573a.86.86 0 01-.859-.86zm.86-4.297a.86.86 0 100 1.72h.572a.86.86 0 100-1.72h-.573z"
          fill="#686C7C"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_2576_11949">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function SMS(props) {
  return (
    <svg
      width={56}
      height={56}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={56} height={56} rx={28} fill="#F3ECFD" />
      <path
        d="M28.013 14.606c-.088.005-.362.027-.613.048-2.403.216-4.427.858-6.776 2.146-1.712.942-2.795 1.95-4.016 3.747-.763 1.123-1.379 2.232-1.725 3.12-.294.747-.443 1.344-.694 2.76-.266 1.499-.306 1.89-.288 2.755.014.707.064 1.088.232 1.755.222.874.499 1.543 1.059 2.535.45.803.765 1.176 1.445 1.712.824.649 1.614 1.115 2.683 1.59.621.274.885.416.901.485.027.11.099.664.142 1.115.029.293.045.784.053 1.48.01 1.35.024 1.44.336 2 .088.16.192.344.227.405.037.07.122.155.216.219.085.056.17.125.192.152.21.253 1.05.165 1.744-.181.389-.195.661-.403 1.685-1.288 1.325-1.147 2.467-1.857 3.36-2.083.301-.075 1.133-.192 2.064-.29 1.421-.15 1.87-.22 2.707-.427 1.784-.443 3.594-1.198 4.664-1.947.821-.574 1.808-1.541 2.373-2.328.28-.39.523-.808.843-1.459.794-1.616 1.336-3.525 1.442-5.088.038-.563.016-1.67-.042-2.203-.192-1.733-.758-3.455-1.606-4.887-.922-1.563-2.17-3.003-3.264-3.76-.677-.473-2.101-1.174-2.824-1.393-.512-.154-1.114-.255-1.517-.255-.237 0-.296.031-.243.136.03.053.027.056-.016.04-.272-.107-1.266-.353-1.786-.44a14.437 14.437 0 00-2.958-.171zm2.68 1.075c.966.069 1.936.234 2.83.482l.392.11.41.442c.227.245.678.744.998 1.112.32.365.749.843.952 1.059a15.131 15.131 0 012.032 2.701c.632 1.046 1.261 2.733 1.56 4.19.21 1.015.237 2.17.08 3.218-.187 1.221-.664 2.525-1.275 3.472-.653 1.014-1.728 2.07-2.712 2.662-.61.367-1.688.837-2.755 1.202-1.042.357-1.285.405-3.085.616-2.765.325-3.603.63-5.616 2.05-.31.217-.864.636-1.232.929-.37.296-.76.594-.87.67l-.197.133.016-.131c.136-1.085.043-3.195-.181-4.078-.139-.549-.419-.992-.763-1.202-.288-.173-1.01-.517-1.77-.843-.814-.346-1.062-.47-1.467-.733-.715-.467-1.208-.997-1.661-1.787-.595-1.042-.872-2.317-.784-3.602.056-.793.216-1.942.381-2.74.179-.869.485-1.567 1.339-3.055.752-1.312 1.306-2.075 2.066-2.843.56-.568 1.062-.979 1.806-1.48 1.186-.802 2.218-1.338 3.44-1.781 1.741-.63 4.002-.918 6.066-.774z"
        fill="#6800FD"
      />
    </svg>
  );
}

function NOTIFICATION(props) {
  return (
    <svg
      width={56}
      height={56}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={56} height={56} rx={28} fill="#FFF9F0" />
      <path
        d="M18.36 30.125c-.067 1.067-.17 2.008-.77 2.699-.278.32-.55.641-.819.962-.562.667-1.142 1.358-1.772 2.008-.605.625-1.115 1.2-1.556 1.755-.053.068-.112.117-.165.163-.155.134-.389.338-.219.744.162.389.553.586 1.16.586.265 0 .539-.035.759-.063.11-.015.211-.028.295-.034.6-.045 1.21-.051 1.728-.051l1.237.004c.365 0 .819 0 1.156-.072h1.219c.607.021 1.208.055 1.805.087 1.47.081 3.04.151 4.366.056.636-.07 1.358-.07 1.994-.07.369 0 1.077-.07 1.083-.072.373 0 .746.05 1.142.102.42.056.854.114 1.313.114.634 0 1.267-.015 1.9-.03.874-.021 1.748-.043 2.623-.023.476.011.989.073 1.532.14.623.076 1.267.154 1.885.154.441 0 .822-.04 1.162-.123.352-.085.834-.242.952-.613.125-.39-.205-.77-.553-1.172-.066-.075-.132-.152-.198-.23a27.731 27.731 0 00-1.528-1.689l-.069-.07c-.286-.29-.49-.643-.704-1.017-.07-.122-.14-.243-.214-.363-.136-.224-.322-.43-.501-.628-.177-.195-.343-.38-.443-.557-.254-.455-.242-1.304-.231-2.052.006-.452.012-.879-.031-1.232-.072-.715-.146-1.455-.288-2.142 0-.202-.053-.448-.072-.533 0-.135-.005-.314-.072-.435-.002-.186-.011-.371-.073-.527a6.182 6.182 0 00-.072-.624c-.047-.415-.031-.764-.015-1.134.008-.188.016-.376.015-.592-.073-.884-.223-1.556-.435-2.326a21.028 21.028 0 01-.1-.78c-.068-.585-.132-1.136-.35-1.732-.212-.496-.984-2.185-2.015-3.123-.364-.303-.771-.464-1.165-.62-.112-.044-.225-.09-.35-.142-.204-.075-.403-.158-.6-.241-.579-.244-1.176-.496-1.865-.496l-.06.008c-.177.044-.371.093-.564.118a2.646 2.646 0 00-.1-.498l-.216-.433-.045-.062c-.017-.017-.032-.04-.05-.062-.03-.04-.063-.084-.104-.124-.047-.401-.289-.75-.595-.862l.005-.02c-.28-.094-.521-.156-.793-.156a1.602 1.602 0 00-.547.097c-.166.083-.322.162-.422.261a1.07 1.07 0 00-.094.114l-.033.045-.027.013c-.173.086-.416.377-.513.498-.415.519-.548 1.015-.401 1.526l.003.01c-.096.042-.19.083-.284.119-.206.068-.428.12-.663.174-.236.054-.481.11-.723.192-1.738.708-2.584 2.059-3.48 3.489-.15.237-.3.477-.458.719-.635.988-1.184 1.842-1.334 3.123a34.69 34.69 0 00-.365 2.927c0 .215.025.428.048.633.034.296.066.576.027.851-.145 1.063-.216 2.096-.293 3.334zm2.453-2.418l-.006-.258c.001-.064 0-.128-.003-.191l-.003-.102c-.007-.33-.012-.658-.012-.987 0-.64.12-1.3.25-1.999l.04-.239c0-.4.068-1.463.268-1.998.376-.877.95-1.832 1.708-2.845.51-.728 1.206-1.614 2.056-2.007.687-.264 2.468-.879 4.166-.879.372 0 .716.031 1.022.092 1.46.292 3.645 2.096 4.1 3.386.426 1.208.493 2.412.571 3.732.034.136.05.27.067.405.02.154.039.308.075.45.037.182.073.346.11.51.035.161.07.322.102.453a.74.74 0 00.072.271c0 .189.006.35.073.565.008.15.052.356.105.588.02.081.035.148.038.164 0 .075.025.15.05.22.009.03.02.059.024.093.033.33.07.664.107 1.001.124 1.128.253 2.294.253 3.45 0 .05-.003.119-.007.198-.014.313-.035.778.055 1.196-.04.196-.028.367.037.56l.018.053.04.04c.016.016.04.051.063.089-.06.415.06.755.371 1.067.053.053.117.114.19.183.37.354 1.239 1.184 1.158 1.62-.007.036-.026.14-.23.24-.743-.075-1.713-.027-2.614.031-.219.014-.439.029-.685.043-.114.02-.28.03-.492.03-.283 0-.573-.018-.723-.027a1.87 1.87 0 00-.08-.004h-.003a65.513 65.513 0 00-1.84-.288c-.61-.09-1.222-.18-1.875-.291h-.939c-.195 0-.478.05-.584.069a3.624 3.624 0 00-.192-.02c-.778-.129-1.838-.082-2.819-.014l-.537.037c-.973.072-1.946.126-2.92.18-.975.055-1.951.11-2.91.18-.283 0-.585-.017-.887-.035l-.19-.01c.366-.311.705-.708 1.032-1.204.221-.222.386-.456.527-.747.22-.294.574-.86.585-.877.046-.068.098-.136.15-.203.116-.148.235-.301.3-.471.14-.21.281-.43.364-.72.061-.087.109-.202.137-.278.164-.212.173-.554.171-.598.155-1.306.126-2.627.096-3.904zM30.616 40.547a2.162 2.162 0 00-.54-.163 1.255 1.255 0 00-.595-.126c-.137 0-.275.013-.407.026-.102.01-.199.02-.285.02-.608 0-1.237 0-1.89-.071-.274 0-.462.094-.613.17l-.062.045a1.17 1.17 0 00-.12.146h-.168v.085c-.674.077-1.218.472-1.392 1.032-.169.544.067 1.1.616 1.478.616.492 1.637.811 2.6.811.192 0 .376-.013.557-.041.37-.075.704-.156 1-.382.159-.08.438-.288.459-.304a4.04 4.04 0 00.49-.412.523.523 0 00.193-.12l.145.008v-.23h.145v-.259c.066-.145.144-.366.144-.487v-.028c.144-.395.08-.764-.192-1.127l-.034-.045-.051-.026z"
        fill="#FFA610"
      />
    </svg>
  );
}
function backSlash(props) {
  return (
    <svg
      width={5}
      height={13}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0_3398_22511)">
        <path d="M4.673.342l-3.281 12.19H.318L3.6.342h1.074z" fill="#84889B" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_3398_22511">
          <path fill="#fff" d="M0 0h5v13H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function STORIES(props) {
  return (
    <svg
      width={56}
      height={56}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={56} height={56} rx={28} fill="#FEECE2" />
      <path
        d="M17.741 15.79c-.104.029-.088-.027-.192.757-.117.883-.162 1.44-.282 3.493-.115 1.96-.182 2.838-.374 4.84-.264 2.755-.274 3.064-.298 8.267-.027 4.907-.024 5.021.114 5.834.086.515.211.878.435 1.273.101.175.219.392.264.48.112.224.224.357.397.471.083.054.192.142.246.19.133.128.19.152.354.152.31 0 .696-.157 1.475-.605 1.165-.667 1.653-.878 4.4-1.894a71.344 71.344 0 004.227-1.71c.92-.413.938-.42 2.346-1.117 1.222-.605 1.787-.882 2.614-1.274.685-.328 3.757-1.867 4.266-2.139.272-.147.638-.352.814-.456.92-.554 2.17-1.581 2.442-2.005.051-.08.128-.224.168-.32.043-.096.11-.227.152-.294.04-.066.088-.18.107-.253a1.36 1.36 0 01.09-.253c.033-.067.094-.267.134-.448.061-.272.072-.373.061-.6-.013-.323-.074-.47-.298-.707-.195-.21-.416-.368-1.79-1.283A42.877 42.877 0 0036.6 24.32c-.696-.395-1.264-.723-2.693-1.552l-1.867-1.075-.893-.506a90.021 90.021 0 00-2.934-1.574c-.78-.405-1.736-.914-1.933-1.026a82.75 82.75 0 00-2.547-1.33c-1.005-.502-1.349-.636-2.253-.87-.933-.24-2.037-.384-2.083-.27-.032.086.251.526.632.982.643.768 1.68 1.704 2.544 2.296.328.224 2.856 1.656 3.894 2.205.146.077.352.184.453.24.104.056.565.296 1.027.534 2.264 1.165 4.885 2.568 6.32 3.38 1.144.649 2.55 1.454 2.933 1.686.525.315 1.621 1.008 1.64 1.04.008.014-.139.117-.328.235-.888.552-1.41.845-2.725 1.53l-.667.35c-.4.208-2.613 1.315-2.84 1.419a119.53 119.53 0 00-3.24 1.626 99.97 99.97 0 01-3.133 1.592c-.643.31-1.152.55-1.36.648-.528.248-1.53.717-1.81.85a8.12 8.12 0 01-.324.15c-.005 0-.408.187-.898.416-.886.413-1.64.792-2.192 1.102-.16.09-.294.16-.299.157-.032-.032-.099-1.024-.13-1.936a80.274 80.274 0 00-.254-4.352c-.09-1.142-.133-1.774-.2-2.894-.048-.786-.072-1.8-.093-3.8-.024-2.269-.038-2.634-.134-4.266l-.098-1.627a42.281 42.281 0 01-.048-2.213c-.003-.813-.008-1.507-.01-1.539-.006-.107-.174-.179-.316-.139z"
        fill="#F56C1F"
      />
    </svg>
  );
}

function AUTOMATION(props) {
  return (
    <svg
      width={56}
      height={56}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={56} height={56} rx={28} fill="#EBFFF5" />
      <g clipPath="url(#prefix__clip0_2261_17232)" fill="#3DCC87">
        <path d="M42.486 16.123c-.525-.79-1.814-1.365-2.43-1.874-1.118-.923-2.268-1.932-3.684-2.359-.128-.038-.27-.076-.39-.02-.187.087-.218.333-.222.537-.022 1.02-.073 2.09.113 3.096-.45.064-.993.156-1.475.184-.551.032-1.06.092-1.554.15-.678.08-1.317.154-2.008.154-1.216 0-2.44-.016-3.666-.033-2.415-.034-4.912-.07-7.315.034l-.2.017c-.955.081-2.397.203-2.868.993-.438.562-.427 1.515-.419 2.283.003.27.006.503-.015.673a59.487 59.487 0 01-.152 1.897c-.057.63-.114 1.26-.153 1.923 0 .33 0 .939.382 1.25a.987.987 0 00.97.309c.372-.086.652-.361.75-.763.043-.293.022-.672.002-1.04-.018-.323-.035-.658.001-.898 0-.393.053-.806.108-1.242.059-.461.12-.939.12-1.421 0-.22.018-.422.037-.624.02-.216.039-.433.039-.67v-.398c1.512-.28 2.825-.275 4.334-.264l.815.004c2.937 0 5.71 0 8.599-.076.612 0 1.29-.098 1.62-.154.19-.017.4-.023.62-.029.437-.012.873-.045 1.305-.094.122 1.325.284 2.706.432 4.05.234 2.134 1.784.013 2.533-.704.76-.728 1.485-1.488 2.215-2.246.331-.344 1.54-1.103 1.699-1.514.164-.422.08-.796-.143-1.131zM40.601 34.06c0-.389-.074-1.062-.076-1.062 0-.098-.039-.175-.078-.263l-.008-.052c-.045-.317-.07-.493-.17-.706l-.04.018.034-.029a2.82 2.82 0 00-.221-.37c-.132-.264-.522-.293-.684-.293h-.736l.212.165c-.15.094-.282.24-.388.43-.334.666-.055 2.124-.027 2.239 0 .581-.063 1.127-.13 1.705-.035.305-.07.613-.095.915a11.62 11.62 0 00-.079.777c-.018.241-.037.482-.076.777v.05a9.047 9.047 0 00-1.268.077c-.47 0-1.514.147-1.522.151-1.252 0-2.568-.067-3.84-.133-.668-.034-1.339-.068-2.019-.095-.828 0-2.968 0-3.37-.05l-.435-.025c-.18 0-.342-.018-.504-.036-.18-.02-.36-.04-.56-.04l-1.496.001c-.473-.049-.944-.091-1.417-.134a65.373 65.373 0 01-2.067-.208 71.147 71.147 0 01-.094-3.278l-.008-.061c-.022-.089-.028-.186-.035-.285-.018-.237-.04-.532-.26-.818-.099-.1-.25-.234-.432-.28a.78.78 0 00-.086-.035l-.093-.031c-.115-.03-.235-.032-.253-.033-.144 0-.288.066-.404.118-.035.016-.067.032-.052.034-.439 0-.821.398-1.074.66l-.102.106a40.945 40.945 0 00-2.444 2.894l-1.141 1.367-.032.049a3.53 3.53 0 01-.172.314c-.655.993-.71.951.205 1.89 1.199 1.23 5.752 5.456 6.402 2.083.236-1.226-.183-1.973 1.327-2.324 1.01-.235 2.224.165 3.247.206.835.034 1.677.068 2.527.094 1.228.038 2.438.057 3.657.076 1.197.019 2.404.038 3.656.076.448 0 .907.016 1.371.033 1.28.046 2.605.092 3.858-.191 1.502-.334 1.496-2.311 1.493-3.493v-2.98z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_2261_17232">
          <path fill="#fff" transform="translate(12 12)" d="M0 0h32v32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function ArrowIntegration() {
  return (
    <svg
      width="9"
      height="14"
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 1.16602L7.33333 6.99935L1.5 12.8327"
        stroke="#686C7C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function Reward_Calender(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.375 2A.625.625 0 017 2.625v.625h10v-.625a.625.625 0 111.25 0v.625h1.25a2.5 2.5 0 012.5 2.5V19.5a2.5 2.5 0 01-2.5 2.5h-15A2.5 2.5 0 012 19.5V5.75a2.5 2.5 0 012.5-2.5h1.25v-.625A.625.625 0 016.375 2zM4.5 4.5a1.25 1.25 0 00-1.25 1.25V19.5a1.25 1.25 0 001.25 1.25h15a1.25 1.25 0 001.25-1.25V5.75A1.25 1.25 0 0019.5 4.5h-15z"
        fill="#2960EC"
      />
      <path
        d="M5.125 7a.625.625 0 01.625-.625h12.5a.625.625 0 01.625.625v1.25a.625.625 0 01-.625.625H5.75a.625.625 0 01-.625-.625V7zM12 12a.624.624 0 01.625.625V14.5H14.5a.624.624 0 110 1.25h-1.875v1.875a.624.624 0 11-1.25 0V15.75H9.5a.625.625 0 110-1.25h1.875v-1.875A.624.624 0 0112 12z"
        fill="#2960EC"
      />
    </svg>
  );
}

function Reward_Gift(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.556 1a3.667 3.667 0 00-3.458 4.889H4.667A3.667 3.667 0 001 9.556v1.222c0 1.086.472 2.061 1.222 2.733v4.6c0 2.7 2.19 4.889 4.89 4.889h9.777c2.7 0 4.889-2.189 4.889-4.889v-4.6A3.658 3.658 0 0023 10.778V9.556a3.667 3.667 0 00-3.667-3.667h-1.43A3.667 3.667 0 0012 1.934 3.653 3.653 0 009.555 1zm4.888 4.889a1.222 1.222 0 10-1.222-1.222v1.222h1.222zm-3.666 0V4.667a1.222 1.222 0 10-1.222 1.222h1.222zm2.444 14.667h3.667a2.444 2.444 0 002.444-2.445v-3.667h-6.11v6.112zm0-8.556h6.111c.675 0 1.223-.547 1.223-1.222V9.556c0-.675-.548-1.223-1.223-1.223h-6.11V12zm-2.444-3.667V12H4.667a1.222 1.222 0 01-1.223-1.222V9.556c0-.675.548-1.223 1.223-1.223h6.11zm0 6.111v6.112H7.11a2.445 2.445 0 01-2.444-2.445v-3.667h6.11z"
        fill="#EDA12F"
      />
    </svg>
  );
}

function Reward_Visit(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.875 13.011c0-.179.066-.35.183-.476a.603.603 0 01.442-.198c.166 0 .325.071.442.197a.702.702 0 01.183.477v4.495c0 .178-.066.35-.183.476a.603.603 0 01-.442.198.603.603 0 01-.442-.198.702.702 0 01-.183-.476V13.01zm-15.83 4.551a.732.732 0 01-.003-.056V13.01c0-.179.066-.35.183-.476a.603.603 0 01.442-.198c.165 0 .324.071.442.197a.702.702 0 01.183.477v4.495h10.416V13.01c0-.179.066-.35.183-.476a.603.603 0 01.442-.198c.166 0 .325.071.442.197a.702.702 0 01.183.477v4.495h4.614c.788 0 1.428.69 1.428 1.54v1.413c0 .85-.64 1.541-1.428 1.541H3.428c-.187 0-.373-.04-.546-.117a1.426 1.426 0 01-.464-.334A1.604 1.604 0 012 20.459v-1.413c0-.707.442-1.303 1.044-1.484zm.383 1.292a.177.177 0 00-.126.056.205.205 0 00-.052.136v1.413c0 .106.08.193.178.193h17.144c.047 0 .092-.02.126-.057a.2.2 0 00.052-.136v-1.413a.2.2 0 00-.052-.136.172.172 0 00-.126-.056H3.428zM5.1 3.348L3.375 6.604a.632.632 0 01-.378.304.585.585 0 01-.467-.067.668.668 0 01-.291-.4.722.722 0 01.051-.506l1.817-3.432A.993.993 0 014.973 2h14.053c.352 0 .68.182.878.526l1.804 3.41a.709.709 0 01.07.517.698.698 0 01-.108.24.644.644 0 01-.187.176.595.595 0 01-.481.063.61.61 0 01-.22-.123.664.664 0 01-.159-.205l-1.721-3.256H5.1zm2.928 9.538a.604.604 0 01.466-.122c.082.014.16.045.23.091s.131.107.18.18a.7.7 0 01.11.502.707.707 0 01-.085.248.657.657 0 01-.167.192L6.74 15.563a.59.59 0 01-.464.119.62.62 0 01-.407-.27.715.715 0 01-.111-.5.684.684 0 01.248-.44l2.022-1.585zm3.511 0a.581.581 0 01.694-.03c.07.047.131.108.18.18a.699.699 0 01.111.501.707.707 0 01-.084.247.658.658 0 01-.166.193l-3.033 2.378a.59.59 0 01-.465.12.62.62 0 01-.409-.27.716.716 0 01-.111-.501.684.684 0 01.25-.44l3.033-2.378z"
        fill="#2960EC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 8.26c0 1.702-1.235 3.082-2.758 3.082-1.04 0-1.944-.642-2.415-1.59-.47.948-1.375 1.59-2.413 1.59-1.039 0-1.943-.642-2.414-1.59-.47.948-1.375 1.59-2.414 1.59-1.039 0-1.943-.642-2.413-1.59-.471.948-1.375 1.59-2.415 1.59C3.235 11.342 2 9.962 2 8.26c0-.336.252-.609.564-.609h18.872c.311 0 .564.273.564.609z"
        fill="#2960EC"
      />
    </svg>
  );
}

function Reward_Point(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.715 16.715a7.944 7.944 0 10-9.43-9.43 7.944 7.944 0 109.43 9.43zm3.84-7.77A5.5 5.5 0 009.85 7.161a7.948 7.948 0 016.988 6.987 5.503 5.503 0 003.718-5.205zm-6.11 6.11a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0z"
        fill="#2960EC"
      />
    </svg>
  );
}

function WidgetEarnIcon(props) {
  return (
    <svg width={28} height={28} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.245 2.674c-.067.01-.149.028-.183.042a1.987 1.987 0 01-.174.05c-.174.039-.265.096-.437.279-.51.53-1.16 1.643-1.778 3.037-.192.435-.498 1.162-1.335 3.187l-.228.548h-.34c-.188 0-.974-.016-1.747-.034-2.473-.06-3.253-.048-3.703.057-.596.142-.7.192-.798.389-.144.29-.073.578.32 1.291.387.7.794 1.116 3.34 3.41.372.337.683.62.69.631.007.012-.07.26-.171.556-.448 1.31-.615 1.858-1.155 3.815-.649 2.343-.699 2.583-.704 3.213l-.002.368.098.192c.055.106.122.208.147.229.045.034.043.039-.055.194-.226.357-.544.896-.544.926.002.178.468.263.926.169.656-.137 1.6-.564 2.198-.999.192-.137.823-.644 2.524-2.03a247.811 247.811 0 012.132-1.725c.003 0 .245.221.54.491.608.563.72.663 1.408 1.292.274.249.74.68 1.035.96 1.001.939 1.408 1.296 1.982 1.728.32.24.468.329.65.39.125.044.152.046.246.021.21-.055.347-.194.441-.436.023-.06.066-.147.096-.192a.49.49 0 00.073-.167.35.35 0 01.037-.112c.009-.014.046-.121.08-.24.132-.469.087-1.555-.14-3.29-.128-.985-.388-2.4-.79-4.317a12.205 12.205 0 01-.113-.576c0-.04.247-.224 1.2-.908l.583-.418c.702-.507 1.228-.88 1.909-1.358 1.122-.786 1.25-.898 1.442-1.28.204-.4.29-.713.28-1.01-.01-.29-.047-.334-.456-.54-.36-.18-.708-.278-1.266-.356-.555-.078-.85-.091-2.594-.128-.912-.02-1.856-.043-2.1-.053l-.444-.016-.215-.822c-.617-2.375-.919-3.395-1.372-4.629-.386-1.051-.71-1.634-.96-1.714a.987.987 0 01-.162-.083c-.085-.059-.178-.066-.411-.032zm.265 1.596c.302.77.676 2.062.999 3.456.134.58.491 2.176.491 2.201 0 .014-.398.018-1.136.007-1.509-.02-3.559-.062-3.57-.073a.988.988 0 01.077-.197l.677-1.52c.325-.731.672-1.497.77-1.703.311-.647.702-1.34 1.07-1.892.192-.293.455-.604.49-.583.01.007.07.144.132.304zm-6.796 6.885c1.415.027 1.822.045 1.808.077a92.348 92.348 0 00-.736 1.893 8.587 8.587 0 01-.24.612c-.006 0-.11-.089-.228-.198-.498-.46-1.612-1.454-2.126-1.898l-.55-.475.166-.014c.281-.02.754-.02 1.906.003zm3.513.148c.282.02.995.078 1.585.128 1.622.137 2.436.199 3.017.229.315.016.537.036.55.052.028.025.092.327.512 2.391l.22 1.084-.25.16a88.89 88.89 0 00-3.2 2.17 15.81 15.81 0 01-.603.42c-.016.006-.249-.197-.516-.453-.576-.554-1.18-1.12-2.359-2.215-.478-.444-.866-.816-.862-.832.005-.014.11-.293.238-.62.334-.86.658-1.634 1.024-2.44.032-.074.062-.108.091-.108.026 0 .275.016.553.034zm7.722.526c.42.018 1.07.043 1.44.057 1.385.05 1.719.066 1.728.075.02.019-1.006.72-1.911 1.308-.5.322-1.735 1.085-1.758 1.085-.007 0-.043-.13-.078-.292a165.01 165.01 0 00-.535-2.263c-.01-.027.014-.03.167-.018.099.009.526.03.947.048zm-9.351 5.289a190.42 190.42 0 011.895 1.723c.068.062.114.121.102.128a48.12 48.12 0 00-1.424 1.027c-1.014.768-2.406 1.945-2.854 2.418-.179.19-.59.688-.739.9-.04.055-.04.053-.027-.114a6.33 6.33 0 01.16-.914c.073-.27.827-2.791 1.026-3.429.352-1.127.876-2.612.912-2.59.012.01.44.392.949.85zm7.888-.09c0 .015.061.346.137.737.404 2.098.567 3.22.692 4.8l.03.359-.756-.748a47.146 47.146 0 00-1.246-1.193 212.832 212.832 0 01-1.62-1.479l-.147-.135.441-.375c.979-.831 2.4-1.988 2.446-1.988.014 0 .023.011.023.023z"
        fill={props.color ? props.color : "#EA4335"}
      />
    </svg>
  );
}

function WidgetRedeemIcon(props) {
  return (
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.355 3.055c-.224.02-.657.084-.743.112-.05.016-.245.068-.432.112a3.016 3.016 0 00-.366.103c-.014.009-.128.052-.254.093a4.271 4.271 0 00-.297.105l-.286.121c-.425.174-.54.227-.788.355-.51.26-.74.42-1.054.731-.165.165-.38.441-.466.6-.103.184-.192.328-.208.328-.01 0-.028-.027-.04-.064-.033-.096-.28-.43-.477-.644-.366-.398-.768-.739-1.104-.926a5.27 5.27 0 00-1.828-.63c-.28-.038-.896-.04-1.132-.003-.258.04-.635.12-.663.142a.69.69 0 01-.14.052c-.344.1-.644.338-.86.679-.097.15-.159.309-.25.64-.037.132-.011.56.046.766.08.285.125.388.313.72.254.45.37.59.743.891.345.279.78.519 1.2.663.169.06.178.064.125.087-.032.014-.436.046-.902.073-1.164.064-1.82.112-1.875.137a2.47 2.47 0 01-.308.043c-.375.037-1.054.138-1.109.163a7.039 7.039 0 01-.514.112c-.645.123-.837.18-.962.28a.738.738 0 01-.204.117c-.199.067-.194.049-.19.926.003.896.019 1.013.176 1.315.318.605.366.678.522.784.054.036.15.107.212.157a.88.88 0 00.194.124l.183.077c.13.057.457.124.704.144l.192.016-.013.266c-.007.146-.003.5.011.79.011.288.032 1.514.041 2.72a95.01 95.01 0 00.044 2.515c.013.176.048.603.073.948.027.345.057.665.068.709.012.043.037.413.057.823.019.409.04.813.046.902.03.384.087.894.103.915.01.011.025.126.032.251.023.306.062.487.14.62l.187.34c.121.224.153.26.432.498.112.096.135.108.199.096a.657.657 0 00.146-.059c.091-.057.352-.062 1.538-.034.97.023 2.137-.019 3.875-.135.251-.018.941-.062 1.531-.1.592-.04 1.234-.087 1.429-.104.8-.073 2.164-.219 2.24-.24.043-.013.183-.034.308-.047.473-.053 1.122-.14 1.2-.163.044-.011.389-.061.766-.112 1.11-.144 1.543-.22 2.057-.36.268-.074.37-.113.418-.159.016-.016.042-.03.053-.03.027 0 .203-.16.203-.187 0-.011.02-.04.044-.066a.304.304 0 00.06-.105c.02-.09.109-.268.143-.293.016-.014.037-.07.044-.125a.336.336 0 01.04-.138c.017-.018.053-.12.083-.228.057-.217.087-.706.046-.789-.02-.04-.041-.199-.163-1.28-.04-.36-.212-1.746-.285-2.302a38.936 38.936 0 01-.14-1.584 1.503 1.503 0 00-.032-.274 2.314 2.314 0 01-.032-.343c-.045-.916-.134-2.089-.173-2.228-.028-.103-.197-1.527-.183-1.54a6.19 6.19 0 01.377-.072c.201-.034.377-.068.389-.08a.464.464 0 01.125-.034c.057-.007.163-.03.233-.05.163-.044.275-.156.352-.354a.828.828 0 01.09-.179.21.21 0 00.034-.119.16.16 0 01.043-.118c.05-.046.087-.176.117-.412.03-.242.007-.405-.08-.55-.041-.067-.067-.131-.057-.143.009-.009.048-.173.082-.36.055-.3.064-.4.064-.79.002-.397-.002-.463-.05-.623a1.797 1.797 0 00-.115-.297.8.8 0 01-.073-.229c-.011-.107-.014-.112-.125-.158a5.755 5.755 0 01-.277-.125c-.203-.1-.27-.096-.279.018l-.007.08-.793.064c-.437.034-.83.07-.873.082-.14.037-1.744.128-2.754.16-.428.014-.821.035-.876.046-.123.03-.256.03-.256.002 0-.011.055-.04.121-.066.247-.094 1.312-.677 1.388-.759a.718.718 0 01.1-.064c.277-.162.704-.562.965-.905.18-.242.249-.361.489-.87a2.86 2.86 0 00.162-.598c.069-.43-.013-.729-.251-.925-.22-.179-.66-.345-1.058-.396a7.665 7.665 0 00-1.002-.045zm1.234 1.104c.057.016.135.04.176.06a.357.357 0 00.098.033c.032 0 .027.026-.043.263a2.072 2.072 0 01-.496.745c-.195.215-.501.416-1.038.68a9.24 9.24 0 01-.48.22c-.032.01-.108.044-.167.074-.062.03-.201.087-.308.123-.11.04-.23.083-.268.101-.037.016-.14.053-.229.08l-.388.126c-.126.043-.306.1-.4.126a2.403 2.403 0 00-.24.08 4.84 4.84 0 01-.331.102 2.883 2.883 0 00-.286.092 2.242 2.242 0 01-.332.091c-.169.041-.374.092-.457.117-.174.05-.576.14-.583.13a1.179 1.179 0 01.01-.137.497.497 0 01.111-.265c.053-.076.096-.144.096-.151 0-.025.43-.64.574-.823.14-.174.43-.448.563-.53a.607.607 0 00.086-.064c.11-.12.986-.6 1.36-.75.094-.037.183-.075.195-.087.013-.009.137-.057.274-.103.14-.048.263-.096.277-.107.013-.01.166-.055.338-.096.171-.043.322-.087.334-.094.013-.009.123-.03.246-.046.26-.038 1.146-.03 1.308.01zm-10.019.39c.16.014.314.035.339.046.025.01.112.032.194.046.215.039.526.114.606.149.039.016.15.059.251.093.217.076.597.27.782.398.402.279.919.83 1.17 1.246l.078.128.002.45c.002.247.012.466.023.487.01.025.005.04-.016.05-.032.011-.656-.128-.736-.167a5.74 5.74 0 00-.4-.103 5.78 5.78 0 01-.4-.103 6.599 6.599 0 00-.708-.157 1.479 1.479 0 01-.206-.048 1.471 1.471 0 00-.194-.046 7.337 7.337 0 01-.707-.16 3.324 3.324 0 00-.276-.094c-.535-.167-.933-.434-1.184-.802a.759.759 0 01-.074-.119c0-.007-.032-.077-.07-.155-.08-.165-.142-.441-.12-.546.017-.08.2-.28.339-.369.149-.093.473-.2.667-.221a2.58 2.58 0 01.64-.002zM22.777 8.2a.382.382 0 01-.034.11 1.96 1.96 0 00-.069.31c-.052.31-.114.575-.134.593-.04.03-.147.535-.158.727-.007.126-.02.217-.037.222-.013.005-.54.037-1.168.069-.628.031-1.312.068-1.52.082-.866.052-1.108.064-2.023.087-2.28.061-2.646.07-2.973.084l-.345.014-.085-.61a7.715 7.715 0 00-.105-.652.773.773 0 01-.027-.208l-.007-.167.137-.03a9.3 9.3 0 01.754-.061 57.765 57.765 0 001.36-.094c.592-.03 2.222-.13 2.42-.148.122-.01.574-.05 1.009-.09.434-.038.932-.086 1.108-.105a65.643 65.643 0 001.614-.18l.27-.034c.023-.003.027.018.013.082zm-9.812 1.51c-.005.461-.016.822-.028.83-.011.006-.738.031-1.616.054-1.577.041-3.632.126-3.675.155a18.33 18.33 0 01-.94.044c-.724.023-.978.023-1.22 0a2.283 2.283 0 01-.332-.046.308.308 0 00-.1-.034c-.201-.037-.256-.062-.279-.124-.027-.068-.07-.534-.075-.813l-.003-.18.115-.028a.708.708 0 00.141-.042c.035-.02.65-.098 1.241-.153.27-.025.595-.054.72-.068.126-.012.533-.037.903-.057 1.443-.073 1.96-.105 2.103-.126.082-.011.684-.06 1.337-.103a34.19 34.19 0 001.292-.1c.057-.01.176-.021.263-.023l.16-.003-.007.816zm8.2 2.473c0 .1.017.436.035.75.048.783.08 1.803.08 2.502 0 .325.01.633.023.686.011.055.032.39.046.75.02.564.11 1.979.148 2.354.058.55.087 2.47.04 2.519-.051.05-.465.12-1.194.2-.334.037-.775.088-.983.113-.46.057-1.348.14-1.495.14a.444.444 0 00-.146.02c-.02.011-.25.032-.507.046l-1.12.059-.828.043-.176.012.025-.062.042-.107c.13-.33.141-.947.034-1.772-.018-.132-.076-.59-.126-1.017a16.198 16.198 0 00-.114-.823c-.044-.105-.108-1.024-.16-2.343a7.82 7.82 0 00-.046-.697c-.02-.112-.046-.493-.137-2.148a13.033 13.033 0 00-.069-.894.645.645 0 01-.023-.176v-.107l.122-.003a90.084 90.084 0 013.43-.133c1.74-.038 3.018-.073 3.029-.084.005-.005.023-.01.041-.01.023 0 .03.047.03.181zm-8.218 1.08c-.016 1.13.022 4.252.061 4.846.025.377.05.633.158 1.516.025.212.07.615.103.891.075.686.119 1.004.16 1.214.036.18.21.601.279.677.03.034.03.04.004.05-.018.007-.315.034-.66.06-.345.027-.761.063-.926.08l-.937.1c-.352.039-.76.084-.903.105-.144.02-.633.08-1.086.135-.452.052-.839.103-.857.112a4.258 4.258 0 01-.384.043l-.347.032-.023-.082c-.041-.16-.126-1.15-.172-2.012a2.596 2.596 0 00-.034-.342A24.913 24.913 0 017.28 19.6a26.272 26.272 0 00-.103-1.109c-.03-.15-.043-.53-.068-1.965-.03-1.64-.087-2.885-.137-3.006a13.526 13.526 0 01-.092-.94c0-.015.114-.03.327-.038.9-.041 2.537-.135 2.667-.156.083-.011.787-.04 1.566-.064.78-.023 1.44-.043 1.47-.046l.05-.002-.014.988z"
        fill={props.color ? props.color : "#EA4335"}
      />
    </svg>
  );
}

function toggleIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.75 12a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zM9.75 5a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zM9.75 19a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0z"
        fill="#2D2E2E"
      />
    </svg>
  );
}

function IconWalletlyOld(props) {
  return (
    <svg
      width={26}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.44 2.212C-.47 4.203-.232 7.285.725 8.567l.058.061.04.034c.147.12 1.632.34 2.799-.608l5.126-5.432-.392-.41A4.775 4.775 0 004.897.72 4.776 4.776 0 001.44 2.213z"
        fill="url(#prefix__paint0_linear_4378_27579)"
      />
      <path
        d="M16.78 2.253l-.27.28 4.818 5.169c-1.286-1.044-2.48-.496-2.48-.496a2.564 2.564 0 00-.926.586l-5.22 5.433 1.952 2.03a2.382 2.382 0 003.096.315c.131-.09.256-.195.371-.315l1.16-1.205 4.423-4.599a5.1 5.1 0 001.081-1.699c.71-1.835.35-4.012-1.08-5.5a4.79 4.79 0 00-3.463-1.49 4.791 4.791 0 00-3.462 1.49z"
        fill="url(#prefix__paint1_linear_4378_27579)"
      />
      <path
        d="M11.1.687L3.854 8.364a3.266 3.266 0 01-2.329.707l5.733 6.038a2.131 2.131 0 001.549.668c.59 0 1.144-.24 1.561-.676l7.286-7.587c.27-.284.606-.497.977-.622a3.44 3.44 0 011.078-.194c.051 0 .101.002.151.004L14.27.682a2.177 2.177 0 00-3.17.005z"
        fill="url(#prefix__paint2_linear_4378_27579)"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_4378_27579"
          x1={9.033}
          y1={2.476}
          x2={0.526}
          y2={9.174}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2FD8E5" />
          <stop offset={1} stopColor="#FF6CD6" />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear_4378_27579"
          x1={23.331}
          y1={3.317}
          x2={12.535}
          y2={14.628}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2FD8E5" />
          <stop offset={1} stopColor="#FF6CD6" />
        </linearGradient>
        <linearGradient
          id="prefix__paint2_linear_4378_27579"
          x1={20.457}
          y1={4.006}
          x2={3.251}
          y2={16.665}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2FD8E5" />
          <stop offset={1} stopColor="#FF6CD6" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function AppleWalletIcon() {
  return(
    <svg style={{borderRadius:"inherit"}} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 width="100%" viewBox="0 0 96 96" enable-background="new 0 0 96 96">
<path fill="#010101" opacity="1.000000" stroke="none" 
	d="
M62.000000,97.000000 
	C41.333332,97.000000 21.166666,97.000000 1.000000,97.000000 
	C1.000000,65.000000 1.000000,33.000000 1.000000,1.000000 
	C33.000000,1.000000 65.000000,1.000000 97.000000,1.000000 
	C97.000000,33.000000 97.000000,65.000000 97.000000,97.000000 
	C85.500000,97.000000 74.000000,97.000000 62.000000,97.000000 
M87.680984,44.068703 
	C87.785706,35.906326 88.043671,27.742132 87.946884,19.582146 
	C87.868782,12.997859 83.753410,8.919447 77.307320,8.893850 
	C59.012486,8.821204 40.716522,8.791331 22.422281,8.922648 
	C14.110612,8.982310 10.189018,12.091499 9.353160,20.276478 
	C8.442525,29.193684 8.173335,38.219814 8.307242,47.188267 
	C8.445905,56.475216 9.569767,65.743065 9.954132,75.032028 
	C10.306202,83.540527 14.416119,87.976273 22.966776,88.006424 
	C40.130619,88.066948 57.295498,88.048920 74.458946,87.924423 
	C84.631836,87.850639 88.240936,84.065544 88.096741,73.899620 
	C87.960014,64.259842 87.705482,54.621723 87.680984,44.068703 
z"/>
<path fill="#363736" opacity="1.000000" stroke="none" 
	d="
M87.591873,44.525787 
	C87.705482,54.621723 87.960014,64.259842 88.096741,73.899620 
	C88.240936,84.065544 84.631836,87.850639 74.458946,87.924423 
	C57.295498,88.048920 40.130619,88.066948 22.966776,88.006424 
	C14.416119,87.976273 10.306202,83.540527 9.954132,75.032028 
	C9.569767,65.743065 8.445905,56.475216 8.307242,47.188267 
	C8.173335,38.219814 8.442525,29.193684 9.353160,20.276478 
	C10.189018,12.091499 14.110612,8.982310 22.422281,8.922648 
	C40.716522,8.791331 59.012486,8.821204 77.307320,8.893850 
	C83.753410,8.919447 87.868782,12.997859 87.946884,19.582146 
	C88.043671,27.742132 87.785706,35.906326 87.591873,44.525787 
M65.277786,75.017120 
	C75.007408,74.770592 78.679367,72.122940 79.579239,62.931553 
	C80.533142,53.188255 80.836426,43.347164 80.791306,33.551701 
	C80.759300,26.605072 76.914192,23.179905 70.104500,22.980457 
	C55.972412,22.566540 41.837830,22.193464 27.701607,21.981995 
	C19.576744,21.860451 16.109703,25.327572 16.006174,33.402504 
	C15.897280,41.895790 15.911006,50.391510 15.956878,58.885700 
	C16.011414,68.984230 20.269680,73.505920 30.417702,73.942291 
	C41.716286,74.428139 53.025356,74.670074 65.277786,75.017120 
z"/>
<path fill="#101111" opacity="1.000000" stroke="none" 
	d="
M64.803825,75.017654 
	C53.025356,74.670074 41.716286,74.428139 30.417702,73.942291 
	C20.269680,73.505920 16.011414,68.984230 15.956878,58.885700 
	C15.911006,50.391510 15.897280,41.895790 16.006174,33.402504 
	C16.109703,25.327572 19.576744,21.860451 27.701607,21.981995 
	C41.837830,22.193464 55.972412,22.566540 70.104500,22.980457 
	C76.914192,23.179905 80.759300,26.605072 80.791306,33.551701 
	C80.836426,43.347164 80.533142,53.188255 79.579239,62.931553 
	C78.679367,72.122940 75.007408,74.770592 64.803825,75.017654 
M58.819630,24.645271 
	C48.343849,24.439102 37.868725,24.134312 27.392038,24.065216 
	C21.481773,24.026234 18.646078,26.142250 18.394474,31.759377 
	C17.948444,41.717079 18.016445,51.710461 18.253042,61.679806 
	C18.346498,65.617744 19.959223,70.144905 24.292938,70.419556 
	C39.663967,71.393677 55.082100,71.871910 70.481903,71.860901 
	C72.634102,71.859367 76.440773,68.236107 76.654594,66.016968 
	C77.720963,54.949425 77.934181,43.793526 78.255554,32.663174 
	C78.397919,27.732462 75.288902,25.503281 70.729980,25.144951 
	C67.084290,24.858398 63.417233,24.843693 58.819630,24.645271 
z"/>
<path fill="#CFDEDE" opacity="1.000000" stroke="none" 
	d="
M59.289642,24.676802 
	C63.417233,24.843693 67.084290,24.858398 70.729980,25.144951 
	C75.288902,25.503281 78.397919,27.732462 78.255554,32.663174 
	C77.934181,43.793526 77.720963,54.949425 76.654594,66.016968 
	C76.440773,68.236107 72.634102,71.859367 70.481903,71.860901 
	C55.082100,71.871910 39.663967,71.393677 24.292938,70.419556 
	C19.959223,70.144905 18.346498,65.617744 18.253042,61.679806 
	C18.016445,51.710461 17.948444,41.717079 18.394474,31.759377 
	C18.646078,26.142250 21.481773,24.026234 27.392038,24.065216 
	C37.868725,24.134312 48.343849,24.439102 59.289642,24.676802 
M42.197514,58.832100 
	C47.114868,62.897881 50.497196,62.918457 53.245865,58.401031 
	C53.871685,57.624050 54.497505,56.847069 55.977291,56.054131 
	C61.591496,55.661747 67.228889,55.449535 72.801270,54.732231 
	C73.983734,54.580017 75.758324,52.640934 75.840240,51.429123 
	C76.198936,46.123348 76.068199,40.782173 76.051559,35.454041 
	C76.037384,30.913414 73.476463,28.743820 69.155975,28.649422 
	C55.996593,28.361906 42.834606,28.195835 29.674498,27.938375 
	C25.457891,27.855885 22.905567,29.855576 22.603096,33.994301 
	C22.191206,39.630157 22.284904,45.301399 21.955885,50.945465 
	C21.764261,54.232639 22.946188,55.376957 26.273260,55.167229 
	C31.892557,54.813004 37.694386,54.015152 42.624722,58.292805 
	C42.624722,58.292805 42.753696,58.207989 42.197514,58.832100 
z"/>
<path fill="#15130F" opacity="1.000000" stroke="none" 
	d="
M42.511562,58.187817 
	C37.694386,54.015152 31.892557,54.813004 26.273260,55.167229 
	C22.946188,55.376957 21.764261,54.232639 21.955885,50.945465 
	C22.284904,45.301399 22.191206,39.630157 22.603096,33.994301 
	C22.905567,29.855576 25.457891,27.855885 29.674498,27.938375 
	C42.834606,28.195835 55.996593,28.361906 69.155975,28.649422 
	C73.476463,28.743820 76.037384,30.913414 76.051559,35.454041 
	C76.068199,40.782173 76.198936,46.123348 75.840240,51.429123 
	C75.758324,52.640934 73.983734,54.580017 72.801270,54.732231 
	C67.228889,55.449535 61.591496,55.661747 55.601891,55.686344 
	C61.068321,54.082939 66.910156,52.847321 72.751991,51.611706 
	C71.168823,49.796211 69.015274,48.274395 66.788414,48.158260 
	C56.641949,47.629124 46.475998,47.421680 36.314487,47.266811 
	C33.507812,47.224033 30.577181,47.381245 27.927221,48.184772 
	C26.506714,48.615501 25.562096,50.615673 24.402725,51.907612 
	C28.843632,52.986259 32.336201,52.835400 35.810177,53.025017 
	C40.011089,53.254314 41.578815,54.601593 42.511562,58.187817 
M50.116291,41.389515 
	C43.468449,41.296864 36.817638,41.045879 30.173870,41.170433 
	C26.132238,41.246204 25.467319,42.225304 25.617584,46.459381 
	C41.659725,46.459381 57.712696,46.459381 73.638885,46.459381 
	C73.178009,42.695889 72.695580,42.161648 68.495270,42.007423 
	C62.681877,41.793968 56.866005,41.647968 50.116291,41.389515 
M46.499146,38.982124 
	C55.579292,38.982124 64.659439,38.982124 74.656319,38.982124 
	C72.850731,37.759846 71.136162,35.609058 69.349571,35.547470 
	C55.883621,35.083260 42.402935,34.923203 28.928612,34.995335 
	C27.398954,35.003525 25.880150,37.038532 24.356312,38.133713 
	C24.642773,38.416172 24.929234,38.698635 25.215694,38.981098 
	C31.977058,38.981098 38.738422,38.981098 46.499146,38.982124 
M34.628433,29.923141 
	C31.538158,30.541994 27.658884,28.428474 24.878559,33.158127 
	C41.384754,33.158127 57.199703,33.158127 73.222160,33.158127 
	C72.785919,32.571304 72.350922,31.434044 71.863319,31.411020 
	C59.778126,30.840332 47.687370,30.387489 34.628433,29.923141 
z"/>
<path fill="#E44450" opacity="1.000000" stroke="none" 
	d="
M42.568142,58.240311 
	C41.578815,54.601593 40.011089,53.254314 35.810177,53.025017 
	C32.336201,52.835400 28.843632,52.986259 24.402725,51.907612 
	C25.562096,50.615673 26.506714,48.615501 27.927221,48.184772 
	C30.577181,47.381245 33.507812,47.224033 36.314487,47.266811 
	C46.475998,47.421680 56.641949,47.629124 66.788414,48.158260 
	C69.015274,48.274395 71.168823,49.796211 72.751991,51.611706 
	C66.910156,52.847321 61.068321,54.082939 55.174904,55.694321 
	C54.497505,56.847069 53.871685,57.624050 52.698883,58.664078 
	C49.019165,58.687412 45.886429,58.447701 42.753696,58.207989 
	C42.753696,58.207989 42.624722,58.292805 42.568142,58.240311 
z"/>
<path fill="#15130F" opacity="1.000000" stroke="none" 
	d="
M42.475605,58.520042 
	C45.886429,58.447701 49.019165,58.687412 52.527939,58.912178 
	C50.497196,62.918457 47.114868,62.897881 42.475605,58.520042 
z"/>
<path fill="#6BBB90" opacity="1.000000" stroke="none" 
	d="
M50.583740,41.431301 
	C56.866005,41.647968 62.681877,41.793968 68.495270,42.007423 
	C72.695580,42.161648 73.178009,42.695889 73.638885,46.459381 
	C57.712696,46.459381 41.659725,46.459381 25.617584,46.459381 
	C25.467319,42.225304 26.132238,41.246204 30.173870,41.170433 
	C36.817638,41.045879 43.468449,41.296864 50.583740,41.431301 
z"/>
<path fill="#F3B70F" opacity="1.000000" stroke="none" 
	d="
M45.999466,38.981613 
	C38.738422,38.981098 31.977058,38.981098 25.215694,38.981098 
	C24.929234,38.698635 24.642773,38.416172 24.356312,38.133713 
	C25.880150,37.038532 27.398954,35.003525 28.928612,34.995335 
	C42.402935,34.923203 55.883621,35.083260 69.349571,35.547470 
	C71.136162,35.609058 72.850731,37.759846 74.656319,38.982124 
	C64.659439,38.982124 55.579292,38.982124 45.999466,38.981613 
z"/>
<path fill="#426D9E" opacity="1.000000" stroke="none" 
	d="
M35.113018,29.918421 
	C47.687370,30.387489 59.778126,30.840332 71.863319,31.411020 
	C72.350922,31.434044 72.785919,32.571304 73.222160,33.158127 
	C57.199703,33.158127 41.384754,33.158127 24.878559,33.158127 
	C27.658884,28.428474 31.538158,30.541994 35.113018,29.918421 
z"/>
</svg>
  )
}


function LocationIcon (props){
  return (
   <svg height={props.height || "13px"} width={props.width || "13px"} fill={props.color || "#000000"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">{/*! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. */}<path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" /></svg>

  )
}



const SvgIcons = {
  IconWalletlyOld,
  backSlash,
  toggleIcon,
  Reward_Point,
  Reward_Calender,
  Reward_Gift,
  Reward_Visit,
  ArrowIntegration,
  Link,
  Star,
  STORIES,
  AUTOMATION,
  NOTIFICATION,
  SMS,
  Connection,
  ReportsIcon,
  Crown,
  Present,
  IconPlus,
  Tooltip,
  OrdersIcon,
  FilledAutomationIcon,
  AutomationIcon,
  VisitDealIcon,
  PointDealIcon,
  FlowDealIcon,
  GrowthToolFlowIcon,
  FlowCollapseIcon,
  YesIcon,
  ConditionalActionIcon,
  SignUpIcon,
  HorizontalIcon,
  VerticalIcon,
  QrIcon,
  CheckInIcon,
  VisitIcon,
  GiveDealIcon,
  PointIcon,
  EventIcon,
  GripIcon,
  Point,
  Deactivate,
  FilterSearch,
  IconSearch,
  IconStop,
  IconInformation,
  IconCheckList,
  Image,
  Facebook,
  CrossEyeIcon,
  EyeIconPassword,
  HelperTextIcon,
  Instagram,
  BellIcon,
  Website,
  ImagePlus,
  Error,
  DollarSolid,
  PercentSolid,
  GiftSolid,
  Add,
  LogoMain,
  NavDashboardIcon,
  NavAudienceIcon,
  NavAudienceFillIcon,
  NavCommuncationIcon,
  NavCampaignIcon,
  NavSettingIcon,
  NavRedemptionIcon,
  NavGrowthIcon,
  SubNavWalletPushIcon,
  SubNavGeoPushIcon,
  SubNavIBeaconIcon,
  AddIcon,
  SearchIcon,
  FilterIcon,
  ApiIcon,
  UrlIcon,
  SmsIcon,
  QrCodeIcon,
  CampaignIcon,
  EditIcon,
  LeftArrowIcon,
  ShareIcon,
  DownloadIcon,
  CopyIcon,
  ArrowOpen,
  ArrowClose,
  CloseIcon,
  LockIcon,
  RightIcon,
  NudgesIcon,
  WalletScanIcon,
  BarcodeIcon,
  CameraIcon,
  CustomerInfoIcon,
  CodeInputIcon,
  PhoneIcon,
  EmailIcon,
  WalletlyShadedLogoIcon,
  NextarrowIcon,
  SteparrowIcon,
  ColorselectIcon,
  ShopifyIcon,
  PalletteIcon,
  SelectIconDropDown,
  InviteIcon,
  ImpressionIcon,
  ParticipantIcon,
  ReferralIcon,
  WalletlyHeaderLogoIcon,
  ProfilePictureIcon,
  IconTick,
  BackIcon,
  ViewMoreIcon,
  EclipseIcon,
  UploadIcon,
  DeleteIcon,
  DropDownTriangleIcon,
  DropDownTriangleHorizontalIcon,
  HeaderCollapseIcon,
  Check,
  NavLoyatlyIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowExpand,
  ArrowUnExpand,
  PlusIcon,
  CommunicationNotificationIcon,
  CommunicationChatFlowIcon,
  CommunicationEmailIcon,
  CommunicatonSmsIcon,
  CircularTickIcon,
  NavDesignIcon,
  EyeIcon,
  BrushIcon,
  EditPencil,
  DoneCheck,
  NavigatorIcon,
  CursorIcon,
  DesktopViewIcon,
  MobileViewIcon,
  ArrowIcon,
  AliginCenterEditorIcon,
  AliginLeftEditorIcon,
  AliginRightEditorIcon,
  BoldEditorIcon,
  BulletedEditorIcon,
  ItalicEditorIcon,
  UnderlineEditorIcon,
  LinkEditorIcon,
  StrikeEditorIcon,
  AlignHorizontalCenter,
  AlignLeft,
  AlignVerticalCenter,
  RadiusBottomLeft,
  RadiusBottomRight,
  RadiusTopLeft,
  RaduisTopRight,
  TextAlignCenter,
  TextAlign,
  TextBulletedList,
  TextItalic,
  TextStrikeThrough,
  TextUnderline,
  JustifyCenterIcon,
  ExpirationIcon,
  JustifyLeftIcon,
  CustomDropDownReplacedTriangleIcon,
  WidgetHeadingIcon,
  WidgetParagraphIcon,
  WidgetLinkIcon,
  WidgetButtonIcon,
  WidgetInputIcon,
  WidgetImageIcon,
  WidgetFormIcon,
  WidgetBlockIcon,
  WidgetDividerIcon,
  SendIcon,
  NoUserFoundIcon,
  CalanderIcon,
  AndroidIcon,
  AppleIcon,
  ExportIcon,
  AgencyInviteUserIcon,
  QrCodePreviewIcon,
  AvalibilityIcon,
  DeclineIcon,
  WalletlyLoaderIcon,
  NavNewSettingIcon,
  AddCustomerIcon,
  CrossIcon,
  TimeIcon,
  RedeemCameraIcon,
  DashboardMemberIcon,
  DashboardPointsIcon,
  DashboardSpendingIcon,
  RefreshIcon,
  CheckBoxUnCheckIcon,
  CheckBoxCheckIcon,
  TickIconSub,
  InventoryIcon,
  DealIcon,
  FillNavDashboardIcon,
  FillNavCommunicationIcon,
  FillNavDealIcon,
  FillNavInventoryIcon,
  FillNavLoyalityIcon,
  FillNavSettingIcon,
  FillNavWalletScanIcon,
  FillNavGrowthIcon,
  GiveawayIcon,
  FillGiveawayIcon,
  FlowCollapseIcon,
  RuleCheckInIcon,
  RulePointsIcon,
  RuleDealIcon,
  RuleFlowIcon,
  RuleContactIcon,
  RuleDaysIcon,
  CardIcon,
  LoyaltyIcon,
  ImageDropIcon,
  WelcomeAvatarIcon,
  InfoIcon,
  LandingPagePoinIcon,
  LandingPageTitleIcon,
  SubBrandPageSeperator,
  InfoIconEarnPoint,
  ChatraceIcon,
  profileIcon,
  GoogleIcon,
  GiftIcon,
  PresentIcon,
  BusinessProfileIcon,
  SettingIcon,
  TeamMembersIcon,
  ActivityLogsIcon,
  CustomFieldsIcon,
  APIIcon,
  IntegrationIcon,
  BillingIcon,
  DesignIcon,
  Failure,
  TagsIcon,
  WidgetEarnIcon,
  WidgetRedeemIcon,
  AppleWalletIcon,
  LocationIcon
};

export default SvgIcons;
